{
	"backoffice": {
		"billType": {
			"actions": "Actions",
			"addCategory": "Ajouter une catégorie de compte",
			"addType": "Ajouter un type de compte",
			"categories": "Catégories",
			"categoryName": "Nom de la catégorie du compte",
			"createCategory": "Créer une catégorie de compte",
			"createType": "Créer un type de compte",
			"createTypeIn": "Créer un type de compte {{categoryName}}",
			"editCategory": "Modifier la catégorie du compte",
			"editType": "Modifier le type de compte",
			"editTypeIn": "Modifier le type de compte dans {{categoryName}}",
			"name": "Nom",
			"typeName": "Nom du type de compte"
		},
		"cashFlow": {
			"pageTitle": "Flux de trésorerie",
			"pageParagraph": "Toute entreprise a besoin d'un flux de trésorerie pour suivre ses entrées et ses sorties. Le gestionnaire qui connaît son flux financier sait ce qui entre et ce qui sort au jour, à la semaine et au mois. Disposer d'un outil comme celui-ci et l'utiliser est d'une grande importance pour la prise de décision et pour savoir où se dirige l'entreprise. Actuellement, notre flux de trésorerie prend en compte la date d'échéance des titres enregistrés dans les comptes à payer et à recevoir.",
			"tooltipMessage": "Les lignes de catégories du niveau {{level}} affichent la somme de tous les niveaux regroupés à l'intérieur.",
			"fileName": "flux-de-trésorerie",
			"topActions": {
				"lblAccountName": "Rechercher par Compte",
				"plhAccountName": "Entrez le nom du compte",
				"lblDate": "Filtrer par Expiration",
				"btnPdf": "Exporter en PDF",
				"btnExcel": "Exporter en Excel"
			},
			"totalizers": {
				"income": "Total des revenus",
				"costs": "Total des coûts",
				"expenses": "Total des dépenses",
				"balance": "Total des revenus, coûts et dépenses"
			},
			"rowTotal": "Solde de la période",
			"rowHead": "Solde initial",
			"rowTail": "Solde du jour",
			"viewPerDay": "Visualiser par jour",
			"viewPerMonth": "Visualiser par mois",
			"columns": {
				"income": "Revenus",
				"expenses": "Coûts et dépenses",
				"level": "Niveau",
				"name": "Nom",
				"day": "Jour",
				"month": "Mois"
			},
			"bills": {
				"searchAccountPlaceholder": "Entrez le nom du compte",
				"dueDateFilter": "Filtrer par échéance",
				"exportExcel": "Exporter vers excel",
				"emptyText": "Aucun titre trouvé pour la période sélectionnée.",
				"cards": {
					"receipts": "Revenus",
					"expenses": "Dépenses",
					"finalBalance": "Solde final de la période"
				},
				"columns": {
					"dueDate": "Échéance",
					"description": "Description",
					"counterparty": "Client/Fournisseur",
					"account": "Compte courant",
					"category": "Catégorie",
					"status": "Situation",
					"value": "Valeur"
				},
				"status": {
					"received": "Reçu",
					"paid": "Payé",
					"pending": "Ouvert",
					"overdue": "En retard"
				},
				"openingBalance": "Solde initial",
				"dayBalance": "Solde du jour {{date}}",
				"periodBalance": "Solde de la période"
			}
		},
		"costCenter": {
			"action": "Actions",
			"addCostCenter": "Ajouter un centre de coûts",
			"costCenter": "Centre de coûts",
			"editCostCenter": "Modifier le centre de coûts",
			"name": "Nom",
			"namePlaceholder": "Titulaire du centre de coûts"
		},
		"reports": {
			"graphs": {
				"balance": "Solde",
				"category": "Catégorie",
				"costCenterCaps": "CENTRE DE COÛTS",
				"date": "Date",
				"dateCaps": "DATE",
				"description": "Description",
				"descriptionCaps": "DESCRIPTION",
				"expense": "Dépenses",
				"expenseCaps": "DÉPENSES",
				"expenses": "Dépense",
				"finalBalance": "Solde final",
				"finalBalanceExtract": "Solde final",
				"period": "Période",
				"periodBalance": "Solde sur la période",
				"periodBalanceExtract": "Solde sur la période",
				"previousBalance": "Solde précédent",
				"previousBalanceExtract": "Solde précédent",
				"profit": "Bénéfice de l'exercice",
				"receipt": "Recette",
				"receiptCaps": "RECETTE",
				"receipts": "Recettes",
				"result": "Revenu avant impôt",
				"supplierCaps": "FOURNISSEUR",
				"tax": "Taxe",
				"totalCaps": "TOTAL",
				"totalExpenses": "Total Dépenses",
				"totalPaid": "Total payé",
				"totalReceipts": "Total Recettes",
				"totalReceived": "Total Reçu",
				"type": "Type",
				"typeCaps": "TYPE",
				"until": "jusqu'à",
				"value": "Montant",
				"valueCaps": "MONTANT"
			},
			"noComponent": "Attendez, il sera bientôt disponible",
			"reportNames": {
				"cashFlow": {
					"demonstrative": "Démonstratif",
					"expensses": "Dépenses/Recettes",
					"extract": "Extract",
					"history": "Historique"
				},
				"expense": {
					"perAnything": "Dépenses payées à...",
					"perCategory": "Dépenses par Catégorie",
					"perCostCenter": "Dépenses par Centre de coûts",
					"perDay": "Dépenses par Jour",
					"perDescripion": "Dépenses par Description",
					"perHistory": "Dépenses par Historique",
					"perType": "Dépenses par Type"
				},
				"receipts": {
					"perAnything": "Recettes reçues de...",
					"perCategory": "Recettes par Catégorie",
					"perCostCenter": "Recettes par Centre de coûts",
					"perDay": "Recettes par Jour",
					"perDescripion": "Recettes par Description",
					"perHistory": "Recettes par Historique",
					"perType": "Recettes par Type"
				}
			}
		},
		"viewLevel": "Voir le niveau {{level}}",
		"stockTransferHistory": {
			"titlePage": "Transferts de stock",
			"tabLabel": "Transferts",
			"description": "Ce rapport permet de suivre les mouvements entre les stocks, offrant une visibilité adéquate des transferts pour les gestionnaires de stock et les responsables.",
			"actionButtons": {
				"print": "Imprimer",
				"downloadExcel": "Télécharger en Excel"
			},
			"filterToPeriod": "Filtrer par période",
			"column": {
				"dateTransfer": "Date de transfert",
				"employee": "Employé",
				"outgoingStock": "Stock sortant",
				"incomingStock": "Stock entrant",
				"inputAndProduct": "Intrant/Produit",
				"amount": "Quantité"
			},
			"employeePlaceholder": "Employé",
			"storagePlaceholder": "Stock",
			"searchBy": "Rechercher par"
		}
	},
	"event": {
		"barReports": {
			"bar": "Bar {{name}}",
			"tabs": {
				"chipsBurned": {
					"byEmployee": {
						"label": "Puce brûlées par l'employé",
						"sheetFileName": "puce-brûlées-employee"
					},
					"columns": {
						"count": "Montant",
						"discount": "Réductions",
						"fracionalCount": {
							"grams": "Grammes",
							"kg": "Kilos",
							"label": "Montant fractionné",
							"lt": "Litres"
						},
						"name": "Nom",
						"subtotal": "Sous total",
						"totalValue": "Total",
						"unitaryCount": "Quantité à l'unité",
						"unitaryValue": "Valeur unitairee",
						"type": "Type"
					},
					"label": "Total puces brûlées",
					"loading": "Générer un tableau",
					"mountableModal": {
						"count": "Montant",
						"name": "Nome",
						"section": "Session Combinable"
					},
					"mountables": {
						"category": "Catégorie",
						"count": "Montant",
						"fiscalCode": "SKU",
						"label": "Combinables",
						"name": "Article combinable",
						"product": "Produit",
						"section": "Étape combinable"
					},
					"sheetFileName": "total-puces-brûlées",
					"since": "Depuis",
					"total": "TOTAL",
					"totalItem": "Total",
					"until": "Jusqu'à"
				},
				"consolidatedBarReport": {
					"filter": "Filtrer par type de transaction",
					"label": "Finances par bar",
					"sheet": {
						"fileName": "finances-par-bar",
						"name": "Produit",
						"quantity": "Quantité",
						"title": "Finances par bar",
						"totalDiscount": "Total réduction",
						"totalValue": "Total montant",
						"value": "Montant net",
						"totalTax": "Total de l'impôt",
						"vat": {
							"totalValue": "Valeur TTC",
							"valueWithDiscount": "Valeur avec remise",
							"value": "Valeur HT",
							"totalTax": "Montant de la TVA",
							"totalTaxPercentage": "Pourcentage total de la TVA (%)"
						}
					},
					"total": "Total",
					"paymentMethodReport": {
						"titleBar": "Méthode de paiement au bar",
						"titleEmployee": "Méthode de paiement des employés",
						"info": "Les valeurs de ce rapport peuvent avoir été estimées et il peut donc y avoir de légères différences",
						"sheet": {
							"titleBar": "Méthode de paiement au bar",
							"filenameBar": "methode-paiement-bar",
							"titleEmployee": "Méthode de paiement des employés",
							"filenameEmployee": "methode-paiement-employe"
						},
						"columns": {
							"App": "Application",
							"Cash": "Espèces",
							"DebitCard": "Carte de débit",
							"CreditCard": "Carte de crédit",
							"Voucher": "Bon",
							"ZigPosDebit": "Zig Débit",
							"ZigPosCredit": "Zig Crédit",
							"PostEvent": "Après l'événement",
							"Dashboard": "Tableau de bord",
							"Anticipated": "Anticipé",
							"DeliveryOnline": "Livraison en ligne",
							"Consumption": "Consommation",
							"Ame": "Ame",
							"Rappi": "Rappi",
							"Uber": "Uber",
							"Ifood": "Ifood",
							"Bonus": "Bonus",
							"Pix": "Pix",
							"Opened": "Ouvert",
							"Other": "Autre",
							"ZigPosCreditInInstallments": "Zig Crédit en versements",
							"IntegratedFoodVoucher": "Ticket Restaurant",
							"name": "Nom",
							"total": "Total",
							"MBWay": "MBWay",
							"Cashless": "Cashless"
						}
					}
				},
				"deliveredProductsByBar": {
					"label": "Produits livrés par bar"
				},
				"soldProductReport": {
					"filter": "Filtrer par type de transaction",
					"label": "Production générale de produits",
					"sheet": {
						"count": "Quantité",
						"fileName": "rapport_production_générale_produits",
						"fiscalCode": "SKU",
						"name": "Produit",
						"title": "Production générale de produits"
					}
				},
				"soldProducts": {
					"columns": {
						"category": "Catégorie",
						"count": "Quantité",
						"discount": "Réduction",
						"fiscalCode": "SKU",
						"variable": "variable",
						"devolution": "Dévolution",
						"variableTooltip": "La valeur unitaire des produits à valeur variable est la moyenne des valeurs vendues",
						"fracionalCount": {
							"grams": "grammess",
							"kg": "Kilos",
							"label": "Quantité Fractionnée",
							"lt": "Litres"
						},
						"grossTotalValue": "Total brut",
						"mountable": "Combinable",
						"name": "Nom",
						"net_sales": "Ventes nettes",
						"subtotal": "Sous total",
						"tax_money": "Taxe {{currencySymbol}}",
						"tax_percentage": "% Taxe",
						"totalValue": "Montant total",
						"unitaryCount": "Quantité unitaire",
						"unitaryValue": "Valeur unitaire",
						"operationType": "Opération",
						"type": "Type"
					},
					"downloadAllSales": "Télécharger toutes les ventes",
					"filter": {
						"all": "Tous",
						"balcony": "Balcon",
						"cashless": "Cashless",
						"dashboard": "Tableau de bord",
						"delivery": "Livraison",
						"ficha": "Ticket",
						"grabngo": "Grab n Go",
						"label": "Filtrer par type de transaction",
						"onlineBill": "Facture en ligne",
						"placeholder": "Sélectionner un type de transaction",
						"zigQrCode": "QR Code ZIG"
					},
					"label": "Total des produits vendus",
					"loading": "Générer un tableau",
					"mountableModal": {
						"count": "Quantité",
						"name": "Nom",
						"section": "Session Combinable"
					},
					"mountables": {
						"category": "Catégorie du Produit",
						"count": "Quantité",
						"fiscalCode": "SKU",
						"label": "Combinable",
						"name": "Article combinable",
						"product": "Produit",
						"section": "Étape combinable"
					},
					"selectDate": "Sélectionnez la date",
					"selectTime": "Sélectionnez l'heure",
					"selectTimeTooltip": "Sélectionnez la date avant de sélectionner l'heure",
					"sheetFileName": "total-produits-vendus",
					"since": "Depuis",
					"total": "TOTAL",
					"totalItem": "Total",
					"until": "Jusqu'à"
				},
				"waiterReport": {
					"filter": "Filtrer par type de transaction",
					"label": "Classement des ventes"
				},
				"reprintReport": {
					"title": "Réimpression de cartes",
					"filename": "reimpression-de-cartes",
					"byTransaction": "Par transaction",
					"byProduct": "Par produit",
					"variable": "Variable",
					"variableTooltip": "La valeur unitaire des produits à valeur variable est la moyenne des valeurs vendues",
					"table": {
						"authorizedBy": "Employé autorisant",
						"date": "Date/heure",
						"employee": "Employé connecté",
						"transactionId": "ID de transaction",
						"device": "Machine",
						"product": "Produit",
						"total": "Total",
						"reprintTotal": "Total des réimpressions",
						"reprintProductTotal": "Total des produits réimprimés",
						"authorizedByPassword": "Autorisé par mot de passe",
						"quantity": "Quantité",
						"productName": "Nom du produit",
						"unitValue": "Valeur unitaire",
						"value": "Valeur"
					},
					"tooltipTitle": "Ce rapport n'apportera des données que si le point de vente est à la version 5.0.190 ou supérieure."
				},
				"productReturnsReport": {
					"title": "Retour de produits",
					"product": "Produit",
					"quantity": "QTÉ",
					"returnValue": "Valeur de retour",
					"totalValue": "Total",
					"noRecords": "Aucun enregistrement",
					"noReturnedProducts": "Aucun retour dans cette période",
					"noReturnsThisEvent": "Aucun retour lors de cet événement",
					"productReturnReport": "Rapport de retour de produits",
					"totalReturnedProducts": "Total des produits retournés",
					"productsReturnedByEmployee": "Produits retournés par le personnel",
					"employee": "Employé",
					"summary": "Résumé"
				}
			},
			"undefinedBar": "Bar non défini"
		},
		"booking": {
			"reserve": {
				"bookDetail": {
					"confirmed": "{{count}} confirmé",
					"copyModal": {
						"copy": "Copier",
						"defaultReserveName": "Copie de {{name}}",
						"errors": {
							"inputs": "Les champs n'ont pas été remplis correctement.",
							"length": "Le nom du forfait n'a pas atteint le nombre minimum de caractères.",
							"name": "Le nom du forfait est le même que le nom original."
						},
						"placeholder": "Nom de la copie du orfait",
						"text": "Voulez-vous créer une copie de la sauvegarde",
						"title": "Créer une copie du forfait"
					},
					"delete": "Êtes-vous sûr de vouloir supprimer ce produit ?",
					"guests": "Invités",
					"guestsCount": "{{count}} invités",
					"invoices": "Factures générées",
					"issueInvoice": "Émettre facture",
					"modal": {
						"add": "Ajouter un groupe de taxe",
						"addDiscount": "Ajouter des réductions à la facture",
						"basket": "CEST",
						"chooseOptions": "Choisissez l'une des options",
						"cnpj": "CNPJ",
						"completeValue": "Compléter la montant du forfait",
						"cpf": "CPF",
						"discount": "Réduction",
						"errors": {
							"inputs": "Les champs n'ont pas été remplis correctement",
							"value": "Inclure un produit avec montant pour utiliser cette fonctionnalité"
						},
						"fiscalGroup": "Groupe fiscal",
						"fiscalProfile": "Profil fiscal",
						"inputMultiplePaymentsManual": {
							"add": "Ajouter paiement",
							"label": "Moyen de paiement",
							"placeholder": "Sélectionner",
							"value": "Montant"
						},
						"invoiceAlert": "Les factures d'une valeur supérieure à 2 000 EUR seront fractionnées.",
						"invoiceValue": "Montant de la facture",
						"issueInvoice": "Facture en cours d'émission",
						"ncm": "NCM",
						"none": "Aucun",
						"optionalTip": {
							"add": "Ajouter pourboire",
							"title": "Pourboire (optionnel)"
						},
						"packageValue": "Montant Forfait",
						"paymentMethod": "Moyen de paiement",
						"remove": "Supprimer",
						"removeTip": "Supprimer pourboire",
						"title": "Émettre une facture pour {{name}}",
						"total": "Total",
						"type": "Pourboire",
						"value": "Montant"
					},
					"none": "Aucune promotion sélectionnée",
					"of": "de",
					"peopleArrived": {
						"subtitle": "Déjà sorti",
						"title": "À l'événement"
					},
					"peopleDidntArrive": {
						"subtitle": "Auncune information",
						"title": "Inconnu"
					},
					"promotions": "Forfait Promotions",
					"tableMultiplePayment": {
						"columns": {
							"paymentMethod": "Moyen de paiement",
							"value": "Montant"
						},
						"total": "Total ajouté"
					},
					"title": "Forfait de",
					"value": "Montant du Forfait"
				},
				"create": "Créer un forfait",
				"empty": {
					"subtitle": "Créez votre premier forfait en cliquant sur le bouton ¨Créer un forfait¨ en haut de cette page.",
					"title": "Aucun forfaits pour cet événement"
				},
				"label": "Forfaits",
				"reserveCard": {
					"guests": "{{count}} invités",
					"none": "Aucune promotion sélectionnée",
					"people": "{{count}} personnes confirméesconfirmed people",
					"promotions": "{{count}} promotions"
				},
				"reserveModal": {
					"clientInfo": "Informations client",
					"create": "Créer",
					"edit": "Modifier le forfait",
					"errors": {
						"inputs": "Veuillez remplir tous les champs requis pour la catégorie sélectionnée.",
						"promotion": "Aucune promotion sélectionnée",
						"selectedTemplate": "Le modèle n'a pas pu être trouvé"
					},
					"estimatedPeopleCount": "Nombre d'invités",
					"expiresAt": "Expire dans",
					"inactive": "(Promotion inactive)",
					"modalTitle": {
						"create": "Créer forfait",
						"edit": "Modifier {{name}}",
						"newTemplate": "Créer un Modèle",
						"template": "Créer depui un modèle"
					},
					"models": "Modèles",
					"name": "Nom",
					"newTemplate": "Attention ! Le modèle créé peut être utilisé pour tous les événements dans ce lieu.",
					"promotion": "Promotion",
					"promotionLabel": "Promotion {{number}}",
					"template": "Le forfait peut être personnalisé, mais il créera une association avec le modèle à utiliser dans les rapports et les métriques.",
					"updateModal": {
						"description": "Description",
						"percentage": "Pourcentage",
						"productName": "Nom du produit",
						"promotionName": "Nom de la promotion"
					},
					"value": "Montant Forfait "
				},
				"reserveOptions": {
					"allEvents": "tous les événements",
					"canBeUsedIn": "Peut être utilisé dans",
					"create": {
						"label": "Définissez la manière dont le forfait sera proposé et si vous souhaitez inclure une promotion.",
						"name": "Créer un forfait personnalisé"
					},
					"createTemplate": {
						"label": "Créez un modèle de forfait personnalisé pour l'utiliser ultérieurement lors de vos événements.",
						"name": "Créer un nouveau modèle"
					},
					"createWithTemplate": {
						"label": "Créez un forfait pour vos clients sur la base des modèles créés précédemment.",
						"name": "Créer depuis un modèle"
					},
					"fromThisPlace": "depuis ce lieu",
					"managePackages": "Gérer les forfaits"
				},
				"reserveTemplate": {
					"empty": "Le lieu n'a pas de modèle enregistré.",
					"guests": "Invités",
					"loading": "Chargement ...",
					"modalConfirm": {
						"content": "Il ne peut plus être utilisé pour aucun événement dans ce lieu.",
						"title": "Êtes-vous sûr de vouloir supprimer le modèle ?"
					},
					"promotions": "Promotions",
					"remove": "Supprimer",
					"value": "Montant Forfait"
				},
				"search": "Rechecrher des forfaits"
			},
			"reserveReport": {
				"label": "Rapport Forfait",
				"subtitle": {
					"default": "{{count}} forfaits actif pendant l'événement",
					"none": "Aucun forfait actif pendant l'événement",
					"one": "un forfait actif pendant l'événement"
				}
			}
		},
		"clients": {
			"atEventNameTitle": "à {{eventName}}",
			"details": {
				"ticketByUserReport": {
					"excel": {
						"title": "Contrôle des jetons - {{userName}}",
						"filename": "controle_des_jetons_{{userName}}"
					},
					"columns": {
						"product": "Produit",
						"burnedTickets": "Jetons brûlés",
						"refundedTickets": "Jetons remboursés",
						"purchasedTickets": "Jetons achetés"
					},
					"emptyState": {
						"title": "Aucun jeton consommé",
						"description": "L'utilisateur n'a pas encore acheté de jeton"
					}
				},
				"bonusAndDiscounts": {
					"bonus": {
						"columns": {
							"date": "Date",
							"givenBy": "Donné par",
							"reason": "Motif",
							"totalValue": "Montant reçu",
							"usedValue": "Montant dépensé"
						},
						"label": "Bonus"
					},
					"discounts": {
						"columns": {
							"date": "Date",
							"givenBy": "Donné par",
							"percentage": "Pourcentage",
							"reason": "Motif",
							"value": "Réduction"
						},
						"label": "Réductions"
					},
					"sheet": {
						"bonus": {
							"clientTitle": "Bonus de {{client}}",
							"columns": {
								"date": "Date",
								"givenBy": "Donné par",
								"reason": "Motif",
								"totalValue": "Montant reçu",
								"usedValue": "Montant dépensé"
							},
							"title": "Bonus"
						},
						"discount": {
							"clientTitle": "Réduction de {{client}}",
							"columns": {
								"date": "Date",
								"givenBy": "Donné par",
								"percentage": "Pourcentage",
								"reason": "Motif",
								"value": "Réduction"
							},
							"title": "Réductions"
						},
						"fileName": "réductions-et-bonus"
					}
				},
				"clientDetails": "Données client",
				"confirm": "Êtes-vous sûr de vouloir modifier les informations relatives à ce client ?",
				"consolidatedHistory": {
					"action": "Action",
					"balance": "Solde",
					"bonusAndConsumption": "Consommation/Bonus",
					"consumption": "Consommation",
					"consumptionObligations": "Montant minimum de consommation",
					"consumptionObligationsNotUsed": "Reliquat",
					"discount": "Réduction",
					"formatters": {
						"attachCount": "Cartes ZIG rattachées",
						"bonusReceived": "Bonus reçu",
						"consumptionObligations": "Consommations minimum",
						"consumptionObligationsNotUsed": "Reliquat minimum",
						"entrances": "Entrées",
						"minimumConsumptionUsed": "Consommation utilisée",
						"notSyncRecharges": "Rechargements non synchronisés",
						"notUsedMinimumConsumption": "Consommation non utilisée",
						"notUsedRecharges": "Rechargement non utilisé",
						"openedBill": "Factures ouvertes",
						"openedBillPayments": "Paiement des comptes ouverts",
						"packages": "Forfaits",
						"paymentsInEvent": "Paiements à l'événement",
						"paymentsInOtherEvents": "Paiements lors d'autres événements",
						"postPaidLimitChanged": "Modification de la limite post payée",
						"productRefunds": "Remboursement produits",
						"products": "Produits",
						"promotionsUsed": "Promotions utilisées",
						"rechargeDevolutions": "Rechargements remboursés",
						"rechargeDevolutionsFromOtherEvents": "Rechargements remboursés depuis un autre événement",
						"rechargesFromOtherEvents": "Rechargements d'autres événements",
						"rechargesInEvent": "Rechargement à l'événement",
						"removedTip": "Pourboires supprimés",
						"tip": "Pourboires",
						"bonusPayments": "Paiement avec bonus restant",
						"singleProductReturns": "Retour produit"
					},
					"isShared": "-(shared)",
					"label": "Historique consolidé",
					"method": "Moyens",
					"name": "Nom",
					"others": "Autres",
					"payments": "Paiements",
					"printInfo": "Imprimer Information",
					"product": "Produit",
					"qntt": "Qté.",
					"quantity": "Quantité",
					"recharges": "Rechargements",
					"totalConsumption": "Total consommation",
					"totalValue": "Montant",
					"unknown": "Inconnu",
					"value": "Montant",
					"toolTipMarketPlaceDiscount": "Remise du delivery (ifood, rappi, etc.). Remise sur la valeur totale du commande."
				},
				"data": {
					"at": "à",
					"birthDate": "Date de naissance",
					"checkIn": "Enregistrement",
					"checkOut": "Départ",
					"cpf": "CPF",
					"email": "Email",
					"hasApp": "HA l'Application",
					"noEmail": "Auncun email enregistré",
					"noPhone": "Aucun téléphone enregistré",
					"noRegistry": "Aucun registre",
					"notDefined": "N'a pas eu lieu",
					"notRegistered": "Date non enregistrée",
					"phone": "Téléphone",
					"remaningValue": "Solde disponible sur place",
					"clientsAtTag": "Nombre de clients à table"
				},
				"downloadTable": {
					"actions": {
						"columns": {
							"attachCount": "Cartes ZIG rattachées",
							"date": "Date",
							"packages": "Forfaits",
							"postPaidLimitChanged": "Limite post payé modifiée",
							"productRefunds": "Produits remboursés",
							"promotionsUsed": "Promotions utilisée",
							"removedTips": "Pourboires supprimés"
						},
						"title": "Actions"
					},
					"bonusAndConsumption": {
						"columns": {
							"bonusReceived": "Bonus reçu",
							"consumptionUsed": "Consommation utilisée",
							"date": "Date",
							"notUsedConsumption": "Consommation non utilisée"
						},
						"title": "Bonus and Consumption"
					},
					"consumption": {
						"columns": {
							"date": "Date",
							"entrances": "Entrées",
							"products": "Produits",
							"service": "Service",
							"totalConsumption": "Total Consommation"
						},
						"title": "Consommation"
					},
					"fileName": "historique-consolidé",
					"payments": {
						"columns": {
							"date": "Date",
							"openedBill": "Factures ouvertes",
							"paymentsInEvent": "Paiements dans l'évément",
							"paymentsInOtherEvents": "Paiements dans d'autres événements",
							"bonusPayments": "Paiement avec bonus restant"
						},
						"title": "Paiements"
					},
					"recharges": {
						"columns": {
							"date": "Date",
							"notSynchRecharges": "Rechargements non synchronisés",
							"notUsedRecharges": "Rechargements non utilisés",
							"rechargeDevolutions": "Remboursement des rechargements",
							"rechargesFromOtherEvents": "Rechargements dans d'autres événements",
							"rechargesInEvent": "Rechargements dans l'événement"
						},
						"title": "Rechargements"
					}
				},
				"edit": "Modifier",
				"fiscalNotes": {
					"at": "at",
					"cancelInvoice": {
						"okText": "Oui, annuler la facture",
						"title": "Êtes-vous sûr de vouloir annuler la facture ?"
					},
					"columns": {
						"links": "Liens",
						"status": "Statut",
						"time": "Date/Heure",
						"type": "Type"
					},
					"emit": "Émettre facture",
					"empty": "Aucune facture client pour la période sélectionnée.",
					"generate": "À générer {{type}}",
					"image": "Image",
					"invoiceStatus": {
						"canceled": "Facture annulée",
						"error": "Erreur lors de l'émission de",
						"issued": "Facture émise",
						"issuing": "Facture en cours d'émission"
					},
					"label": "Factures",
					"modalError": {
						"content": "Contactez le service d'assistance et signalez cette erreur",
						"error": "Erreur",
						"title": "Description de l'erreur"
					},
					"mode": {
						"nfe": "NF-e",
						"nfse": "NFS-e",
						"nfsen": "NFS-e Nacional",
						"nfce": "NFC-e",
						"sat": "SAT"
					},
					"send": "Envoyer la facture email",
					"showError": "Voir erreur"
				},
				"goBack": "RETOUR",
				"invoices": {
					"alert": "Si vous souhaitez regrouper les factures d'autres clients avec celles déjà sélectionnées, il suffit de les ajouter ci-dessous",
					"client": "Client",
					"cnpj": "CNPJ",
					"cnpjPlaceholder": "Saisir le CNPJ",
					"count": "Quantité",
					"cpf": "CPF",
					"cpfPlaceholder": "Saisir le CPF",
					"date": "Date et heure",
					"discountValue": "Réduction",
					"empty": "Il n'y a pas de transactions à émettre.",
					"id": "Transaction",
					"issueTo": "Émise pour",
					"nif": "NIF",
					"nifPlaceholder": "Saisir le NIF",
					"generateServiceFee": "Générer la taxe de service proportionnelle",
					"noCPForCNPJ": "Émission sans CPF et sans CNPJ",
					"noNIF": "Émission sans NIF",
					"otherCNPJ": "Émettre pour un autre CNPJ",
					"otherCPF": "Émettre pour un autre CPF",
					"otherNIF": "Émettre pour un autre NIF",
					"products": "Produits",
					"razaoSocial": "RAZÃO SOCIAL",
					"inscricaoEstadual": "INSCRIÇÃO ESTADUAL",
					"indicadorInscricaoEstadual": "INDICADOR INSCRICÃO ESTADUAL",
					"indicadorInscricaoEstadualOptions": {
						"ContribuinteICMS": "Contribuinte ICMS",
						"ContribuinteIsento": "Contribuinte Isento",
						"NaoContribuinte": "Não contriibuinte",
						"none": "Não informar"
					},
					"shouldAddAddressQuestion": "Adicionar endereço do tomador?",
					"issueWithAdress": "Sim, adicionar endereço do tomador",
					"issueWithoutAdress": "Não, emitir sem endereço",
					"infoCNPJSection": "Dados do CNPJ",
					"addressSection": "Endereço",
					"address": {
						"cep": "CEP",
						"logradouro": "logradouro",
						"numero": "numero",
						"bairro": "bairro",
						"municipio": "municipio",
						"uf": "UF",
						"complemento": "complemento"
					},
					"steps": {
						"buyers": "Acheteurs",
						"consumption": "Consommation minimale non émise",
						"emission": "Émission",
						"transactions": "Transactions non émises",
						"receipientExtraInfo": "Informations Complémentaires"
					},
					"totalNotissued": "Total non émis",
					"unitValue": "Montant Total",
					"value": "Montant",
					"valueToEmit": "Montant à émettre"
				},
				"issueNotes": "Émission Factures",
				"consummationGiven": "Consummation donnée",
				"rechargesReturned": "Recharges retournées",
				"singleProductReturns": "Retour de produits",
				"refundedPostPayments": "Annulation de paiement",
				"paymentMethods": {
					"ame": "Ame",
					"anticipated": "Anticipé",
					"app": "Application",
					"cash": "Espèces",
					"creditCard": "Crédit",
					"dashboard": "Tableau de bord",
					"debitCard": "Débit",
					"deliveryOnline": "Livraison en ligne",
					"foodVoucher": "Ticket Restaurant",
					"ifood": "Ifood",
					"installment": "Versement",
					"noMethod": "Non informé",
					"pix": "Pix",
					"postEvent": "Post-événement",
					"rappi": "Rappi",
					"total": "Total",
					"uber": "Uber",
					"voucher": "Voucher",
					"zigPosCredit": "Post crédit ZIG",
					"zigPosDebit": "Post débit ZIG",
					"online": "Online",
					"mbway": "Mbway"
				},
				"printable": {
					"author": "Créé par",
					"bonus": "Bonus",
					"cashier": "Caisse",
					"count": "Quantité",
					"cpf": "cpf",
					"date": "Date",
					"discount": "Réduction",
					"email": "Email",
					"expired": "Expiré",
					"method": "Moyen",
					"name": "Nom",
					"paidBill": "facture payée",
					"payers": "Payeurs",
					"paymentMethod": "Moyen de paiement",
					"payments": "Paiements",
					"phone": "Téléphone",
					"products": "Produits",
					"purchase": "Achat",
					"recharge": "Rechargement",
					"refunded": "Remboursé",
					"service": "Service",
					"shared": "Partagé",
					"total": "Total",
					"totalProducts": "Total ({{count}} Produits)",
					"unavailable": "Indisponible",
					"used": "Utilisé",
					"value": "Montant",
					"zigcode": "Code ZIG"
				},
				"sendByEmail": {
					"datetime": "Date/Heure",
					"email": "Email",
					"invoices": "Factures",
					"nfce": "Consommation (NFC-e)",
					"nfse": "Service (NFS-e)",
					"sat": "Consommation (SAT)",
					"sendEmail": "Envoyer email",
					"sendInvoucesByEmail": "Envoyer les factures par email",
					"type": "Type"
				},
				"sheet": {
					"actions": {
						"columns": {
							"method": "Type",
							"value": "Montant"
						},
						"title": "Actions"
					},
					"consumption": {
						"columns": {
							"count": "Quantité",
							"name": "Nom",
							"value": "Montant"
						},
						"title": "Consommation"
					},
					"fileName": "historique-consolidé",
					"payments": {
						"columns": {
							"method": "Type",
							"value": "Montant"
						},
						"title": "Paiements"
					},
					"recharges": {
						"columns": {
							"method": "Moyen",
							"value": "Montant"
						},
						"title": "Rechargements"
					},
					"summary": {
						"bonusReceveid": "Bonus reçus",
						"columns": {
							"method": "Type",
							"value": "Montant"
						},
						"entrances": "Entrées",
						"minimumConsumptionUsed": "Consommation utilisée",
						"notSyncRecharges": "Rechargements non synchronisés",
						"notUsedMinimumConsumption": "Consommation non utilisé",
						"notUsedRecharges": "Rechargements non utilisés",
						"openedBill": "Factures ouvertes",
						"payments": "Paiements",
						"paymentsInOtherEvents": "Paiements dans d'autres événements",
						"products": "Produits",
						"rechargeBalance": "Solde rechargé",
						"rechargeDevolutions": "Remboursement rechargement",
						"recharges": "Rechargements",
						"rechargesFromOtherEvents": "Rechargements dans d'autres événements",
						"service": "Service",
						"title": "Synthèse",
						"totalConsumption": "Total Consommation",
						"bonusPayments": "Paiement avec bonus restant",
						"marketPlaceDiscount": "Remise du delivery"
					},
					"transactionalHistory": {
						"filter": "Filtrer par",
						"filterPlaceholder": "Saisir ou sélectionner les types de transactions",
						"columns": {
							"transaction": "transaction",
							"seller": "vendeur",
							"cardNumber": "Numéro de carte",
							"value": "montant",
							"id": "id",
							"time": "heure de la transaction",
							"sync": "synchronisation",
							"zigCode": "zigTag",
							"bonusCategoryName": "catégorie bonus"
						}
					},
					"consumptionHistory": {
						"title": "Historique de Consommation",
						"consumption": "Consommation",
						"servicePaidOnEvent": "Service Payé à l'Événement",
						"amountConsumption": "Consommation Totale",
						"columns": {
							"date": "Date",
							"type": "Type",
							"item": "Article",
							"qtd": "Qté",
							"value": "Valeur",
							"discountValue": "Remise"
						}
					},
					"withoutInfo": "Aucune information à afficher",
					"noCard": "Pas de carte"
				},
				"tabs": {
					"bonusAndDiscounts": "Bonus et Réductions",
					"debtorsReport": "Factures ouvertes",
					"ticketsByUserReport": "Contrôle des jetons"
				},
				"transactionalHistory": {
					"acquirerModal": {
						"acquirer": "Acquéreur",
						"cardHolderName": "Nom du titulaire de la carte",
						"cardHolderNumber": "Carte",
						"notKnown": "Inconnu",
						"paidAmount": "Montant de la ransaction",
						"transactionType": "Type de transaction",
						"unknown": "Inconnu",
						"urlLabel": "url"
					},
					"employee": "Vendeur",
					"event": "Événement",
					"export": "Exporté sous format Excel",
					"formatters": {
						"appPrePayment": "Prépaiement via app",
						"attach": "Enregistrement de la carte",
						"attachToReserve": "Inclusion dans le forfait",
						"bonus": "Bonus",
						"changePostLimit": "Modification de la limite",
						"consumeRecharge": "Remboursement du rechargement",
						"consumptionObligation": "Consommation minimum",
						"detachAndRefundActivation": "retour de carte",
						"discount": "Réduction",
						"entranceTransaction": "Entrée",
						"minimumConsumption": "Consommation",
						"postPayment": "Paiement",
						"productTransaction": "Achat",
						"promotion": "Promotion obtenue",
						"recharge": "Rechargement",
						"refundRecharge": "Remboursement de rechargement",
						"refundTransaction": "Remboursement",
						"sharedTransaction": "Paiement partagé",
						"tipRemoval": "Pourboire supprimé",
						"zigCardPixRefund": "Remboursement de Pix",
						"transferConsumptionObligation": "Obligation de transfert de consommation",
						"singleProductReturn": "Retour produit",
						"refundPostPayment": "Remboursement de paiement"
					},
					"value": "Montant",
					"id": "ID",
					"hour": "Heure",
					"label": "Historique des transactions",
					"loading": "Chargement...",
					"paymentTable": {
						"acquirer": "Acquéreur",
						"cpf": "CPF",
						"method": "Moyens",
						"name": "Payeurs",
						"value": "Montant"
					},
					"productTable": {
						"name": "Produit",
						"value": "Montant",
						"count": "Qté.",
						"discountValue": "Réduction",
						"total": "TOTAL",
						"totalValue": "Montant final",
						"transferFrom": "Transféré de",
						"transferTo": "Transféré à",
						"details": "Détails",
						"item": "Article",
						"section": "Étape"
					},
					"refundTable": {
						"count": "Qté.",
						"name": "Produit"
					},
					"service": "Service",
					"marketPlaceDiscount": "Remise du delivery",
					"toolTipMarketPlaceDiscount": "Remise du delivery (ifood, rappi, etc.). Remise sur le montant total de la commande.",
					"sheet": {
						"date": "Date",
						"employee": "Vendeur",
						"cardNumber": "Numéro de carte",
						"fileName": "Historique-transactions-de-",
						"hour": "Heure",
						"id": "ID",
						"in": "-in-",
						"operation": "Opération",
						"title": "Historique de transactions de {{user}} à {{event}}",
						"value": "Montant",
						"bonusCategoryName": "catégorie bonus"
					},
					"unknown": "Inconnu"
				}
			},
			"errorCountIssuedInvoice": "un type d'erreur a été rencontré lors de l'émission des facture",
			"errorCountIssuedInvoices": "des types d'erreurs ont été rencontrés lors de l'émission des notes",
			"fileTitle": "Les clients de l'événement {{eventName}} {{eventDate}}",
			"filename": "clients_de_événement_{{eventName}}_{{eventDate}}",
			"issueAllInvoicesButton": "Émettre toutes les factures",
			"issueLoading": "Émission des factures...",
			"issuedInvoice": "la facture a été émise avec suucès",
			"issuedInvoices": "les factures ont été émises avec succès",
			"onlyClientsCheckbox": "Clients avec des factures non émises",
			"period": "Période",
			"searchPlaceholder": "Recherche par nom, CPF ou téléphone",
			"table": {
				"appTransactionsValue": "Payé avec app",
				"bonusTransactionsValue": "Payé avec bonus",
				"checkInTime": "Heure d'entrée",
				"checkOutTime": "Heure de départ",
				"document": "CPF",
				"housePostPaidTransactionsValue": "Post payé dans le lieu",
				"housePrePaidTransactionsValue": "Paiement direct dans le lieu",
				"name": "Nom",
				"noDataText": "Aucune donnée à afficher.",
				"phone": "Téléphone",
				"total": "Total"
			},
			"thisEventTitle": "dans cet événement",
			"title": "Clients",
			"until": "Jusqu'à"
		},
		"conference": {
			"title": "Conférence d'événement",
			"eventOpen": "Ouvrir l'événement",
			"closeEventToConference": "Vous devez clôturer l'événement pour tenir la conférence",
			"titleTypeOfConference": {
				"resumed": "Tableau récapitulatif",
				"integratedIncome": "Frais sur les applications intégrées et les machines (crédit/débit)",
				"notIntegratedIncome": "Frais sur les terminaux de paiement non intégrés (crédit/débit)",
				"zigFees": "Frais Zig",
				"securityDeposit": "Dépôt de garantie",
				"otherCharges": "Autres frais",
				"rechargeRefund": "Remboursement de recharge"
			},
			"columnsTable": {
				"name": "Nom",
				"grossValue": "Valeur brute",
				"tax": "Taxe",
				"taxReceivedOrPayable": "Zig à recevoir / à payer",
				"receiptForecast": "Prévisions de réception"
			},
			"conference": "Conférence",
			"processConference": "Traiter la conférence"
		},
		"entranceBilling": {
			"tabs": {
				"boxOfficeBilling": {
					"filename": "facturation_billet",
					"label": "Facturation Billet",
					"percentage": "pourcentage",
					"quantity": "quantité",
					"revenue": "recettes",
					"value": "montant"
				},
				"entranceReport": {
					"columns": {
						"count": "Quantité",
						"discountValue": "Réduction",
						"entrance": "Entrée",
						"name": "Nom",
						"subtotal": "Sous total",
						"totalValue": "Montant Total",
						"unitValue": "Valeur unitaire"
					},
					"filename": "billets-vendus-par-employés",
					"label": "Billets vendus par les employés",
					"sheet": {
						"count": "Quantité",
						"discountValue": "Réduction",
						"fileName": "entrée",
						"name": "Nom",
						"subtotal": "Sous total",
						"title": "Entrée",
						"totalValue": "Montant total",
						"unitValue": "Valeur unitaire"
					},
					"total": "Total",
					"totalCategory": "Total ({{category}})"
				},
				"pageTabs": {
					"boxOffice": "Recettes",
					"soldEntrances": "Billets Vendus",
					"employeeReport": "Billets par Employé"
				},
				"soldEntrances": {
					"clientsReport": {
						"title": "Liste des Clients par Billet Vendu",
						"filterLabel": "Filtrer par Billet Vendu",
						"filterPlaceholder": "Ajouter des filtres par billet",
						"clients": "Clients",
						"entranceValue": "Valeur du Billet",
						"consumption": "Consommation",
						"total": "Total",
						"name": "Nom",
						"document": "Document",
						"entrance": "Billet",
						"checkin": "Enregistrement",
						"checkout": "Check-out",
						"fileName": "clients-par-billet-vendu_{{date}}"
					},
					"columns": {
						"averageValue": "Prix moyen",
						"count": "Unités vendues",
						"name": "Nom",
						"totalValue": "Total"
					},
					"filter": "Filtrer par heure",
					"label": "Total Billets vendus",
					"sheet": {
						"average": "Montant moyen",
						"count": "Quantité",
						"fileName": "billets vendus",
						"name": "Nom",
						"title": "Billets vendus",
						"totalValue": "Prix"
					},
					"since": "depuis",
					"tabs": {
						"total": "Total",
						"clients": "Clients par Billet"
					},
					"total": "Total recettes",
					"until": "jusqu'à"
				}
			}
		},
		"eventReports": {
			"afterClosingEvent": {
				"columns": {
					"customerName": "Nom de l'utilisateur",
					"date": "Date/Heure de synchronisation",
					"employee": "Employé",
					"origin": "origine",
					"transactionType": "Type de Transaction",
					"value": "Montant"
				},
				"description": "Signaler les actions ou les transactions après la clôture de l'événement.",
				"filterOriginLabel": "Visualiser",
				"filterTransactionLabel": "Filtrer par type de transaction",
				"historyMachineAfterClosingLabel": "Historique après la clôture",
				"historyMachineLabel": "History machine",
				"offlineActionLabel": "After closing",
				"optionAll": "All transactions",
				"optionHistoryMachine": "Transactions machine's history",
				"optionHistoryMachineAfterClosing": "Historique des transactions du terminal après la clôture de l'événement",
				"optionOfflineAction": "Transactions synchronisées après la clôture de l'événement",
				"searchLabel": "Recherche par nom d'employé",
				"searchPlaceHolder": "Saisir le nom de l'employé",
				"title": "Actions synchronisées après l'événement"
			},
			"cashierClosings": {
				"all": "Tous",
				"balanceTitle": "Recettes par caissier",
				"balanceTitleDay": "Recettes par caissier le {{day}}",
				"card": {
					"bleeding": "Retrait de caisse",
					"cardDevolution": "Retour carte",
					"productDevolution": "Retours de produit",
					"cash": "Espèces",
					"casher_one": "{{numberOfCashiers}} Caisse",
					"cashier_other": "{{numberOfCashiers}} Caisses",
					"changeFund": "Fonds de roulement",
					"closed": "Clôturée",
					"difference": "Différence",
					"modality": "Modalité",
					"noFlag": "Pas d'Indicateur",
					"notClosed_one": "({{numberOfOpenCashiers}} non clôturée)",
					"notClosed_other": "({{numberOfOpenCashiers}} non clôturées)",
					"open": "Ouvert",
					"received": "Facturé",
					"rechargeDevolutions": "Remboursement du rechargement",
					"total": "TOTAL",
					"xlsx": {
						"cashier": "Caisse",
						"closed": "Clôturée",
						"closingCashier": "Clôture par Caisse",
						"closingResume": "Synthèse Clôture",
						"difference": "Différence",
						"filename": "clôture-par-caisse-dans-lieu",
						"filenameEvent": "clôture-par-caisse-{{eventDate}}",
						"modality": "Modalité",
						"received": "Facturé"
					}
				},
				"cashier": "Caisse",
				"filenameBalance": "Recette_par_caisse",
				"header": {
					"addBleed": "Ajouter Retrait de caisse",
					"addChange": "Ajouter Fonds de roulement",
					"addObs": "Ajouter un commentaire",
					"cashierHistory": "Visualiser Historique de caisse",
					"closeCashier": "Êtes-vous sûr de vouloir fermer la caisse {{cashierName}} ??",
					"closeCashierButton": "Clôturer Caisse",
					"historyTitle": "Historique de caisse - {{cashierName}}",
					"obs": "Commentaire",
					"reopenCashier": "Êtes-vous sûr de vouloir rouvrir la caisse ?",
					"reopenCashierButton": "Rouvrir Caisse",
					"transactionalHistory": "Visualiser Historique des transactions"
				},
				"info": {
					"addNewModality": "Ajouter nouvelle modalité",
					"billed": "Facturé",
					"bleeding": "Retrait de caisse",
					"bleeds": "Retraits de caisse",
					"cancel": "Annuler les modifications",
					"cardDevolution": "Retour Carte",
					"cashierNotClosed": "Caisse non clôturée",
					"cashierReceipt": "Revenu par caisse",
					"cashier_one": "caisse",
					"cashier_other": "caisse",
					"changeFund": "Fonds de roulement",
					"changes": "Modifications",
					"closeCashier": "Clôturer Caisse",
					"closed": "Clôturée",
					"closingCashier": "Clôture Caisse",
					"createBleed": "Créer un Retrait de caisse",
					"createChange": "Ajouter un Fonds de roulement",
					"devolutions": "Retournée",
					"modality": "Modalité",
					"negative": "Différence",
					"notClosed": "non clôturée",
					"rechargeDevolutions": "Remboursements de rechargement",
					"save": "Sauvegarder le clôture",
					"searchCashier": "Rechercher Caisse par nom",
					"totalBilled": "Total Facturé",
					"totalClosed": "Total Clôturé"
				},
				"modal": {
					"addFlag": "Ajouter un Indicateur",
					"cashierPosts": "Transactions post-payées",
					"cashierRecharges": "Rechargements",
					"cashiers": "Caisse",
					"changeFund": "Fonds de roulement",
					"column": {
						"author": "Employé",
						"client": "Client",
						"clients": "Client(s)",
						"cardNumber": "ZigTag",
						"date": "Date",
						"method": "Moyens",
						"obs": "Commentaire",
						"payments": "Paiements",
						"serialNumber": "Numéro de série",
						"total": "Total",
						"valueComsumed": "Montant consommé",
						"valueRecharged": "Montant rechargé"
					},
					"history": "Historique",
					"historyTitle": "Historique de {{name}}",
					"refundPayment": "Remboursement de paiement",
					"saveValues": "Sauvegarde des montants",
					"value": "Montant"
				},
				"valueGreaterThanZero": "Le montant doit être supérieur à 0",
				"value": "Montant",
				"noCard": "Pas de carte",
				"noCashierSelected": "Aucune caisse sélectionnée",
				"paymentMethod": {
					"ame": "Ame",
					"anticipated": "Anticipé",
					"bonus": "Bonus",
					"cash": "Espèces",
					"credit": "Crédit",
					"dashboard": "Tableau de bord",
					"debit": "Débit",
					"deliveryOnline": "Livraison en ligne",
					"devolution": "Retours",
					"foodVoucher": "Ticket Restaurant",
					"ifood": "Ifood",
					"installment": "Versement",
					"pix": "Pix",
					"postEvent": "Payé après l'événement",
					"rappi": "Rappi",
					"subtotal": "Sous total",
					"total": "Total",
					"uber": "Uber",
					"voucher": "Voucher",
					"zigCredit": "Credit ZIG",
					"zigDebit": "Débit ZIG",
					"online": "En ligne",
					"mbway": "MBWay"
				},
				"postPaid": "Transactions post payées",
				"recharges": "Rechargements",
				"total": "Total",
				"transactionsTitle": "Historique de {{name}}"
			},
			"debtorsReport": {
				"modal": {
					"addPayment": "Ajouter paiement",
					"bonus": "Payer avec bonus",
					"cash": "Espèces",
					"column": {
						"bonus": "Bonus",
						"value": "Montant"
					},
					"confirm": "Confirmer",
					"creditCard": "Carte de crédit",
					"debitCard": "Carte de débit",
					"eventScope": "événement",
					"multiplePaymentConfirm_part1": "Ce paiement ",
					"multiplePaymentConfirm_part2": "va payer {{value}}",
					"multiplePaymentConfirm_part3": "du client dans {{scope}}, êtes-vous sûr de vouloir faire cela ?",
					"multiplePaymentError": "Attention ! Ajouter un moyen de paiement",
					"no": "Non",
					"observation": "Commentaire",
					"observationPlaceholder": "Ajouter un commentaire",
					"openConsumption": "Consommation ouverte",
					"pay": "Payer",
					"paymentConfirm_part1": "Ce paiement",
					"paymentConfirm_part2": "va payer TOUTE les dettes du client",
					"paymentConfirm_part3": "dans {{scope}}, êtes-vous sûr de vouloir faire cela ?",
					"paymentConsumption": "Payer en consommation",
					"paymentMethod": "Moyen de paiement",
					"paymentMethodError": "Sélectionner un moyen de paiement",
					"paymentService": "Paiement en pourboire",
					"placeScope": "Lieu",
					"postEvent": "Marqué comme payé",
					"reason": "Motif",
					"reasonPlaceholder": "Ajouter le motif du Bonus",
					"select": "Sélectionner",
					"service": "Pourboire ({{tip}}%)",
					"submitError": "Il n'est possible de surpayer que jusqu'à 25 % du montant total dû.",
					"total": "Total",
					"voucher": "Voucher",
					"yes": "Oui",
					"discharge": "Décharge"
				},
				"title": "Comptes ouverts",
				"alertTitleOpenBill": "Il n'est pas possible d'envoyer des factures dans le rapport de l'événement",
				"alertMessageOpenBill": "Pour envoyer des factures, accédez au menu [Lieux] > sélectionnez le lieu > menu [Rapports Financiers] > onglet 'Comptes en attente' et utilisez le lien dans la colonne 'Facturer'."
			},
			"individualLimitPost": {
				"columns": {
					"client": "Client",
					"date": "Date",
					"employeeName": "Employé",
					"emptyText": "Aucune donnée à afficher.",
					"limit": "Augmentation du plafond",
					"newLimite": "Nouveau plafond",
					"username": "Utilisateur"
				},
				"filename": "Rapport_modification_plafond_individuel_dépôt",
				"searchPlaceholder": "Recherche par utilisateur, identifiant ou nom",
				"title": "Informations clients",
				"titleTab": "Modification du plafond individuel du dépôt"
			},
			"minimumConsumption": {
				"title": "Consommation anticipée"
			},
			"openedBillPayment": {
				"columns": {
					"client": "Client",
					"employeeName": "Payé pour",
					"method": "Moyen",
					"openedEventDate": "Date d'ouverture du compte",
					"value": "Montant",
					"document": "Document",
					"tipValue": "Montant du pourboire"
				},
				"filename": "rapport_des_paiements_de_comptes_ouverts_dans_événement",
				"title": "Paiements du compte ouvert"
			},
			"rappiDiscounts": {
				"columns": {
					"date": "Date",
					"employee": "Employé ayant appliqué la réduction",
					"products": "Produits",
					"value": "Montant Réduction"
				},
				"filename": "rapport_réduction_rappi",
				"rappiDiscounts": "Réduction Rappi",
				"title": "Réductions Rappi"
			},
			"rechargeConsumption": {
				"columns": {
					"ame": "Ame",
					"anticipated": "Anticipé",
					"author": "Caisse",
					"cash": "Espèces",
					"client": "Client",
					"credit": "Crédit",
					"dashboard": "Tableau de bord",
					"debit": "Débit",
					"deliveryOnline": "Livraison en ligne",
					"ifood": "Ifood",
					"method": "Moyen",
					"pix": "PIX",
					"rappi": "Rappi",
					"total": "Total",
					"uber": "Uber",
					"value": "Montant",
					"voucher": "Voucher",
					"integratedFoodVoucher": "Chèque-repas",
					"zigPosCreditInInstallments": "Crédit à tempérament"
				},
				"detailDialog": "Visualiser le rechargement remboursé par le caissier",
				"filename": "remboursement-rechargement",
				"rechargesRefundedBy": "Rechargement remboursé par {{author}}",
				"title": "Remboursement du rechargement"
			},
			"refunded": {
				"columns": {
					"canceled": "Annulé",
					"category": "Catégorie",
					"clients": "Clients",
					"count": "Quantité",
					"date": "Date",
					"moreRefundedBuyer_other": "et plus de {{buyers}} personnes",
					"moreRefundedBuyer_one": "et plus de {{buyers}} personne",
					"name": "Nom du produit",
					"refundObs": "Commentaires",
					"reason": "Raison",
					"refunded": "Remboursé",
					"refundedBy": "remboursé par",
					"soldBy": "Vendu par",
					"totalCount": "Montant total",
					"totalRefunded": "Total ({{total}} remboursé)",
					"totalValue": "Montant Total",
					"type": "Type",
					"value": "Montant",
					"operationType": "Opération"
				},
				"filename": "produits-remboursés",
				"title": "Produits remboursés/annulés"
			},
			"resumeReport": {
				"fileName": "facturation-{{eventName}}",
				"finished": {
					"end": "Clôturé : {{end}}h",
					"not": "L'événement n'est pas clôturé"
				},
				"reportIn": "Facturation de l'événement '{{eventName}}'",
				"title": "Resume"
			},
			"servicesRemoval": {
				"clientInfo": "Information Client",
				"columns": {
					"date": "Date",
					"name": "Client",
					"reason": "Motif",
					"total": "Total Supprimé",
					"value": "Montant",
					"employee": "Employé"
				},
				"goTo": "allez à",
				"title": "Suppression des pourboires par le caissier",
				"titlePrint": "Pourboires supprimés"
			},
			"tabs": {
				"storageV2": {
					"tabs": {
						"products": {
							"transferDrawer": {
								"title": "Transférer le produit du stock {{productName}}",
								"form": {
									"label": {
										"product": "Produit",
										"fromStorage": "Retirer des produits du stock",
										"toStorage": "Transférer des produits vers le stock",
										"quantity": "Quantité à transférer"
									},
									"placeholder": {
										"toStorage": "Sélectionner le stock"
									},
									"hint": {
										"maxQuantity": "Maximum disponible : {{maxQuantity}}"
									},
									"sectionTitle": {
										"chooseDestination": "Choisissez le stock de destination"
									},
									"validation": {
										"maxStorageCountIs": "La quantité maximale en stock est {{productMaxCountString}}",
										"missingField": "Champ obligatoire",
										"invalidQuantity": "Quantité invalide"
									}
								},
								"actions": {
									"cancel": "Annuler",
									"submit": "Terminer le transfert"
								},
								"notifications": {
									"success": "Transfert effectué avec succès."
								}
							},
							"removeProductFromStorageDialog": {
								"title": "Supprimer le produit",
								"warningMessageSingle": "Êtes-vous sûr de vouloir supprimer le produit {{productName}} du stock ?",
								"warningMessageMultiple": "Êtes-vous sûr de vouloir supprimer les {{count}} produits du stock ?",
								"warningMessageStrong": " Cette action ne peut pas être annulée",
								"submit": "Supprimer le produit",
								"notifications": {
									"success": "Produit supprimé du stock avec succès."
								}
							}
						}
					}
				},
				"afterClosingEvent": "Actions synchronisées après l'événement",
				"bonusByProduct": "Bonus par produit",
				"cashierClosings": "Clôtures de caisse",
				"consumptionObligation": "Consommation minimum",
				"debtors": "Comptes ouverts",
				"devolution": "Retour Carte par caisse",
				"discounts": "Remises sur compte",
				"individualLimitPost": "Changement du plafond individuel",
				"minimumConsumption": "Consommation anticipée",
				"openSales": "Ventes ouvertes",
				"openedBillPayment": "Paiements du compte ouvert",
				"openedBillReports": {
					"stillOpenInPeriod": "Encore ouverts dans la période",
					"stillOpenInPeriodTooltip": "Se réfère au montant des comptes ouverts dans la période sélectionnée",
					"linksGenerated": "Liens générés",
					"paidInPeriod": "Paiements de comptes ouverts résolus dans la période",
					"tabs": {
						"debtors": "Comptes ouverts",
						"payments": "Paiements de comptes ouverts"
					}
				},
				"promotion": "Promotions utilisées",
				"rappiDiscounts": "Réductions Rappi",
				"rechargeConsumption": "Remboursement des rechargements",
				"refunded": "Produits remboursés",
				"refundedRecharges": "Rechargement remboursés",
				"resume": "Resume",
				"servicesRemoval": "Pourboires supprimés",
				"userBonus": "Bonus",
				"forciblySynchronizedBalances": "Soldes synchronisés de force",
				"tipReport": "Rapport de Pourboire",
				"transactionTransfer": "Transferts de factures",
				"zigAppReport": "Ventes par transações Zig.app",
				"cashierAdjustments": "Fonds de saignements et de changement"
			},
			"forciblySynchronizedBalance": {
				"title": "Soldes synchronisés de force",
				"table": {
					"columns": {
						"date": "Date/Heure",
						"user": "Client",
						"employee": "Employé",
						"reason": "Justification",
						"balance": "Balance synchronisée"
					}
				},
				"successfulExportMsg": "Feuille de calcul exportée avec succès !"
			}
		},
		"financialReport": {
			"fileName": "Facturation-{{event}}",
			"finished": {
				"end": "Clôturé : {{end}}",
				"not": "L'événement n'est pas clôturé"
			},
			"label": "Resume",
			"reportIn": "Facturation de l'événement '{{event}}'",
			"tabs": {
				"bonusReport": {
					"title": "Bonus",
					"description": "Voir tous les rapports de concession et d'utilisation de bonus",
					"filenameBonus": "bonus-accordé",
					"filenameAnticipated": "consommation-anticipée",
					"filenameComsumption": "consommation",
					"total": "Total de {{category}}",
					"select": "Sélectionnez une catégorie",
					"selectNotFound": "Catégorie introuvable",
					"tabs": {
						"given": "Bonus Accordé",
						"used": "Bonus Utilisé"
					},
					"columns": {
						"client": "Client",
						"category": "Catégorie",
						"date": "Date",
						"reason": "Raison",
						"receivedValue": "Valeur reçue",
						"spentValue": "Valeur dépensée lors de l'événement",
						"spentValueInOtherEvents": "Valeur dépensée dans d'autres événements",
						"givenBy": "Donné par",
						"total": "Total"
					}
				}
			}
		},
		"multivendor": {
			"closings": {
				"columns": {
					"eventDate": "Date de l'événement",
					"fixedFee": "Frais de location fixes",
					"generalFeeValue": "Frais généraux variables",
					"generalPercentageFee": "Frais variables sur la facturation",
					"otherProductsFeeValue": "Frais variables sur les produits spéciaux",
					"payDate": "Date de paiement",
					"totalSoldValue": "Total facturation",
					"vendorName": "Vendeur",
					"vendorValueToReceive": "Montant à recevoir"
				},
				"emptyText": "Aucune donnée à afficher.",
				"filename": "clôture-par-vendeur",
				"title": "Clôture par Vendeur"
			},
			"productsSold": {
				"title": "Produits vendus par vendeur"
			},
			"revenues": {
				"columns": {
					"name": "Vendeur",
					"total": "Total",
					"totalSoldValue": "Produits vendus",
					"totalTipValue": "Pourboires"
				},
				"filename": "facturation_par_vendeur",
				"title": "Facturation par vendeur"
			}
		},
		"panel": {
			"canceled": "Annulé",
			"closeEvent": {
				"emptyName": "Le nom de l'événement est vide",
				"eventNameMessage": "Saisir le nom de l'événement pour confirmer la clôture",
				"finishedActivityDevices": "Il y a {{finishedActivityDevices}} POS avec des transactions ouvertes !",
				"incorectName": "Le nom de l'événement est incorrect",
				"message": "Êtes-vous sûr de vouloir clôturer l'événement ? Cela permettra de vérifier tous les utilisateurs et de clôturer le rapport, l'inventaire et les caisses.."
			},
			"closeEventButton": "Clôturer l'événement",
			"deleteEvent": {
				"confirm": "Êtes-vous sûr de vouloir supprimer l'événement ? Il s'agit d'une action permanente"
			},
			"eventNotOpen": "Cet événement n'est pas encore ouvert",
			"eventStatus": "Statut de l'événement",
			"finished": "Clôturé",
			"finishedActivityText": "{{activeDevices}} POS avec des transactions ouvertes",
			"goTo": "allez à",
			"importConsumption": {
				"balanceType": "Type de solde",
				"bonus": "Bonus",
				"columns": {
					"document": "CPF",
					"email": "E-mail",
					"gender": "Genre",
					"isForeign": "Est-il étranger ?",
					"name": "Nom",
					"phone": "Téléphone",
					"reason": "Motif",
					"value": "Montant"
				},
				"confirm": "Confirmer",
				"consumption": "Consommation",
				"consumptionErrors": "Consommations qui ont échoué",
				"consumptionType": "Type de consommation",
				"document": "CPF",
				"import": "Importer consommation",
				"minimumConsumption": "Consommation anticipée",
				"normal": "Normal",
				"reason": "Motif",
				"recharge": "Rechargement",
				"spreadsheet": "Tableau",
				"successNotification": "Consommation importée !",
				"title": "Importer Consommation",
				"user": "Utilisateur",
				"warningNotification": "Les données n'ont pas été envoyées. Certaines consommations ont échoué."
			},
			"importConsumptionCardsGroup": {
				"title": "Groupe de cartes",
				"fields": {
					"group": {
						"label": "Nom du groupe de cartes",
						"required": "Sélectionner un groupe de cartes"
					},
					"balanceType": {
						"label": "Type d'équilibre",
						"required": "Le montant du solde doit être supérieur à zéro"
					},
					"balance": {
						"label": "Valeur de la balance"
					}
				}
			},
			"importConsumptionZigCode": {
				"title": "ZigCode",
				"fileName": "Feuille de travail de consommation",
				"rechargeSuccess": "Recharge réussie!",
				"balanceType": "Type de solde",
				"columns": {
					"reason": "Raison",
					"value": "Valeur",
					"zigCode": "ZigCode"
				}
			},
			"importConsumptionUser": {
				"bonus": "Bonus",
				"document": "Document",
				"documentError": "Document requis",
				"documentType": "Type de Document",
				"minimumConsumption": "Consommation minimum",
				"paymentMethod": "Moyen de paiement",
				"paymentMethodError": "Moyen de paiement requis",
				"reason": "Motif",
				"recharge": "Rechargement",
				"submitRecharge": "Recharger",
				"value": "Montant rechargement",
				"valueError": "Montant de rechargement requis",
				"saveToDigitalCardQuestion": "Voulez-vous enregistrer le rechargement sur la carte numérique du client, s'il en a une ?",
				"saveToDigitalCardQuestionPlural": "Voulez-vous enregistrer les rechargements sur les cartes numériques des clients, s'ils en ont ?"
			},
			"notOpened": "Pas ouvert",
			"openedBy": "Ouvert par",
			"open": "Ouvert",
			"openEvent": "Événement ouvert",
			"publicCard": {
				"allInsideText": "sont encore en train de profiter",
				"allOutsideText": "déjà parti",
				"capacity": "Capacité",
				"genderCard": {
					"averageTicket": "Ticket moyen",
					"female": "Femme",
					"invoice": "Facturé",
					"male": "Homme",
					"other": "Autre",
					"realTicket": "Ticket réel",
					"zeroTicket": "Ticket Zéro"
				},
				"newPublicText": "Nouveaux clients",
				"oldPublicText": "Revenu",
				"people": "personnes",
				"title": "Public",
				"totalPublic": "{{totalPublic}} était à l'événement"
			},
			"removeEventButton": "Supprimer événement",
			"topClientsCard": {
				"clientInfo": "Information client",
				"clients": "Clients",
				"count": "Consommation",
				"title": "Clients qui consomment le plus"
			},
			"topProductsPriceCard": {
				"allProductsSold": "Tous les produits vendus",
				"altNavlink": "Lien vers le rapport de tous les produits vendus",
				"consumption": "Consommation",
				"noData": "Pas de données",
				"other": "Autres",
				"products": "Produits",
				"quantity": "Quantité",
				"title": "Produits par représentation commerciale",
				"unavailable": "Non disponible"
			},
			"totalOpenedTable": "Total de table ouverte",
			"editEvent": {
				"title": "Modifier l'événement",
				"confirm": "Confirmer",
				"passTemplate": "ID du modèle de passe"
			},
			"totalOpenedTables": "Total de tables ouvertes",
			"totalTables": "Total de tables",
			"zigMesaOperationMode": {
				"message": "État du serveur au PDV",
				"online": "Online",
				"local": "Local"
			},
			"operationCard": {
				"title": "Opération Zig Table",
				"peopleSingle": "Personne",
				"peoplePlural": "Personnes",
				"tableSingle": "Table",
				"tablePlural": "Tables",
				"time": "Temps"
			},
			"totalReceiptCard": {
				"averageTicket": "Ticket moyen",
				"column": {
					"adjustedReceipt": "Recettes ajustées",
					"bar": "Bar",
					"entrance": "Entrée",
					"entranceConsumptions": "Consommation à l'entrée",
					"extraConsumptions": "Consommation extra",
					"invoicing": "Facturation",
					"opened": "Comptes ouverts",
					"rechargeReturned": "Rechargements remboursés",
					"refundedPostPayments": "Annulation de paiement",
					"tableRow": {
						"ame": "Ame",
						"anticipated": "Anticipé",
						"app": "App",
						"cash": "Espèces",
						"credit": "Crédit",
						"debit": "Débit",
						"deliveryOnline": "Livraison en ligne",
						"ifood": "Ifood",
						"pix": "Pix",
						"postEvent": "Payé après événement",
						"rappi": "Rappi Pay",
						"uber": "Uber",
						"voucher": "Voucher",
						"integratedFoodVoucher": "Ticket Restaurant",
						"mbway": "Mbway",
						"online": "Online"
					},
					"title": "Moyen de paiement",
					"total": "Total",
					"value": "Montant"
				},
				"emptyContent": "Il n'y a rien à montrer ici",
				"errorContent": "Erreur!",
				"notIdealStateMessage": "Cette information n'est disponible que pour les événements à partir du 08/01/2017",
				"realTicket": "Ticket réel",
				"receipt": "Reçu",
				"operationTable": {
					"title": "Opération",
					"operationMode": "Mode opératoire",
					"zigTable": "Zig Table",
					"zigCard": "Zig Card",
					"zigDelivery": "Zig Delivery",
					"total": "Total",
					"invoicing": "Facturation"
				},
				"timelineCard": {
					"consumption": "Consommation",
					"period": "Période",
					"recharge": "Rechargements",
					"zigCardConsumption": "Consommation Zig Card",
					"tableConsumption": "Consommation mesa",
					"tooltipMessage": "{{titleMap}} dans la période du {{start}} au {{end}}",
					"value": "Montant consommé"
				},
				"title": "Financier",
				"zeroTicket": "Ticket Zéro"
			},
			"vendorsResumeCard": {
				"name": "Vendeurs",
				"title": "Ventes par vendeur",
				"totalSold": "Total vendu"
			}
		},
		"pos": {
			"columns": {
				"fingerPrint": "CODE",
				"product": "PRODUIT",
				"version": "VERSION",
				"employee": "EMPLOYÉ",
				"activation": "ACTIVATION",
				"lastUpdate": "DERNIÈRE MISE À JOUR",
				"cleanedDataStatus": "NETTOYÉ?",
				"hasFinishedActivity": {
					"finished": "CLÔTURÉ",
					"label": "Opération",
					"open": "Ouvert"
				},
				"devicePlatform": "MODÈLE",
				"status": "STATUT",
				"date": "DATE"
			},
			"deviceConfigColumn": {
				"bluetooth": "Bluetooth",
				"bluetoothMachine": "Appareil Bluetooth",
				"connected": "connecté",
				"disconnect": "déconnecté",
				"mobileData": "Données mobiles",
				"nfc": "NFC",
				"noData": "pas de données",
				"off": "off",
				"on": "on",
				"tryingToConnect": "Essai de connexion à la machine bluetooth",
				"wifi": "Wifi"
			},
			"editConfig": {
				"bluetooth": "Bluetooth",
				"configs": {
					"checkbox": "Essayer d'appairer l'appareil Bluetooth",
					"label": "Paramètres"
				},
				"confirmMessage": "Êtes-vous sûr de vouloir enregistrer les modifications ? Le wifi et les données mobiles de l'appareil sont désactivés, il ne sera donc pas possible de consulter les informations mises à jour du terminal.",
				"errorMessage": "L'une de ces préférences 'Permettre la vente' et 'Permettre la vente groupée' doit être active.",
				"label": "Modifier Paramètres",
				"noName": "Préférence sans nom",
				"preferences": "Préférences",
				"title": "Modifier ({{count}}) POS",
				"wifi": "Wifi"
			},
			"error": "Cette opération n'est autorisée que si aucun POS n'est sélectionné.",
			"humanizedPreferencies": {
				"dettachOnCheckout": "Se détache automatiquement à la sortie",
				"hideDettachOption": "Masquer le détachement",
				"hidePaymentModeVoucher": "Masquer le mode de paiement par chèque",
				"isGroupedSellEnabled": "Permettre la vente groupée",
				"isKeyboardOpenEnabled": "Clavier déjà ouvert dans la recherche",
				"isNormalSellEnabled": "Permettre la vente",
				"isNumericKeyboardInObsEnabled": "Commentaire avec le clavier numérique",
				"isSearchByCodeEnabled": "Recherche numérique",
				"isSellWithoutCardEnabled": "Permettre la vente sans carte",
				"isStockTransfEnabled": "Permettre le transfert de stock",
				"isStorageTransferPrinterLanActive": "Activer l'imprimante de transfert de stock du réseau local",
				"printTwoTickets": "Imprimer deux tickets de vente",
				"printViaBtForWaiter": "Afficher un bouton pour imprimer les commandes en attente des serveurs",
				"registerWithoutCard": "S'enregistrer sans carte",
				"removeCreditDebitPaymentOption": "Supprimer les options de débit et de crédit"
			},
			"info": "Il est nécessaire que le POS soit connecté à internet pour synchroniser les paramètres..",
			"noName": "Pas de nom",
			"open": "{{active}} sur {{total}} POS ouverts",
			"searchPlaceholder": "Rechercher un dispositif ou un employé",
			"settings": "Paramètres",
			"title": "Dispositifs: POS et Totems de l'événement"
		},
		"sellChip": {
			"addCollaborator": "Ajouter un contributeur",
			"chipsFound": "{{num}} puces trouvées",
			"columns": {
				"actionButton": "Rembourser puce",
				"clients": "Clients",
				"date": "Date",
				"employee": "Employé",
				"products": "Produits",
				"refunded": "Remboursé",
				"value": "Montant"
			},
			"modal": {
				"okText": "Rembourser",
				"product": "Produit",
				"products": "Produits",
				"reason": "Motif",
				"reasonError": "Ce champ ne peut pas être vide",
				"reasonPlaceholder": "Indiquer le motif du remboursement",
				"reasonRequired": "Motif requis.",
				"returnToStorage": "Remettre le produit en stock",
				"shouldReturnToStorage": "Doit-il être remis en stock ?",
				"title": "Rembourser la puce de {{client}}"
			},
			"noChipsFound": "Pas de puce trouvée",
			"oneChipFound": "Une puce trouvée",
			"placeholder_one": "Sélectionner le contributeur",
			"placeholder_other": "Sélectionner les contributeurs",
			"searchPlaceholder": "Recherche par client ou par produit",
			"title": "Puces vendues lors de l'événement"
		},
		"operationReports": {
			"tabs": {
				"orangeScreenReport": "Rapport d'Écran Orange",
				"allEventActionsReport": "Actions de l'Événement",
				"totemActionsReport": "Actions sur le totem"
			},
			"orangeScreenReport": {
				"title": "Rapport d'Écran Orange",
				"subtitle": "Liste de toutes les occurrences pendant la période de l'événement.",
				"filters": {
					"employee": {
						"label": "Nom de l'opérateur",
						"placeholder": "Tapez le nom de l'opérateur"
					},
					"deviceFingerprint": {
						"label": "ID du PDV",
						"placeholder": "Entrez l'ID du PDV"
					}
				},
				"columns": {
					"date": "Date/heure de l'occurrence",
					"employee": "Opérateur",
					"deviceId": "ID de PDV",
					"zigDeviceUid": "ID de Carte"
				},
				"filename": "rapport-d-ecran-orange"
			},
			"allEventActionsReport": {
				"title": "Actions de l'Événement",
				"description": "Liste de toutes les actions pendant l'événement.",
				"filters": {
					"employee": {
						"label": "Nom de l'opérateur",
						"placeholder": "Entrez ou sélectionnez l'opérateur"
					},
					"transaction": {
						"label": "Type de transaction",
						"placeholder": "Entrez ou sélectionnez le type"
					}
				},
				"columns": {
					"id": "Id",
					"date": "Date et heure",
					"transactionType": "Type de transaction",
					"employee": "Opérateur",
					"user": "Client",
					"paymentMethod": "Mode de paiement",
					"products": {
						"title": "Produits",
						"name": "Nom du produit",
						"count": "Quantité",
						"value": "Valeur"
					},
					"value": "Valeur"
				},
				"filename": "rapport-actions-de-l-evenement",
				"paymentMethodWithCashless": {
					"ZigPosCredit": "ZigPos Crédit",
					"ZigPosCreditInInstallments": "ZigPos Crédit en Versements",
					"ZigPosDebit": "ZigPos Débit",
					"CreditCard": "Carte de Crédit",
					"DebitCard": "Carte de Débit",
					"Cash": "Espèces",
					"App": "Application",
					"Voucher": "Bon",
					"Anticipated": "Anticipé",
					"Pix": "Pix",
					"Cashless": "Sans Espèces",
					"IntegratedFoodVoucher": "Bon Alimentaire Intégré",
					"MBWay": "MBWay",
					"Bonus": "Bonus",
					"MinimumConsumption": "Consommation Minimum",
					"DigitalCashless": "Cashless numérique",
					"Ifood": "Ifood"
				},
				"openingInfoModal": "Données d'ouverture d'événement",
				"opening": "Ouverture",
				"by": "Par",
				"openingTime": "Heure d'ouverture",
				"openingBy": "Event Open By"
			},
			"totemActionsReport": {
				"title": "Acciones en el Totem",
				"description": "Liste de toutes les actions pendant l'événement.",
				"filters": {
					"totem": {
						"label": "Totem",
						"placeholder": "Entrez ou sélectionnez l'totem"
					},
					"transaction": {
						"label": "Type de transaction",
						"placeholder": "Entrez ou sélectionnez le type"
					},
					"search": {
						"label": "Rechercher",
						"placeholder": "Rechercher par ID"
					}
				},
				"columns": {
					"date": "DATE ET HEURE",
					"transactionType": "TYPE DE TRANSACTION",
					"totem": "TOTEM",
					"user": "CLIENT",
					"value": "VALEUR",
					"paymentMethod": "MODE DE PAIEMENT"
				},
				"filename": "rapport-totem-actions"
			}
		},
		"zigTags": {
			"block": {
				"success": "Carte bloquée avec succès"
			},
			"empty": {
				"title": "Rechercher une carte ZIG pour la gérer"
			},
			"form": {
				"errors": {
					"zigTagRequired": "Tapez le numéro de la carte à rechercher"
				},
				"label": "Rechercher Carte ZIG",
				"placeholder": "Saisir le numéro de la carte",
				"searchBtn": "Rechercher"
			},
			"table": {
				"actions": {
					"blockTag": "Bloquer carte"
				},
				"columns": {
					"actions": "Actions",
					"isBlocked": "Est-elle bloquée ?",
					"userDocument": "Document de l'utilisateur",
					"userName": "Utilisateur",
					"zigCode": "Code ZIG"
				}
			},
			"title": "Gérer Cartes ZIG"
		},
		"tableReports": {
			"tabs": {
				"general": {
					"label": "Rapport général",
					"eventDate": "Date de l'événement",
					"filters": {
						"table": "Table",
						"employeeName": "Serveur",
						"payment": "Paiement",
						"tablePlaceholder": "Sélectionnez un tableau",
						"employeeNamePlaceholder": "Tous",
						"status": "Tous",
						"paymentPlaceholder": "Tous",
						"dateOrPeriod": "Données ou période"
					},
					"resume": {
						"people": "Personnes",
						"totalRevenue": "Chiffre d'affaires total",
						"openTables": "Tableaux en cours d'utilisation",
						"tablesUsed": "Mesas utilisés",
						"averageLengthStay": "Temps moyen de séjour",
						"hours": "heures et",
						"minutes": "minutes",
						"chargeback": "Remboursements",
						"averageTicket": "Ticket moyen"
					},
					"table": {
						"title": "Consommation des tables",
						"allPayments": "Voir tous les paiements",
						"columns": {
							"tableName": "TABLE",
							"employeeName": "SERVEUR",
							"numberOfSeats": "PERSONNES",
							"permanence": "PERMANENCE",
							"openedAt": "OUVERTURE",
							"closedAt": "FERMETURE",
							"discount": "RÉDUCTIONS",
							"refundValue": "REMBOURSEMENTS",
							"totalValue": "TOTAL",
							"icon": "COMPTE",
							"buyers": {
								"name": "NOM",
								"document": "CPF",
								"paymentType": "PAIEMENT",
								"total": "TOTAL"
							}
						}
					},
					"paymentTypes": {
						"CreditCard": "Carte de crédit",
						"DebitCard": "Carte de débit",
						"Pix": "Pix",
						"Cash": "Espèces"
					}
				},
				"totalProductsSold": {
					"label": "Total des produits vendus"
				},
				"totalByClient": {
					"label": "Total par client",
					"title": "Total des ventes par client",
					"table": {
						"title": "Consommation des tables",
						"columns": {
							"name": "NOM",
							"document": "CPF",
							"openedAt": "OUVERTURE",
							"closedAt": "FERMETURE",
							"payment": "PAIEMENT",
							"serviceValue": "VALEUR DU SERVICE",
							"discount": "RÉDUCTIONS",
							"refundValue": "REMBOURSEMENTS",
							"totalValue": "TOTAL",
							"products": {
								"imageUrl": "IMAGE",
								"sku": "SKU",
								"name": "NOM DU PRODUIT",
								"tableName": "TABLE",
								"payment": "PAIEMENT",
								"quantity": "QUANTITÉ",
								"unitValue": "VALEUR UNITAIRE",
								"totalValue": "VALEUR TOTALE"
							}
						}
					}
				},
				"productsByTable": {
					"label": "Sortie de produits sur table"
				},
				"tableProductsSold": {
					"mainTitle": "Revenu de table",
					"mainSubtitle": "Surveillez les performances des tables et améliorez la gestion de votre restaurant.",
					"label": "Sortie de produits sur table",
					"title": "Sortie de produits sur table",
					"filters": {
						"table": "Table",
						"employeeName": "Serveur",
						"payment": "Paiement",
						"product": "Produit",
						"tablePlaceholder": "Sélectionnez un tableau",
						"employeeNamePlaceholder": "Tous",
						"status": "Tous",
						"paymentPlaceholder": "Tous",
						"productPlaceholder": "Tous"
					},
					"table": {
						"title": "Consommation des tables",
						"columns": {
							"tableName": "TABLE",
							"employeeName": "SERVEUR",
							"permanence": "PERMANENCE",
							"numberOfSeats": "PERSONNES",
							"openedAt": "OUVERTURE",
							"closedAt": "FERMETURE",
							"closedBy": "FERMÉ PAR",
							"discount": "RÉDUCTIONS",
							"refundValue": "REMBOURSEMENTS",
							"totalValue": "TOTAL",
							"products": {
								"imageUrl": "IMAGE",
								"sku": "SKU",
								"name": "NOM DU PRODUIT",
								"quantity": "QUANTITÉ",
								"unitPrice": "VALEUR UNITAIRE",
								"subTotal": "SOUS-TOTAL",
								"discount": "RÉDUCTIONS",
								"total": "VALEUR TOTALE"
							}
						}
					}
				}
			}
		},
		"posBar": {
			"title": "Appareils par barre",
			"columns": {
				"bar": "Pub",
				"quantity": "Montant"
			}
		},
		"device": {
			"tab": {
				"deviceStatus": "Appareils",
				"deviceBars": "Appareils par barre"
			}
		},
		"performanceTableReport": {
			"tabName": "Performance des tables",
			"label": "Rapports de tables",
			"title": "Suivez la performance des tables et optimisez la gestion de votre restaurant.",
			"averageTime": "temps moyen",
			"filters": {
				"table": "Toutes les tables",
				"periodOptions": {
					"sevenDays": "7 jours",
					"fifteenDays": "15 jours",
					"thirtyDays": "30 jours",
					"sixtyDays": "60 jours"
				},
				"allTables": "Toutes les tables"
			},
			"more": "plus",
			"less": "moins",
			"eventPercentage": "{{comparison}} que le dernier événement",
			"companiePercentage": "{{comparison}} que lors des {{days}} derniers jours",
			"tableNumber": "Numéro de table",
			"qtdTimes": "fois",
			"served": "servies",
			"cards": {
				"totalBilling": "Chiffre d'affaires total",
				"peopleServed": "Personnes servies",
				"averageTicketPerTable": "Ticket moyen par table",
				"averageTicketPerPerson": "Ticket moyen par personne",
				"bestPerformanceByWaiter": "Meilleure performance par serveur",
				"mostSoldProduct": "Produit le plus vendu",
				"averageSpins": "Moyenne de rotations",
				"AverageLengthOfStay": "Durée moyenne du séjour",
				"tableCombinations": "Combinaisons de tables",
				"nextPage": "Suivant",
				"previousPage": "Précédent",
				"totalSales": "Total des ventes",
				"averageTicket": "Ticket moyen",
				"attendances": "Services"
			},
			"table": {
				"title": "Consommation des tables",
				"columns": {
					"tableName": "TABLE",
					"employeeName": "SERVEUR",
					"numberOfSeats": "PERSONNES",
					"openedAt": "OUVERTURE",
					"permanence": "DURÉE DE SÉJOUR",
					"tip": "SERVICE",
					"productsValue": "PRODUITS",
					"closedAt": "FERMÉ",
					"discount": "REMBOURSEMENTS",
					"refundValue": "REEMBOLSSEMENTS",
					"totalValue": "TOTAL",
					"products": {
						"imageUrl": "PHOTO",
						"sku": "SKU",
						"name": "NOM DU PRODUIT",
						"quantity": "QUANTITÉ",
						"unitPrice": "PRIX UNITAIRE",
						"subTotal": "SOUS-TOTAL",
						"discount": "REMBOURSEMENTS",
						"total": "PRIX TOTAL"
					}
				}
			}
		}
	},
	"shared": {
		"fiscalReportDateFilterHint": "Ce filtre utilise la date de la transaction, pas la date d'émission de la facture",
		"fiscalReportDateFilterRechargeHint": "Ce filtre utilise la date de la recharge, pas la date d'émission de la facture",
		"yes": "Oui",
		"no": "Non"
	},
	"globalKeys": {
		"important": "Important",
		"clean": "Nettoyer",
		"add": "Ajouter",
		"all": "Tous",
		"and": "et",
		"attention": "Attention",
		"by": "par",
		"deletedEmployee": "supprimé",
		"cancel": "Annuler",
		"filter": "Filtrer",
		"close": "Clôturer",
		"code": "Code",
		"comingSoon": "Prochainement",
		"pending": "En attente",
		"conclude": "Terminer",
		"confirm": "Confirmer",
		"continue": "Continuer",
		"cpf": "CPF",
		"promoter": "Promoteur",
		"create": "créer",
		"currencies": {
			"dollar": "Dollar",
			"euro": "Euro",
			"mexPeso": "Mexican peso",
			"real": "Real"
		},
		"day": "Jour",
		"days": "Jours",
		"month": "Mois",
		"category": "Catégorie",
		"daysOfTheWeek": {
			"fri": "Fri",
			"friday": "Vendredi",
			"mon": "Mon",
			"monday": "Lundi",
			"sat": "Sat",
			"saturday": "Samedi",
			"sun": "Sun",
			"sunday": "Dimanche",
			"thu": "Thu",
			"thursday": "Jeudi",
			"tue": "Tue",
			"tuesday": "Mardi",
			"wed": "Wed",
			"wednesday": "Mercredi"
		},
		"daysOfTheWeekComplete": {
			"friday": "Vendredi",
			"holidays": "Jours fériés",
			"monday": "Lundi",
			"saturday": "Samedi",
			"sunday": "Dimanche",
			"thursday": "Jeudi",
			"tuesday": "Mardi",
			"wednesday": "Mercredi"
		},
		"daysOfTheWeekSmall": {
			"fri": "Ven",
			"hol": "Fér",
			"mon": "Lun",
			"sat": "Sam",
			"sun": "Dim",
			"thu": "Jeu",
			"tue": "Mar",
			"wed": "Mer"
		},
		"typeDate": {
			"Day": "Jour",
			"Week": "Semaine",
			"Month": "Mois",
			"Year": "Année"
		},
		"typeDatePlural": {
			"Days": "Jours",
			"Weeks": "Semaines",
			"Months": "Mois",
			"Years": "Années"
		},
		"delete": "Supprimer",
		"disable": "Désactiver",
		"disabled": "Désactivé",
		"download": "Télécharger",
		"duplicate": "Dupliquer",
		"edit": "Modifier",
		"erase": "Effacer",
		"error": "Erreur",
		"exclude": "Supprimer",
		"export": "Exporter",
		"exportExcel": "Exporter en Excel",
		"exportPdf": "Exporter en PDF",
		"false": "Faux",
		"falseCaps": "FAUX",
		"finished": "Terminé",
		"from": "de",
		"gender": {
			"female": "Femme",
			"male": "Homme",
			"others": "Autre"
		},
		"goBack": "Précédent",
		"goFoward": "Suivant",
		"grams": "grammes",
		"import": "Importer",
		"invalid": "Invalide",
		"issue": "Émettre",
		"kilos": "Kilos",
		"leave": "Sortie",
		"liter": "Litre",
		"loading": "Chargement",
		"message": "Message",
		"messages": "Messages",
		"months": {
			"april": "Avril",
			"august": "Août",
			"december": "Décembre",
			"february": "Février",
			"january": "Janvier",
			"july": "Juillet",
			"june": "Juin",
			"march": "Mars",
			"may": "Mai",
			"november": "Novembre",
			"october": "Octobre",
			"september": "Septembre"
		},
		"more": "plus",
		"new": "Nouveau",
		"name": "Nom",
		"next": "Suivant",
		"no": "Non",
		"noCaps": "NON",
		"notTested": "Non testé",
		"order": "Commande",
		"phone": "Téléphone",
		"phoneInternational": "Téléphone (international seulement)",
		"preview": "Vue d'ensemble",
		"previous": "Précédent",
		"print": "Imprimer",
		"reload": "Recharger",
		"remove": "Supprimer",
		"restore": "Restaurer",
		"request": "Demande",
		"requiredField": "Champ obligatoire",
		"save": "Sauvegarder",
		"search": "Rechercher",
		"seeAttachments": "Voir pièces jointes",
		"seeLess": "Voir moins",
		"seeMore": "Voir plus",
		"select": "Sélectionner",
		"selected": "Sélectionné",
		"selectedPlural": "Sélectionnés",
		"send": "Envoyé",
		"sendMessageNow": "Envoyer un message maintenant",
		"shortMonths": {
			"apr": "Avr",
			"aug": "Aoû",
			"dec": "Déc",
			"feb": "Fév",
			"jan": "Jan",
			"jul": "Juil",
			"jun": "Juin",
			"mar": "Mar",
			"may": "Mai",
			"nov": "Nov",
			"oct": "Oct",
			"sep": "Sep"
		},
		"tested": "Testé",
		"to": "à",
		"toSelect": "Sélectionner",
		"today": "Aujourd'hui",
		"tomorrow": "Demain",
		"transfer": "Transfert",
		"true": "Vrai",
		"truthCaps": "VRAI",
		"tryAgain": "Réessayer",
		"typeHere": "Saisir ici",
		"unknown": "Anonyme",
		"uid": "Code Zig",
		"upload": "Charger",
		"value": "Montant",
		"withoutPermission": "Vous n'avez pas les autorisations",
		"withoutPermissionToViewPage": "Pas autorisé à voir la page",
		"yes": "Oui",
		"yesCaps": "OUI",
		"yesterday": "Hier",
		"update": "Mettre à jour",
		"enable": "Activer",
		"enabled": "Activé",
		"dataSavedSuccess": "Données enregistrées avec succès",
		"backToMainPage": "Retourner à la page d'accueil",
		"somethingWentWrong": "Oups... Quelque chose ne s'est pas passé comme prévu",
		"savingData": "Enregistrement des données",
		"subtotal": "Total",
		"total": "Total",
		"type": "Type",
		"invalidEmail": "E-mail invalide",
		"emptyText": "Aucune donnée à afficher.",
		"of": "sur",
		"noneOfTheOptions": "Aucune des options",
		"transaction": "Transaction",
		"page": "page",
		"recharge": "Recharge",
		"date": "Date",
		"since": "Depuis",
		"until": "Jusqu'à"
	},
	"nav": {
		"header": {
			"event": "Événement",
			"logout": "Déconnexion",
			"org": "Organisation",
			"place": "Lieu",
			"language": "Langue"
		},
		"navbar": {
			"default": {
				"logout": "Déconnexion",
				"changeLanguage": "Changer la langue",
				"changeSystemLanguage": "Changer la langue du système"
			},
			"selectLanguageModal": {
				"selectLanguage": "Sélectonnez la langue",
				"cancel": "Annuler",
				"confirm": "Confirmer"
			},
			"event": {
				"barReports": "Rapports Bar",
				"salesReport": "Rapports de ventes",
				"bookings": "Réservations",
				"clients": "Information Clients",
				"conference": "Conférence d'événement",
				"financialReport": "Rapports financiers",
				"guestList": "Listes d'invités",
				"multivendor": "Multi-vendeur",
				"panel": "Panneau",
				"businessIntelligence": "Panneau général",
				"eventPanel": "Tableau de bord des événements",
				"reports": "Rapports",
				"customers": "Clients",
				"devices": "Dispositifs",
				"sellChip": "Ventes sans carte",
				"ticketsReport": "Rapports Ticket",
				"zigTag": "Carte ZIG",
				"operationReport": "Rapport d'Opération",
				"hawkersReport": "Rapport sur les ambulants",
				"rechargeManagement": "Gestion du solde",
				"tableReports": "Rapports de tables"
			},
			"org": {
				"panel": "Lieux",
				"employee": "Accès équipe",
				"crm": "CRM",
				"categories": "Catégories",
				"reports": "Rapports",
				"recharge": "Recharge",
				"stock": "Stock",
				"giftback": "Giftback",
				"fiscal": "Fiscal",
				"internalSalesCampaign": "Campagne de vente interne",
				"taxRegistration": "Enregistrement Fiscal",
				"stockInventory": "Stock",
				"stockInventoryV1": "Enregistrement de la base de produits",
				"productRegistration": "Enregistrement de produit",
				"advancedBI": "BI avancée",
				"customersList": "Liste des Clients",
				"taxData": "Données fiscales",
				"fiscalSettings": "Données fiscales",
				"financialReport": "Rapports",
				"satisfactionSurvey": "Questionnaire de satisfaction",
				"customers": "Espace client",
				"sendingMessages": "Envoi de messages",
				"loyalty": "Programmes de fidélisation",
				"communication": "Campagnes de Communication",
				"chartOfAccounts": "Tableau des Comptes",
				"fiscalBoard": "Tableau fiscal",
				"vendors": "Fournisseurs",
				"team": "Équipe"
			},
			"place": {
				"audits": "Audits",
				"barReports": "Rapports Bar",
				"salesReport": "Rapports de ventes",
				"prechargeReports": "Précharger par feuille de calcul",
				"businessInteligence": "Business Intelligence",
				"pdvTeam": "Opérateurs de PDV",
				"productAndMenu": "Produits et menus",
				"cashFlow": "Financier",
				"clients": "Clients",
				"contracts": "Contrats",
				"tagGroups": "Groupes de Balises",
				"delivery": "Livraison",
				"deliveryOrders": "Commandes",
				"deliveryReport": "Rapports",
				"deliveryMenus": "Menus",
				"deliverySettings": "Paramètres",
				"events": "Événements",
				"extract": "Extract",
				"financialReport": "Rapports financiers",
				"guestList": "Liste d'invités",
				"invoices": "Factures",
				"transferReport": "Rapport de transfert",
				"multivendor": "Multi-vendeur",
				"passwordCard": "Carte de mot de passe",
				"pos": "Ventes POS",
				"precharge": "Sites de préchargement",
				"products": "Produits",
				"menu": "Menu",
				"bars": "Bars et secteurs",
				"opened": "Ouvert",
				"closed": "Fermé",
				"crm": "CRM",
				"reports": "Rapports",
				"preChargeLabel": "Pré-charge",
				"inventoryControl": "Contrôle de l'inventaire",
				"receptive": "Réceptif",
				"promotions": "Promotions et réductions",
				"settings": "Paramètres",
				"storage": "Stockage",
				"tickets": "Tickets",
				"ticketsReport": "Rapports Ticket",
				"whatsup": "Quoi de neuf ??",
				"zigAccount": "Compte ZIG",
				"rechargeManagement": "Gestion du solde",
				"tableReports": "Rapports de tables",
				"generalConfig": "Configuration Générale",
				"operationReport": "Rapport d'opération",
				"config": "Paramètres",
				"kds": "Gestionnaire de commandes (KDS)",
				"kdsConfig": "Gérer KDS",
				"kdsReport": "Rapport"
			}
		}
	},
	"noAuth": {
		"expiredSession": {
			"cardTitle": "Pour votre sécurité, votre session a expiré.",
			"loginButtonLabel": "Se reconnecter"
		},
		"login": {
			"dashboard": "Tableau de bord"
		},
		"errors": {
			"required": "Champ obligatoire",
			"passwordMustBeSame": "Les mots de passe doivent être identiques",
			"minLength": "Le mot de passe doit contenir au moins {{count}} caractères"
		},
		"actions": {
			"send": "Envoyer"
		},
		"confirmMessages": {
			"passwordUpdated": "Mot de passe mis à jour avec succès"
		},
		"labels": {
			"password": "Mot de passe",
			"confirmPassword": "Confirmation du mot de passe"
		},
		"recoveryPassword": "Récupération du mot de passe"
	},
	"org": {
		"employees": {
			"tabs": {
				"employees": {
					"addEmployeeZigtagError": "Erreur lors de l'ajout d'un collaborateur avec carte ZIG",
					"addModal": "Ajouter employé",
					"checkAll": "Sélectionner l'employé ({{counter}})",
					"columns": {
						"bar": {
							"label": "Bar",
							"none": "Pas de bar sélectionné"
						},
						"custom": "Sur mesure",
						"name": "Employé",
						"places": {
							"label": "Lieux",
							"none": "Pas de lieux sélectionné"
						},
						"role": "Fonction",
						"username": "Identifiant",
						"zigtag": "Carte ZIG"
					},
					"createEmployee": {
						"barsSelect": {
							"bars": "Bars",
							"menu": "Menu",
							"print": "Imprimer"
						},
						"fakeBarBlocklistPermission": "Restreindre l'affichage des produits du menu",
						"menuVisualization": {
							"label": "Types",
							"placeholder": "Sélectionner le type de visualisation du menu",
							"title": "Menu visualisation",
							"type": {
								"grid": "Défault",
								"list": "Pas de photo",
								"smallGrid": "Petite photo"
							}
						},
						"noSelectedPlace": "Sélectionnez un lieu pour activer cette autorisation",
						"onlyOneSelect": "Pour activer cette autorisation, ne sélectionnez qu'un seul lieu",
						"validation": {
							"initialValueSmaller": "La valeur initiale doit être inférieure à la valeur finale",
							"login": "Veuillez saisir un identifiant valide",
							"name": "Veuillez saisir un nom valide",
							"negative": "Les montants ne peuvent pas être négatifs",
							"password": "Veuillez saisir un mot de passe valide",
							"role": "Sélectionner un rôle",
							"same": "Les valeurs renseignées sont les mêmes",
							"selectedPlaces": "Au moins un lieu est requis",
							"twoValues": "Les deux valeurs doivent être renseignées"
						}
					},
					"deleteModal": {
						"content": "Attention ! Les employés seront définitivement supprimés.",
						"title": "Voulez-vous supprimer le(s) employé(s) {{count}} ?"
					},
					"deleteWarning": "Oups ! Un problème s'est produit, réessayez",
					"edit": {
						"data": {
							"employeeNumber": {
								"end": "Jusqu'à",
								"label": "Ajouter plus d'un employé",
								"start": "Dans",
								"tooltip": "Uniquement pour plus d'un employé au sein d'un même poste"
							},
							"label": "Données employé",
							"login": "Connexion",
							"name": "Nom de l'employé",
							"password": "Mot de passe",
							"photo": "Photo",
							"zigCard": "Carte ZIG"
						},
						"extra": {
							"fichasAmount": {
								"label": "Nombre de moyens enregistrés",
								"placeholder": "Quantité de moyens"
							},
							"label": "Informations supplémentaires",
							"type": "Type de collaborateur"
						},
						"label": "Modifier employé",
						"places": {
							"label": "Lieux",
							"selectedBar": {
								"label": "Bars",
								"placeholder": "Aucun"
							},
							"selectedPlace": "Lieux",
							"mainBar": "Bar principale / point de vente"
						},
						"role": {
							"employeeRole": {
								"custom": "Sur mesure",
								"label": "Bureau",
								"none": "Aucun",
								"placeholder": "Choisir une fonction"
							},
							"label": "Fonctions et permissions",
							"permissions": "Permissions"
						},
						"seeProducts": {
							"blockedBar": {
								"label": "Blocquer bars",
								"placeholder": "Aucun"
							},
							"label": "Voir les produits du bar"
						}
					},
					"editButton": "Modifier employé",
					"exportButton": "Exporter les employés",
					"deleteButton": "Supprimer les employés",
					"editMultiple": {
						"bar": "Bars",
						"confirm": "Voulez-vous modifier les collaborateurs suivants ?",
						"fichasAmount": "Nombre de moyens enregistrés",
						"info": "Les champs non remplis conservent leur valeur initiale.",
						"label": "Modifier l'employé ({{count}})",
						"none": "Aucun",
						"number": "Nombre de",
						"places": "Lieux",
						"rename": "Renommer",
						"role": "Modifier la fonction",
						"mainBar": "Barre principale"
					},
					"employeeDelete": {
						"customized": "Position personnalisée",
						"text": "Voulez-vous vraiment supprimer {{nom}} ({{rôle}})' ? Cette action ne peut être annulée"
					},
					"filter": "Filtrer par lieux",
					"importModal": {
						"buttonText": "Choisir un tableau",
						"columns": {
							"fichasAmount": "Nombre de moyens en jetons",
							"name": "Nom",
							"password": "Mot de passe",
							"username": "Nom d'utilisateur",
							"zigTag": "Carte ZIG"
						},
						"custom": "Sur mesure",
						"errorNotification": "Pas de tableau sélectionné",
						"label": "Importer employé",
						"passwordRequirements": "Les employés disposant de l'autorisation 'Accès au tableau de bord' doivent respecter les règles suivantes pour le mot de passe : minimum de 6 caractères, au moins une lettre.",
						"permissions": "Permissions",
						"places": "Lieux and Bars",
						"requiredField": "Champs obligatoire",
						"role": "Bureau",
						"selectPlace": "Au moins un lieu doit être sélectionné",
						"sheetFileName": "Employé"
					},
					"multipleEmployeeModalError": {
						"success": "Création réussie",
						"successMessage": "Les employés connectés {{logins}} ont été créés",
						"error": "Échoué",
						"errorMessage": "Impossible de créer des employés connectés {{logins}}. La connexion existe déjà"
					},
					"importSuccess": "Salariés importés avec succès",
					"label": "Équipe",
					"search": "Rechercher",
					"uncheckAll": "Désélectionner tous les employés ({{counter}})"
				},
				"roles": {
					"columns": {
						"employees": "Nombre de salariés",
						"none": "Aucun",
						"options": "Options",
						"role": "Fonctions"
					},
					"create": "Créer une fonction",
					"edit": "Modifier fonction",
					"isNameInvalid": "Les champs n'ont pas été remplis correctement",
					"label": "Fonctions",
					"modal": {
						"importPermissions": {
							"label": "Autorisations d'importation",
							"placeholder": "Ex: caisse"
						},
						"permissions": "Permissions",
						"placesBar": {
							"bar": "Bar",
							"blocked": "Bloquer bars",
							"chooseBar": "Choisir un bar",
							"chooseLocal": "Choisir un lieu",
							"chooseMinimum": "Choisissez au moins un bar",
							"none": "Aucun",
							"place": "Lieux"
						},
						"roleName": {
							"error": "Nom invalide",
							"label": "Nom de la fonction",
							"placeholder": "Ex: Serveur"
						}
					},
					"removeRole": "Êtes-vous sûr de vouloir supprimer la fonction ?",
					"roleError": "La fonction n'a pas été trouvée, veuillez réessayer",
					"search": "Rechercher par fonction"
				}
			}
		},
		"clients": {
			"applyFilter": "Appliquer les filtres",
			"cancel": "Annuler",
			"clearFilter": "Effacer tous les champs",
			"place": "Lieu",
			"daysOfTheWeek": {
				"friday": "Vendredi",
				"monday": "Lundi",
				"saturday": "Samedi",
				"sunday": "Dimanche",
				"thursday": "Jeudi",
				"tuesday": "Mardi",
				"wednesday": "Mercredi"
			},
			"documentTypePlaceHolder": "Sélectionner le type de document du client",
			"filter": {
				"addProduct": "Ajouter un autre produit",
				"consumptionVolume": "Consommation minimale",
				"daysOfTheWeek": "Jours de la semaine",
				"daysOfTheWeekPlaceholder": "Sélectionnez les jours de la semaine",
				"gender": "Genre",
				"noProducts": "Aucun produit trouvé",
				"notUsedRecharges": "Solde minimum de recharge non utilisé",
				"period": "Période",
				"periodFrequency": "Fréquence",
				"firstTime": "1er fois",
				"frequencyPlaceholder": "Choisir la fréquence du client",
				"product": "Produit",
				"productsConsumed": "Produits consommés",
				"quantity": "Quantité",
				"removeProduct": "Supprimer un produit",
				"selectProduct": "Sélectionner un produit",
				"yearPlaceholder": "aaaa",
				"birthdateRange": "Période d'Anniversaire",
				"birthdateYear": "Année d'Anniversaire",
				"products": "Produits",
				"productsPlaceholder": "Sélectionner les produits",
				"errors": {
					"type": "Données invalides",
					"birthdate": {
						"day": "Données invalides",
						"month": "Données invalides",
						"year": "Insérer une année entre 1900 et l'année en cours"
					}
				}
			},
			"filterTitle": "Filtres avancés",
			"filterByProductTitle": "Filtrer par produit",
			"gender": {
				"female": "Femme",
				"male": "Homme",
				"others": "Autres"
			},
			"productError": "La quantité de {{product}} doit être supérieure à 0",
			"search": "Rechercher",
			"searchTitle": "Type de recherche",
			"searchPlaceholder": "Insérer le document du client",
			"searchClientByName": "Insérer le nom du client",
			"table": {
				"birthDate": "Anniversaire",
				"consumption": "Consommé",
				"countClients_one": "Client trouvé",
				"countClients_other": "Clients trouvés",
				"countTicketClients": "Ticket moyen par client",
				"cpf": "CPF",
				"email": "Email",
				"emptyText": "Aucune donnée à afficher",
				"firstTimeAtPlace": "Première fois",
				"lastTimeAtPlace": "Dernière visite",
				"hasApp": "Application active",
				"infoLabel": "Sélectionner un client pour voir les détails.",
				"moreResults": "Charger plus de résultatss",
				"moreThan": "plus de",
				"name": "Client",
				"phone": "Téléphone",
				"presences": "Présence",
				"remaningValueOnPlace": "Solde disponible",
				"uninformed": "Uninformed"
			},
			"titleWithPlace": "Liste des clients"
		},
		"fiscal": {
			"fiscalData": "Données fiscales",
			"validations": {
				"number": "Nombres uniquement"
			}
		},
		"fiscalBoard": {
			"addPlace": "Ajouter un lieu",
			"column": {
				"date": "Date",
				"errorType": "Type d'erreur",
				"total": "Total à émettre",
				"type": "Type",
				"value": "Montant"
			},
			"fiscalProfile": "Émissions par profil fiscal",
			"issuingErrors": "Erreurs d'émission",
			"nfce": "NFC-e",
			"nfceIssued": "NFC-e émis",
			"nfse": "NFS-e",
			"nfseIssued": "NFS-e émis",
			"selectMonth": "Sélectionner un mois",
			"selectPlace": "Sélectionner un lieu"
		},
		"fiscalData": {
			"components": {
				"drawers": {
					"drawerProfile": {
						"excludeTaxProfile": "Exclure le profil",
						"infoDataCompany": {
							"CNPJ": "CNPJ",
							"cityCode": "Ville",
							"corporateReason": "Raison sociale",
							"fantasyName": "Nom d'emprunt",
							"municipalRegistration": "Inscription au registre municipal",
							"stateRegistration": "Enregistrement de l'État",
							"taxRegime": "Régime fiscal"
						},
						"infoDataIvaVendus": {
							"apikey": "clé API",
							"cashierIds": "ID Caisse",
							"country": "Pays",
							"payments": {
								"cash": "Espèces",
								"credit": "Crédit",
								"debit": "Débit",
								"mbway": "Mbway",
								"others": "Autres",
								"paymentMethodId": "Moyen de paiement"
							}
						},
						"infoDataNfce": {
							"certificate": "Certificat",
							"certificatePassword": "Mot de passe du certificat",
							"cscNfceHomologation": "Homologation CSC NFC-e",
							"cscNfceProduction": "Production CSC NFC-e",
							"expirationDate": "Date d'expiration",
							"idNfceHomologation": "Homologation ID NFC-e",
							"idNfceProduction": "Production Id NFC-e"
						},
						"infoDataSat": {
							"serialNumberSat": "Numéro de série SAT"
						},
						"infoDataTax": {
							"mode": "Mode d'imposition"
						},
						"infoManifestation": {
							"manifestation": "Manifestation"
						},
						"infoNationalService": {
							"nationalService": "Serviço Nacional"
						},
						"infosGeneralData": {
							"email": "Email",
							"phone": "Téléphone"
						},
						"infosGeneralDataFiscalModeBR": {
							"cep": "Code postal",
							"county": "Ville",
							"neighborhood": "Quartier",
							"number": "Numéro",
							"publicPlace": "Rue",
							"state": "État"
						},
						"infosTipConfig": {
							"taxGroup": "Groupe fiscal",
							"registered": "Enregistré"
						},
						"titles": {
							"companyData": "Données de l'entreprise",
							"generalData": "Données générales",
							"taxData": "Données fiscales",
							"tipConfig": "Configuration de la pointe"
						}
					},
					"editData": "Modifier information",
					"viewlinkedplaces": "Voir les lieux associés",
					"drawerCouvert": {
						"code": "SKU",
						"couvertGeneralData": "Données générales de couvert",
						"taxGroup": "Groupe fiscal",
						"taxProfile": "Profil fiscal"
					},
					"drawerGroup": {
						"excludeTaxGroup": "Exclure le groupe",
						"titles": {
							"generalData": "Données générales",
							"vat": "VAT",
							"service": "Service"
						},
						"fiscalProductGroupType": {
							"vat": "Taxe sur la Valeur Ajoutée (VAT)",
							"vatFactura": "Taxe sur la Valeur Ajoutée (VAT) - Mexico",
							"service": "Service",
							"invoice": "Facture",
							"serviceNational": "Service National"
						},
						"fields": {
							"taxRate": {
								"label": "Taux d'imposition (%)"
							},
							"code": {
								"label": "SKU"
							},
							"productType": {
								"label": "Type de produit"
							},
							"taxExemption": {
								"label": "Exonération fiscale"
							},
							"taxType": {
								"label": "Type d'impôt"
							}
						}
					}
				},
				"infoCard": {
					"seeDatails": "Voir détails"
				},
				"modalPlaces": {
					"message": "Utilisez le tableau ci-dessous pour activer et désactiver la {{ groupOrProfile }} d'imposition dans votre organisation",
					"group": "Groupe",
					"profile": "Profil",
					"title": "Lieux liés au {{ groupOrProfile }} d'imposition: {{ name }}",
					"searchPlace": "rechercher des endroits",
					"placesAt": "Endroits dans"
				},
				"modalDelete": {
					"messageProfile": "En confirmant l'action, vous supprimerez définitivement le profil fiscal {{ profile }}. Souhaitez-vous continuer?",
					"messageGroup": "En confirmant l'action, vous supprimerez définitivement le groupe fiscal {{ group }}. Souhaitez-vous continuer?",
					"profileDeletedSuccess": "Profil fiscal supprimé avec succès !",
					"groupDeletedSuccess": "Groupe fiscal supprimé avec succès !"
				}
			},
			"taxTabs": {
				"tabTaxCouvert": {
					"emptyTaxCouvertMessage": "Il n'y a pas de données sur la taxe des couvertsRecherche de données fiscales sur les couverts",
					"infosTaxCouvert": {
						"cest": "CEST",
						"cfop": "CFOP",
						"code": "SKU",
						"group": "Groupe",
						"ncm": "NCM",
						"profile": "Profil"
					},
					"searchPlaceholder": "Recherche de données fiscales sur les couverts"
				},
				"tabTaxGroups": {
					"addNewTaxGroup": "Ajouter nouveau groupe",
					"emptyTaxGroupsMessage": "Il n'y a pas de groupe fiscal sur les produits à afficher",
					"infosTaxGroup": {
						"aliquot": "Aliquot",
						"cfop": "CFOP",
						"tax": "Taxe",
						"type": "Type"
					},
					"searchPlaceholder": "Rechercher groupes fiscaux des produits",
					"typeLabel": {
						"invoice": "Factures",
						"service": "Service",
						"vat": "TVA"
					}
				},
				"tabTaxProfiles": {
					"addNewTaxProfile": "Ajouter nouveau profil",
					"emptyTaxProfilesMessage": "Il n'y a pas de profil fiscal à montrer",
					"infosTaxProfile": {
						"cnpj": "CNPJ",
						"corporateName": "Nom de l'entreprise",
						"fantasyName": "Nom d'emprunt",
						"stateRegistration": "Enregistrement de l'État",
						"taxRegime": "Régime fiscal",
						"phone": "Téléphone",
						"email": "E-mail"
					},
					"optionsTaxation": {
						"normalRegime": "Régime normal",
						"simpleNational": "Simple national",
						"simpleNationalExcess": "Franchise nationale simple"
					},
					"searchPlaceholder": "Rechercher Profil fiscal"
				}
			},
			"titlePage": "Données fiscales",
			"titlesTabs": {
				"taxCouvert": "Données fiscales des couverts",
				"taxGroups": "Groupes de taxe sur les produits",
				"taxProfiles": "Profils fiscaux",
				"minimumConsummation": "Consommation minimale",
				"recharge": "Recharge"
			}
		},
		"fiscalCouvertForm": {
			"editOfPlace": "Modifier le couvert fiscal de {{ placeName }}",
			"fields": {
				"code": {
					"label": "SKU",
					"placeholder": "Insérer le SKU"
				},
				"NCM": {
					"label": "NCM",
					"placeholder": "Insérer le NCM"
				},
				"CEST": {
					"label": "CEST",
					"placeholder": "Insérer le CEST"
				},
				"taxProfile": {
					"label": "Profil fiscal"
				},
				"taxGroup": {
					"label": "Groupe fiscal"
				}
			}
		},
		"fiscalGroupForm": {
			"navigateBackGroupLabel": "Retourner aux groupes fiscaux",
			"navigateBackCouvertLabel": "Retourner aux couvert fiscaux",
			"titleSteps": {
				"vat": "Taxe sur la Valeur Ajoutée",
				"service": "Service",
				"serviceNational": "Service National",
				"general": "Données générales"
			},
			"steps": {
				"general": {
					"fields": {
						"name": {
							"label": "Nom",
							"placeholder": "Nom du groupe"
						},
						"type": {
							"label": "Type"
						}
					},
					"types": {
						"invoice": "Facture",
						"vat": "VAT Portugal",
						"vatFactura": "VAT Mexico",
						"vatSpain": "VAT Espagne",
						"service": "Service",
						"serviceNational": "Service National"
					}
				},
				"vat": {
					"fields": {
						"taxRate": {
							"label": "Taux d'imposition (%)"
						},
						"code": {
							"label": "SKU",
							"placeholder": "Sélectionner le SKU"
						},
						"productType": {
							"label": "Type de produit",
							"placeholder": "Sélectionner le type de produit"
						},
						"taxExemption": {
							"label": "Exonération fiscale",
							"placeholder": "Sélectionner l'exonération fiscale"
						},
						"taxType": {
							"label": "Sélectionnez impuesto",
							"placeholder": "Sélectionnez le type de taxe"
						},
						"region": {
							"label": "Région",
							"placeholder": "Sélectionner la région"
						}
					},
					"vatVendusTaxExemptionOptions": {
						"M01": "Article 16, paragraphe 6 du CIVA ou similaire",
						"M02": "Article 6 du décret-loi n° 198/90, du 19 juin",
						"M03": "Exigibilité de caisse",
						"M04": "Article 13 du CIVA ou similaire",
						"M05": "Article 14 du CIVA ou similaire",
						"M06": "Article 15 du CIVA ou similaire",
						"M07": "Article 9 du CIVA ou similaire",
						"M08": "TVA (autoliquidation)",
						"M09": "TVA (pas de droit à déduction)",
						"M10": "TVA (régime d'exemption : article 53 du CIVA)",
						"M11": "Régime spécial du tabac",
						"M12": "Régime de marge bénéficiaire pour les agences de voyage",
						"M13": "Régime de marge bénéficiaire pour les biens d'occasion",
						"M14": "Régime de marge bénéficiaire pour les objets d'art",
						"M15": "Régime de marge bénéficiaire pour les objets de collection et les antiquités",
						"M16": "Article 14 du RITI ou similaire",
						"M99": "Non soumis ; non imposé ou similaire"
					},
					"vatVendusProductTypeOptions": {
						"P": "Produit",
						"S": "Service",
						"O": "Autre (frais de port, avances, etc.)",
						"I": "Impôt (à l'exception de la TVA et de l'IS) ou Charge Parafiscale",
						"E": "Impôt spécial sur la consommation (IABA, ISP et IT)"
					},
					"vatVendusCodeOptions": {
						"INT": "Taux intermédiaire",
						"ISE": "Exonéré",
						"NOR": "Taux normal",
						"RED": "Taux réduit",
						"RED2": "Tarif super réduit",
						"OUT": "Tarif exceptionnel",
						"OUT2": "Tarif exceptionnel 2"
					}
				}
			}
		},
		"fiscalProfileForm": {
			"components": {
				"infoBanner": {
					"tipError": {
						"title": "Nous n'avons pas pu terminer l'inscription.",
						"description": "Vérifiez les champs remplis ou réessayez dans quelques minutes."
					}
				}
			},
			"steps": {
				"company": {
					"fields": {
						"CNPJ": {
							"label": "CNPJ",
							"placeholder": "Saisir CNPJ"
						},
						"cityCode": {
							"label": "Ville",
							"placeholder": "Saisir la ville"
						},
						"corporateReason": {
							"label": "Raison sociale",
							"placeholder": "Saisir la Raison sociale"
						},
						"fantasyName": {
							"label": "Nom d'emprunt",
							"placeholder": "Saisir le nom d'emprunt"
						},
						"municipalRegistration": {
							"label": "Inscription au registre municipal",
							"placeholder": "Saisir l'Inscription au registre municipal"
						},
						"stateRegistration": {
							"label": "Enregistrement de l'État",
							"placeholder": "Saisir l'Enregistrement de l'État"
						},
						"taxRegime": {
							"label": "Régime fiscal",
							"placeholder": "Sélectionner le Régime fiscal"
						}
					},
					"optionsTaxation": {
						"normalRegime": "Régime normal",
						"simpleNational": "Simple national",
						"simpleNationalExcess": "Simple national excess"
					}
				},
				"fiscal": {
					"fieldsIvaVendus": {
						"apikey": {
							"label": "Clé API",
							"placeholder": "Saisir la clé API"
						},
						"cashierIds": {
							"label": "Id Caissier",
							"placeholder": "Saisir l'Id Caissier"
						},
						"country": {
							"label": "Pays",
							"placeholder": "Sélectionner un pays",
							"options": {
								"PT": "PT - Portugal",
								"ES": "ES - Espagne"
							}
						},
						"paymentMethodIds": {
							"labelCash": "Espèces",
							"labelCredit": "Crédit",
							"labelDebit": "Débit",
							"labelMbway": "Mbway",
							"labelOthers": "Autres",
							"labelPayment": "IDs moyen de paiement:",
							"placeholderPaymentId": "Saisir ID"
						}
					},
					"fieldsIvaFactura": {
						"apikey": {
							"label": "Clé API",
							"placeholder": "Insérer la clé API"
						},
						"secretkey": {
							"label": "Clé secrète API",
							"placeholder": "Insérer la clé secrète API"
						},
						"fiscalProductGroup": {
							"label": "Groupe fiscal de produit",
							"placeholder": "Choisir le groupe fiscal de produit"
						},
						"autoInvoicingURL": {
							"label": "URL d'auto-facturation",
							"placeholder": "Insérer l'URL d'auto-facturation"
						},
						"issuerDocument": {
							"label": "RFC de l'émetteur",
							"placeholder": "Insérer le RFC de l'émetteur"
						},
						"expiration": {
							"label": "Date d'expiration",
							"placeholder": "Choisir une option pour la date d'expiration",
							"expirationDaysLabel": "Jours après la date de transaction",
							"expirationDaysPlaceholder": "Choisir les jours après la date de transaction",
							"expirationDaysHint": "En fixant une échéance dépassant le mois de création de la transaction, la date d'expiration sera le dernier jour du mois.",
							"lastMonthDay": "Le dernier jour du mois",
							"daysAfterTransaction": "Jours après la date de transaction"
						}
					},
					"fieldsNfce": {
						"certificate": {
							"label": "Certificat"
						},
						"certificatePassword": {
							"label": "Mot de passe du Certificat",
							"placeholder": "Saisir le mot de passe du certificat"
						},
						"cscNfceHomologation": {
							"label": "Homologation CSC NFC-e",
							"placeholder": "Saisir l'homologation CSC NFC-e"
						},
						"cscNfceProduction": {
							"label": "Production CSC NFC-e",
							"placeholder": "Saisir la production CSC NFC-e"
						},
						"expirationDate": {
							"label": "Date d'expiration",
							"placeholder": "00/00/0000"
						},
						"idNfceHomologation": {
							"label": "Homologation ID NFC-e",
							"placeholder": "Saisir l'homologation ID NFC-e"
						},
						"idNfceProduction": {
							"label": "Production Id NFC-e",
							"placeholder": "Saisir la production ID NFC-e"
						}
					},
					"fieldsSat": {
						"serialNumberSat": {
							"label": "Numéro de série SAT",
							"placeholder": "Saisir le Numéro de série SAT"
						}
					},
					"optionsTaxation": {
						"SimpleNationalExcess": "Simple national excess",
						"normalRegime": "Régime normal",
						"simpleNational": "Simple national"
					}
				},
				"general": {
					"fieldsAddress": {
						"cep": {
							"label": "CEP",
							"placeholder": "00000-000"
						},
						"complement": {
							"label": "Complément",
							"placeholder": "Saisir le complément"
						},
						"county": {
							"label": "Région",
							"placeholder": "Saisir la Région"
						},
						"neighborhood": {
							"label": "Quartier",
							"placeholder": "Saisir le Quartier"
						},
						"number": {
							"label": "Numéro",
							"placeholder": "Saisir le numéro"
						},
						"publicplace": {
							"label": "Place publique",
							"placeholder": "Saisir la Place publique"
						},
						"uf": {
							"label": "UF",
							"placeholder": "Sélectionner l'État"
						}
					},
					"fieldsGeneral": {
						"email": {
							"label": "Email",
							"placeholder": "Saisir email"
						},
						"fiscalMode": {
							"label": "Mode fiscal",
							"placeholder": "Sélecyionner le mode fiscal"
						},
						"name": {
							"label": "Nom",
							"placeholder": "Nom du profil"
						},
						"phone": {
							"label": "Téléphone",
							"placeholder": "Saisir le Téléphone",
							"error": "Numéro de téléphone non valide: doit contenir 10 à 11 chiffres avec l'indicatif régional",
							"errorIvaVendus": "Numéro de téléphone invalide : doit contenir 9 chiffres",
							"errorIvaFactura": "Numéro de téléphone invalide : doit contenir 9 à 12 chiffres"
						}
					},
					"optionsFiscalMode": {
						"ivaFactura": "IVA - Factura",
						"ivaVendus": "TVA - Vendus",
						"nfce": "NFC-e",
						"sat": "SAT"
					}
				},
				"service": {
					"descriptionInfoWarning": "Les champs ci-dessous sont obligatoires pour l'émission des factures. S'ils ne sont pas modifiés, les factures seront émises selon la norme fiscale de ZIG.",
					"insertCestManual": "Ajouter manuellement CEST?",
					"labelFields": {
						"CEST": "CEST",
						"NCM": "NCM",
						"code": "Code",
						"name": "Nom",
						"taxGroup": "Groupe fiscal",
						"taxProfile": "Profil fiscal"
					},
					"messageErrorNotReturnCest": "Impossible de renvoyer le CEST au MR renseigné",
					"messageErrorNotReturnTaxGroups": "Impossible de renvoyer les groupes fiscaux",
					"placeholderFields": {
						"CEST": "Saisir CEST",
						"NCM": "Saisir NCM",
						"code": "Code Service",
						"name": "Saisir nom",
						"selectCEST": "Sélectionner CEST",
						"taxGroup": "Sélectionner le groupe fiscal",
						"taxProfile": "Profil fiscal"
					},
					"titleInfoWarning": "Données requises pour la délivrance"
				}
			},
			"titleSteps": {
				"company": "Données de l'entreprise",
				"fiscal": "Données fiscales",
				"general": "Informations générales",
				"tip": "Paramètres de pourboire"
			},
			"navigateBackLabel": "Retourner aux profils fiscaux"
		},
		"giftback": {
			"giftbacks": {
				"title": "Campagnes de giftback",
				"description": "Créez et gérez vos campagnes de giftback.",
				"createGiftback": "Créer giftback",
				"searchPlaceholder": "Rechercher par nom de campagne",
				"deleteConfirm": "Êtes-vous sûr de vouloir supprimer le giftback ?",
				"deleteGiftback": "Supprimer le giftback",
				"steps": {
					"general": {
						"title": "Configuration générale"
					},
					"resume": {
						"title": "Résumé"
					}
				},
				"emptyState": {
					"title": "Il n'y a encore rien ici...",
					"description": "Ajustez le filtre de recherche ou ajoutez une nouvelle campagne de giftback."
				},
				"buttonsTitle": {
					"createAndActivateLater": "Créer et activer plus tard",
					"createAndActivateNow": "Créer et activer giftback",
					"saveChanges": "Enregistrer les modifications"
				},
				"feedbackerros": {
					"selectAtLeastOnePlace": "Sélectionnez au moins un endroit",
					"maxCharactersName": "Maximum de 50 caractères"
				},
				"form": {
					"active": "Activer giftback",
					"name": "Nom de la campagne",
					"namePlaceHolder": "Entrez le nom de la campagne",
					"minimumConsumptionLabel": "Montant minimum de consommation",
					"minimumConsumptionTooltip": "Montant que le client doit consommer pour le convertir en giftback.",
					"percentageLabel": "Pourcentage",
					"percentageTooltip": "Combien du montant consommé par le client sera offert à celui-ci.",
					"expiresInLabel": "Délai d'expiration du giftback",
					"expiresInTooltip": "Nombre maximum de jours pendant lesquels le client doit utiliser le giftback.",
					"expiresInPlaceholder": "Sélectionnez le délai pour expirar le giftback",
					"expiresAtLabel": "Période de rachat",
					"expiresAtTooltip": "Temps que le client aura pour profiter du giftback.",
					"expiresAtPlaceholder": "Sélectionnez la période de validité du giftback",
					"placeLabel": "Endroits participants",
					"removeGiftback": "Supprimer le giftback",
					"selectAll": "Tout sélectionner",
					"day": "jour",
					"days": "jours",
					"week": "semaine",
					"noValidity": "Aucune validité",
					"selectAllPlacesDescription": "Sélectionnez les endroits où le giftback sera disponible.",
					"shouldConsiderEntranceLabel": "Inclure les entrées dans le calcul du Giftback"
				},
				"tabs": {
					"addNewGiftback": "Ajouter un nouveau giftback"
				}
			},
			"giftbackReport": {
				"selectGiftbackLabel": "Campagne",
				"selectGiftbackPlaceholder": "Sélectionnez la/les campagne(s)",
				"table": {
					"createdAt": "Créé le",
					"giftback": "Campagne",
					"messagesSent": "SMS envoyés",
					"places": "Lieux",
					"rescues": "Rescues",
					"totalValue": "{{ currencySymbol }} totale des ventes",
					"giftbackSent": "Total des giftbacks",
					"giftbackValue": "{{ currencySymbol }} giftback échangé",
					"conversionRate": "Taux de conversion"
				},
				"title": "Rapport de rescues",
				"totalizers": {
					"quantity": "Campagnes créées",
					"totalRescues": "Total des rescues",
					"totalSales": "Ventes totales utilisant le giftback",
					"totalSms": "Total des SMS créés"
				}
			},
			"giftbackPowerBi": {
				"title": "Rapport de Giftback"
			}
		},
		"giftCard": {
			"tabs": {
				"campaigns": "Campagnes",
				"metabase": "Performance"
			},
			"pageTitleList": "Gift Card",
			"pageSubtitle": "Configurez votre carte cadeau pour les campagnes.",
			"modalTitle": "Gift Cards",
			"modalDescription": "Campagne créée avec succès. Vous pouvez maintenant exporter le fichier pour utiliser les coupons.",
			"manageGiftCardModal": {
				"title": {
					"active": "Activer la campagne",
					"inactive": "Désactiver la campagne"
				},
				"description": {
					"active": "Activation de la campagne ({{campaign}}), continuer ?",
					"inactive": "Désactivation de la campagne ({{campaign}}), continuer ?"
				}
			},
			"fields": {
				"campaignName": "Nom de la campagne",
				"campaignPlaces": "Emplacement",
				"campaignCreatedAt": "Date de création",
				"numberOfGifts": "Nombre de coupons",
				"giftCardValue": "Valeur unitaire",
				"giftCardExpirationDate": "Date d'expiration",
				"giftCardRedeemed": "sauvé",
				"validation": {
					"campaignNameAlreadyExists": "Ce nom de campagne existe déjà"
				}
			},
			"form": {
				"validations": {
					"required": "Champ obligatoire"
				},
				"messages": {
					"successInCreating": "Campagne créée avec succès",
					"failedToCreate": "Échec de la création de la campagne",
					"successInCreatingSubtitle": "Accédez à tous les codes de la campagne en téléchargeant la feuille de calcul ci-dessous :",
					"campaignEdited": "Campagne mise à jour",
					"campaignEditedFailure": "Échec de la mise à jour de la campagne"
				}
			},
			"actions": {
				"label": "Actions",
				"exportCupons": "Exporter les coupons",
				"track": "Piste",
				"createCampaign": "Créer une campagne",
				"inactivate": "Désactiver",
				"activate": "Activer",
				"expired": "Expiré"
			},
			"status": {
				"label": "Statut",
				"active": "Active",
				"inactive": "Inactive"
			},
			"excel": {
				"title": "Cartes cadeaux",
				"filename": "cartes-cadeaux",
				"columns": {
					"giftCardcodes": "Codes",
					"giftCardValue": "Valeur unitaire"
				}
			}
		},
		"helpers": {
			"humanize": {
				"paymentMethod": {
					"ame": "Ame",
					"anticipated": "Anticipé",
					"app": "App",
					"automaticDebit": "Débit automatique",
					"bankTransfer": "Virement bancaire",
					"bleedings": "Retrait d'espèces",
					"boleto": "Relevé bancaire",
					"bonus": "Bonus",
					"cash": "Espèces",
					"check": "Chèque",
					"consumptionFromBar": "Consommation anticipée",
					"creditCard": "Carte de crédit",
					"dashboard": "Tableau de bord",
					"debitCard": "Carte de débit",
					"deliveryOnline": "Livraison en ligne",
					"ifood": "Ifood",
					"other": "Autre",
					"pix": "Pix",
					"postEvent": "Post événement",
					"promissory": "Promesse de paiement",
					"rappi": "Rappi",
					"uber": "Uber",
					"voucher": "Voucher",
					"zigCredit": "Crédit ZIG",
					"zigDebit": "Débit ZIG",
					"zigPosCredit": "Post crédit ZIG",
					"zigPosDebit": "Post débit ZIG",
					"zigPosCreditInInstallments": "Crédit en versements",
					"integratedFoodVoucher": "Ticket Restaurant"
				}
			},
			"string": {
				"grams": "Grammes",
				"kilogram": "Kilogrammes",
				"liter": "Litres",
				"lowercase": {
					"grams": "grammes",
					"kilogram": "kilogramme",
					"liter": "litre",
					"milliliter": "millilitre",
					"unit": "unité"
				},
				"milliliter": "Mililitre",
				"unit": "Unité"
			}
		},
		"loyalty": {
			"commingSoon": {
				"cards": {
					"paper": {
						"description": "Vos clients peuvent suivre et échanger leurs points gagnés via l'application Zig.app.",
						"title": "Dites adieu au papier."
					},
					"retainCustomers": {
						"description": "Choisissez les lieux participants, les récompenses, les points et engagez vos clients.",
						"title": "Fidéliser les clients"
					},
					"trackResults": {
						"description": "Vous pouvez suivre les performances de vos programmes de fidélisation.",
						"title": "Suivre les résultats"
					}
				},
				"description": "Vous pouvez choisir parmi différents moyens pour vos clients de gagner des points et les récompenses qu'ils recevront. Augmentez la fidélisation de vos clients en les incitant à visiter des sites ou à acheter un produit en échange de points, parmi d'autres options disponibles dans le module de fidélisation.",
				"subtitle": "Améliorez vos résultats et l'expérience de vos clients grâce aux programmes de fidélisation."
			},
			"title": "Fidélisation client",
			"tabs": {
				"programs": {
					"createSteps": {
						"points": {
							"pointRules": {
								"npsAnswer": {
									"mainTitle": "Réponse NPS",
									"description": "Définir le nombre de points que les clients gagneront lorsqu'ils répondront à l'enquête de satisfaction",
									"detailTitle": "Nombre de points par réponse à l'enquête de satisfaction"
								}
							},
							"npsAnswerPoints": {
								"inputLabel": "Points",
								"inputPlaceholder": "Entrez les points par réponse NPS",
								"continueButtonText": "Ajouter des points"
							}
						}
					}
				}
			}
		},
		"productFeatureTemplates": {
			"activeTab": "modèles-fonctionnalité-produit",
			"form": {
				"addProduct": {
					"fields": "Remplir au moins un champ",
					"isRequired": "Ce champ est obligatoire",
					"wrongFields": {
						"field": "champ",
						"from": "de",
						"label": "Remplir toutes les données",
						"of": "de"
					}
				},
				"createModel": "Créer modèle",
				"editModel": "Modifier modèle",
				"isRequired": "Ce champ est obligatoire",
				"templateFieldsContainer": {
					"add": "Ajouter champ",
					"field": "Champ {{number}}",
					"isRequired": "Est-ce que le champ {{number}} est requis?",
					"label": "Modèle de champs",
					"name": {
						"label": "Nom du champ {{number}}",
						"placeholder": "Saisir le nom du champ {{number}}"
					},
					"remove": "Supprimer le champ",
					"type": {
						"bool": "Vrai/Faux",
						"enum": "Options",
						"label": "Type de champ {{number}}",
						"number": "Numéro",
						"placeholder": "Sélectionner le type de champ",
						"text": "Texte"
					},
					"value": {
						"label": "Options pour le champ{{number}}",
						"placeholder": "Valeur {{count}} du champ {{number}}"
					}
				},
				"templateName": {
					"label": "Nom du modèle",
					"placeholder": "Saisir le nom du modèle"
				},
				"templateObservation": {
					"label": "Commentaires",
					"placeholder": "Écrire un commentaire (optionnel)"
				}
			},
			"header": {
				"add": "Ajouter un modèle"
			},
			"modal": {
				"add": "Ajouter",
				"edit": "Modifier",
				"title": "modèle de fonctionnalité du produit"
			},
			"templateList": {
				"actions": {
					"edit": "Modifier le modèle",
					"remove": "Supprimer le modèle",
					"title": "Voulez-vous vraiment supprimer le modèle ? Toutes les fonctionnalités qui l'utilisent seront également désactivées."
				},
				"status": {
					"title": "Voulez-vous vraiment désactiver le modèle ? Toutes les fonctionnalités qui l'utilisent seront également désactivées."
				}
			},
			"title": "Modèles de fonctionnalité des produits",
			"tooltip": "Créer des modèles avec des champs personnalisés pour votre produit"
		},
		"communication": {
			"actions": {
				"campaignCategoryModal": {
					"placeholder": "Sélectionner une campagne",
					"successMessage": "Campagne liée au message",
					"text": "Sélectionner une campagne",
					"textButtonConfirm": "Confirmer la sélection",
					"title": "Envoi d'un lien vers la campagne",
					"tooltipMessage": "OPTIONNEL : Lier cet envoi à une campagne pour faciliter l'analyse des performances de plusieurs envois ensemble."
				},
				"cancelModal": {
					"at": "à",
					"cancel": "Annuler l'expédition",
					"clients": "clients dans la journée",
					"close": "Fermer",
					"confirm": "Lorsque vous annulez l'envoi, votre solde est reversé sur votre compte dans les heures qui suivent.",
					"text": "Voulez-vous annuler l'envoi du message programmé pour "
				},
				"list": {
					"canceled": "Voir le rapport sur les messages",
					"schedule": {
						"cancelShipping": "Annuler l'expédition",
						"editAddressees": "Modifier les destinataires",
						"editMessage": "Modifier le contenu du message",
						"hitchCampaign": "Envoi d'un lien vers la campagne"
					},
					"sent": "Voir le rapport d'expédition"
				}
			},
			"at": "à",
			"columns": {
				"campaign": "Campagne",
				"channel": "Canal",
				"date": "Date et heure",
				"impactedCustomers": "Clients concernés",
				"message": "Message",
				"place": "Lieu",
				"status": "Statut"
			},
			"export": "Export Excel",
			"label": "Messages envoyés",
			"message": {
				"columnsTableClients": {
					"attendance": "Visites",
					"cpf": "CPF",
					"name": "Nom du client",
					"ticket": "Ticket moyen"
				},
				"crudMessage": {
					"campaignModal": {
						"confirmButton": "Créer une campagne",
						"placeholder": "Saisir le nom de la campagne",
						"title": "Nom de la campagne",
						"tooltipMessage": "OPTIONNEL : Lier cet envoi à une campagne pour faciliter l'analyse des performances de plusieurs envois ensemble."
					},
					"campaignSelect": {
						"createOrSearch": "Recherche par campagne ou création d'une nouvelle campagne",
						"placeholder": "Sélectionner une campagne",
						"text": "OPTIONNEL : Lier cet envoi à une campagne pour faciliter l'analyse des performances de plusieurs envois ensemble.",
						"title": "Campagne"
					},
					"campaignsDetail": {
						"canceled": "Annulée",
						"canceledMessage": "Le message qui devait être envoyé le {{day}} a été annulé",
						"client": "client",
						"clients": "clients",
						"columns": {
							"clientName": "Nom du client",
							"cpf": "CPF",
							"gender": "Genre",
							"phone": "Téléphone",
							"status": "Statu"
						},
						"genders": {
							"female": "Femme",
							"male": "Homme",
							"other": "Autre",
							"uninformed": "Non renseigné"
						},
						"programmedMessage": "Votre message a été programmé le {{day}} pour être envoyé le {{date}}",
						"sent": "Envoyé",
						"sentInDay": "Envoyé le jour {{day}} à"
					},
					"content": "Contenu du message",
					"create": {
						"client": "personne",
						"clients": "personnes",
						"mes": "Cliquez ici pour obtenir des informations sur le contenu",
						"subtitle": {
							"sms": "Saisissez le contenu qui sera envoyé à la liste de clients sélectionnée. Votre message aura un impact sur ",
							"whatsapp": "Sélectionnez un modèle en fonction de ce que vous souhaitez communiquer, puis modifiez ses paramètres."
						},
						"subtitleTemplateList": "Sélectionnez un modèle en fonction de ce que vous souhaitez communiquer, puis modifiez ses paramètres.",
						"title": "Nouveau message"
					},
					"day": "Jour",
					"edit": {
						"subtitle": "Réécrire le contenu du message ou modifier le calendrier d'envoi.",
						"title": "Modifier un message programmé"
					},
					"errors": {
						"campaign": "Impossible de créer une campagne.",
						"editMessage": {
							"sendNow": "Données mises à jour. Un message sera envoyé sous peu.",
							"success": "Données mises à jour."
						},
						"place": "Impossible d'identifier le lieu",
						"smsCost": "Le coût du SMS doit être configuré"
					},
					"footer": {
						"reprogram": "Reprogrammer l'envoi de SMS",
						"scheduleShipping": "Programmer l'envoi de SMS",
						"send": "Envoyer un SMS maintenant"
					},
					"hour": "Heure",
					"modalMessage": {
						"addBalance": "Ajouter solde",
						"messageScheduled": {
							"at": "à",
							"cancelOrEdit": "Si vous souhaitez vous désabonner ou modifier le contenu, retournez dans la liste des messages et modifiez les informations d'expédition.",
							"client": "client",
							"clients": "clients",
							"clientsCount": "Votre message sera envoyé à ",
							"day": "jour",
							"of": "de"
						},
						"messageSent": {
							"client": "client",
							"clients": "clients",
							"clientsCount": "Votre message a été envoyé à ",
							"of": "de"
						},
						"messageTips": {
							"tipFour": "Lancement d'un nouveau produit ? Filtrez vos meilleurs clients et envoyez-leur toutes les informations relatives à votre produit.",
							"tipThree": "Une promotion intéressante est-elle prévue ? Filtrez le groupe de clients qui ont droit à la promotion et envoyez des SMS ciblés.",
							"tipTwo": "Vous pouvez inclure des liens importants pour vos clients. Les liens vers votre page d'accueil ou votre billetterie permettent au client d'accéder plus facilement aux informations et d'acheter des billets.",
							"tips": "Conseils sur ce que vous pouvez faire",
							"typeOne": "Un message bien rédigé a un impact unique sur vos clients ! Comme vous disposez de {{characters}}, votre message doit idéalement être succinct, clair et direct."
						},
						"notBalance": "Vous ne disposez pas d'un solde suffisant pour envoyer des SMS au groupe sélectionné. Voulez-vous ajouter le solde restant ?",
						"title": {
							"messageScheduled": "Message programmé",
							"messageSent": "Message envoyé",
							"messageTips": "Conseils sur les messages"
						}
					},
					"program": "Programmer l'envoi",
					"resumeCard": {
						"amountMessageNotReceived": {
							"error": {
								"sms": "SMS non reçu par erreur",
								"whatsapp": "messages non reçus par erreur"
							},
							"notRecieved": {
								"sms": "SMS non reçu",
								"whatsapp": "messages non reçus"
							},
							"optout": {
								"sms": "SMS non reçu par optout",
								"whatsapp": "messages non reçus par l'optout"
							}
						},
						"amountMessageReceived": {
							"sms": "SMS reçus",
							"whatsapp": "messages reçus"
						},
						"amountMessageSent": "Total des destinataires",
						"footerText": {
							"addedValue": "Le montant de {{value}} sera ajouté au paiement des charges mensuelles de ZIG.",
							"charactersLimit": "Le nombre de caractères a dépassé la limite. Le coût du SMS a été modifié et le montant de {{value}} sera ajouté au paiement mensuel de ZIG.",
							"noExtraCost": "Comme il n'y a pas eu de changement dans le montant de la liste des destinataires, il n'y aura pas de coût supplémentaire.",
							"smsBalanceAddedValue": "Le montant supplémentaire de {{value}} sera ajouté au paiement de la redevance mensuelle de ZIG.",
							"smsBalanceSubtractedValue": "La montant de {{value}} sera déduite du paiement de la redevance mensuelle de ZIG.",
							"summarizes": "Les messages adressés aux clients qui se désistent ne sont pas facturés."
						},
						"messageCost": "Frais d'envoi",
						"messageInProcess": {
							"sms": "SMS en cours",
							"whatsapp": "Message en cours"
						},
						"postShipmentBalance": "Solde après envoi",
						"rescheduledShippingCost": "Coût de l'envoi reprogrammé",
						"resume": "Résumé de la demande",
						"sms": "SMS"
					},
					"sendNow": "Envoyer maintenant",
					"success": {
						"createTemplate": "Nouveau modèle demandé"
					},
					"summarizes": "Données d'envoi",
					"textArea": {
						"at": "at",
						"character": "caractère restant",
						"characters": "caractères restants",
						"content": "Contenu du message",
						"copy": "Copier le contenu du message",
						"footer": "Conseil : pour ajouter des variables et pouvoir les modifier ultérieurement, tapez [VARIABLE] entre crochets.",
						"placeholder": "Rédigez le contenu du message pour le groupe sélectionné...",
						"successCopy": "Message copié dans le presse-papiers"
					}
				},
				"emptyWhatsappList": "Aucun site de l'organisation n'a de numéro enregistré sur WhatsApp. Contactez l'équipe du service clientèle de ZIG et demandez l'enregistrement d'un numéro pour pouvoir envoyer des messages via WhatsApp à vos clients.",
				"footer": {
					"confirmWithSaveGroup": "Sauvegarder le groupe et continuer",
					"confirmWithoutSaveGroup": "Transférer sans sauvegarder le groupe",
					"forward": "Continuer",
					"save": "Sauvegarder les modifications et éditer le message"
				},
				"header": {
					"isCreate": {
						"subtitle": "Sélectionnez un lieu dans votre organisation pour répertorier le groupe de clients destinataires.",
						"title": "Nouveau message"
					},
					"isEdit": {
						"subtitle": "Modifiez la case pour sélectionner un autre groupe de destinataires.",
						"title": "Modifier un message programmé"
					}
				},
				"import": "Importer des tableaux Excel",
				"infos": {
					"agree": "Compris",
					"text": "En important la liste de contacts du client, dans le but d'envoyer des SMS, vous confirmez qu'il a accepté la réception de messages, conformément à la loi générale sur la protection des données (RGPD).",
					"title": "Responsabilité en matière d'information des clients"
				},
				"modalImportClients": {
					"add": "Ajouter clients",
					"addedClient": "client ajouté",
					"addedClients": "clients ajoutés",
					"clients": "Clients",
					"cpf": "CPF",
					"downloadSheet": "Télécharger le modèle de tableau",
					"emptyMessage": {
						"description": "Ajouter des clients par CPF ou en important une liste de CPF à partir de l'exemple de tableau.",
						"title": "Aucun client ajouté"
					},
					"feedback": {
						"default": "Une erreur s'est produite lors de l'importation du tableau",
						"download": "Téléchargement",
						"emptyHeaderCell": "Nom des colonnes manquants",
						"emptySheet": "Cette feuille est vide",
						"errorMessage": "Tableau invalide, téléchargez-la à nouveau et apportez les modifications nécessaires.",
						"sheetPoorlyFormatted": "Formatage de la feuille de calcul pour la police Calibri, taille 11, suppression des espaces, des retours à la ligne inutiles et des caractères gras.",
						"unidentifiedColum": "Erreur dans les noms de colonnes",
						"verifyBaseSheet": "Veuillez consulter l'exemple de modèle de tableau ou l'utiliser comme tableau de base."
					},
					"import": "Importer Clients",
					"importSheet": "Importer Tableau",
					"invalidClientList": "Liste Clients (invalide)",
					"name": "Nom",
					"phone": "Téléphone"
				},
				"modalMyModels": {
					"columns": {
						"model": "Modèle",
						"status": "Statut"
					},
					"emptyState": {
						"text": "Demandez un nouveau modèle pour envoyer des messages WhatsApp à vos clients",
						"title": "Pas de modèle enregistré"
					},
					"requestNewModel": "demander un nouveau modèle",
					"status": {
						"approved": "Approuvé",
						"pending": "En attente",
						"received": "Reçu",
						"rejected": "Rejeté"
					},
					"title": "Mes modèles"
				},
				"modalSaveGroup": {
					"filtersList": "Filtres appliqués",
					"groupName": {
						"placeholder": "Sélectionnez un nom pour le nouveau groupe de clients",
						"title": "Nom du groupe"
					},
					"text": "Enregistrez les filtres appliqués pour créer un groupe de clients et faciliter l'envoi de SMS à l'avenir.",
					"title": "Sauvegarder Groupe"
				},
				"myModels": "Mes modèles",
				"places": "Lieux",
				"sheet": {
					"columns": {
						"cpf": "CPF",
						"name": "Nom",
						"phone": "Téléphone"
					},
					"title": "Liste Clients (exemple)"
				}
			},
			"modalChannel": {
				"channel": {
					"email": {
						"description": "Sélectionner un lieu, filtrer les clients et envoyer des courriels personnalisés",
						"title": "Email"
					},
					"sms": {
						"description": "Sélectionner un lieu, filtrer les clients et envoyer des messages textuels standard",
						"title": "SMS"
					},
					"whatsapp": {
						"description": "Sélectionner un lieu, filtrer les clients et envoyer des messages WhatsApp",
						"title": "Whatsapp"
					}
				},
				"tags": {
					"comingSoon": "Prochainement",
					"new": "Nouveau"
				},
				"title": "Canal"
			},
			"new": "Nouveau message",
			"packages": {
				"header": {
					"subtitle": "Ajoutez un solde pour envoyer des messages à vos clients",
					"title": "Ajoute solde"
				},
				"modalPackage": {
					"addBalance": "et ajouter {{amount}} de solde sms?",
					"footer": {
						"sellPackage": "Acheter un forfait SMS"
					},
					"for": "par",
					"label": "Voulez-vous acheter le forfait ?",
					"title": "Acheter Forfait"
				},
				"packageCard": {
					"forSMS": "par SMS",
					"sell": "Acheter Forfait",
					"sms": "SMS",
					"tagLabel": "Tag Label"
				},
				"title": "Packages",
				"xlsx": {
					"date": "Date et heure",
					"filename": "compagnes sms",
					"impactedCustomers": "Clients concernés",
					"message": "Message",
					"place": "Lieu",
					"status": "Statut",
					"title": "Historique Campagne SMS"
				}
			},
			"permissionDenied": "Aucune localisation n'est autorisée pour gérer les messages WhatsApp",
			"status": {
				"canceled": "annualé",
				"delivered": "délivré",
				"error": "erreur",
				"notSent": "non envoyé",
				"optout": "optout",
				"scheduled": "programmé",
				"sending": "envoi",
				"sent": "envoyé"
			},
			"title": "Messages",
			"warningCard": {
				"label": "La valeur de {{value}} sera ajoutée au paiement des charges mensuelles de ZIG.",
				"title": "Paiement"
			},
			"whatsapp": {
				"actionButtons": {
					"actionButton": "Actions",
					"addButton": "Ajouter un autre bouton",
					"formatValidation": {
						"phoneNumber": "Numéro de téléphone invalide",
						"url": "Lien vers le site web invalide"
					},
					"noneButton": "Aucun",
					"optionsAction": {
						"label": {
							"accessWebsite": "Accéder au site web",
							"buttonText": "Texte du bouton",
							"country": "Pays",
							"makeCall": "Passer un appel",
							"phoneNumber": "Numéro de téléphone",
							"typeAction": "Type d'action",
							"websiteLink": "Lien vers le site web"
						},
						"placeholder": {
							"accessWebsite": "Accéder à notre site",
							"callNow": "Appeler maintenant",
							"enterNumber": "Saisir le numéro ici",
							"insertLink": "Insérer le lien ici"
						},
						"observation": {
							"name": "Commentaire",
							"description": "Commentaire"
						}
					},
					"quickResponseAction": {
						"placeholderQuickResponse": "Saisir une réponse rapide ici",
						"title": "Réponse rapide {{numbering}}"
					},
					"quickResponseButton": "Réponse rapide",
					"subTitle": "Il s'agit de boutons qui apparaissent comme des options cliquables juste après votre message.",
					"title": "Optional - Bouttons",
					"validationFields": {
						"requiredField": "Champ obligatoire {{field}}"
					}
				},
				"contentControlModal": {
					"alcoholicBeverages": "Boissons alcoolisées",
					"confirmation": {
						"label": "Je confirme que j'ai lu les politiques de WhatsApp Business et que je suis conscient(e) de ce qui peut être divulgué.",
						"paragraph": "Facebook a des règles concernant le type de contenu publié par WhatsApp. Confirmez-vous que vous avez lu les",
						"underlined": "politiques de confidentialité et êtes-vous conscient de ce qui peut ou ne peut pas être divulgué par la plateforme ?"
					},
					"paragraph1": {
						"text": "Whatsapp et Facebook ont des politiques d'utilisation claires. Tous les contenus de communication qui passent par la plateforme doivent être examinés et approuvés pour s'assurer qu'ils ne violent pas les politiques de Whatsapp. Voici quelques utilisations interdites tirées de la documentation elle-même.",
						"textLink": "Politique commerciale de WhatsApp. Pour lire la documentation complète, cliquez ici."
					},
					"paragraph2": {
						"text": "Compte tenu du contexte dans lequel ZigPay opère, nous devons clarifier certaines politiques contenues dans la documentation de politique commerciale de Whatsapp qui sont susceptibles d'interférer avec ce que vous pouvez divulguer sur la plateforme. Nous en avons énuméré quelques-unes ci-dessous, mais il est très important que vous lisiez le document de politique commerciale de Whatsapp.",
						"textLink": "la documentation complète relative à la politique commerciale."
					},
					"paragraph3": {
						"exampleBold": "Exemples:",
						"politicsBold": "Politique:",
						"text": "Les entreprises ne peuvent pas vendre ou promouvoir la vente de boissons alcoolisées."
					},
					"paragraph4": {
						"areAllowedBold": "Sont autorisés :",
						"text": "Divulgation de livres ou de DVD sur les boissons alcoolisées. ou des articles liés à l'alcool tels que des verres, des boissons non alcoolisées et des porte-bouteilles."
					},
					"paragraph5": {
						"areNotAllowedBold": "Ne sont pas autorisés :",
						"text": "Informations sur les boissons alcoolisées ou les kits de production de boissons alcoolisées."
					},
					"title": "Contrôle du contenu"
				},
				"newTemplatePage": {
					"footer": {
						"newModelButton": "Demander un nouveau modèle",
						"title": "Aperçu du message"
					},
					"glossary": {
						"client": {
							"description": "Nom du client",
							"name": "Nom du client"
						},
						"date": {
							"description": "Jour de la semaine ou date spécifique",
							"name": "Période"
						},
						"description": "Pour réutiliser ce modèle, entrez le code ci-dessous entre crochets, comme dans l'exemple : “[date]”",
						"discount": {
							"description": "Montant du Pourcentage de réduction",
							"name": "Pourcentage de réduction"
						},
						"originalProductPrice": {
							"description": "Prix initial du produit spécifique",
							"name": "Prix du produit"
						},
						"productName": {
							"description": "Nom du produit",
							"name": "Nom du produit spécifique"
						},
						"productPromotionalPrice": {
							"description": "Prix promotionnel d'un produit spécifique",
							"name": "Prix promotionnel du produit"
						},
						"title": "Glossaire des variables"
					},
					"glossaryVariables": {
						"client": "client",
						"date": "date",
						"discount": "réduction",
						"productName": "nom-produit",
						"productOriginalPrice": "prix-initial-produit",
						"productPromotionalPrice": "prix-promotionnel-produit",
						"observation": "commentaire"
					},
					"header": {
						"subtitle": {
							"link": "N'oubliez pas de toujours respecter les directives de WhatsApp en matière de contenu",
							"text": "La demande de nouveau modèle peut prendre quelques jours. Tapez ci-dessous ce que vous voulez inclure dans votre nouveau modèle."
						},
						"title": "Demander un nouveau modèle pour"
					},
					"imageLabel": "Image",
					"imageTooltipMessage": "Joindre une image à télécharger dans votre modèle",
					"invalideVariableMessage": "Vous devez utiliser l'une des variables du glossaire",
					"messageErrorUpload": "La pièce jointe doit être de type image.",
					"modelTitle": "Titre du modèle",
					"modelTitlePlaceholder": "Saisir le modèle",
					"modelTitleTooltipMessage": "Saisir un titre pour votre modèle",
					"removeFileButtonLabel": "Cliquez ici pour joindre une image",
					"textareaLabel": "Contenu du message",
					"textareaPlaceholder": "Écrivez ici le contenu du modèle. Conseil : pour ajouter des variables et pouvoir les modifier à l'avenir, suivez le glossaire ci-contre.",
					"textareaTooltipMessage": "Rédigez le contenu du modèle que vous souhaitez créer",
					"warning": {
						"description": "WhatsApp peut prendre jusqu'à trois jours pour autoriser le nouveau modèle. Pendant cette période, vous pouvez envoyer d'autres messages à partir des autres modèles de la zone précédente.",
						"responseDeadline": "Délai de réponse"
					}
				},
				"section": {
					"emptyTemplateState": {
						"text": "Demandez un nouveau modèle pour envoyer des messages WhatsApp à vos clients",
						"title": "Pas de modèle enregistré"
					},
					"footer": {
						"btnRequestNewModel": "Demander un nouveau modèle",
						"btnUnderstandWhy": "Comprendre pourquoi vous ne pouvez envoyer des messages WhatsApp qu'à partir de modèles"
					},
					"form": {
						"checkboxLabel": "Utiliser le nom du client de la banque",
						"previewTitle": "Aperçu du message",
						"title": "Définir les paramètres du message"
					},
					"header": {
						"editTitle": "Modifier un message WhatsApp",
						"goBack": "Revenir en arrière et sélectionner un autre modèle",
						"model": "Modèle"
					},
					"tags": {
						"approvedModel": "Modèle approuvé",
						"modelInValidation": "Modèle en cours de validation",
						"modelRecieved": "Modèle reçu par Whatsapp",
						"modelRefused": "Modèle non approuvé par Whatsapp"
					},
					"understandWhyModal": {
						"text": "Whatsapp et Facebook ont des politiques d'utilisation claires. Tous les contenus de communication qui passent par la plateforme doivent être examinés et approuvés pour s'assurer qu'ils n'enfreignent pas les politiques de Whatsapp. Pour vous assurer que les politiques de confidentialités sont respectées, vous ne pourrez entamer des conversations qu'à l'aide de ce modèle de message. Facebook se réserve le droit de réviser et de refuser les modèles de messages à tout moment.",
						"title": "Comprendre pourquoi vous ne pouvez envoyer des messages WhatsApp qu'à partir de modèles",
						"understandButton": "Compris"
					}
				}
			}
		},
		"products": {
			"emptyList": "Aucun produit trouvé",
			"functions": {
				"modal": {
					"sheet": {
						"columns": {
							"category": "Catégorie",
							"fiscalCode": "SKU",
							"fiscalNcm": "Fiscal - NCM",
							"hasAlcohol": "Le produit contient-il de l'alcool ?",
							"id": "Id Produit",
							"name": "Nom",
							"type": "Type de Produit"
						},
						"inventory": "stock"
					}
				}
			},
			"tabs": {
				"categories": {
					"add": "Ajouter catégorie",
					"addProduct": "Ajouter produit dans {{category}}",
					"addSubcategory": "Ajouter sous-catégorie dans {{category}}",
					"categoryModal": {
						"create": "Créer catégorie",
						"createSubcategory": "Créer sous-catégorie",
						"edit": "Modifier catégorie",
						"inputs": {
							"image": "Image",
							"name": {
								"label": "Nom",
								"placeholder": "Saisir un nom pour la catégorie"
							},
							"description": {
								"label": "Description",
								"placeholder": "Décrivez la catégorie"
							},
							"prefix": "Niveau",
							"priorityLevel": {
								"errorMessage": "Entrez un niveau de priorité valide (ex : 1, 2, 3...)",
								"label": "Niveau de priorité"
							},
							"chartAccount": {
								"label": "Plan de Comptes",
								"placeholder": "Sélectionner un plan de comptes"
							},
							"printOrder": {
								"label": "Phase de catégorie",
								"placeholder": "Entrez la phase de catégorie"
							},
							"errors": {
								"requiredName": "Le nom est obligatoire",
								"requiredPriority": "Le niveau de priorité est obligatoire",
								"invalidPriority": "Niveau de priorité invalide",
								"requiredPrintOrder": "La phase de catégorie est obligatoire",
								"invalidPrintOrder": "Phase de catégorie invalide"
							}
						}
					},
					"columns": {
						"actions": "Actions",
						"combo": "Combo",
						"product": "Produit",
						"systemProduct": "Produit de Système"
					},
					"deleteCategory": "Voulez-vous supprimer la catégorie ? Cette opération ne peut être annulée.",
					"deleteProduct": "Voulez-vous supprimer ce produit ? Cette opération ne peut être annulée.",
					"label": "Catégories",
					"priorityLevel": "Niveau de priorité {{level}}",
					"productModal": {
						"create": "Créer produit",
						"edit": "Modifier produit",
						"inputs": {
							"hasAlcohol": "Contient de l'alcool",
							"image": "Image",
							"name": {
								"emptyError": "Le nom du produit n'est pas renseigné",
								"label": "Nom",
								"noCategory": "Nom de la catégorie non renseigné",
								"noPriority": "Niveau de priorité non valide",
								"noStringError": "Utiliser uniquement des caractères valides"
							},
							"type": {
								"error": "Sélectionner un type de produit",
								"label": "Type de produit",
								"placeholder": "Sélectionner un type de produit"
							}
						}
					},
					"search": {
						"label": "Rechercher",
						"placeholder": "Catégorie, sous-catégorie ou produit"
					},
					"subcategories": "Sous-catégories",
					"subcategory": "sous-catégorie",
					"description": "Description",
					"chartAccount": "Plan de Comptes",
					"products": "Produits",
					"noSystemProduct": "Produit de système non lié"
				},
				"generalStock": "Stock général",
				"productsTab": {
					"addEditProductModal": {
						"add": "Ajouter produit",
						"edit": "Modifier produit",
						"form": {
							"category": {
								"error": "Choisir ou créer une catégorie",
								"info": "Vous allez créer une nouvelle catégorie",
								"label": "Catégorie",
								"placeholder": "Sélectionner ou créer une catégorie"
							},
							"code": {
								"label": "SKU",
								"placeholder": "Saisir un SKU",
								"tooltip": "S'il n'est pas rempli, le code sera généré automatiquement."
							},
							"error": "Ce champ est obligatoire",
							"hasAlcohol": "Contient de l'alcool ?",
							"name": {
								"error": "Utiliser uniquement des caractères valides",
								"label": "Nom du produit",
								"placeholder": "Saisir un nom pour le produit"
							},
							"ncm": {
								"error": "Le NCM doit être composé de 8 chiffres",
								"label": "NCM",
								"placeholder": "Saisir un NCM"
							},
							"photo": "Image",
							"type": {
								"label": "Type",
								"placeholder": "Sélectionner un type de produit"
							}
						},
						"unavailable": "Non disponible",
						"undefined": "Non défini",
						"update": "Mettre à jour le produit"
					},
					"description": "Liste des produits enregistrés dans l'organisation et leurs informations de base.",
					"exportProducts": {
						"columns": {
							"category": "Catégorie",
							"description": "Description",
							"fiscalCode": "SKU",
							"fiscalNcm": "NCM",
							"hasAlcohol": "Le produit contient-il de l'alcool ?",
							"id": "id du produit",
							"systemProduct": "Produit de système",
							"places": "Lieux",
							"title": "Nom",
							"type": "Type"
						},
						"products": "Produits",
						"warningNotification": "Produits non modifiés"
					},
					"header": {
						"add": "Ajouter produit",
						"addPlaces": "Ajouter Lieux",
						"counter": "{{amount}} Produits",
						"deleteProduct": "Supprimer (1) produit",
						"deleteMultipleProducts": "Supprimer ({{products}}) produits",
						"editPlaces": "Modifier Lieux",
						"export": "Exporter produits",
						"inventory": "Modifier Stock",
						"search": "Rechercher"
					},
					"inventoryUpdate": {
						"columns": {
							"category": "Catégorie",
							"fiscalCode": "SKU",
							"fiscalNcm": "NCM - Fiscal",
							"hasAlcohol": "DLe produit contient-il de l'alcool ?",
							"id": "Id Produit",
							"name": "Nom",
							"type": "Type de produit"
						},
						"download": "Télécharger tableau",
						"import": "Importer tableau",
						"label": "Modifier Stock"
					},
					"label": "Enregistrement de base de produit",
					"modalDelete": {
						"title": "Supprimer le produit",
						"description": "En confirmant l'action, vous supprimez définitivement le produit. Voulez-vous continuer ?"
					},
					"modalDeleteMultipleProducts": {
						"title": "Supprimer des produits",
						"description": "Lors de la suppression des produits sélectionnés, ils seront supprimés de tous les emplacements et il ne sera pas possible d'annuler cette action.",
						"confirm": "Voulez-vous quand même le supprimer ?"
					},
					"link": "Lien",
					"links": "Liens",
					"productPlacesModal": {
						"title": "Liens du produit",
						"description": "Liste des emplacements où le produit est présent",
						"seePlace": "Voir l'emplacement"
					},
					"productForm": {
						"alcoholLabel": "Contient de l'alcool ?",
						"categoryLabel": "Catégorie",
						"categoryPlaceholder": "Entrez la catégorie du produit",
						"createProduct": "Créer un produit d'inventaire",
						"editProduct": "Modifier le produit d'inventaire",
						"fiscalCodelabel": "SKU",
						"fiscalCodePlacehodler": "Entrez le code SKU du produit",
						"ncmLabel": "NCM",
						"ncmPlaceholder": "Entrez le code NCM du produit",
						"photolabel": "Photo",
						"productNameLabel": "Nom du produit",
						"productNamePlaceholder": "Entrez le nom du produit",
						"placesLabel": "Lieux",
						"placesPlaceholder": "Sélectionnez les lieux du produit",
						"price": "Prix",
						"priceTooltip": "Changer le prix dans ce champ modifie le prix du produit pour tous les lieux associés",
						"editPrice": "Modifier le prix",
						"saveProduct": "Enregistrer le produit",
						"saveEditProduct": "Enregistrer les modifications",
						"confirmProductPrice": {
							"goBack": "Retour à l'édition",
							"confirm": "Confirmer le changement",
							"title": "Confirmer l'ajustement",
							"description": {
								"title": "Voulez-vous confirmer le changement de prix ?",
								"subtitle": "Les lieux liés auront la nouvelle valeur de <b>{{productValue}}</b> pour le produit <b>{{productName}}</b>."
							}
						}
					},
					"removeProduct": {
						"label": "Supprimer produit",
						"title": "Voulez-vous vraiment supprimer le produit ??"
					},
					"rows": {
						"noProducts": "Pas de produit",
						"places": "Lieux",
						"products": "Produits",
						"type": "Type",
						"fiscalCode": "SKU"
					},
					"selectPlaces": {
						"label": "Sélectionner des lieux",
						"search": "Rechercher des lieux"
					},
					"types": {
						"product": "Produit",
						"supply": "Fourniture"
					},
					"filters": {
						"status": {
							"all": "Tous",
							"active": "Actif",
							"inactive": "Inactif"
						}
					}
				}
			}
		},
		"clientArea": {
			"title": "Hub de Données",
			"places": "Lieux",
			"org": "Organisation",
			"searchPanel": "Nom du panneau",
			"noPanels": "Aucun panneau disponible.",
			"noPanelsForFilter": "Aucun panneau correspondant aux filtres.",
			"autoRefresh": "Actualisation automatique.",
			"fullScreen": "Plein écran",
			"autoUpdatesOn": "Mises à jour automatiques activées",
			"autoUpdatesOff": "Mises à jour automatiques désactivées",
			"rotateDevice": "Veuillez faire pivoter votre appareil",
			"otherPanels": "Autres",
			"retrospective": "Rétrospective de l'Année",
			"retrospectiveDescription": "Voir votre rétrospective de l'année",
			"subtitle": "Accédez de manière centralisée aux tableaux de bord de données essentiels. Ici, vous trouverez des insights actualisés pour l'analyse et la prise de décision, le tout en un seul endroit.",
			"panelSelector": {
				"title": "Ajouter des panneaux à la vue"
			}
		},
		"reports": {
			"addPlacesPlaceholder": "Sélectionner lieu(x)",
			"addPlacesTitle": "Ajouter des lieux dans le rapport",
			"all": "Tous",
			"downloadExcel": {
				"columns": {
					"date": "Date",
					"inboundService": "Services entrants",
					"place": "Lieu",
					"service": "Service",
					"totalBilling": "Facturation totale"
				},
				"fileName": "billing-{{orgName}}",
				"title": "Report {{orgName}}"
			},
			"emptyComponent": "Pas de données pour afficher le rapport",
			"emptyPlaces": "Ajouter au moins un lieu où consulter le rapport",
			"header": {
				"day": "Jour",
				"entrance": "Couvert/Entrée",
				"people": "Personnes",
				"period": "Période",
				"products": "Produits",
				"revenue": "Revenu",
				"service": "Service",
				"ticket": "Ticket moyen"
			},
			"products": {
				"currentPeriod": "à {{currPeriod}}",
				"dayFilter": "Sélectionner le jour",
				"empty": "Pas de données pour afficher le rapport",
				"nextPeriod": "{{currPeriod}} à {{nextPeriod}}",
				"period": "Period: ({{since}} à {{until}})",
				"periodTitle": "Période",
				"productConsumptionTab": "Produits par heure",
				"productsSold": {
					"table": {
						"count": "QUANTITÉ",
						"productName": "NOM DU PRODUIT",
						"place": "LIEU",
						"sku": "SKU",
						"total": "Total",
						"totalPlaceValue": "TOTAL DU LIEU",
						"totalValue": "MONTANT TOTAL",
						"unitValue": "VALEUR UNITAIRE"
					},
					"totalizers": {
						"totalCount": "Quantité totale de produits",
						"totalSold": "Facturation totale pour la période"
					}
				},
				"productSoldTab": "Produits vendus par lieu",
				"title": "Ventes totales par période",
				"totalConsumedAt": "Total consommé à {{value}}",
				"totalConsumedPeriod": "Total consommé de {{since}} au {{until}}:"
			},
			"revenue": {
				"methodChart": {
					"adjustedMoney": "Argent ajusté : {{value}}",
					"rechargeDevolutions": "Rechargement remboursé {{value}}"
				},
				"paymentMethod": "Moyen de paiement",
				"periodChart": {
					"duringPeriodSubtitle": "Pendant la période",
					"perLocalTitle": "Revenu total par lieu"
				},
				"revenueChart": {
					"entranceService": "Service d'entrée : {{entrance}}"
				},
				"title": "Total income"
			},
			"services": {
				"subtitle": "Par lieu en pourcentage",
				"title": "Total service"
			},
			"tooltip": "Ne comprend pas de comptes ouverts"
		},
		"satisfactionSurvey": {
			"customModal": {
				"successNotification": "Lien du questionnaire copié"
			},
			"smsReport": {
				"filterByPlace": "Filtrer par lieu",
				"filterByDate": "Date de l'événement",
				"columns": {
					"date": "Date de l'événement",
					"smsSentCount": "Sms envoyés",
					"npsAnswersCount": "Réponses",
					"conversion": "Taux de conversion des SMS"
				},
				"totalizers": {
					"smsSents": "Sms envoyés",
					"npsFormAnswers": "Total des réponses",
					"checkins": "Taux de conversion total"
				}
			},
			"formatQuestionType": {
				"cleaness": "Nettoyage",
				"mixes": "Menu Variété",
				"music": "Musique",
				"nps": "NPS",
				"price": "Prix",
				"product": "Produit",
				"service": "Service / Service client",
				"paymentExperience": "Expérience de paiement"
			},
			"periodData": {
				"custom": "Période personnalisée",
				"ninety": "Les 90 derniers jours",
				"period": "Période",
				"placeholder": "Sélectionner Période",
				"rangeFormat": "{{sinceDay}} de {{sinceMonth}} à {{untilDay}} de {{untilMonth}}",
				"sixty": "Les 60 derniers jours",
				"thirty": "Les 30 derniers jours"
			},
			"results": {
				"columns": {
					"averageTicket": "Ticket moyen",
					"birthDate": "Date de naissance",
					"client": "Client",
					"comment": "Commentaire",
					"date": "Date",
					"document": "Document",
					"phone": "Téléphone",
					"ratingDate": "Date d'évaluation"
				},
				"customerAnswer_one": "{{totCustomers}} client a répondu à l'enquête de satisfaction",
				"customerAnswer_other": "{{totCustomers}} clients ont répondu à l'enquête de satisfaction",
				"drawer": {
					"answerNps": "De 1 à 10, la probabilité que ce client recommande {{name}} à ses amis et à sa famille est de",
					"assessment": "Évaluation",
					"consumedProducts": "Produits consommés",
					"date": "Date",
					"event": "Événement",
					"stars_one": "{{value}} étoile",
					"stars_other": "{{value}} étoiles",
					"title": "Détails de l'expérience",
					"client": "Client",
					"cpf": "CPF",
					"phone": "Téléphone",
					"birthDate": "Date de naissance"
				},
				"emptyStateDescription": "Ce lieu n'est pas activé pour recevoir les réponses aux enquêtes de satisfaction. Contactez l'équipe ZIG pour activer ce service.",
				"emptyStateTitle": "Le lieu n'est pas activé",
				"searchClientPlaceholder": "Rechercher par nom ou numéro de document",
				"export": "Exporter tableau",
				"fileTitle": "Historique de l'évaluation de l'événement",
				"filename": "nps-avis",
				"filterPlaceholder": "Filrer par lieu",
				"lastDays_one": "sur le {{days}} dernier jour",
				"lastDays_other": "sur les {{days}} derniers jours",
				"popover": {
					"answer_one": "{{totalAnswers}} note",
					"answer_other": "{{totalAnswers}} notes",
					"client_one": "{{count}} client",
					"client_other": "{{count}} clients",
					"opinion_one": "{{count}} avis",
					"opinion_other": "{{count}} avis"
				},
				"resultsEvent": "Rechercher résultats par événement"
			},
			"searchSettings": {
				"cancelButton": "Annuler les modifications",
				"description": "Choisissez les paramètres que vous souhaitez que vos clients évaluent chez eux.",
				"emptyState": {
					"description": "Aucun lieu activé pour configurer l'enquête de satisfaction n'a été trouvé. Contactez l'équipe ZIG pour activer ce service.",
					"title": "Aucun lieu activé"
				},
				"new": "Nouveau",
				"saveButton": "Enregistrer les modifications",
				"successNotification": "Les paramètres de recherche ont été mis à jour",
				"title": "Paramètres de l'enquête",
				"shouldSendSmsOnCheckout": "Envoyez automatiquement des SMS NPS à tous les clients après le checkout"
			},
			"shareSettings": {
				"content": "Il est très important de définir les moyens d'activation des clients afin d'obtenir un retour d'information équitable de la part de votre organisation.",
				"modal": {
					"downloadAllQRCode": "Télécharger tous les QR codes",
					"link": "Copier le lien",
					"linkDescription": "Cliquez pour copier le lien de l'enquête",
					"qrCode": "Télécharger QR code",
					"qrCodeDescription": "Cliquez ici pour ouvrir QR code",
					"rowModal": {
						"link": "Aucun lieu n'est activé. Pour générer un lien vers une enquête de satisfaction, il suffit de l'activer dans la section \"Paramètres de l'enquête\"",
						"qrCode": "Aucun lieu n'est activé. Pour télécharger le QR code de cette enquête, il suffit de l'activer dans la section \"Survey Settings\""
					}
				},
				"qrCodeSection": {
					"description": "Cliquez sur le bouton ci-dessous pour télécharger et imprimer le QR code qui conduira votre client vers le lien de l'enquête de satisfaction.",
					"downloadButton": "Télécharger le QR code",
					"title": "QR code sur table / salon"
				},
				"smsSection": {
					"copyButton": "Copier le lien de l'enquête",
					"description": "Copiez le lien ci-dessous et envoyez un message à la liste de clients que vous avez sélectionnée. Il vous suffit de vous rendre dans la section messages de l'espace client.",
					"title": "SMS manuel"
				},
				"title": "Paramètres de partage",
				"cancelUpdates": "Annuler les modifications",
				"saveUpdates": "Enregistrer les modifications",
				"dailyLimit": {
					"label": "Limite quotidienne de SMS",
					"tooltip": "Le coût par SMS envoyé est indiqué dans votre contrat.",
					"description": "Ce sera la limite pour l'envoi automatique de liens."
				}
			},
			"tabs": {
				"newPlaceAvailable": "Nouveau lieu disponible",
				"results": "Résultats",
				"searchSettings": "Paramètres de l'enquête",
				"shareSettings": "Paramètres et partage",
				"smsReport": "Rapport d'investissement"
			},
			"title": "Enquête de satisfaction"
		},
		"chartOfAccounts": {
			"titlePage": "Plan de Comptes",
			"tableTitle": {
				"revenues": "Revenus",
				"costs": "Coûts",
				"expenses": "Dépenses"
			},
			"tableRows": {
				"minimizeAll": "Minimiser",
				"expandAll": "Étendre"
			},
			"expandLevels": "Étendre les niveaux",
			"categoryFixedInfo": "Cette catégorie reçoit des entrées automatiques du système et ne peut pas être modifiée.",
			"viewCode": "Afficher le code du plan comptable",
			"usageInfo": "Le Plan de Comptes Financiers est la liste des catégories de revenus et de dépenses d'une entreprise. En tant que moyen de classer les transactions financières, il aide à organiser et à mieux comprendre la situation financière en examinant les entrées et les sorties.",
			"titleModal": {
				"edit": "Renommer le compte",
				"create": "Ajouter un compte",
				"exclude": "Supprimer le plan de comptes",
				"warning": "Ce plan de comptes a des liens"
			},
			"modalExcludeChart": {
				"warningContent": "Ce plan de comptes <strong>ne peut pas être supprimé</strong> car des transactions y sont liées.",
				"excludeContent": "En confirmant l'action, vous supprimerez définitivement le plan de comptes des \"{{name}}\". Souhaitez-vous continuer?",
				"buttonExclude": "Oui, je veux supprimer le plan"
			},
			"typeChartCredit": "Crédit",
			"typeChartDebit": "Débit"
		},
		"teamAndRoles": {
			"employeesRole": {
				"table": {
					"roleName": "Nom du rôle",
					"access": "Accès",
					"collaboratorsQuantity": "Nombre de collaborateurs dans le rôle",
					"none": "Aucun"
				},
				"masterOperationPDVAndDashboard": "Maître - Opération (POS) et Tableau de bord",
				"operationPDV": "Opération (POS)",
				"dashboard": "Tableau de bord",
				"roleNeedsASlug": "Le rôle a besoin d'un slug",
				"collaborators": "Collaborateurs",
				"collaborator": "Collaborateur",
				"editRole": "Modifier le travail",
				"deleteRole": "supprimer le travail",
				"newRole": "Nouveau rôle",
				"rolePermissionWarning": "Après avoir séparé les employés en dash et pdv, il n'est plus possible de créer ou d'utiliser des postes avec des autorisations des deux types.",
				"deleteRoleModal": {
					"title": "Voulez-vous supprimer le rôle?",
					"describe": "En supprimant un rôle, tous les collaborateurs liés à celui-ci perdront le lien."
				},
				"header": {
					"roles": "Rôles",
					"describe": "Ajouter, modifier et supprimer des rôles à utiliser dans le tableau de bord ou au point de vente (POS)",
					"searchRole": "Rechercher un rôle",
					"searchRolePlaceholder": "Rechercher par nom de rôle",
					"closeSearch": "Fermer la recherche",
					"alertMessage": "Après avoir séparé les employés en dash et pdv, il n'est plus possible de créer ou d'utiliser des postes avec des autorisations des deux types."
				},
				"roleModal": {
					"PDVRole": "Opération",
					"PDVDescription": "Rôle pour les collaborateurs avec autorisation d'accès à <b>POS</b>",
					"PDVFooterText": "Créer un rôle POS",
					"enterpriseRole": "Manager",
					"enterpriseDescription": "Rôle pour les collaborateurs avec autorisation d'accès au <b>Tableau de bord</b>",
					"enterpriseFooterText": "Créer un rôle de tableau de bord",
					"newManagerRole": "Nouveau rôle manager",
					"newOperationRole": "Nouveau rôle opérationnel",
					"operationPermission": "Permissions de PDV",
					"managerPermission": "Permissions de manager",
					"enterprisePermission": "Permissions de Dashboard",
					"paymentPermission": "Méthodes de paiement"
				},
				"form": {
					"roleNameDescription": "Sélectionnez le type de rôle que vous souhaitez créer",
					"roleNameRequired": "Le nom du rôle est obligatoire",
					"roleName": "Nom du rôle",
					"roleNamePlaceholder": "Entrez le nom du nouveau rôle",
					"roleNameError": "Nom de rôle invalide",
					"importExistingRolePermissions": "(Facultatif) Importer les permissions d'un rôle existant",
					"selectExistingRole": "Sélectionnez un rôle existant",
					"roleType": "Type de rôle",
					"operational": "POS",
					"managerial": "Tableau de bord",
					"master": "Maître",
					"saveEditions": "Enregistrer les modifications",
					"createNewRole": "Créer un nouveau rôle",
					"discardChanges": "Ignorer les modifications",
					"discardCreation": "Ignorer la création"
				}
			}
		},
		"vendors": {
			"title": "Fournisseur",
			"searchNamePlaceholder": "Recherche par nom/login de fournisseur",
			"header": {
				"create": "Crear vendedor"
			},
			"list": {
				"vendors": "Fournisseurs",
				"rent": "Location",
				"revenuePercentageFee": "% de revenu",
				"tipPercentageFee": "Frais de service",
				"places": "Lieux",
				"fiscalProfile": "Profil fiscal",
				"login": "Login",
				"paymentDaysOffset": "Temps de transfert",
				"actions": {
					"editVendor": "Modifier le fournisseur",
					"deleteVendor": "Supprimer le fournisseur"
				},
				"place": "Emplacement",
				"bars": "Barres"
			},
			"modal": {
				"close": "Fermer",
				"prevStep": "Etape précédente",
				"nextStep": "Etape suivante",
				"steps": {
					"dataCollection": "Données du fournisseur",
					"barSelection": "Données des lieux et des barres",
					"feesCalculation": "Tarifs et profil fiscal",
					"guidance": "Guide"
				},
				"delete": {
					"title": "Supprimer le fournisseur",
					"description": "Etes-vous sûr de vouloir supprimer définitivement ce fournisseur ?",
					"buttonConfirm": "Confirmer"
				},
				"mode": {
					"create": "Crear nuevo vendedor",
					"update": "Editar vendedor",
					"updateDataCollection": "Modifier les données du fournisseur",
					"updateLinkingBarsAndLocations": "Modifier les lieux et les bars",
					"updateFeesTaxProfile": "Modifier les tarifs et le profil fiscal"
				},
				"submit": {
					"create": "Crear vendedor",
					"update": "Guardar"
				},
				"form": {
					"required": "Campo requerido",
					"nonnegative": "La valeur doit être supérieure ou égale à zéro",
					"name": {
						"label": "Nombre",
						"validation": "El nombre no puede estar vacío",
						"placeholder": "Ingrese el nombre del vendedor",
						"nonempty": "El nombre no puede estar vacío"
					},
					"login": {
						"label": "Connexion",
						"validation": "Le login ne peut pas être vide",
						"placeholder": "Entrez la connexion du fournisseur",
						"nonempty": "La connexion ne peut pas être vide",
						"emailRegexValidation": "La connexion ne doit pas être un e-mail",
						"charactersRegexValidation": "La connexion ne doit pas contenir de majuscules ni de caractères spéciaux"
					},
					"password": {
						"label": "Contraseña",
						"validation": "La contraseña no puede estar vacía",
						"placeholder": "Ingrese la contraseña del vendedor",
						"required": "Contraseña requerida",
						"nonempty": "La contraseña no puede estar vacía"
					},
					"places": {
						"label": "Ubicaciones",
						"validation": "Seleccione al menos una ubicación",
						"placeholder": "Seleccione las ubicaciones donde estará activo el vendedor",
						"selectAll": "Seleccionar todo"
					},
					"bars": {
						"label": "Barras",
						"validation": "Seleccione al menos una barra",
						"placeholder": "Seleccione las barras del vendedor",
						"noBars": "No se han seleccionado barras"
					},
					"dailyRentalFeeValue": {
						"label": "Forfait par événement"
					},
					"revenuePercentageFee": {
						"label": "Tarifa de porcentaje de ingresos"
					},
					"tipPercentageFee": {
						"label": "Tarifa de porcentaje de propina"
					},
					"paymentDaysOffset": {
						"label": "Días de pago (D+)",
						"maxValidation": "Doit être compris entre 0 et {{count}}"
					},
					"anticipationFee": {
						"label": "Avance de frais"
					},
					"fiscalProfileId": {
						"label": "Perfil fiscal",
						"placeholder": "Seleccione el perfil fiscal"
					},
					"isFinancialVendor": {
						"label": "Fermetures financières",
						"description": "Générer des fermetures financières pour ce fournisseur"
					},
					"paymentMethodFees": {
						"credit": "Commission sur paiement à crédit",
						"debit": "Commission sur paiement par débit",
						"pix": "Frais de paiement en pix"
					},
					"floorComplement": "Minimum garanti par événement"
				},
				"guidance": {
					"vendorData": {
						"title": "Modifier les données du fournisseur",
						"description": "Nom, identifiant et mot de passe"
					},
					"linkingBarsAndLocations": {
						"title": "Modifier des lieux et des bars",
						"description": "Sélectionnez les emplacements des fournisseurs et leurs bars"
					},
					"feesTaxProfile": {
						"title": "Modifier les frais et le profil fiscal",
						"description": "Tarifs journaliers, pourcentage de chiffre d'affaires, pourcentage de service, date de paiement et profil fiscal"
					}
				}
			}
		},
		"minimmConsummation": {
			"titleTab": "Configuration de Consommation minimale",
			"titleColumnsTable": {
				"place": "Lieu",
				"fiscalProfile": "Profil fiscal",
				"fiscalGroup": "Groupe fiscal",
				"ncm": "NCM",
				"action": "Action"
			},
			"placeholders": {
				"fiscalProfile": "Sélectionnez un profil fiscal",
				"fiscalGroup": "Sélectionnez un groupe fiscal",
				"ncm": "Entrez le code NCM"
			},
			"errors": {
				"requiredField": "Champ obligatoire",
				"invalidFormatNcm": "Le NCM doit contenir 8 chiffres"
			},
			"messageWarning": "En annulant cette action, les modifications effectuées ne seront pas enregistrées. Voulez-vous quand même continuer ?",
			"titleButtonOut": "Quitter sans sauvegarder"
		},
		"fiscalRecharge": {
			"titleTab": "Configuration de Recharge",
			"titleColumnsTable": {
				"place": "Lieu",
				"fiscalProfile": "Profil fiscal",
				"fiscalGroup": "Groupe fiscal",
				"ncm": "NCM",
				"action": "Action"
			},
			"placeholders": {
				"fiscalProfile": "Sélectionnez un profil fiscal",
				"fiscalGroup": "Sélectionnez un groupe fiscal",
				"ncm": "Entrez le code NCM"
			},
			"errors": {
				"requiredField": "Champ obligatoire",
				"invalidFormatNcm": "Le NCM doit contenir 8 chiffres"
			},
			"messageWarning": "En annulant cette action, les modifications effectuées ne seront pas enregistrées. Voulez-vous quand même continuer ?",
			"titleButtonOut": "Quitter sans sauvegarder"
		},
		"internalSalesCampaign": {
			"title": "Campagnes internes",
			"subtitle": "Créez des campagnes internes, suivez la progression et gérez le paiement des primes.",
			"campaignDetails": {
				"back": "Retour",
				"summary": "Résumé",
				"position": "Position",
				"points": "Points",
				"downloadExcel": "Télécharger le fichier Excel",
				"resultsPerPage": "Résultats par page",
				"operator": "OPERATEUR (USER)",
				"ranking": "Classement des opérateurs"
			},
			"bonusManagement": {
				"filters": {
					"campaignName": "Filtrer par nom de campagne",
					"campaignStatus": "Filtrer par statut",
					"operatorName": "Filtrer par nom de collaborateur",
					"pending": "En attente",
					"done": "Effectué"
				},
				"paymentType": {
					"bonus": "Prime",
					"dayOff": "Folga extra",
					"employeeOfTheMonth": "Colaborador do mês",
					"money": "Dinheiro",
					"pix": "PIX"
				},
				"table": {
					"status": "STATUT",
					"campaignName": "CAMPAGNE",
					"operator": "OPERATEUR",
					"bonusType": "TYPE DE PRIME",
					"value": "VALEUR",
					"retrievedAt": "EFFECTUÉ LE",
					"retrievedBy": "RESPONSABLE",
					"confirmBonus": "Confirmer la prime"
				}
			},
			"tabs": {
				"campaign": "Campagnes",
				"bonusManagement": "Gestion des primes"
			},
			"messages": {
				"errorMsg": "Erreur lors de la clôture de la campagne",
				"errorDescriptionError": "Veuillez réessayer plus tard ou contacter le support.",
				"successMsg": "Succès !",
				"successDescription": "Une campagne a été créée !",
				"warnMsg": "Clôturer la campagne",
				"warnDescription": "Cette campagne se terminera avant la période définie. Si la campagne a déjà commencé, cela pourrait affecter directement les objectifs des collaborateurs et les ventes. Voulez-vous continuer ?",
				"closeCampaignMsg": "Oui, clôturer la campagne",
				"close": "Fermer",
				"editcampaign": "Modifier la campagne",
				"duplicateCampaign": "Dupliquer la campagne",
				"closeCampaignBtn": "Clôturer la campagne"
			},
			"modal": {
				"confirmationTitle": "Votre campagne n'a pas été créée",
				"continuebtn": "Non, continuer la configuration",
				"exitBtn": "Oui, quitter sans enregistrer",
				"content": "Si vous quittez, la configuration de la campagne sera perdue et cette action ne pourra pas être annulée. Voulez-vous continuer ?"
			},
			"steps": {
				"generalSettings": "Paramètres généraux",
				"generalSettingsDetails": "Configurez les détails de votre campagne.",
				"salesTarget": "Objectif de ventes",
				"bonus": "Prime",
				"summary": "Résumé",
				"allSettings": "Tous les paramètres",
				"back": "Retour",
				"cancel": "Annuler",
				"next": "Suivant",
				"finish": "Terminer",
				"campaignLocale": "Lieu de la campagne",
				"campaignLocalePlaceholder": "Sélectionnez un ou plusieurs lieux pour cette campagne",
				"campaignName": "Nom de la campagne",
				"charCount": "Nombre maximum de caractères : 20",
				"campaignNamePlaceholder": "Saisissez le nom de la campagne",
				"sponsor": "Sponsor (optionnel)",
				"sponsorPlaceholder": "Saisissez le nom du sponsor",
				"salesTargetDescription": "Choisissez le type d'objectif sur lequel votre campagne sera axée.",
				"campaign": "Campagne",
				"campaignSubtitle": "Configurez les détails de votre campagne.",
				"winnerQuantity": "Nombre de gagnants",
				"winnerQuantityPlaceholder": "Sélectionnez le nombre de gagnants",
				"onlyFirstPlace": "Seul le 1er place dans le classement général",
				"onlyFirstAndSecondPlace": "Seul le 1er et 2ème place dans le classement général",
				"top3": "Seul le top 3 dans le classement général",
				"allOperators": "Tous les opérateurs qui atteindront l'objectif recevront une prime de",
				"withBonusExtra": "Le {{position}}ème place dans le classement général recevra une prime supplémentaire de",
				"withBonus": "Le {{position}}ème place dans le classement général recevra une prime de",
				"selectWinners": "Sélectionnez le(s) gagnant(s) et configurez la valeur :",
				"prizeByRanking": "Prime par classement",
				"addPositionToRanking": "Ajouter une position au classement",
				"dateInfo": "Attention : La campagne ne pourra être modifiée que jusqu'à 30 minutes avant l'heure prévue de début.",
				"startDate": "Date de début de la campagne",
				"endDate": "Date de fin de la campagne",
				"types": {
					"soldProducts": "Par produit",
					"metaType": "Type d'objectif",
					"metaTypeTooltip": "La meta est l'objectif de la campagne et sert à mesurer le rendement des collaborateurs. Elle peut être définie par : quantité de produits vendus, nombre d'attentes ou valeur totale des ventes.",
					"selectTypeGoal": "Sélectionnez le type d'objectif",
					"soldProductsPlaceholder": "Choisissez un produit",
					"soldProductsDescription": "Définissez un produit stratégique comme objectif pour votre campagne.",
					"productsQuantity": "Objectif de ventes (quantité)",
					"selectProducts": "Sélectionnez le produit",
					"salesTotal": "Par valeur totale des ventes",
					"salesTotalDescription": "Définissez une valeur totale des ventes comme objectif pour votre campagne.",
					"salesTotalGoal": "Objectif de ventes (€)",
					"attendance": "Par nombre de clients",
					"attendanceGoal": "Quantité",
					"attendanceDescription": "Définissez un nombre de clients (personnes ou tables) comme objectif pour votre campagne."
				},
				"bonusContent": {
					"title": "Prime",
					"subtitle": "Sélectionnez et configurez le type de prime à attribuer au collaborateur.",
					"moneyTitle": "Prime en espèces",
					"moneySubtitle": "Prime versée en espèces ou par virement électronique.",
					"bonusTitle": "Cashless Zig",
					"bonusSubtitle": "Prime disponible sur le CPF ou sur la carte de consommation Cashless Zig du(des) collaborateur(s).",
					"featuredContribuitorTitle": "Collaborateur distingué",
					"featuredContribuitorSubtitle": "Cette prime est une reconnaissance du mérite. Son attribution sera définie par le gestionnaire.",
					"slackTitle": "Jour de congé supplémentaire",
					"slackSubtitle": "Cette prime accorde un jour de congé supplémentaire, en plus du congé régulier. Son attribution sera définie par le gestionnaire.",
					"winnersQuantity": "Nombre de gagnants",
					"firstPlaceBonus": "Prime 1ère place",
					"scondPlaceBonus": "Prime 2ème place",
					"thirdPlaceBonus": "Prime 3ème place"
				},
				"resume": {
					"title": "Résumé",
					"subtitle": "Passez en revue le résumé de la configuration de la campagne.",
					"warning": "Attention : Après la création de la campagne, elle ne pourra être modifiée que jusqu'à 30 minutes avant l'heure prévue de début.",
					"geralSettings": "Paramètres généraux",
					"campaignLocale": "Lieu de la campagne",
					"campaignName": "Nom de la campagne",
					"sponsor": "Sponsor",
					"schedule": "Planification",
					"initialDate": "Date de début de la campagne",
					"endDate": "Date de fin de la campagne",
					"goal": "Objectif de ventes",
					"type": "Type",
					"goalSell": "Objectif de ventes (quantité)",
					"product": "Produit",
					"bonus": "Prime",
					"bonusType": "Type de prime",
					"winnerQuantity": "Nombre de gagnants",
					"allOperators": "Tous les opérateurs qui atteindront l'objectif recevront une prime de"
				}
			},
			"newCampaign": "Créer une campagne",
			"campaign": {
				"cards": {
					"active": "Campagnes actives",
					"campaignsProgramed": "Campagnes programmées",
					"campaignsConcluded": "Campagnes terminées",
					"totalProductsSold": "Total des ventes",
					"onSale": "Campagnes en cours"
				},
				"filters": {
					"campaignName": "Filtrer par nom de campagne",
					"campaignStatus": "Filtrer par statut",
					"operatorName": "Filtrer par nom de collaborateur"
				},
				"table": {
					"noContent": "Aucune campagne trouvée",
					"checkFilters": "Créez une campagne ou vérifiez les filtres.",
					"status": "STATUT",
					"campaignName": "CAMPAGNE",
					"start": "DÉBUT",
					"end": "FIN",
					"metaType": "TYPE D'OBJECTIF",
					"productsSell": "PRODUITS VENDUS",
					"services": "SERVICES",
					"totalValue": "VALEUR TOTALE",
					"edit": "Modifier la campagne",
					"duplicate": "Dupliquer la campagne",
					"finish": "Clôturer la campagne"
				},
				"tags": {
					"active": "Active",
					"finished": "Terminée",
					"scheduled": "Programmée",
					"onSale": "En cours"
				}
			}
		}
	},
	"place": {
		"storage": {
			"storage": {
				"zeroProducts": {
					"noProproductIsSelected": "Aucun produit sélectionné"
				},
				"removeProduct": {
					"noProproductIsSelected": "Aucun produit sélectionné"
				},
				"layout": {
					"goBack": "Retour"
				},
				"indicators": {
					"cost": {
						"title": "Valeur totale en stock"
					},
					"turnover": {
						"high": "Rotation élevée",
						"low": "Rotation faible"
					},
					"zeroed": {
						"title": "Produits épuisés",
						"seeMore": "Voir plus"
					},
					"intervalNotice": "Valeurs relatives aux 90 derniers jours",
					"updatedAt": "Mis à jour le {{date}}"
				},
				"modalXML": {
					"title": "Importer XML",
					"warningMessage": {
						"line1": "Sélectionnez le stock de destination, téléchargez la feuille de calcul exemple, complétez-la et importez-la à nouveau.",
						"line2": "Attention ! La valeur des produits est indiquée en centimes. Ex : 123 équivaut à {{currencySymbol}} 1,23"
					},
					"form": {
						"label": {
							"storage": "Stock",
							"xml": "XML"
						},
						"placeholder": {
							"xml": "Choisissez un fichier .xml à importer"
						},
						"validation": {
							"missingField": "Champ obligatoire"
						},
						"submit": "Importer la note"
					}
				},
				"modalManualChange": {
					"title": {
						"add": "Ajouter le produit \"{{prodName}}\"",
						"subtract": "Supprimer le produit \"{{prodName}}\""
					},
					"okText": {
						"add": "Ajouter le produit",
						"subtract": "Supprimer le produit"
					},
					"cancel": "Annuler",
					"message": {
						"add": "Saisissez la quantité de produit que vous souhaitez ajouter et le prix de revient",
						"subtract": "Saisissez la quantité que vous souhaitez supprimer et une observation si nécessaire"
					},
					"form": {
						"hasProductionRuleWarning": "Ce produit a une fiche technique et ses éléments ne seront réduits du stock que lorsqu'ils seront épuisés.",
						"label": {
							"quantity": "Quantité",
							"costPrice": "Prix de revient",
							"obs": "Observation"
						},
						"validation": {
							"invalidQuantity": "Quantité invalide",
							"missingProductInfo": "Informations sur le produit manquantes",
							"missingActionInfo": "Informations sur l'action manquantes"
						}
					}
				},
				"header": {
					"searchPlaceHolder": "Rechercher par produit",
					"importXML": "Importer XML",
					"transferProducts": "Transférer des produits",
					"addProducts": "Ajouter des produits",
					"addProductsManually": "Ajouter des produits manuellement",
					"actionsToolbar": "Actions de l'inventaire",
					"importViaXlsx": "Importer via Excel"
				},
				"table": {
					"columns": {
						"name": "produit",
						"category": "catégorie",
						"quantity": "quantité",
						"action": "action",
						"lastCost": "dernier prix",
						"avgCost": "prix moyen",
						"totalCost": "coût total"
					},
					"actions": {
						"zeroStorage": "Vider le stock",
						"removeProducts": "Supprimer des produits",
						"label": "Actions par lot",
						"message": "Cochez la case pour les actions par lot"
					},
					"confirmationModal": {
						"warnignHiddenProductsInSearch": "Attention, certains produits peuvent être masqués en raison de la recherche, effacez la recherche pour continuer",
						"deleteSingle": {
							"title": "Supprimer le produit",
							"message": "En confirmant cette action, vous supprimerez définitivement ces éléments du stock. Voulez-vous continuer ?",
							"confirmMessage": "Oui, je souhaite supprimer"
						},
						"deleteMultiple": {
							"title": "Supprimer le produit",
							"message": "En confirmant cette action, vous supprimerez définitivement ces éléments du stock. Voulez-vous continuer ?",
							"confirmMessage": "Oui, je souhaite supprimer"
						},
						"zero": {
							"title": "Vider les produits",
							"message": "En confirmant cette action, vous viderez définitivement tous les éléments sélectionnés du stock. Voulez-vous continuer ?",
							"confirmMessage": "Oui, je souhaite vider les produits"
						}
					},
					"filters": {
						"categoryPlaceholder": "Filtrer par catégorie",
						"productPlaceholder": "Rechercher par nom de produit",
						"suggestions": "Suggestions",
						"other": "Autres"
					},
					"selectedProductsCount": "Tous les produits sélectionnés: {{total}} produits"
				},
				"inputViaXlsx": {
					"header": {
						"title": "Importer des produits via Excel"
					},
					"layout": {
						"importProductsTable": "Importez votre tableau de produits",
						"tutorial": "Ajoutez 1 ou plusieurs produits à la fois en important une feuille de calcul."
					},
					"form": {
						"totalProducts": "Total de produits",
						"successfullyImported": "Produits importés",
						"productsWithErrors": "Produits avec erreurs",
						"alert": {
							"title": "Produits avec erreurs",
							"message": "Nous avons identifié des produits avec des informations incorrectes. Téléchargez la feuille de calcul avec les erreurs, corrigez les données, puis importez à nouveau."
						},
						"tooltip": {
							"totalProducts": "Votre tableau avait {{totalProducts}} produits",
							"successfullyImported": "{{totalProducts}} produits ont déjà été importés avec succès dans votre stock",
							"productsWithErrors": "Téléchargez le tableau avec les erreurs et importez à nouveau"
						}
					},
					"sheet": {
						"columns": {
							"productName": "Produit",
							"quantity": "Quantité",
							"unit": "Unité de mesure",
							"costPrice": "Prix de revient",
							"costType": "Type de coût"
						},
						"costType": {
							"byUnit": "Coût unitaire",
							"byTotal": "Coût total"
						},
						"sampleFileName": "exemple_entree_produits",
						"errorFileName": "entree_produits_avec_erreurs"
					}
				}
			},
			"storageList": {
				"layout": {
					"title": "Liste des stocks"
				},
				"header": {
					"searchPlaceHolder": "Rechercher un stock",
					"importXML": "Importer XML",
					"createStorage": "Créer un stock"
				},
				"indicators": {
					"cost": {
						"title": "Montant total du stock",
						"footer": {
							"localStorage": "Stock local",
							"centralStorage": "Stock global"
						}
					},
					"turnover": {
						"high": "Rotation élevée",
						"low": "Rotation faible"
					},
					"zeroed": {
						"title": "Produits avec quantité zéro",
						"seeMore": "Voir plus"
					},
					"intervalNotice": "Valeurs relatives aux 90 derniers jours",
					"updatedAt": "Mis à jour le {{date}}"
				},
				"list": {
					"local": "Local",
					"central": "Global",
					"rename": "Renommer le stock",
					"delete": "Supprimer",
					"valueInStorage": "Valeur en stock",
					"productsInStorage": "Produits en stock",
					"productsInStorageCount": "{{count}} produits",
					"createdAt": "Créé le {{date}}"
				},
				"modalXml": {
					"title": "Importer XML",
					"warningMessage": {
						"line1": "Sélectionnez le stock de destination, téléchargez la feuille de calcul exemple, complétez-la et importez-la à nouveau.",
						"line2": "Attention ! La valeur des produits est indiquée en centimes. Ex : 123 équivaut à {{currencySymbol}} 1,23"
					},
					"form": {
						"label": {
							"storage": "Stock",
							"xml": "XML"
						},
						"placeholder": {
							"xml": "Choisissez un fichier .xml à importer"
						},
						"validations": {
							"missingFields": "Champ obligatoire"
						},
						"cancel": "Annuler",
						"submit": "Enregistrer"
					}
				},
				"modalForm": {
					"title": {
						"createStorage": "Créer un stock",
						"editarStorage": "Modifier le stock"
					},
					"form": {
						"label": {
							"name": "Nom",
							"isCentral": "Type de stock"
						},
						"options": {
							"central": "Global",
							"local": "Local"
						},
						"placeholder": {
							"name": "Nom du stock"
						}
					}
				},
				"modalDelete": {
					"title": "Supprimer le stock",
					"warningMessage": "Êtes-vous sûr de vouloir supprimer le stock \"{{storageName}}\" ?",
					"submit": "Supprimer"
				}
			},
			"storageListV2": {
				"layout": {
					"title": "Stocks"
				},
				"header": {
					"searchPlaceHolder": "Rechercher par nom du stock",
					"createStorage": "Créer un stock",
					"storageTypeFilter": {
						"local": "Local",
						"central": "Global",
						"all": "Tous les stocks (central et local)",
						"ariaLabel": "Sélectionner le type de stock"
					}
				},
				"indicators": {
					"storagesCount": {
						"label": "Stocks enregistrés"
					},
					"productsCount": {
						"label": "Produits en stock"
					},
					"totalCost": {
						"label": "Coût des stocks"
					},
					"zeroedProductsCount": {
						"label": "Produits en rupture",
						"seeProducts": "Voir les produits"
					}
				},
				"list": {
					"productsCount_zero": "{{count}} produits",
					"productsCount_one": "{{count}} produit",
					"productsCount_other": "{{count}} produits",
					"createdAt": "Créé le {{date}}",
					"productsCount": "En stock",
					"totalCost": "Coût total",
					"attachedBars_zero": "{{count}} bars liés",
					"attachedBars_one": "{{count}} bar lié",
					"attachedBars_other": "{{count}} bars liés",
					"seeBars": "Voir les bars",
					"noBarsLinked": "Aucun bar lié",
					"central": "Central",
					"local": "Local"
				},
				"attachedBarsDrawer": {
					"drawerTitle": "Bars liés",
					"title": "Bars",
					"description": "Voir où votre produit est disponible pour consommation",
					"linkedBarsLabel": "Bars liés",
					"barDescription": {
						"storage": "Stock",
						"printersIps": "IPs des imprimantes"
					}
				},
				"irregularProductsDrawer": {
					"filters": {
						"storage": "Stock",
						"selectStorage": "Sélectionner le stock"
					},
					"quantity": {
						"title": "Produits avec quantité zéro",
						"description": "Mettre à jour vos produits avec quantité zéro",
						"save": "Mettre à jour la quantité"
					},
					"unitCostValue": {
						"title": "Produits avec coût unitaire zéro",
						"description": "Mettre à jour vos produits avec coût unitaire zéro",
						"save": "Mettre à jour le coût unitaire"
					},
					"table": {
						"columns": {
							"product": "Produit",
							"fiscalCode": "SKU",
							"storage": "Stock",
							"quantity": "Quantité",
							"unitCostValue": "Coût unitaire",
							"totalCost": "Coût total"
						}
					},
					"successUpdateIrregularProducts": "Produits mis à jour avec succès"
				},
				"actions": {
					"editStorage": "Modifier le stock",
					"deleteStorage": "Supprimer le stock"
				},
				"persistStorageDrawer": {
					"title": {
						"create": "Créer un stock",
						"edit": "Modifier le stock"
					},
					"form": {
						"name": {
							"label": "Nom du stock",
							"placeholder": "Nom du stock",
							"error": "Le nom du stock est obligatoire",
							"maxLengthError": "Le nom du stock doit avoir au maximum {{maxLength}} caractères"
						},
						"type": {
							"label": "Type de stock",
							"options": {
								"local": "Local",
								"central": "Global"
							}
						}
					},
					"actions": {
						"submitEdit": "Enregistrer les modifications",
						"submitCreate": "Créer un stock"
					},
					"successEditModal": "Stock modifié avec succès",
					"successCreateModal": "Stock créé avec succès"
				},
				"modalDelete": {
					"title": "Supprimer le stock",
					"warningMessage": "Êtes-vous sûr de vouloir supprimer le stock \"{{storageName}}\" ?",
					"warningMessageStrong": "Cette action ne peut pas être annulée.",
					"submit": "Supprimer",
					"successDeleteModal": "Stock supprimé avec succès"
				}
			},
			"storageAdd": {
				"warningProductAlreadyOnList": "Ce produit a déjà été ajouté à la liste!",
				"title": "Ajouter un produit au stock {{storageName}}",
				"cancel": "Annuler",
				"finish": "Terminé",
				"addProductForm": {
					"form": {
						"modalWarning": {
							"title": "Produit à coût nul",
							"errorMessage": "Le coût unitaire nul affectera le suivi de votre CMV et compromettra la lecture de certains rapports financiers. Voulez-vous quand même continuer?",
							"button": "Non, remplir le coût"
						},
						"label": {
							"product": "Produit",
							"count": "Quantité",
							"cost": "Prix de revient"
						},
						"validation": {
							"missingField": "Champ obligatoire",
							"invalidQuantity": "Quantité invalide"
						},
						"submit": "Ajouter"
					}
				},
				"table": {
					"columns": {
						"product": "Produit",
						"count": "Quantité",
						"unitcost": "Coût unitaire",
						"totalcost": "Coût total",
						"action": "Action"
					}
				}
			},
			"tabs": {
				"storageV2": {
					"tabs": {
						"products": {
							"table": {
								"columns": {
									"categoryFilterButton": "Filtrer par catégorie {{categoryName}}"
								},
								"quantityInput": {
									"add": "Ajouter la quantité de {{productName}}",
									"remove": "Retirer la quantité de {{productName}}"
								}
							}
						}
					}
				},
				"profitMarginReport": {
					"seeMore": "Voir plus",
					"pageTitle": "Rapport sur les coûts et la marge bénéficiaire",
					"empty": "Aucun rapport disponible",
					"label": "Coûts et marge bénéficiaire",
					"notAssociatedReport": "(Rapport non associé)",
					"export": "Exporter",
					"print": "Imprimer",
					"selectPlaceholder": "Sélectionnez ici",
					"excelFileName": "rapport_couts_et_marge_beneficiaire",
					"successfullExportMsg": "Rapport exporté avec succès",
					"period": "Période",
					"columns": {
						"productName": "Produit",
						"category": "Catégorie",
						"quantity": "Quantité",
						"value": "Valeur moyenne",
						"soldAmount": "Total",
						"invoicing": "Participation",
						"averageSellingPrice": "Prix ​​unitaire moyen",
						"totalCost": "Coût total",
						"costPercentage": "% Coût",
						"profitMarginValue": "Bénéfice",
						"profitMarginPercentage": "% Bénéfice"
					},
					"indicators": {
						"updatedAt": "Mis à jour le {{ date }}",
						"profitMargin": {
							"title": "Marge bénéficiaire"
						},
						"totalBilling": {
							"title": "Facturation totale"
						},
						"totalCost": {
							"title": "Coût total"
						},
						"mostProfitMargin": {
							"title": "Marge bénéficiaire la plus élevée",
							"seeMore": "Produits avec la plus haute marge bénéficiaire"
						},
						"lessProfitMargin": {
							"title": "Marge bénéficiaire la plus faible",
							"seeMore": "Produits avec la plus faible marge bénéficiaire"
						}
					},
					"flags": {
						"red": "Parmi les 5 produits avec la plus faible marge bénéficiaire",
						"green": "Parmi les 5 produits avec la plus haute marge bénéficiaire"
					},
					"filters": {
						"period": "Filtrer par période",
						"product": "Filtrer par produit",
						"category": "Filtrer par catégorie",
						"allProducts": "Tous les produits",
						"allCategories": "Toutes les catégories"
					}
				},
				"abcReports": {
					"abcPurchaseReport": {
						"title": "Rapport d'achats ABC",
						"label": "Achats ABC",
						"description": "La méthode de la courbe ABC dans la gestion des stocks révélera principalement l'importance de chaque article pour l'entreprise - c'est-à-dire, quels sont les biens les plus chers qui nécessitent une attention particulière dans le contrôle des coûts et les processus d'achat.",
						"export": "Télécharger en Excel",
						"filterByPlaceholder": "Toutes les courbes",
						"contentTable": {
							"emptyReports": "Aucun rapport disponible",
							"totalizers": {
								"totalValues": "Valeurs totales des produits",
								"curveA": "Courbe A",
								"curveB": "Courbe B",
								"curveC": "Courbe C",
								"tooltips": {
									"curveA": "Produits de grande valeur correspondant à jusqu'à 80% de la valeur d'achat",
									"curveB": "Produits de valeur intermédiaire correspondant à jusqu'à 15% de la valeur d'achat",
									"curveC": "Produits de faible valeur correspondant à jusqu'à 5% de la valeur d'achat"
								}
							},
							"columns": {
								"name": "Produit ou Ingrédient",
								"quantity": "Quantité Achetée",
								"unitaryValue": "Coût Unitaire",
								"total": "Coût Total",
								"cumulateTotal": "Total Cumulé",
								"percentage": "Représentation Individuelle",
								"cumulativePercentage": "Représentation Cumulative",
								"tier": "Classification"
							}
						}
					},
					"abcSupplierReport": {
						"title": "Rapport ABC des Fournisseurs",
						"label": "Fournisseurs ABC",
						"description": "Ce rapport classe les fournisseurs en trois catégories (A, B, C) en fonction du volume des achats. Les fournisseurs de la catégorie A sont ceux qui concentrent la majeure partie des dépenses d'achat de produits, tandis que ceux de la catégorie C sont ceux avec les dépenses les plus faibles.",
						"export": "Télécharger en Excel",
						"contentTable": {
							"emptyReports": "Aucun rapport disponible",
							"totalizers": {
								"totalValues": "Valeurs totales des produits",
								"curveA": "Courbe A",
								"curveB": "Courbe B",
								"curveC": "Courbe C",
								"tooltips": {
									"curveA": "Fournisseurs avec une valeur élevée correspondant jusqu'à 80% de la valeur des achats",
									"curveB": "Fournisseurs avec une valeur intermédiaire correspondant jusqu'à 15% de la valeur des achats",
									"curveC": "Fournisseurs avec une faible valeur correspondant jusqu'à 5% de la valeur des achats"
								}
							},
							"columns": {
								"name": "Fournisseur",
								"total": "Coût Total",
								"cumulateTotal": "Total Cumulé",
								"percentage": "Représentation Individuelle",
								"cumulativePercentage": "Représentation Cumulative",
								"tier": "Classification"
							}
						}
					},
					"header": {
						"filter": "Filtrer par période",
						"searchPlaceholderProducts": "Recherche par produit ou intrant",
						"searchPlaceholderSuppliers": "Recherche par fournisseur"
					}
				},
				"cmvCost": {
					"alert": "Attention ! Il y a des produits avec une quantité négative qui devraient être examinés.",
					"averageCost": "Coût moyen x prix de vente",
					"averageCostSelection": "Coût moyen x prix de vente de la sélection",
					"export": "Exporter tableau",
					"filter": {
						"apply": "Filtrer",
						"category": {
							"all": "Toutes les catégories",
							"label": "Sélectionner la catégorie",
							"title": "Catégorie"
						},
						"clear": "Effacer le filtre",
						"label": "Filtrer par",
						"product": {
							"all": "Tous les produits",
							"label": "Sélectionner un produit",
							"title": "Produit"
						},
						"storage": {
							"all": "Tous les stocks",
							"label": "Sélectionner un stock",
							"title": "Stock"
						}
					},
					"label": "Coûts",
					"products": "Produits",
					"selectTotalCost": "Coût total de la sélection",
					"sheet": {
						"averageCost": "Coût moyen",
						"count": "Quantité",
						"fileName": "rapport-coût-cmv",
						"fiscalCode": "SKU",
						"margin": "Marge",
						"name": "Produit",
						"realCost": "Prix de vente",
						"stockValue": "Valeur du stock",
						"title": "CMV",
						"unityCount": "Quantité (Unité)"
					},
					"showAll": "Montrer tous les {{count}} product(s)",
					"showLess": "Montrer moins",
					"storageTotalCost": "Coût total du stock",
					"table": {
						"checkbox": "Ne pas montrer les articles avec la fiche technique",
						"columns": {
							"averageCost": "Coût moyen",
							"code": "SKU",
							"count": "Quantité",
							"margin": "Marge",
							"name": "Produit",
							"realCost": "Prix de vente",
							"stockValue": "Valeur du stock"
						}
					}
				},
				"irregularCmvProducts": {
					"label": "Produits CMV irréguliers",
					"layout": {
						"goBack": "Retour"
					},
					"table": {
						"columns": {
							"productId": "Identifiant produit",
							"name": "Produit",
							"storageId": "Identifiant stock",
							"storage": "Stock",
							"fiscalCode": "SKU",
							"lastCost": "Dernier coût",
							"unitCost": "Coût unitaire",
							"edit": "Modifier"
						},
						"actions": {
							"edit": "Modifier le coût unitaire"
						}
					},
					"batchActions": {
						"title": "Actions en lot",
						"actions": {
							"useLastCost": "Utiliser le dernier coût",
							"editCost": "Modifier le coût unitaire",
							"editViaSpreadsheet": "Modifier via le tableau"
						},
						"caption": "Sélectionnez les produits pour appliquer l'action en lot",
						"useLastCost": {
							"title": "Utiliser le dernier coût",
							"description": "Les produits suivants seront affectés:",
							"selectedProductsWithoutCost": "Les produits sélectionnés n'ont pas de coût unitaire"
						}
					},
					"updating": {
						"title": "Mise à jour des coûts",
						"subtitle": "Veuillez patienter, nous mettons à jour les coûts unitaires"
					},
					"editForm": {
						"title": "Modifier le coût",
						"inputs": {
							"product": "Produit",
							"storage": "Stock",
							"lastCost": "Dernier coût",
							"unitCost": "Coût unitaire",
							"save": "Sauvegarder",
							"cancel": "Annuler"
						},
						"errors": {
							"unitCostValueBiggerThanZero": "Le coût unitaire doit être supérieur à 0"
						}
					},
					"spreadsheetExportModal": {
						"title": "Modifier le coût",
						"fileName": "irregular-cmv-products-{{timesamp}}",
						"exportingSuccess": "Tableau exporté avec succès !",
						"exportButton": "Cliquez ici pour télécharger le tableau",
						"currencyWarning": "Attention ! la valeur des produits est indiquée en centimes, ex : 123 équivaut à 1,23 R$",
						"importButton": "Importer le tableau",
						"closeButton": "Fermer",
						"successTitle": "Mise à jour réussie",
						"successSubtitle": "Produits mis à jour",
						"errorTitle": "Oups... Quelque chose s'est mal passé.",
						"errorSubtitle": "Nous n'avons pas pu mettre à jour les produits. Veuillez réessayer plus tard."
					}
				},
				"cmvReport": {
					"label": "CMV",
					"description": "Le Coût des Marchandises Vendues (CMV), également connu sous le nom de Coût des Ventes, est le coût total encouru pour acquérir des marchandises qui ont été vendues pendant une période de temps spécifique. Il est essentiel pour déterminer le bénéfice brut d'une entreprise.",
					"periodInfo": "Affichage du rapport du {{since}} au {{until}}",
					"columns": {
						"product": "Produit",
						"category": "Catégorie",
						"quantity": "Montant",
						"fiscalCode": "SKU",
						"ncm": "NCM",
						"count": "Quantité",
						"unitValue": "Valeur unitaire",
						"totalValue": "Montant total",
						"productUnitCost": "Coût unitaireUnit cost",
						"totalCost": "Coût total",
						"percentageCost": "Coût en pourcentage",
						"margin": "Marge",
						"empty": "Aucun produit trouvé !",
						"total": "Total",
						"totalProduct": "Total ({{product}})",
						"supplie": "Saisir"
					},
					"infoCards": {
						"updated": "Mis à jour",
						"titleCard1": "Quantité de produits",
						"titleCard2": "Quantité totale",
						"titleCard3": "Coût total",
						"titleCard4": "Marge en pourcentage",
						"titleCard5": "Marge",
						"titleCard6": "Coût unitaire zéro",
						"titleCard6Action": "Voir tout"
					},
					"sheet": {
						"title": "Rapport CMV",
						"fileName": "rapport_cmv",
						"fiscalCode": "SKU",
						"margin": "Marge",
						"ncm": "NCM",
						"percentageCost": "Coût de la marge",
						"product": "Produit",
						"productUnitCost": "Coût unitaire",
						"total": "Total",
						"totalCost": "Coût total",
						"totalProduct": "Total ({{product}})",
						"totalValue": "Montant total",
						"unitValue": "Valeur unitaire"
					},
					"expandIcon": {
						"arrowDown": "Fermer Produits",
						"arrowUp": "Montrer Produits"
					},
					"expandedTable": {
						"columns": {
							"codeProduct": "SKU",
							"margin": "Marge",
							"percentMargin": "Marge en pourcentage",
							"cmv": "CDV",
							"product": "Produit",
							"quantity": "Quantité",
							"lostQuantity": "Quantité perdue",
							"totalCost": "Coût total",
							"totalValue": "Montant total",
							"unitCost": "Coût unitaire",
							"unitValue": "Valeur unitaire"
						},
						"loading": "Chargement"
					},
					"export": "Exporter tableau",
					"forms": {
						"cmvType": "Produits affichés",
						"cmvType1": "Tous les produits",
						"cmvType2": "Produits du lieu uniquement",
						"cmvType3": "Produits du vendeur uniquement",
						"period": "Période",
						"product": "Produit",
						"productPlaceholder": "Rechercher par produit",
						"searchPlaceholder": "Rechercher par catégorie"
					}
				},
				"lossReport": {
					"add": "Ajouter Perte",
					"export": "Exporter Excel",
					"periodInfo": "Affichage du rapport du {{since}} au {{until}}",
					"description": "Le rapport de pertes regroupe tous les mouvements de stock marqués comme des pertes. Ainsi, l'administrateur peut avoir une vue d'ensemble des produits qui ont été perdus.",
					"emptyText": "Aucune donnée n'a été trouvée",
					"addModal": {
						"count": "Quantité",
						"date": "Date",
						"loading": "Chargement...",
						"lossQuantity": "Quantité perdue",
						"none": "Aucun produit trouvé",
						"other": "Ajouter un autre produit",
						"productSelect": "Sélectionner un produit",
						"storageSelect": "Sélectionner un stock"
					},
					"columns": {
						"manual": "Perte manuelle",
						"product": "Produit",
						"inventory": "Inventaire",
						"production": "Perte de production",
						"refund": "Perte en remboursement",
						"intentoryLoss": "Perte d'inventaire",
						"sku": "SKU",
						"subtotal": "Sous-total",
						"total": "Perte totale",
						"totalLoss": "Valeur totale de perte"
					},
					"label": "Pertes",
					"period": "Période",
					"sheet": {
						"fileName": "rapport-pertes",
						"manual": "Perte manuelle",
						"product": "Produit",
						"inventory": "Inventaire",
						"production": "Perte de production",
						"refund": "Perte en remboursement",
						"intentoryLoss": "Perte d'inventaire",
						"sku": "SKU",
						"subtotal": "Sous-total",
						"title": "Rapport de perte",
						"basicStorageUnit": "Unité",
						"total": "Perte totale",
						"totalLoss": "Valeur totale de perte"
					},
					"title": "Rapport de perte",
					"validations": {
						"validDate": "Sélectionner une date valide",
						"validProduct": "Sélectionner un produit valide",
						"validQuantity": "Saisir une quantité valide",
						"validStorage": "Sélectionner un stock valide",
						"totalLossTooltip": "Valeur totale de perte pour la période sélectionnée.",
						"totalLossHeading": "Valeur totale de perte"
					}
				},
				"nfReport": {
					"columns": {
						"date": "date d'importation",
						"emission": "Date d'émission",
						"name": "Numéro de facture",
						"value": "Montant"
					},
					"empty": "Aucun produit",
					"label": "Factures d'achats",
					"notAssociatedProduct": "(Produit non associé)",
					"productColumns": {
						"name": "Produits",
						"quantity": "Quantité",
						"total": "Total",
						"unit": "Unité",
						"unitValue": "Valeur unitaire"
					}
				},
				"manualInvoiceImporting": {
					"form": {
						"num": "Numéro de facture",
						"serie": "Série de facture",
						"date": "Date d'émission",
						"inputDate": "Date d'entrée en stock physique",
						"operationType": "Type d'opération",
						"accessKey": "Clé d'accès",
						"supplier": "Émetteur",
						"suppliers": "Fournisseurs",
						"newSupplier": "Nouveau fournisseur",
						"totalValue": "Valeur de la facture",
						"discountValue": "Réductions",
						"finalValue": "Valeur totale",
						"amountOfDuplicates": "Nombre d'échéances",
						"firstDueDate": "Première échéance",
						"duplicateInterval": "Intervalle entre les échéances",
						"duplicatesDetails": "Détails du paiement échelonné",
						"duplicateNumber": "Numéro d'échéance",
						"dueDate": "Date d'échéance",
						"value": "Valeur",
						"intervalTypes": {
							"Month": "Mensuel",
							"Week": "Hebdomadaire"
						},
						"shippingValue": "Frais de transport",
						"insuranceValue": "Assurance",
						"otherExpensesValue": "Dépenses supplémentaires",
						"icmsValue": "ICMS",
						"icmsstValue": "ICMS ST",
						"ipiValue": "IPI",
						"associatedProduct": "Produit associé",
						"associatedChartAccount": "Plan comptable",
						"count": "Quantité",
						"unitCostValue": "Coût unitaire",
						"totalCost": "Coût total",
						"basicStorageUnit": "Unité de mesure",
						"success": "Facture importée avec succès",
						"storage": "Stock",
						"accessKeyInfo": "La clé d'accès de la NF-e est composée de 44 chiffres numériques qui identifient la facture électronique. Elle inclut des informations telles que le numéro d'identification fiscale de l'émetteur (CNPJ), le code de l'état, l'année et le mois d'émission, le numéro de la facture, le modèle, la série et un code de contrôle unique."
					},
					"sections": {
						"inviceDetails": "Détails de la facture",
						"duplicates": "Paiement échelonné",
						"expenses": "Frais de transport et dépenses",
						"taxes": "Taxes",
						"products": "Produits"
					},
					"validations": {
						"storageIsRequired": "Il est obligatoire de sélectionner un stockage.",
						"duplicateInvoice": "La facture est dupliquée.",
						"supplierIsRequired": "Il est obligatoire de sélectionner un émetteur.",
						"numIsRequired": "Il est obligatoire de fournir le numéro de la facture.",
						"numIsInvalid": "Le numéro de la facture doit contenir uniquement des chiffres.",
						"serieIsInvalid": "La série doit contenir uniquement des chiffres.",
						"serieIsRequired": "Il est obligatoire de fournir la série de la facture.",
						"operationTypeIsRequired": "Il est obligatoire de fournir le type d'opération.",
						"totalValueIsRequired": "Il est obligatoire de fournir la valeur totale de la facture.",
						"productsIsRequired": "Il est obligatoire d'ajouter au moins un produit.",
						"invalidAccessKey": "Clé d'accès invalide."
					}
				},
				"purchaseInvoice": {
					"detailingProduct": {
						"infoBasCalcUnitCost": "La base de calcul du coût unitaire est : Valeur totale - Remise + IPI + ICMS + Expédition + Assurance + Autres dépenses / Quantité",
						"columns": {
							"associateProduct": "Produit associé (ZIG)",
							"commercialUnit": "UN (NF)",
							"commercialUnitZig": "UN (ZIG)",
							"emission": "Date d'émission",
							"invoiceEntry": "Produit importé",
							"nf": "NF",
							"inputDate": "Date d'entrée en stock",
							"supplierName": "Fournisseur",
							"totalValue": "Coût total (NF)",
							"unitQuantity": "QTÉ (NF)",
							"unitQuantityZig": "QTÉ (ZIG)",
							"unitValue": "Coût unitaire (NF)",
							"unitValueZig": "Coût unitaire (ZIG)"
						},
						"emptyText": "Il n'y a pas de produits non associés dans ce profil fiscal.",
						"excelExportDetailingProduct": {
							"fileName": "détail_produit",
							"title": "Détail par produit"
						},
						"fields": {
							"isAssociatedProduct": "Produits non associés uniquement",
							"searchDateRange": {
								"emissionDate": {
									"end": "Date de fin d'émission",
									"start": "Date de début d'émission"
								},
								"processedAtDate": {
									"end": "Date de fin de saisie",
									"start": "Date de début de saisie"
								}
							},
							"searchNf": "Saisir le numéro de la facture",
							"searchSupplier": "Saisir le nom de l'émetteur"
						},
						"unassociatedProduct": "Produit non associé"
					},
					"importHistory": {
						"actionTable": {
							"delete": "Supprimer",
							"download": "Télécharger",
							"unprocess": "Ne pas traiter"
						},
						"columns": {
							"createdAt": "Date d'importation",
							"emission": "Date d'émission",
							"nf": "NF",
							"status": "Statut",
							"statusMessage": {
								"Deprocessed": "Déprogrammé",
								"Unprocessed": "Non traité",
								"processed": "Traité"
							},
							"supplier": "Fournisseur",
							"totalValue": "Montant"
						},
						"excelExportHistoryImport": {
							"filename": "importer_historique",
							"title": "Importer l'historique"
						},
						"fields": {
							"searchDateEmissionRange": {
								"end": "Date de fin d'émission",
								"start": "Date de début d'émission"
							},
							"searchDateImportRange": {
								"end": "Date de fin d'importation",
								"start": "Date de début d'importation"
							},
							"searchNf": "Numéro de facture",
							"searchSupplier": "Nom du fournisseur"
						},
						"modalDelete": {
							"cancelText": "Annuler",
							"message1": "Suppression de la facture",
							"message2": "Cette action est permanente. Désirez-vous continuer ?",
							"okText": "Supprimer",
							"title": "Supprimer la facture"
						},
						"modalEdit": {
							"associetedProduct": "Produit associé",
							"cancelText": "Annuler",
							"equals": "équivalents",
							"okText": "Produit associé",
							"selectStorage": "Sélectionner un stock",
							"storage": "Stock",
							"title": "Produit associé",
							"unitValue": "Prix unitaire"
						},
						"modalUnprocess": {
							"cancelText": "Annuler",
							"closeText": "Fermer",
							"message1": "La suppression d'une facture entraîne les actions suivantes :",
							"message2": "Les produits ajoutés au stock vont être supprimés;",
							"message3": "La comptabilisation de la facture sera retirée de la comptabilité fournisseurs..",
							"message4": "Voulez-vous quand même annuler le traitement de la facture ?",
							"okText": "Facture non traitée",
							"title": "Facture non traitée"
						},
						"table": {
							"emptyText": "Il n'y a pas de facture à afficher",
							"reportPrint": "Importer historique"
						}
					},
					"importationInvoices": {
						"btnUpdate": "Mettre à jour",
						"columns": {
							"issueDate": "Date d'émission",
							"issuerCnpj": "CNPJ ou CPF",
							"issuerName": "Nom de l'émetteur",
							"status": {
								"authorized": "Autorisé",
								"imported": "Importé",
								"notAllowed": "Non autorisé",
								"title": "Statut",
								"xmlUnavailable": "XML indisponible"
							},
							"totalValue": "Montant total"
						},
						"fiscalProfilesOptions": {
							"disabledMessage": "Le profil fiscal n'est pas activé pour rechercher des factures, modifiez le profil avant de continuer",
							"notEnabled": "(NON ACTIVÉ)"
						},
						"emptyText": "Pas de facture d'achat",
						"fiscalProfiles": "Profil fiscal",
						"issueDate": "Filtrer par date",
						"issuer": "Filtrer par nom de fournisseur",
						"xmlUnavailableInfo": "Pour rendre disponibles les fichiers XML avec le statut indisponible, il est nécessaire de réaliser la manifestation de la note. En cas de doute sur la manifestation, consultez votre comptable.",
						"modalInfoImport": {
							"notAllowed": {
								"title": "Non autorisé"
							},
							"xmlUnavailable": {
								"reason": "Le code XML pour cette facture n'est pas encore disponible. Veuillez patienter avant d'impoter la facture.",
								"title": "XML indisponible"
							}
						},
						"status": "Filtrer par statut",
						"title": "Sélectionner un profil fiscal pour commencer"
					},
					"tabs": {
						"detailingByProduct": "Détail par produit",
						"historyNf": "Importer l'historique"
					},
					"titlePage": "Factures d'achat",
					"description": "La factura de compra est le document se référant au mouvement des stocks de marchandises que votre entreprise reçoit. Ici, vous pourrez importer vos factures, consulter votre historique d'importation, ainsi que le détail par produit de celles-ci."
				},
				"storageAlerts": {
					"addAlertModal": {
						"add": "Créer une alerte",
						"invalidText": "La valeur du stock d'alerte ne peut être inférieure ou égale à la valeur du stock critique.",
						"selectProduct": "Sélectionnez le produit",
						"storageAlert": {
							"below": "En-dessous",
							"label": "Alerte",
							"storageIn": "Stock de"
						},
						"storageCritic": {
							"below": "En-dessous",
							"label": "CRITIQUE",
							"storage": "Stock"
						},
						"title": "Ajouter une nouvelle alerte"
					},
					"addEmailModal": {
						"email": "Email",
						"emptyText": "Emails non enregistrés",
						"name": "Nom",
						"phone": "Téléphone",
						"placeholders": {
							"name": "Entrez le nom",
							"email": "Entrez l'email",
							"phone": "Entrez le téléphone"
						},
						"title": "Configuration de la réception des emails d'alerte"
					},
					"btnAddEmail": "Configure alert reception",
					"btnAddProductAlert": "Ajouter une alerte pour un produit",
					"description": "Configurez et gérez les alertes de votre stock pour ne manquer aucun mouvement",
					"titleAlertPhone": "Recevez des alertes sur votre téléphone !",
					"descriptionAlertPhone": "Maintenant vous pouvez enregistrer des numéros de téléphone pour recevoir les alertes de stock",
					"columns": {
						"actions": "Actions",
						"product": "Produit",
						"storageAlert": {
							"from": "de",
							"label": "Alerte",
							"storageIn": "Stock de"
						},
						"storageCritic": {
							"from": "de",
							"label": "CRITIQUE",
							"storage": "Stock"
						},
						"storageQuantity": "Stock actuel"
					},
					"filters": {
						"ok": "OK",
						"storageAlert": "État de l'alerte",
						"storageCritic": "Condition critique"
					},
					"label": "Alertes de stock",
					"search": "Rechercher Produits"
				},
				"storageHistory": {
					"filename": "rapport-transaction",
					"description": "Le Relatório de Movimentação de Estoque permet une analyse détaillée de tous les mouvements d'entrées et de sorties effectués au cours d'une période donnée.",
					"print": "Imprimer",
					"export": "Exporter",
					"cleanFilters": "Effacer les filtres",
					"emptyState": {
						"title": "Sélectionnez et appliquez les filtres pour commencer",
						"description": "Vous devez sélectionner au moins un stock, une catégorie ou un produit et la période pour commencer"
					},
					"categorys": {
						"label": "Catégories",
						"placeholder": "Sélectionner catégories"
					},
					"columns": {
						"cardExchange": "Retour",
						"inicial": "Quantité initiale",
						"input": "Entrée de produit",
						"lost": "Pertes",
						"manual": "Ajustement manuel",
						"name": "Produit",
						"productionIn": "Entrée en production",
						"productionOut": "Sortie en production",
						"result": "Final",
						"sell": "Ventes",
						"transfer": "Transfert interne",
						"ube": "Unité",
						"lossPercentage": "Pourcentage de perte"
					},
					"editModal": {
						"alert": "Alerte",
						"below": "en-dessous",
						"critical": "Critique",
						"delete": "Supprime Alerte",
						"deleteWarning": "Êtes-vous sûr de supprimer l'alerte pour {{productName}}?",
						"invalidText": "La valeur du stock d'alerte ne peut être inférieure à la valeur du stock critique.",
						"storage": "Stock",
						"storageIn": "Stock de",
						"title": "Modifier les alertes de stock pour {{productName}}"
					},
					"filter": "Appliquer les filtres",
					"filterBy": {
						"category": "Catégorie",
						"label": "Filtrer par",
						"product": "Produit"
					},
					"dateFilterBy": {
						"label": "Filtrer les données par",
						"options": {
							"events": "Événements entre intervalle",
							"interval": "Tout entre intervalle"
						}
					},
					"hideProducts": "Ne pas montrer les produits avec une fiche technique",
					"label": "Rapport transaction",
					"period": "Période",
					"printable": {
						"final": "Fin",
						"initialQuantity": "Qté initiale",
						"internalTransfer": "Transfert interne",
						"losses": "Perte",
						"manualAdjustment": "ajustement manuel",
						"product": "Produit",
						"productEntry": "Entrée Produit",
						"productionEntry": "Entrée en production",
						"productionOutput": "Sortie en production",
						"sales": "Ventes",
						"withoutProducts": "Aucun produit sélectionné"
					},
					"products": {
						"label": "Produits",
						"placeholder": "Sélectionner produits"
					},
					"storageReport": "Rapport de stock",
					"storages": {
						"label": "Stocks",
						"placeholder": "Sélectionner stock"
					}
				},
				"storages": {
					"addNewStorage": "Ajouter un nouveau stock",
					"addProductModal": {
						"form": {
							"addedProducts": "Produits ajoutés",
							"submit": "Soumettre",
							"successNotification": "Données importées"
						},
						"manual": {
							"addOtherProduct": "Ajouter un autre produit",
							"costValue": "Prix",
							"error": {
								"noneValidProduct": "Aucun produit valide sélectionné",
								"zeroCount": "Impossible d'ajouter un produit avec une quantité égale à 0"
							},
							"label": "Manuellement",
							"product": "Produit",
							"quantity": "Quantité"
						},
						"noteInfo": {
							"accessKey": "Clé d'accès",
							"addBill": "Ajouter un compte à payer",
							"addSupplier": "Ajour un émetteur à vos favoris",
							"bill": "Compte",
							"cpnj": "CNPJ",
							"error": "Un problème est survenu avec la facture et la création d'un Fournisseur n'a pas été possible",
							"number": "Numéro de facture",
							"operationType": "Nature de l'opération",
							"provider": "Fournisseur",
							"removeBill": "Supprimer un compte à payer",
							"series": "Séries",
							"supplierName": "Émetteur",
							"title": "Données de facture",
							"totalValue": "Montant total",
							"unavailable": "Indisponible"
						},
						"product": {
							"code": "SKU",
							"commercialQuantity": "Qté",
							"commercialUnit": "Un",
							"cost": "Prix par",
							"description": "Description du produit",
							"equals": "équivalent à",
							"label": "Produit",
							"skip": "Passer",
							"unitValue": "Prix unitaire"
						},
						"title": "Ajouter Produits",
						"xml": {
							"label": "Importer Facture (XML)",
							"upload": "Cliquez sur les fichiers ou faites-les glisser pour les télécharger"
						}
					},
					"confirmMessage": "Êtes-vous sûr de supprimer le stock",
					"createStorage": "Créer Stock",
					"deleteAllProducts": "supprimer tous les produits",
					"deleteProduct": {
						"title": "Êtes-vous sûr de supprimer ce produit ?",
						"tooltip": "Supprimer Produit"
					},
					"editStorage": "Modifier Stock",
					"error": "Erreur lors du chargement des stocks",
					"label": " Stock",
					"modalImportInvoice": {
						"errors": {
							"notKeyAccess": "Impossible de récupérer la clé d'accès XML"
						},
						"labelInputs": {
							"storage": "Stock",
							"xmlKey": "Clé XML"
						},
						"placeholders": {
							"selectStorage": "Sélectionner Stock"
						},
						"typeOptionsImport": {
							"xmlFile": "Joindre un fichier XML",
							"xmlKeyAccess": "Saisir la clé d'accès XML"
						},
						"validationMessage": {
							"emptyFileXml": "Fichier XML non sélectionné",
							"emptySelectTypeImport": "Sélectionner une option d'importation",
							"emptyStorage": "Sélectionner un stock",
							"emptyXmlKey": "Le champ Clé d'accès est vide"
						}
					},
					"modalTransfer": "Transférer les produits depui {{storage}}",
					"newStorage": "Nouveau Stock",
					"removeStorage": "Supprimer Stock",
					"search": "Rechercher un stock",
					"storageCard": {
						"addProduct": "Ajouter un produit",
						"edit": "Modifier Stock",
						"error": "Impossible de {{action}} un produit avec une quantité égale à 0",
						"modal": {
							"add": "Ajouter votre mrix unitaire",
							"addProducts": "Ajouter Produits",
							"amount": "Saisir la quantité que vous souhaitez",
							"costValue": "Prix",
							"count": "Quantité",
							"note": "Facture",
							"removeProducts": "Supprimer Produits"
						},
						"modalTransfer": {
							"error": {
								"selectCount": "Sélectionner une quantité",
								"selectStorage": "Sélectionner un stock"
							},
							"okText": "Transférer",
							"quantity": "Quantité",
							"storage": "Stock",
							"title": "Transférer {{name}}"
						},
						"productSearch": "Rechercher Produit",
						"transfer": "Transférer Produits"
					},
					"storageList": {
						"central": "Général",
						"default": "Lieu",
						"emptyArea": "Aucun stock à afficher",
						"emptyMessage": "Aucun article à afficher"
					},
					"storageName": "Nom du stock",
					"tableProducts": {
						"add": "Ajouter Produit",
						"columns": {
							"actions": "Actions",
							"category": "Catégorie",
							"count": "Quantité",
							"name": "Produit"
						},
						"cost": "Prix",
						"countError": "Impossible d'ajouter un produit avec une quantité à 0",
						"product": "Produit",
						"productError": "Produit introuvable",
						"quantity": "Qualité",
						"total": "au total"
					},
					"transferProductModal": {
						"destinyStorage": {
							"label": "Cibler Stock",
							"placeholder": "Sélectionner un stock"
						},
						"error": {
							"addProduct": "Impossible d'ajouter un produit sans quantité",
							"selectProduct": "Quantité négative en stock. Le produit ne peut pas être sélectionné"
						},
						"printTransfer": {
							"associate": "Cliquer ici pour les associer",
							"download": "Télécharger Tableau depuis les transferts",
							"infoText": "Transfert réaliser avec succès, voir la synthès des produits transférés ci-dessous",
							"none": "Aucun",
							"notFound": "Non trouvé",
							"notTransnfer": "Les produits suivants n'ont pas pu être transférés",
							"print": "Imprimer le document de transfert",
							"quantity": "Quantité",
							"responsible": "Responsable de la destination du stock",
							"sheet": {
								"columns": {
									"count": "Quantité",
									"name": "Produit",
									"totalCost": "Coût total",
									"unit": "Unité",
									"unitaryCost": "Coût unitaire"
								},
								"filename": "transfert-stock",
								"title": "Transfert du stock {{selectedStorage}} à {{toStorage}}"
							},
							"successNotification": "Produits associés et transférés",
							"text": "Ce document atteste du transfert des produits du stock {{fromStorage}} au stock {{toStorage}}. Fait ce jour {{date}} par {{employee}}. Les produits transférés sont dans la liste suivante :",
							"title": "Preuve de transfert",
							"unassociated": "Ils ne sont pas associés avec le lieu ciblé",
							"withoutName": "Sans nom"
						},
						"product": {
							"label": "Produit",
							"placeholder": "Sélectionner un produit"
						},
						"quantity": "Quantité",
						"table": {
							"empty": "aucun produit sélectionné",
							"product": "Produit",
							"quantity": "Quantité",
							"totalCost": "Coût total",
							"unityCost": "Coût unitaire"
						},
						"transferFor": {
							"central": "Stock global",
							"label": "Transférer à",
							"local": "Stock du lieu",
							"placeSelect": {
								"label": "Destination",
								"placeholder": "Sélectionner un lieu"
							}
						}
					},
					"transferResume": "Rapport des transferts",
					"zeroBackoffice": "Supprimer tous les produits dans le stock"
				},
				"productionControl": {
					"label": "Recettes et production",
					"at": "à",
					"attachedToModal": {
						"title": "Pièces jointes de l'élément",
						"description": "Liste des enregistrements auxquels cet élément est attaché",
						"seeDetails": "Voir les Détails"
					},
					"tabs": {
						"production": "Recettes et Production",
						"productionHistory": "Historique de Production"
					},
					"list": {
						"emptyList": "Aucune règle de production trouvée",
						"actions": {
							"produce": "Produire"
						},
						"createdAt": "Créé le {{date}}",
						"title": "Recettes",
						"subtitle": "Sélectionnez la recette que vous souhaitez produire",
						"searchPlaceholder": "Rechercher une recette",
						"links": "Liens",
						"linksTotal": "{{count}} produits"
					},
					"history": {
						"table": {
							"name": "Nom",
							"storage": "Stock",
							"fiscalCode": "SKU",
							"createdAt": "Date de Création",
							"count": "Quantité Produite",
							"cost": "Valeur",
							"author": "Producteur"
						},
						"filters": {
							"search": {
								"label": "Rechercher par",
								"placeholder": "Nom, producteur ou SKU"
							},
							"interval": {
								"label": "Filtrer par période"
							}
						}
					},
					"producer": "Producteur",
					"expectedYield": "Rendement Attendu",
					"yield": "Rendement",
					"storage": "Stock",
					"production": {
						"title": "Produire Ingrédient",
						"steps": {
							"CONFIGURATION": {
								"title": "Configuration",
								"description": "Sélectionnez le stock pour commencer"
							},
							"PREPARE": {
								"title": "Préparation",
								"description": "Remplissez la quantité de chaque ingrédient et cliquez sur suivant pour continuer"
							},
							"RESULT": {
								"title": "Rendement",
								"description": "Revérifiez votre production et remplissez le rendement pour terminer"
							}
						},
						"fields": {
							"storage": {
								"label": "Stock",
								"placeholder": "Sélectionnez un stock"
							},
							"producer": {
								"label": "Producteur"
							},
							"inputCount": {
								"label": "Quantité Utilisée"
							},
							"inputLoss": {
								"label": "Perte"
							},
							"output": {
								"label": "Quantité Produite"
							}
						},
						"statusDialog": {
							"loading": {
								"dialogTitle": "Production",
								"title": "En cours de production...",
								"subtitle": "Nous produisons votre produit, veuillez patienter un moment."
							},
							"success": {
								"dialogTitle": "Production - Succès",
								"title": "Production Terminée !",
								"subtitle": "{{count}} de {{recipe}} entrés dans le stock {{storage}}"
							},
							"error": {
								"dialogTitle": "Production - Erreur",
								"title": "Oups, quelque chose s'est mal passé !",
								"subtitle": "Nous n'avons pas pu effectuer la production. Veuillez réessayer ultérieurement."
							}
						},
						"backToHome": "Retour à la Page d'Accueil",
						"backToYield": "Retour au Rendement",
						"ingredientsTable": {
							"name": "Ingrédient",
							"count": "Quantité",
							"loss": "Perte",
							"totalLoss": "Sortie de Stock"
						},
						"outOfExpectedYield": {
							"cancelText": "Modifier le rendement",
							"description": "Votre production est significativement en dehors de la règle de production. Voulez-vous continuer quand même ?"
						}
					},
					"validation": {
						"numberMustBeGreaterThanZero": "La valeur doit être supérieure à 0",
						"numberMustBePositive": "La valeur doit être positive",
						"nameMustHaveMaxCharacters": "Le nom doit avoir un maximum de 30 caractères",
						"skuMustHaveMaxCharacters": "Le SKU doit avoir un maximum de 60 caractères"
					},
					"save": {
						"newTitle": "Nouvelle Règle",
						"editTitle": "Modifier la Règle",
						"createAction": "Créer la Règle",
						"addSupplyAction": "Ajouter Ingrédient",
						"detailsTitle": "Détails de la Règle",
						"productionRule": "Règle de Production",
						"inputsTable": {
							"name": "Ingrédient",
							"count": "Quantité",
							"loss": "Perte",
							"actions": "Actions"
						},
						"form": {
							"name": {
								"label": "Nom",
								"placeholder": "Entrez un nom"
							},
							"yield": {
								"label": "Rendement de la Règle"
							},
							"image": {
								"label": "Photo",
								"caption": "Image carrée ou 500x500 pixels"
							},
							"inputName": {
								"label": "Ingrédient ou produit"
							},
							"inputCount": {
								"label": "Quantité"
							},
							"inputLoss": {
								"label": "Perte"
							},
							"output": {
								"label": "Quantité Produite"
							}
						}
					},
					"deleteDialog": {
						"title": "Supprimer la Règle",
						"content": "En confirmant cette action, vous supprimerez définitivement cette règle de production. Souhaitez-vous continuer ?"
					},
					"actions": {
						"produce": "Produire",
						"delete": "Supprimer",
						"edit": "Modifier"
					},
					"recipe": {
						"title": "Détails de la Recette",
						"ingredientsTitle": "Recettes et production",
						"totalCost": "Coût Total",
						"yield": "Rendement Espérado",
						"deleteInputDialog": {
							"content": "En confirmant cette action, vous retirerez l'élément de la recette. Souhaitez-vous continuer ?",
							"title": "Supprimer l'Élément"
						},
						"multipleItems": "Articles",
						"singleItem": "Article",
						"links": "Liens"
					}
				},
				"inventoryControl": {
					"label": "Inventaire"
				},
				"stockPositionReport": {
					"label": "Position des Stocks",
					"title": "Rapport de Position des Stocks",
					"filters": {
						"period": "Période",
						"storage": "Stockage",
						"apply": "Appliquer les filtres",
						"clean": "Effacer les filtres"
					},
					"paragraph": "Le rapport de Position des Stocks donne un aperçu de l'état du stock à un certain moment, affichant les produits des stocks sélectionnés, leurs quantités et leurs coûts.",
					"selectStock": "Sélectionnez le stock",
					"emptyMessage": {
						"title": "Sélectionnez un stock pour commencer",
						"description": "Sélectionnez le stock et le jour désiré pour afficher le rapport de position des stocks"
					},
					"table": {
						"product": "Produit",
						"initialQuantity": "Quantité initiale",
						"finalQuantity": "Quantité finale",
						"maxQuantity": "Quantité maximale",
						"minQuantity": "Quantité minimale",
						"replacement": "Remplacement suggéré",
						"averageCost": "Coût moyen",
						"totalCost": "Coût total",
						"total": "Total"
					}
				}
			}
		},
		"audits": {
			"navTitle": " Audit"
		},
		"tagGroups": {
			"title": "Groupe de cartes",
			"total": "Totale",
			"exportToExcel": "Exporter vers Excel",
			"importConsumption": "Consommation d'importation",
			"blockCards": {
				"label": "Bloquer les balises sélectionnées",
				"confirmationMessage": "Vous êtes sur le point de bloquer les balises sélectionnées. Êtes-vous sûr de vouloir continuer ?",
				"confirmationButton": "Oui, bloquer les balises"
			},
			"unblockCards": {
				"label": "Activer les balises sélectionnées",
				"confirmationMessage": "Vous êtes sur le point d'activer les balises sélectionnées. Êtes-vous sûr de vouloir continuer ?",
				"confirmationButton": "Oui, activer les balises"
			},
			"filter": {
				"zigCode": {
					"label": "Filtrer par code zig",
					"placeholder": "Code Zig"
				},
				"group": {
					"label": "Filtrer par groupe",
					"placeholder": "Nom du groupe"
				},
				"serial": {
					"label": "Filtrer par série",
					"from": "De:",
					"to": "Jusqu'à",
					"placeholderFrom": "Ex: 1001",
					"placeholderTo": "Ex: 2001"
				},
				"status": {
					"label": "Statut",
					"options": {
						"all": "Tous",
						"blocked": "Bloqué",
						"inUse": "En cours d'utilisation",
						"used": "Occasion",
						"inactive": "Inactif"
					}
				},
				"userType": {
					"label": "Par type d'utilisateur",
					"options": {
						"all": "Tous",
						"anonymous": "Anonyme",
						"nonAnonymous": "Pas anonyme"
					}
				}
			},
			"table": {
				"export": {
					"fileName": "cartes-groupe-événement-{{eventName}}_{{eventDate}}",
					"titleName": "Groupe de cartes de l'événement {{eventName}}"
				},
				"selectedItems": "Articles sélectionnés :",
				"columns": {
					"zigCode": "Zig Code",
					"serialNumber": "Numéro de série",
					"status": {
						"label": "Statut",
						"blocked": "Bloqué",
						"inUse": "En cours d'utilisation",
						"used": "Occasion",
						"inactive": "Inactif"
					},
					"user": {
						"label": "Utilisateur",
						"anonymous": "Anonyme"
					},
					"zigDeviceGroup": "Groupe de cartes",
					"totalValue": "Solde",
					"actions": {
						"label": "Actions",
						"block": "Bloquer",
						"blockCard": "Bloquer la carte",
						"unblock": "Débloquer",
						"unblockCard": "Débloquer la carte",
						"addConsumption": "Ajouter une consommation"
					}
				}
			},
			"addConsumption": {
				"title": "Ajouter la consommation",
				"confirmButton": "Confirmer",
				"fields": {
					"rechargeType": {
						"label": "Type de recharge"
					},
					"balanceValue": {
						"label": "Valeur de recharge",
						"required": "La valeur de recharge doit être supérieure à zéro"
					},
					"reason": {
						"label": "Raison",
						"required": "Entrez le motif"
					}
				}
			},
			"topUpCancelation": {
				"confirmation": {
					"title": "Confirmer l'annulation des recharges en attente",
					"description": "Vous êtes sur le point d'annuler toutes les recharges en attente associées à cette carte. Confirmer l'annulation ?",
					"confirmButton": "Confirmer l'annulation",
					"cancelButton": "Retour"
				},
				"confirmationByBatch": {
					"title": "Confirmer l'annulation des recharges groupées",
					"description": "Vous êtes sur le point d'annuler toutes les recharges en attente pour les cartes sélectionnées. Poursuivre l'annulation ?",
					"confirmButton": "Confirmer l'annulation",
					"cancelButton": "Retour"
				},
				"cancelationButton": "Annuler les recharges en attente"
			}
		},
		"prechargeReports": {
			"title": "Rapports de précharge",
			"filterByDate": "Filtrer par date",
			"cards": {
				"retrievedRecharge": "Recharges récupérées",
				"consumedValue": "Valeur consommée",
				"avgRechargedValue": "Valeur moyenne de recharge",
				"avgRetrievedValueByDay": "Valeur moyenne récupérée par jour",
				"gender": {
					"label": "Répartition par genre",
					"male": {
						"title": "{{percent}}% Hommes",
						"acronym": "H"
					},
					"female": {
						"title": "{{percent}}% Femmes",
						"acronym": "F"
					},
					"other": {
						"title": "{{percent}}% Autres",
						"acronym": "A"
					}
				}
			},
			"table": {
				"exportToExcel": {
					"title": "{{placeName}}_{{date}}",
					"filename": "{{placeName}}_{{date}}"
				},
				"columns": {
					"date": "Date",
					"maleQuantity": "Total des recharges pour les hommes",
					"femaleQuantity": "Total des recharges pour les femmes",
					"otherQuantity": "Total des recharges pour les autres",
					"topUpQuantity": "Total des recharges en attente",
					"redeemedQuantity": "Total des recharges récupérées",
					"accumulatedValue": "Valeur accumulée",
					"bonusValue": "Valeur bonus",
					"redeemedValue": "Valeur récupérée",
					"usedValue": "Valeur consommée"
				}
			}
		},
		"barReports": {
			"salesReport": {
				"title": "Rapport de Ventes",
				"tabTitle": "Ventes",
				"exportButton": "Exporter",
				"exportLabelWithFilters": "Rapport avec filtres sélectionnés",
				"exportAllSales": "Ventes détaillées",
				"exportOthersReportsLabel": "Autres rapports",
				"exportTotalSales": "Produits vendus",
				"exportDetailedSold": "Ventes Détaillées (Consolidé)",
				"exportSoldProductsAnalytic": "Produits Vendus (Analytique)",
				"exportSoldProductsConsolidated": "Produits Vendus (Consolidé)",
				"productsSoldLabel": "Quantité de produits vendus",
				"subtotalLabel": "Sous-total",
				"subtotalTooltip": "Valeur unitaire x Quantité vendue",
				"discountsLabel": "Réductions",
				"totalProductsSoldLabel": "Total des produits vendus",
				"totalProductsSoldTooltip": "(Valeur unitaire x Quantité vendue) - Réductions",
				"allSalesTab": "Ventes détaillées",
				"totalSalesTab": "Produits vendus",
				"paymentTypes": {
					"bonus": "Bonus",
					"fromApp": "Payé dans l'App",
					"fromEvent": "Payé à l'événement",
					"fromOtherEvent": "Payé à un autre événement",
					"minimumConsumption": "Consommation minimum",
					"post": "Post",
					"ppu": "Pré"
				},
				"allSales": {
					"table": {
						"columns": {
							"date": "Date",
							"client": "Client",
							"document": "Document",
							"employee": "Employé",
							"products": "Produits",
							"paymentType": "Moyen de paiement",
							"isRefunded": "Remboursé",
							"discount": "Réduction",
							"transactionValue": "Valeur de la transaction"
						},
						"total": "Total",
						"method": "méthode",
						"methods": "méthodes",
						"product": "produit",
						"products": "produits"
					},
					"filters": {
						"clientPlaceholder": "Filtrer par client",
						"employeePlaceholder": "Filtrer par employé",
						"paymentTypePlaceholder": "Filtrer par paiement"
					}
				},
				"totalSales": {
					"groupPlaceholder": "Grouper par catégorie de produit",
					"groupByBar": "Grouper par bar",
					"groupByCategory": "Grouper par catégorie de produit",
					"noGroup": "Sans regroupement",
					"groupByProduct": "Grouper par produit",
					"transactionPlaceholder": "Filtrer par type de transaction",
					"productPlaceholder": "Filtrer par produit",
					"barPlaceholder": "Filtrer par bar",
					"tableProductsSold": {
						"sectorsPlaceholder": "Filtrer par secteur",
						"sku": "SKU",
						"name": "Nom",
						"unitQuantity": "Qté unit.",
						"unitValue": "Valeur unitaire",
						"subtotal": "Sous-total",
						"discounts": "Réductions",
						"totalValue": "Valeur totale",
						"addCategory": "Ajouter catégorie",
						"totalInBar": "Total en {{barName}}",
						"productImageAlt": "Image du produit",
						"category": "Catégorie",
						"values": "{{length}} Valeurs",
						"mountable": "montable",
						"noBar": "Pas de barre"
					},
					"mountableProductsTable": {
						"name": "Nom",
						"section": "Section Montable",
						"count": "Quantité"
					}
				}
			},
			"by": "by",
			"chipsBurned": {
				"byEmployee": {
					"filename": "puces-brûlées-employé",
					"printTitle": "Puces brûlées par employé",
					"tabTitle": "Puces brûlées par employé"
				},
				"fileName": "total-puces-brûlées",
				"printTitle": "Total puces brûlées",
				"tabTitle": "Total puces brûlées",
				"table": {
					"count": "Quantiété",
					"fracionalCount": "Quantité partielle",
					"name": "Nom",
					"product": "Produit",
					"totalValue": "Total",
					"unitCount": "Quantité unitaire",
					"unitValue": "Valeur unitaire",
					"unitaryValue": "Valeur unitaire"
				},
				"title": "Total puces brûlées"
			},
			"deliveredProductsByBar": {
				"all": "Tous",
				"bar": "Pub",
				"byBars": "Par bars",
				"filename": "produits-livrés",
				"noSelectedBar": "Sélectionnez au moins un bar pour visualiser le rapport",
				"selectPlaceholder": "Sélectionner Bar(s)",
				"selectVisualization": "Sélectionner Vue",
				"selectedBars": "Bars sélectionnés",
				"tabTitle": "Produits livrés par bar",
				"table": {
					"count": "Unités vendues",
					"fracCount": "Quantité fractionnée",
					"fracionalCount": "Quantité fractionnée",
					"name": "Nom",
					"proportionalValue": "Valeur proportionnelle",
					"subtotal": "Sous-total",
					"total": "Total",
					"totalDiscount": "Réductions",
					"totalValue": "Montant total",
					"totalVat": "TVA Totale",
					"valueVat": "TVA",
					"unitCost": "Valeur unitaire",
					"category": "Catégorie"
				},
				"transactionType": "Type de transaction",
				"bars": "Bars",
				"sectors": "Secteurs",
				"productMasterKinds": "Types de produits",
				"applyFilters": "Appliquer les filtres",
				"total": "Total",
				"emptyState": {
					"withoutFilters": {
						"title": "Aucun filtre appliqué",
						"description": "Sélectionnez au moins un bar pour générer un rapport."
					},
					"anyResults": {
						"title": "Aucun résultat trouvé",
						"description": "Aucun résultat correspondant aux filtres appliqués n'a été trouvé !"
					}
				},
				"totalizer": {
					"totalUnitsSold": "Total des unités vendues",
					"totalInDiscounts": "Total des remises",
					"totalValueSold": "Valeur totale vendue"
				}
			},
			"filter": "Filtrer par type de transaction",
			"filterOptions": {
				"all": "Tous",
				"balcony": "Balcon",
				"cashless": "Cashless",
				"dash": "Tableau de bord",
				"delivery": "Livraison",
				"ficha": "Billet",
				"grabngo": "Grab n Go",
				"onlineBill": "Facture en ligne",
				"zigQrcode": "QR Code ZIG"
			},
			"filterPlaceholder": "Sélectionner un type de transaction",
			"grams": "grammes",
			"kilos": "Kilos",
			"liter": "Litres",
			"no": "Non",
			"printDate": "Délivré le",
			"reportPeriod": "Période du rapport",
			"soldBaseProductReport": {
				"emptyText": "Pas de données à afficher.",
				"filename": "rapport_production_générale_produits",
				"tabTitle": "Production générale de produits",
				"table": {
					"code": "SKU",
					"count": "Quantité",
					"product": "Produit"
				}
			},
			"soldProducts": {
				"fileName": "total-produits-vendus",
				"filter": "Filtrer par type de transaction",
				"printTitle": "Produits vendus",
				"tabTitle": "Total produits vendus",
				"table": {
					"category": "Catégorie",
					"count": "Quantité",
					"fiscalCode": "SKU",
					"fracionalCount": "Quantiété fractionnée.",
					"mountableItem": "Articles combinables",
					"mountableProduct": "Combinable",
					"mountableProducts": "Combinables",
					"mountableSection": "Session combinable",
					"mountableStage": "Étape combinable",
					"name": "Nom",
					"product": "Produit",
					"productCategory": "Catégorie de produits",
					"subtotal": "Sous-total",
					"totalDiscount": "Réduction",
					"totalValue": "Montant total",
					"unitCount": "Quantité unitaire",
					"unitValue": "Valeur unitaire",
					"unitaryValue": "Valeur unitaire"
				},
				"title": "Produits vendus",
				"filterByProducts": "Filtrer par produits",
				"filterByProductsPlaceholder": "Sélectionner un produit",
				"filterByOperationType": "Filtrer par type d'opération",
				"filterByOperationTypePlaceholder": "Toutes",
				"filterByProductKind": "Filtrer par type de produit",
				"productKindOptions": {
					"food": "Nourriture",
					"drinks": "Boissons",
					"tickets": "Billetterie",
					"other": "Autres"
				}
			},
			"soldRankingReport": {
				"tabTitle": "Ventes par produits",
				"pageTitle": "Ventes par produits",
				"pageDescription": "Rapport comparatif entre les opérateurs et leurs ventes.",
				"exportReport": "Rapport d'exportation",
				"groupedView": "Vue groupée",
				"selectPeriod": "Sélectionnez la période",
				"searchCategory": "Catégorie",
				"searchCategoryPlaceholder": "Rechercher catégorie",
				"searchProduct": "Produit",
				"searchProductPlaceholder": "Rechercher producto",
				"filename": "classement_des_ventes",
				"table": {
					"columns": {
						"position": "Position",
						"product": "Produit",
						"count": "Montant",
						"totalSold": "Total",
						"price": "Prix",
						"discount": "Rabais"
					},
					"withoutInfo": "Aucune information à afficher"
				},
				"productSoldTable": {
					"columns": {
						"waiter": "Serveur",
						"count": "Montant",
						"price": "Prix",
						"discount": "Rabais",
						"total": "Total"
					},
					"withoutInfo": "Aucune information à afficher"
				},
				"totalizers": {
					"highestSeller": "Plus grand opérateur",
					"totalSellerSold": "Total de l'opérateur"
				}
			},
			"tipReport": {
				"title": "Rapport de Pourboire",
				"filename": "rapport-de-pourboire_{{date}}",
				"subtitle": "Liste des montants à recevoir par les opérateurs/serveurs pour les pourboires de service.",
				"filterByPeriod": "Filtrer par période",
				"filterByEmployee": "Filtrer par employé",
				"filterByEmployeePlaceholder": "Sélectionnez les employés",
				"eventPeriod": "Période de l'événement",
				"statusRunning": "(en cours)",
				"columns": {
					"name": "Nom",
					"total": "Total en pourboires",
					"extraTip": "Pourboire supplémentaire",
					"cashTotal": "Espèces",
					"debitTotal": "Débit",
					"creditTotal": "Crédit",
					"appTotal": "Application",
					"pixTotal": "Pix",
					"bonusTotal": "Bonus"
				},
				"tooltip": {
					"total": "Total en pourboires (conforme % défini par la maison)",
					"extraTip": "Valeur de pourboire qui dépasse le pourcentage de service défini par la maison"
				},
				"alert": {
					"title": "Attention",
					"message": "Le total des pourboires inclut les factures ouvertes, ce qui peut entraîner des écarts dans les totaux des modes de paiement. Les modes de paiement seront mis à jour après la fermeture de la facture ouverte."
				}
			},
			"waiterReport": {
				"description": "Rapports concernant les ventes de bars, les opérateurs et le classement des produits.",
				"filename": "ventes-par-serveur",
				"filter": "Filtrer par type de transaction",
				"filterWaiterLabel": "Nom de l'employé",
				"filterWaiterPlaceholder": "Sélectionnez les employés",
				"productSell": "Ventes par produits",
				"sellerProductTable": {
					"category": "Catégorie",
					"count": "Quantité",
					"discount": "Réduction",
					"filename": "ventes-par-produit",
					"name": "Nom",
					"total": "Total",
					"value": "Montant"
				},
				"sellerTransactionTable": {
					"clients": "Clients",
					"date": "Date",
					"cardNumber": "Numéro de carte",
					"filename": "ventes-par-transaction",
					"products": "Produits",
					"refunded": "Remboursé",
					"serialNumber": "Numéro de série",
					"tip": "Montant pourboire",
					"transactionValue": "Montant Transaction"
				},
				"tabTitle": "Classement des ventes",
				"table": {
					"name": "Nom",
					"soldValue": "Montant vendu",
					"tip": "Montant en pourboire",
					"total": "Total"
				},
				"title": "Ventes par Serveur",
				"transactionSell": "Ventes par transaction",
				"waiterSell": "Ventes de bars",
				"deletedEmployee": "Utilisateur supprimé"
			},
			"yes": "Oui",
			"productReturnsReport": {
				"title": "Retour de produits"
			}
		},
		"businessIntelligence": {
			"chartCards": {
				"filters": {
					"consumption": "Consommation",
					"ppu": "PPU"
				}
			},
			"clients": {
				"averagePublicPerWeekDay": {
					"averageTicket": "Ticket moyen",
					"label": "Audience moyenne par jour de la semaine pendant la période",
					"title": "Audience moyenne par jour de la semaine"
				},
				"clientRecordPerDay": {
					"label": "Augmentation de l'audience au cours de la période",
					"none": "Aucun",
					"people": "{{num}} Personnes",
					"person": "{{num}} personnes",
					"title": "Audience record"
				},
				"headerChart": {
					"averagePublic": "Audience moyenne",
					"filters": {
						"label": "Filtres",
						"men": "Hommes",
						"others": "Autres",
						"women": "Femmes"
					},
					"label": "Pendant la période",
					"total": "Total Clients"
				},
				"topClients": {
					"infoLabel": "Sélectionnez un client pour voir les détails.",
					"label": "Valeur au cours de la période",
					"title": "TOP Clients"
				}
			},
			"employees": {
				"filters": {
					"checkins": {
						"average": "Moyenne par employé",
						"higher": "Employé avec le plus grand nombre d'entrées",
						"label": "Entrées",
						"lower": "Employé avec moins d'entrées",
						"quantity": "Nombre total d'entrées",
						"shortName": "Entrées"
					},
					"financialOperations": {
						"average": "Moyenne par employé",
						"best": "Meilleure performance",
						"label": "Recettes financières",
						"lower": "Plus basse performance",
						"quantity": "Nombre de transactions",
						"shortName": "Recettes",
						"total": "Produits vendus"
					},
					"refunds": {
						"label": "Remboursement",
						"quantity": "Nombre de remboursements",
						"shortName": "Remboursements",
						"total": "Montant total de remboursements"
					},
					"sellRefunds": {
						"label": "Qui est à l'origine du remboursement ?",
						"shortName": "Remboursement"
					},
					"sells": {
						"average": "Moyenne par employé",
						"best": "Meilleure performance",
						"label": "Ventes",
						"lower": "Plus basse performance",
						"quantity": "Nombre de commandes",
						"shortName": "Ventes",
						"total": "Montant total de commandes"
					},
					"tips": {
						"average": "Moyenne par employé",
						"higher": "Montant le plus haut",
						"label": "Pourboires",
						"lower": "Montant le plus bas",
						"percent": "% des ventes",
						"shortName": "Pourboires",
						"total": "Total Pourboires"
					}
				},
				"userCard": {
					"employeeName": "Nom de l'employé",
					"ofSales": "des ventes",
					"role": "Fonction"
				}
			},
			"financial": {
				"bonus": {
					"label": "Bonus"
				},
				"filters": {
					"average": "Ticket moyen",
					"bonus": "Bonus",
					"income": "Revenus"
				},
				"financialChartCards": {
					"average": " Moyenne",
					"averageTicket": "Ticket moyen",
					"billing": "Facturation",
					"bonus": "Bonus"
				},
				"graphCards": {
					"averageTicket": {
						"label": "Rapport des tickets moyens",
						"subtitle": "Montant facturé par jour pendant la période {{periodLabel}}"
					},
					"averageTicketPerWeekDay": {
						"label": "Jours de la semaine avec les tickets moyens les plus élevés",
						"subtitle": "Valeur moyenne du ticket moyen par jour de la semaine au cours de la période {{periodLabel}}"
					},
					"billingsPerPeriod": {
						"label": "Jours avec les revenus les plus élevés",
						"subtitle": "Montant facturé par jour de la semaine pendant la période {{periodLabel}}"
					},
					"billingsPerWeekDay": {
						"label": "Jours de la semaine avec les revenus les plus élevés",
						"subtitle": "Montant moyen facturé par jour de la semaine au cours de la période {{periodLabel}}"
					},
					"bonusPerWeek": {
						"label": "Jours de la semaine avec le plus de bonus",
						"subtitle": "Montant offerts par jour pendant la période {{periodLabel}}"
					},
					"consumptionTime": {
						"columns": {
							"friday": "Vendredi",
							"general": "Général",
							"monday": "Lundi",
							"period": "Période",
							"saturday": "Samedi",
							"sunday": "Dimanche",
							"thursday": "Jeudi",
							"tuesday": "Mardi",
							"wednesday": "Mercredi"
						},
						"filename": "total_ventes_par_heure",
						"formatPeriod": {
							"currPeriod": "à {{currPeriod}}",
							"nextPeriod": "{{currPeriod}} à {{nextPeriod}}"
						},
						"label": "Total Ventes par heure",
						"subtitle": "Période: {{periodLabel}}",
						"tooltip": {
							"date": "Total consommé à {{date}}",
							"dates": "Total consommé de {{since}} à {{until}}:"
						}
					},
					"highestBonus": {
						"label": "Bonus les plus élevés",
						"subtitle": "Montant offert par jour pendant la période {{periodLabel}}"
					},
					"paymentMethod": {
						"anticipated": "Anticipé",
						"app": "Application",
						"cash": "Espèces",
						"credit": "Crédit",
						"dashboard": "Tableau de bord",
						"debit": "Débit",
						"label": "Moyens de paiement",
						"others": "Autres",
						"postEvent": "Après l'événement",
						"subtitle": "Montant facturé par moyen de paiement au cours de la période {{periodLabel}}",
						"uniformed": "Uniforme",
						"voucher": "Voucher",
						"zigCredit": "Crédit Zigpay",
						"zigDebit": "Débit Zigpay"
					}
				},
				"income": {
					"label": "Comparer avec",
					"labelChart": "Facturé"
				},
				"methodFilters": {
					"cash": "Espèces",
					"credit": "Crédit",
					"debit": "Débit",
					"total": "Moyenne",
					"zigCredit": "Crédit Zigpay",
					"zigDebit": "Débit Zigpay",
					"postEvent": "Après l'événement",
					"voucher": "Voucher",
					"anticipated": "Anticipé",
					"dashboard": "Tableau de bord",
					"app": "Application",
					"others": "Autres"
				},
				"periodLabel": "({{since}} à {{until}})",
				"ticket": {
					"average": "Ticket moyen",
					"real": "Ticket effectif"
				}
			},
			"header": {
				"clients": "Clients",
				"employees": "Employés",
				"financial": "Financier",
				"period": "Période"
			}
		},
		"coala": {
			"config": {
				"form": {
					"additionalFields": "Champs supplémentaires",
					"addressInfo": "informations sur l'adresse",
					"deliveryInfo": "informations sur la livraison",
					"initialInfo": "informations initiales",
					"paymentMethods": "moyens de paiement",
					"qrCodesGenerate": "Générer QR Codes",
					"webpageInfo": "informations sur l'affichage"
				},
				"newImageSaved": "Nouvelle image enregistrée",
				"savedData": "Données sauvegardées",
				"subForms": {
					"additionalFields": {
						"add": "Ajouter un nouveau champ",
						"empty": "Il n'y a pas de champs enregistrés",
						"label": "Légende",
						"required": "Requis",
						"save": "Enregistrer des champs supplémentaires",
						"slug": "Slug",
						"type": {
							"date": "Date",
							"label": "Type",
							"number": "Numéro",
							"options": {
								"label": "Options",
								"placeholder": "Ajouter une nouvelle option"
							},
							"remove": "Supprimer",
							"select": {
								"a": "Option A",
								"b": "Option B",
								"c": "Option C",
								"label": "Choix multiple"
							},
							"text": "Alphanumérique"
						}
					},
					"address": {
						"city": "ville",
						"complement": "Complément d'information",
						"country": "Pays",
						"formattedAddress": "Adresse",
						"neighborhood": "Quartier",
						"postalCode": "Code Postal",
						"save": "Sauvegarder les informations sur l'adresse",
						"state": "État",
						"streetName": "Nom de rue",
						"streetNumber": "Numéro de rue"
					},
					"delivery": {
						"attendanceRadius": {
							"label": "Rayon d'action",
							"sufix": "km"
						},
						"avgWaitTime": {
							"label": "Délai moyen de livraison",
							"sufix": "Minutes"
						},
						"deliveryFeePerKm": "Frais de livraison par km",
						"fixedDeliveryFee": "Frais de livraison minimum",
						"save": "Sauvegarder les informations de livraison"
					},
					"initialInfo": {
						"isManualMenu": "Activation manuelle du menu",
						"isOrganization": "Mode d'organisation",
						"name": "Nom",
						"save": "Sauvegarder les informations initiales"
					},
					"payments": {
						"methods": {
							"alelo": "Alelo",
							"amex": "Amex",
							"ben": "Ben",
							"cash": "Espèces",
							"creditCard": "Carte de crédit",
							"creditCardOnline": "Carte de crédit en ligne",
							"debitCard": "Carte de débit",
							"diners": "Diners",
							"elo": "Elo",
							"hipercard": "Hiper-card",
							"mastercard": "Master-card",
							"others": "Autres moyens de paiements",
							"sodexo": "Sodexo",
							"ticket": "Ticket",
							"visa": "Visa",
							"voucherInPlace": "Voucher",
							"vr": "VR"
						},
						"save": "Sauvegarder les modes de paiement"
					},
					"qrCodeGenerator": {
						"chooseSheet": "Ckoisir un tableau",
						"columns": {
							"params": "Paramètres",
							"url": "URL",
							"value": "Valeur du paramètre"
						},
						"download": "Télécharger QR codes",
						"import": "Importer QR codes",
						"new": "Nouveau QR code",
						"paramsRequired": "Le paramètre est obligatoire",
						"sheetFilename": "QR codes",
						"urlRequired": "URL est obligatoire",
						"valueRequired": "La vaieur du paramètre est obligatoire",
						"warningNotification": "Veuillez remplir tous les champs."
					},
					"webPage": {
						"image": "Image",
						"primaryColor": "Couleur primaire",
						"save": "Sauvegarder Voir les informations",
						"secondaryColor": "Couleur secondaire",
						"slug": "Slug"
					}
				},
				"title": "Paramètres du magasin de livraison",
				"updatingData": "Mise à jour des données"
			},
			"editMenu": {
				"add": "Ajouter un produit",
				"deleteConfirm": "Êtes-vous sûr de vouloir supprimer le menu ?",
				"deleteProducts": "Supprimer Produits",
				"deleteProductsConfirm": "Êtes-vous sûr de vouloir supprimer tous les produits sélectionnés du menu ?",
				"errorEditNotification": "Erreur dans ",
				"errorProductIdentify": "incapable d'identifier le produit correspondant à {{name}}, téléchargez un nouveau modèle de tableauet faites attention à la colonne 'identifiant'.",
				"goBack": "Retour à tous les menus",
				"massDelete": "Supprimer des produits en masse",
				"massEdit": "Modifier des produits en masse",
				"menuActive": "Activer menu",
				"okText": "Oui, je le veux !",
				"search": "Rechercher des produits",
				"successNotification": "Toutes les informations sur les produits ont été modifiées avec succès",
				"updatedPrices": "Mettre à jour les prix",
				"warningNotification": "Menu édité, mais un problème d'enregistrement des heures d'ouverture est survenu :"
			},
			"menu": {
				"header": {
					"create": "Créer Menu",
					"manualMode": "Mode manuel",
					"search": "Rechercher menus"
				},
				"menuCard": {
					"active": "actif",
					"at": "à",
					"businessHour": "Heures d'ouverture",
					"delivery": "Livraison",
					"inactive": "inactif",
					"message": "Fonctionnement sur 24 heures",
					"table": "Commande sur table",
					"type": "Type"
				},
				"menuList": "Menu pour livraison",
				"noMenu": {
					"create": "Créer Menu",
					"message": "Il semble que vous n'ayez pas encore créé de menu.",
					"title": "Menu pour livraison"
				},
				"warningNotification": "Menu créé, mais un problème d'enregistrement des heures d'ouverture est survenu :"
			},
			"orderReport": {
				"channelLabel": {
					"marketplace": "Marketplace",
					"phone": "Téléphone",
					"whatsapp": "Whatsapp",
					"whitelabel": "Marque blanche"
				},
				"columns": {
					"chanel": "Plateforme",
					"customerName": "Client",
					"customerPhone": "Téléphone Client",
					"date": "Date et heure",
					"deliveryFee": "Frais de livraison",
					"discount": "Réduction",
					"note": "OBS",
					"paymentMethods": "Moyens de paiement",
					"reference": "Numéro de commande",
					"status": "Statut",
					"subtotal": "Sous Total",
					"tip": "Pourboire",
					"value": "Montant",
					"vendor": "Vendeur"
				},
				"methodsLabel": {
					"alelo": "Alelo",
					"amex": "Amex",
					"ben": "Ben",
					"cash": "Espèces",
					"creditCard": "Carte de crédit",
					"creditCardOnline": "Carte de crédit en ligne",
					"debitCard": "Carte de débit",
					"diners": "Diners",
					"elo": "Elo",
					"hipercard": "Hiper-card",
					"mastercard": "Master-card",
					"sodexo": "Sodexo",
					"ticket": "Ticket",
					"visa": "Visa",
					"voucherInPlace": "Voucher",
					"vr": "VR",
					"pix": "Pix"
				},
				"sheet": {
					"columns": {
						"chanel": "Plateforme",
						"customerName": "Client",
						"customerPhone": "Téléphone Client",
						"date": "Date et heure",
						"deliveryFee": "Frais de livraison",
						"discount": "Réduction",
						"note": "Commentaires",
						"paymentMethods": "Moyens de paiement",
						"reference": "Numéro de commande",
						"status": "Statut",
						"subtotal": "Sous total",
						"tip": "Pourboire",
						"value": "Montant",
						"vendor": "Vendeur"
					},
					"filename": "rapport-livraison-vendeur",
					"title": "Livraison des ventes"
				},
				"statusLabel": {
					"canceled": "Annulé",
					"concluded": "Conclu",
					"confirmed": "Confirmé",
					"dispatched": "Envoyé",
					"integrated": "Intégré",
					"pendingPayment": "paiement en cours",
					"pickupAreAssigned": "Client dans le lieu",
					"placed": "Créer",
					"ready": "Prêt",
					"scheduled": "Programmé"
				},
				"title": "Rapport Commande",
				"vendorLabels": {
					"coala": "Marque blanche",
					"ifood": "Ifood",
					"rappi": "Rappi",
					"ubereats": "Uber Eats"
				}
			},
			"productReport": {
				"columns": {
					"baseValue": "Valeur de base",
					"count": "Quantité",
					"integration": "Intégration",
					"name": "Produit",
					"sku": "SKU",
					"totalValue": "Prix total"
				},
				"sheet": {
					"allOrdersProductsReport": {
						"columns": {
							"baseUnitPrice": "Prix de base",
							"count": "Quantité",
							"deliveryOrderId": "Identifiant commande",
							"name": "Produit",
							"obs": "Commentaire",
							"productId": "Identifiant produit",
							"sku": "SKU",
							"totalUnitPrice": "Prix total"
						},
						"title": "Rapport de commande de produits"
					},
					"filename": "rapport-livraison",
					"generalProductReport": {
						"columns": {
							"baseValue": "Valeur de base",
							"count": "Quantité",
							"integration": "Intégration",
							"name": "Produit",
							"sku": "SKU",
							"totalValue": "Prix total"
						},
						"title": "Rapport des produits livrés"
					}
				},
				"title": "Rapport de livraison par produit",
				"vendors": {
					"coala": "Marque blanche",
					"ifood": "Ifood",
					"rappi": "Rappi",
					"ubereats": "Uber eats"
				}
			},
			"products": {
				"bottomText": "Toutes les modifications apportées ici affecteront tous les menus",
				"error": "incapable d'identifier le produit correspondant à {{name}}, téléchargez un nouveau modèle de tableauet faites attention à la colonne 'identifiant'.",
				"errorIn": "Erreur dans ",
				"header": {
					"add": "Ajouter produits",
					"delete": "Supprimer produits",
					"deleteConfirm": "Êtes-vous sûr de vouloir supprimer tous les produits sélectionnés ?",
					"edit": "Modifier les produits en masse",
					"massDelete": "Supprimer des produits en masse",
					"search": "Rechercher Produits"
				},
				"success": "Tous les produits ont été modifiés avec succès",
				"title": "Produits"
			},
			"tabs": {
				"config": "Paramètres",
				"menu": "Menu",
				"orderReport": "Rapport Commande",
				"productReport": "Rapport par Produit",
				"products": "Produits",
				"vendorReport": "Rapport Vendeur"
			},
			"vendorReport": {
				"columns": {
					"deliveryFee": "Frais de livraison",
					"tip": "Pourboire",
					"value": "Montant",
					"vendor": "Vendeur"
				},
				"sheet": {
					"columns": {
						"deliveryFee": "Frais de livraison",
						"tip": "Pourboire",
						"value": "Montant",
						"vendor": "Vendeur"
					},
					"filename": "rapport-livraison-vendeur",
					"title": "Ventes par livraison du vendeur"
				},
				"title": "Rapport de livraison du vendeur"
			}
		},
		"contracts": {
			"solicitation": {
				"columns": {
					"id": "Id del billets",
					"requestBy": "Nom du demandeur",
					"requestDate": "Date de la demande",
					"requestReason": "Motif de la demande",
					"requestType": "Type de demande",
					"returnDate": "Date de retour",
					"status": "Statut"
				},
				"filter": {
					"periodTimeLabel": "Date de la demande",
					"statusLabel": "Statut",
					"statusPlaceholder": "Sélectionnez le statut de la demande"
				},
				"incident": "Incident",
				"status": {
					"closed": "Terminé",
					"hold": "En cours",
					"open": "Ouvert",
					"new": "Nouveau",
					"pending": "En attente",
					"solved": "Réglé"
				},
				"title": "Demandes"
			},
			"history": {
				"title": "Historique des Contrats",
				"filename": "historique_des_contrats",
				"status": {
					"approved": "Approuvé",
					"pendingApproval": "Approbation en Attente",
					"pendingSign": "Signature en Attente"
				},
				"columns": {
					"requestDate": "Date de la Demande",
					"signatureDate": "Date de la Signature",
					"contract": "Contrat",
					"managerName": "Directeur Commercial",
					"signedBy": "Signé Par",
					"status": "Statut"
				},
				"filter": {
					"periodTimeLabel": "Date de la Demande",
					"statusLabel": "Statut",
					"statusPlaceholder": "Sélectionnez le statut de la demande"
				},
				"details": {
					"title": "Demande effectuée selon le modèle",
					"temporary": "Temporaire",
					"permanent": "Permanent",
					"contractNotFound": "Contrat non trouvé",
					"equipments": {
						"equipment": "Équipement",
						"quantity": "Quantité",
						"unitValue": "Valeur Unitaire",
						"totalValue": "Valeur Totale"
					},
					"manager": {
						"managerName": "Responsable ZIG",
						"managerContact": "Canal de Contact"
					},
					"file": {
						"type": "Type de Demande",
						"requestModel": "Modèle de Demande",
						"contractPeriod": "Période du Contrat"
					}
				},
				"actionsTable": {
					"details": "Voir les détails de la demande",
					"downloadDocuments": "Télécharger les Documents"
				}
			}
		},
		"currency": "Currency",
		"discountCategory": {
			"activeCategories": "Catégories de réduction actives",
			"allCategories": "Toutes les catégories de réduction",
			"create": "Créer nouvelle catégorie",
			"drawer": {
				"create": "Créer une catégorie de réduction",
				"edit": "Modifier la catégorie de réduction"
			},
			"errorNotification": "Veuillez d'abord sélectionner un lieu",
			"filter": {
				"label": "Filtrer par",
				"placeholder": "Choisir le filtre"
			},
			"form": {
				"and": "et",
				"between": "Entre",
				"discount": {
					"label": "Remise accordée en",
					"percentage": "Pourcentage",
					"value": "Montant"
				},
				"employees": {
					"label": "Employés autorisés à utiliser la catégorie",
					"placeholder": "Rechercher par nom"
				},
				"errors": {
					"name": "Veuillez saisir un nom valide",
					"stabilizedType": "Sélectionnez une option ci-dessus",
					"employees": "Sélectionnez un employé"
				},
				"name": {
					"label": "Nom de la catégorie",
					"placeholder": "Donner un nom à la catégorie de réduction"
				},
				"stabilizedType": {
					"fixed": "Montant fixe",
					"label": "Établi",
					"range": "Gamme"
				},
				"observation": "Remarques",
				"addObservation": "Permettre d'ajouter une remarque"
			},
			"inactiveCategories": "Catégories de réduction inactives",
			"label": "Créer, modifier, supprimer, activer ou désactiver des catégories de réduction",
			"modal": {
				"message": "Voulez-vous supprimer la catégorie de '{{name}}'?",
				"title": "Supprimer une catégorie de réduction"
			},
			"search": {
				"label": "Rechercher",
				"placeholder": "Rechercher un nom de catégorie de réduction"
			},
			"table": {
				"discountType": "RÉDUCTION ACCORDÉE",
				"editCategory": "Modifier la catégorie de réduction",
				"employee": "Employé avec autorisation",
				"emptyText": "Il semble que vous n'ayez pas encore créé de catégorie de réduction.",
				"hideEmployees": "Masquer les employés avec autorisation",
				"loading": "Chargement",
				"name": "NOM DE LA CATÉGORIE DE RÉDUCTION",
				"removeCategory": "Supprimer la catégorie de réduction",
				"showEmployees": "Voir les employés ayant une autorisation",
				"status": "STATUT",
				"value": "GAMME OU VALEUR FIXE"
			},
			"title": "Catégories de réduction"
		},
		"emissionErrors": {
			"drawer": {
				"clients": "Clients",
				"count": "Quantité",
				"date": "Premier jour non émis",
				"details": "Détails de la dernière facture erronés",
				"message": "Message",
				"products": "Produits",
				"profile": "Profil fiscal",
				"status": "Statut",
				"title": "Historique des erreurs",
				"type": "Type d'erreur",
				"updatedAt": "Dernier jour non émis"
			},
			"export": "Exporter tableau",
			"period": "Période",
			"table": {
				"columns": {
					"count": "Quantité",
					"createdAt": "Premier jour non émis",
					"errorMessage": "Message",
					"errorType": "Types d'erreur",
					"fiscalProfileId": "Profil fiscal",
					"status": "Statut",
					"updatedAt": "Dernier jour non émis"
				},
				"errorTypeLabel": {
					"unknown": "Inconnu"
				},
				"statusLabel": {
					"pending": "En cours",
					"resolved": "Résolu"
				}
			},
			"tabs": {
				"invoices": "Factures émises",
				"products": "Produits non émis"
			},
			"title": "Erreurs d'émission"
		},
		"emited": {
			"details": "Détails des Émissions",
			"fiscalGroup": "Émissions par groupe fiscal",
			"fiscalProfile": "Émissions par profil fiscal",
			"byBars": "Émissions par barre",
			"byEmployee": "Émissions par employé",
			"foreignDescription": "Ce rapport présente un détail agrégé du montant brut émis et du montant net émis. Il affiche un regroupement par profil fiscal, groupe fiscal de produit, bar, employé et méthode de paiement.",
			"sheets": {
				"details": {
					"columns": {
						"description": "Description",
						"financialValue": "Valeur financière",
						"valueForeign": "Valeur Brute Émise",
						"netValueForeign": "Valeur Nette Émise",
						"title": "Titre",
						"unitValue": "Valeur unitaire"
					},
					"filename": "détails_émissions",
					"title": "Détails des émissions"
				},
				"byBars": {
					"title": "Émissions par barre",
					"filename": "émissions_par_barre",
					"columns": {
						"name": "Barre",
						"value": "Montant",
						"valueForeign": "Valeur Brute Émise",
						"netValueForeign": "Valeur Nette Émise"
					}
				},
				"fiscalGroup": {
					"columns": {
						"name": "Groupe Produit",
						"value": "Montant",
						"valueForeign": "Valeur Brute Émise",
						"netValueForeign": "Valeur Nette Émise"
					},
					"filename": "émissions_par_groupe_fiscal",
					"title": "Émissions par groupe fiscal"
				},
				"byEmployee": {
					"title": "Émissions par employé",
					"filename": "émissions_par_employé",
					"columns": {
						"name": "Employé",
						"value": "Montant",
						"valueForeign": "Valeur Brute Émise",
						"netValueForeign": "Valeur Nette Émise"
					}
				},
				"fiscalProfile": {
					"columns": {
						"name": "Profil fiscal",
						"value": "Valeur émise",
						"valueForeign": "Valeur Brute Émise",
						"netValueForeign": "Valeur Nette Émise"
					},
					"filename": "émissions_par_profil_fiscal",
					"title": "Émissions par profil fiscal"
				}
			},
			"subtitle": "Ce rapport ne prend en compte que les factures émises dans le cadre du régime NFC-e",
			"table": {
				"fiscalGroups": {
					"columns": {
						"name": "Groupe fiscal",
						"value": "Montant",
						"valueForeign": "Valeur Brute Émise",
						"netValueForeign": "Valeur Nette Émise"
					}
				},
				"fiscalProfiles": {
					"columns": {
						"name": "Profil fiscal",
						"value": "Valeur émise",
						"valueForeign": "Valeur Brute Émise",
						"netValueForeign": "Valeur Nette Émise"
					}
				},
				"byBars": {
					"columns": {
						"name": "Barre",
						"value": "Montant",
						"valueForeign": "Valeur Brute Émise",
						"netValueForeign": "Valeur Nette Émise"
					}
				},
				"byEmployee": {
					"columns": {
						"name": "Employé",
						"value": "Montant",
						"valueForeign": "Valeur Brute Émise",
						"netValueForeign": "Valeur Nette Émise"
					}
				},
				"title": "Titre",
				"value": "Montant",
				"valueForeign": "Valeur Brute Émise",
				"netValueForeign": "Valeur Nette Émise"
			},
			"title": "Emissions"
		},
		"entrance": {
			"add": "Ajouter",
			"addEntrance": "Ajouter entrée",
			"cancel": "Annuler",
			"deleteEntrance": "Voulez-vous supprimer l'entrée {{entranceName}} ?",
			"edit": "À modifier",
			"entranceForm": {
				"addEntrance": "Ajouter Entrée",
				"bonus": "Bonus",
				"category": "Catégorie",
				"categoryPlaceholder": "Sélectionnez la catégorie de l'entrée",
				"cest": "CEST",
				"cestPlaceholder": "Entrez le CEST de l'entrée",
				"code": "SKU",
				"codePlaceholder": "Entrez le code SKU de l'entrée",
				"consumptionObligation": "Consommation minimum",
				"details": "Informations d'entrée",
				"editEntrance": "Modifier entrée",
				"fiscalData": "Données fiscales",
				"fiscalGroup": "Groupe fiscal",
				"fiscalGroupPlaceholder": "Sélectionnez le groupe fiscal de l'entrée",
				"fiscalProfile": "Profil fiscal",
				"fiscalProfilePlaceholder": "Sélectionnez le profil fiscal de l'entrée",
				"image": "Image",
				"minimumConsumptionValue": "Consommation anticipée",
				"minimumValueCharged": "Montant minimum facturé",
				"minimumValueChargedTooltip": "Le montant minimum facturé est le montant le plus bas que le client paiera sur le compte et correspond à la somme de la consommation minimum et du prix d'entrée.",
				"name": "Nom",
				"namePlaceHolder": "Entrez le nom de l'entrée",
				"ncm": "NCM",
				"ncmPlaceholder": "Entrez le NCM de cette entrée",
				"price": "Prix",
				"variablePrice": "Prix variable",
				"newCategory": "Vous allez créer une nouvelle catégorie"
			},
			"errors": {
				"consumption": "Il n'est pas possible d'enregistrer plus d'un type de consommation.",
				"mandatoryField": "Ce champ est obligatoire",
				"validValue": "Veuillez saisir une valeur valide"
			},
			"table": {
				"active": "Active",
				"bonus": "Prime",
				"category": "Catégorie",
				"consumptionObligation": "Consommation anticipée",
				"entrance": "Interdit",
				"minimumConsumptionValue": "Consommation minimum",
				"value": "Montant"
			},
			"title": "Entrée"
		},
		"entranceBilling": {
			"tabs": {
				"boxOfficeBilling": {
					"title": "Facturation Billets",
					"tabLabel": "Facturation"
				},
				"entranceReport": {
					"columns": {
						"count": "Quantité",
						"discountValue": "Réductions",
						"name": "Nom",
						"subtotal": "Sous total",
						"totalValue": "Montant",
						"unitValue": "Valeur unitaire"
					},
					"title": "Total des Billets Vendus",
					"tabLabel": "Billets Vendus",
					"tabs": {
						"total": "Total",
						"clients": "Clients par Billet"
					}
				}
			}
		},
		"events": {
			"averageTicket": "ticket moyen",
			"card": {
				"averageTicket": "Ticket moyen",
				"clients": "Clients",
				"income": "Facturation",
				"lastSyncAfterClosedAt": "Dernière synchro à :",
				"pdv": "POS ouvert",
				"status": {
					"canceled": "Annulé",
					"created": "Fermé",
					"finished": "Terminé",
					"running": "Ouvert"
				},
				"syncAfterClosed": "Synchronisation après clôture"
			},
			"lastEventMonth": "Dernier mois de l'événement",
			"eventsNumber": "Événements",
			"newEvent": {
				"form": {
					"addButton": "Ajouter",
					"backgroundEventPicture": "Image de couverture de l'événement :",
					"cancel": "Annulé",
					"editButton": "À modifier",
					"eventPicture": "Image de l'événement :",
					"labelBegin": "Commencer :",
					"labelDescription": "Description:",
					"labelName": "Nom :",
					"peopleCapacity": "Capacité événementielle",
					"peopleCapacityTooltip": "Nombre de personnes accueillies par l'événement."
				},
				"modalTitle": "Ajouter événement",
				"title": "Nouvel événement"
			},
			"receipts": "reçus",
			"sales": "ventes",
			"timeline": {
				"label": "d'autres événements à venir, modifier la période pour voir plus de"
			},
			"tooltip": {
				"calculation": "Mémorial de calcul : Montant total versé - Remises accordées",
				"incomeSummaryCalc": "Montant reçu lors des événements organisés ce mois-ci",
				"minimumConsumption": "Consommation Minimum",
				"productSold": "Produits Vendus",
				"sales": "Ventes",
				"service": "Service",
				"ticket": "Entreé",
				"manualInvoices": "Factures manuelles"
			},
			"title": "Événements dans {{place}}",
			"totalClients": "clients totaux"
		},
		"extract": {
			"paginationTotal": "{{start}}-{{end}} sur {{total}}",
			"bankAccounts": {
				"titlePage": "Comptes bancaires",
				"addAccount": "Enregistrer un compte",
				"columnsTable": {
					"name": "Nom",
					"bank": "Banque",
					"agency": "Agence",
					"purpose": "Finalité du compte",
					"actions": "Actions",
					"account": "Compte",
					"cpfOrCnpj": "CPF/CNPJ",
					"ownerName": "Titulaire",
					"currentBalance": "Solde actuel",
					"initialBalance": "Solde initial"
				},
				"form": {
					"newNameBankAccount": "Nom du compte",
					"bank": "Institution bancaire",
					"agency": "Code de l'agence",
					"purpose": "Finalité du compte",
					"account": "Compte courant avec chiffre",
					"cpfOrCnpj": "CPF/CNPJ",
					"ownerName": "Titulaire",
					"addAccount": "Ajouter un compte bancaire",
					"namePlaceholder": "Entrez un nom pour le compte",
					"bankPlaceholder": "Rechercher une institution",
					"purposePlaceholder": "Rechercher par type de compte",
					"selectPurpose": "Sélectionner l'objectif du compte",
					"followInstructions": "Suivez les instructions pour continuer",
					"accessBankAccount": "Pour continuer, accédez à votre internet banking et vérifiez s'il est possible de télécharger votre relevé au format OFX.",
					"verifyBankAccount": "Si la banque n'exporte pas ce format de fichier, cliquez sur Terminer pour procéder sans validation.",
					"successContent": "Les informations importées depuis OFX sont conformes à ce qui a été complété à l'étape précédente",
					"inconsistentContent": "Certaines informations importées depuis OFX ne sont pas conformes au remplissage effectué à l'étape précédente. Au fur et à mesure, nous remplacerons les informations renseignées par les informations importées.",
					"emptyBankData": "Certaines informations nécessaires à la validation du compte ne sont pas présentes dans le fichier OFX sélectionné. Cliquez sur continuer pour terminer l'inscription sans validation.",
					"imported": "Importé",
					"registered": "Inscrit",
					"titlesContentVerifield": {
						"success": "Informations vérifiées",
						"inconsistency": "Informations contradictoires",
						"emptyBankData": "Informations manquantes"
					},
					"ofxTitles": {
						"upload": "Cliquez ou faites glisser le fichier OFX",
						"file": "Fichier OFX"
					},
					"incompatibleFile": "Fichier incompatible",
					"purposeList": {
						"inHouseFlow": "Caisse (fonds de roulement)",
						"creditCard": "Carte de crédit",
						"virtualWallet": "Portefeuille virtuel",
						"applicationAccount": "Compte d'investissement",
						"checkingAccount": "Compte courant",
						"savingsAccount": "Compte épargne"
					},
					"accountPlaceholder": "Entrez le compte",
					"agencyPlaceholder": "Entrez le code",
					"cpfPlaceholder": "000.000.000-00",
					"ownerNamePlaceholder": "Nom du titulaire du compte",
					"unlink": "Dissocier le compte bancaire",
					"linkBankAccount": "Associer le compte bancaire",
					"defaultAccount": "Définir comme compte principal :",
					"defaultAccountTooltip": "Le compte principal est utilisé pour remplir automatiquement les formulaires nécessitant cette information.",
					"default": "Par défaut",
					"initialBalance": "Solde initial en €",
					"initialBalanceDate": "Date du solde initial",
					"balancePlaceholder": "0,00",
					"balanceDatePlaceholder": "jj/mm/aaaa",
					"saveChanges": "Enregistrer les modifications",
					"errors": {
						"required": "Champ obligatoire",
						"name": "Entrez un nom valide",
						"account": "Entrez un numéro de compte valide",
						"agency": "Entrez un numéro d'agence valide",
						"cpf": "CPF invalide",
						"cnpj": "CNPJ invalide",
						"formatInvalid": "Ce type de format n'est pas pris en charge"
					}
				},
				"confirmModal": {
					"editInfo": "Modifier les informations",
					"cancelMessage": "Vous n'avez pas enregistré les modifications apportées. Voulez-vous continuer malgré tout ?",
					"cancelButton": "Quitter sans enregistrer",
					"confirmButton": "Enregistrer les modifications",
					"deleteAccount": "Supprimer le compte",
					"deleteMessage": "La suppression du compte est une action définitive. Voulez-vous continuer ?",
					"deleteTransferError": "La suppression de ce compte ne peut être effectuée car il est lié à des paiements ou des réceptions enregistrés.",
					"deleteMainError": "La suppression de ce compte ne peut être effectuée car il est enregistré comme compte principal.",
					"updateMainAccount": "Changer de compte principal",
					"updateMainAccountMessage": "Il existe déjà un compte principal enregistré à cet emplacement. Si vous continuez, ce compte sera remplacé. Voulez-vous toujours continuer ?",
					"confirmUpdate": "Changer de compte"
				},
				"emptyStateTitle": "Aucun compte bancaire enregistré",
				"emptyStateSubtitle": "Ajoutez votre premier compte bancaire pour commencer",
				"notification": {
					"deleteAccount": "Compte supprimé avec succès",
					"createAccount": "Compte créé avec succès",
					"updateAccount": "Compte modifié avec succès"
				}
			},
			"actionLabelBlocked": "Retirer / Payer une facture",
			"adjustments": {
				"filename": "ajustements",
				"label": {
					"advance": "Avance",
					"advanceFee": "Avance de frais",
					"anticipationFee": "Frais d'anticipation",
					"balanceAdjustment": "Équilibrage du solde",
					"totenRental": "Location de totem",
					"balanceRetention": "Maintien du solde",
					"bonifications": "Autres Bonus",
					"cardActivations": "Frais d'activation",
					"equipmentsMaintenance": "Entretien du matériel",
					"equipmentsPurchase": "Achat de matériel",
					"equipmentsRental": "Location de matériel",
					"expiredRecharges": "Rechargements expirées",
					"generalZigMachineTPV": "Facturation via l'acquisition intégrée ZIG",
					"generalZigMachineTax": "Taux d'acquisition sur les terminaux intégrés",
					"genericOperationsFee": "Dépenses générales de fonctionnement",
					"genericServices": "Autres services et charges",
					"lendingCards": "Prêt carte",
					"loanBracelet": "Prêt bracelet",
					"notUsedRecharges": "Rechargements non utilisés",
					"operatorFee": "Journal de l'opérateur",
					"others": "Autres",
					"payments": "Paiements",
					"paymentsTax": "Frais de paiement aux fournisseurs",
					"pos": "Facturation sur des terminaux non intégrés (POS)",
					"posTax": "Frais d'acquisition sur les terminaux non intégrés (POS)",
					"reimbursements": "Remboursements aux clients",
					"renegotiation": "Renégotiation",
					"residueRemain": "Solde restant",
					"systemSetup": "Configuration du système",
					"totemFee": "Frais Totémiques",
					"wifiAssistance": "Assistance technique Wifi",
					"wifiSetup": "Configuration du Wifi",
					"withdraw": "Retraits",
					"zigDevicePurchase": "Achat de commandes",
					"zigFee": "Frais ZIG",
					"missingCards": "Cartes perdues",
					"billingInvoice": "Recouvrement des factures",
					"guaranteedMinimumSupplement": "Supplément au minimum garanti",
					"commandFiscalPurchase": "Achat de Comanda Fiscal",
					"accountsReceivableLegal": "Comptes à recevoir  - Juridique",
					"cardDiscount": "Remise de cartes",
					"discountGeneralOperatingExpenses": "Remise sur les frais généraux d'exploitation",
					"discountOperatorDailyRate": "Remise sur les frais de l'opérateur journalier",
					"generalDiscount": "Remise générale",
					"dailyCoordinatorRate": "Indemnités journalières des coordinateurs",
					"dailyHeadsRate": "Taux journaliers des chefs",
					"setupDailyCoordinatorRate": "Mise en place des indemnités journalières des coordinateurs",
					"setupDailyHeadsRate": "Mise en place des chefs par journal",
					"setupDailySupervisorsRate": "Journal des superviseurs de la mise en place",
					"setupDailyTechnicalRate": "Journal des techniciens de la mise en place",
					"setupDailyTraineeRate": "Journaux pour stagiaires",
					"dailySupervisorRate": "Journaux pour les superviseurs",
					"dailyTechnicianRate": "Journaux des techniciens",
					"dailyTraineeRate": "Journaux des stagiaires",
					"damagedEquipment": "Équipement défectueux",
					"integratedAPPBilling": "Application intégrée de facturation",
					"apartCreditBilling": "Facturation de crédit à l'unité",
					"integratedCreditBilling": "Facturation de crédit intégrée",
					"apartDebitBilling": "Facturation intégrée par débit",
					"integratedDebitBilling": "Facturation de débit intégrée",
					"apartBillingPIX": "Facturation Apartado PIX",
					"integratedPIXBilling": "Facturation PIX intégrée",
					"integratedAdvancedRechargeBilling": "Facturation intégrée de la recharge anticipée",
					"interestandPenalties": "Intérêts et amendes",
					"softwareLicense": "Licence de logiciel",
					"replacedMachines": "Machines remplacées",
					"minimumGuaranteedpermachine": "Minimum garanti par machine",
					"otherEquipment": "Autres équipements",
					"rebate": "Remise",
					"setupAdvancedRecharge": "Mise en place d'une récupération anticipée",
					"setupRefundSite": "Mise en place d'un site de remboursement",
					"acquirementfeeforIntegratedZIGApplication": "Taux d'acquisition sur l'application ZIG intégrée",
					"acquiringfeeonapartCredit": "Frais d'acquisition pour le crédit non standard",
					"acquiringfeeforIntegratedCredit": "Frais d'acquisition pour le crédit intégré",
					"acquiringfeeforapartDebit": "Commission d'acquisition pour le débit sortant",
					"acquiringfeeonIntegratedDebit": "Commission d'acquisition sur débit intégré",
					"acquiringfeeforapartPIX": "Commission d'acquisition pour PIX Plus",
					"acquiringfeeforIntegratedPIX": "Commission d'acquisition pour PIX intégré",
					"acquiringfeeforAdvancedRecharge": "Commission d'acquisition pour les paiements anticipés",
					"refundfee": "Frais de remboursement",
					"relatedpartyretentionfee": "Frais de rétention des parties liées",
					"rappiFee": "Frais Rappi",
					"SMSFee": "Commission SMS",
					"residualFee": "Commission résiduelle",
					"cardtoCashExchange": "Échange de cartes contre des espèces",
					"cardtoProductExchange": "Échange de cartes contre des produits",
					"travelFood": "Voyage Alimentation",
					"shipping": "Fret",
					"accommodation": "Hébergement",
					"transport": "Transport",
					"pixRefundFee": "Frais de remboursement du PIX",
					"softwareLicenseMachine": "Licence de logiciel de machine",
					"softwareLicenseTotem": "Licence de logiciel de totem",
					"integratedAdvanceDebitBilling": "Facturation anticipée par débit intégrée",
					"integratedAdvanceCreditBilling": "Facturation anticipée par crédit intégrée",
					"integratedAdvancePixBilling": "Facturation Pix anticipée intégrée",
					"integratedAdvanceDebitFee": "Frais de débit anticipé intégrés",
					"integratedAdvanceCreditFee": "Frais de crédit anticipé intégrés",
					"integratedAdvancePixFee": "Frais Pix anticipés intégrés",
					"zeDeliveryDiscount": "Zé Delivery Réduction",
					"ticketPrinting": "Impression de billets",
					"validatorRental": "Licence de valideurs",
					"zeDeliveryRetention": "Zé Delivery Rétention",
					"valueAddedTax": "Taxe sur la valeur ajoutée",
					"moneyTPV": "TPV Espèces",
					"acquiringFeeForIntegratedInstallmentCredit": "Frais d'acquisition pour le Crédit Échelonné Intégré",
					"issuedCharge": "Charge Émise",
					"externalResourceContribution": "Apport de ressources externes",
					"integratedOnlineDeliveryIncome": "Revenu de la livraison en ligne intégrée",
					"generalZigMachineCreditIn2Installments": "TPV Crédit en 2 versements",
					"generalZigMachineCreditIn3Installments": "TPV Crédit en 3 versements",
					"generalZigMachineCreditIn4Installments": "TPV Crédit en 4 versements",
					"generalZigMachineCreditIn5Installments": "TPV Crédit en 5 versements",
					"generalZigMachineCreditIn6Installments": "TPV Crédit en 6 versements",
					"generalZigMachineCreditIn7Installments": "TPV Crédit en 7 versements",
					"generalZigMachineCreditIn8Installments": "TPV Crédit en 8 versements",
					"generalZigMachineCreditIn9Installments": "TPV Crédit en 9 versements",
					"generalZigMachineCreditIn10Installments": "TPV Crédit en 10 versements",
					"generalZigMachineCreditIn11Installments": "TPV Crédit en 11 versements",
					"generalZigMachineCreditIn12Installments": "TPV Crédit en 12 versements",
					"generalZigMachineCreditIn2InstallmentsFEE": "Frais pour crédit en 2 versements",
					"generalZigMachineCreditIn3InstallmentsFEE": "Frais pour crédit en 3 versements",
					"generalZigMachineCreditIn4InstallmentsFEE": "Frais pour crédit en 4 versements",
					"generalZigMachineCreditIn5InstallmentsFEE": "Frais pour crédit en 5 versements",
					"generalZigMachineCreditIn6InstallmentsFEE": "Frais pour crédit en 6 versements",
					"generalZigMachineCreditIn7InstallmentsFEE": "Frais pour crédit en 7 versements",
					"generalZigMachineCreditIn8InstallmentsFEE": "Frais pour crédit en 8 versements",
					"generalZigMachineCreditIn9InstallmentsFEE": "Frais pour crédit en 9 versements",
					"generalZigMachineCreditIn10InstallmentsFEE": "Frais pour crédit en 10 versements",
					"generalZigMachineCreditIn11InstallmentsFEE": "Frais pour crédit en 11 versements",
					"generalZigMachineCreditIn12InstallmentsFEE": "Frais pour crédit en 12 versements",
					"totalTpvBarIncome": "Taux des revenus du bar",
					"totalTpvEntranceIncome": "Taux des revenus de la billetterie",
					"totalTpvEntranceIncomeConsumption": "Taux des revenus de consommation à la billetterie",
					"totalTpvBarMinimumConsumption": "Taux minimum des revenus du bar",
					"totalTpvBonus": "Taux des revenus des bonus",
					"bankRefund": "Remboursement bancaire",
					"acquirerRefund": "Remboursement de l'acquéreur",
					"advanceRenegotiation": "Renégociation de l'avance",
					"zigTicketsRetention": "Rétention des billets ZIG",
					"onlineDeliveryAcquisitionFee": "Frais d'acquisition de livraison en ligne",
					"pixPreventiveBlock": "Pix - Blocage Préventif",
					"pixAuthorizedUnblock": "Pix - Déblocage Autorisé",
					"pixRefundByChargeback": "Pix - Remboursement par Chargeback",
					"relatedStakeholderRetentionReprocessing": "Reprocessamento Retenção de partes relacionadas",
					"electrical": "Electricidad",
					"hydraulics": "Hidráulico",
					"cleaning": "Limpieza",
					"supply": "Suministro",
					"other": "Otros"
				},
				"noDataToShow": "There is nothing to show for the selected period",
				"table": {
					"actions": "Actions",
					"balance": "Balance",
					"category": "Category",
					"date": "Competency date",
					"noObs": "No observation",
					"obs": "Observation",
					"payDate": "Settlement date",
					"total": "Total",
					"totalToPay": "Payable",
					"totalToReceive": "Receivable"
				},
				"title": "Adjustments"
			},
			"anticipationDrawer": {
				"accountData": "Information compte",
				"anticipationValue": "Valeur anticipée",
				"form": {
					"accountType": "Virer à",
					"accountTypes": {
						"default": "Compte par défaut",
						"existing": "Compte enregistré",
						"new": "Nouveau compte",
						"tooltip": "Celui qui a été signé dans le contrat"
					},
					"bankData": "Données bancaires",
					"liquidValue": "Montant net",
					"liquidValuePlaceholder": "Saisir ici le montant net",
					"name": "Identifiant du compte",
					"reason": "Motif de la demande",
					"reasonPlaceholder": "Indiquez ici le motif de l'anticipation",
					"selectAccountPlaceholder": "Saisir ou sélectionner un compte",
					"shouldSaveForFutureRequests": "Sauvegarder le compte pour des transactions futures",
					"summaryAnticipationFee": "Frais d'anticipation",
					"summaryLiquidValue": "Valeur liquide demandée",
					"summaryReason": "Motif",
					"summaryThirdPartyFee": "Frais d'anticipation des tiers",
					"summaryTitle": "Révision des valeurs",
					"summaryTotal": "Montant total à anticiper",
					"summaryValue": "Montant demandé",
					"totalValue": "Total à anticiper",
					"totalValueTooltip": "Le montant net plus les frais d'anticipation",
					"withdrawAll": "Anticiper toutes les valeurs disponibles"
				},
				"formStatusError": "La demande n'a pas pu être traitée.",
				"formStatusSuccess": "Avance demandée avec succès !",
				"summary": "Analyse des données",
				"title": "Demander d'anticipation et le Paiement d'une Facture",
				"titleAnticipation": "Demander d'anticipation",
				"titleBilletPayment": "Demander le Paiement d'une Facture",
				"warningAccountChoice": "Des frais à hauteur de {{value}} seront facturés pour l'anticipation sur les comptes de tiers.",
				"warningBanner": "Les demandes effectuées après 10h30 (heure de Brasilia) ne seront traitées que le lendemain."
			},
			"availableInMoreThanOneMonth": "Montant à débloquer dans plus de 32 jours",
			"availableInTwoDays": "Le solde sera publié dans les deux prochains jours",
			"availableMoreThanOneMonth": "Valeur disponible sur 30 jours",
			"totalBalanceAnticipation": "Solde total pour anticipation",
			"valueAvailableToAnticipate": "Valeur disponible en anticipation",
			"availableToAnticipate": "Disponible pour anticiper",
			"availableToWithdraw": "Disponible pour le retrait",
			"withdrawRequestDrawer": {
				"bankSlid": {
					"bankSlipInfo": "Informations sur les relevés bancaires",
					"bankSlipValue": "Montant du relevé bancaire",
					"dataReview": "Analyse des données",
					"form": {
						"anticipationTax": "Frais d'anticipation",
						"anticipationValue": "Montant total à anticiper",
						"attachment": "Sélectionner le fichier de relevés bancaires",
						"available": "Solde disponible pour le retrait",
						"bankSlipInfo": "Informations sur le relevé bancaire",
						"bankSlipValue": "Montant du relevé bancaire",
						"barCode": "Numéro de code barre",
						"beneficiary": "Bénéficiaire",
						"calculating": "Calcul...",
						"dueDate": "Date d'échéance",
						"liquidAmmountRequested": "Montant net demandé",
						"liquidValue": "Montant net",
						"liquidValuePlaceholder": "Saisir ici le montant net",
						"thidPartyWithdrawFee": "Frais de retrait d'un tiers",
						"totalValue": "Montant total",
						"valuesReview": "Analyse des données"
					},
					"transactionDetails": {
						"available": "Valeur de retrait",
						"calculating": "Calcul...",
						"paymentValue": "Montant du paiement",
						"title": "Détail de la transaction",
						"totalValue": "Montant total"
					}
				},
				"bankslipPaymentOption": "Paiement par relevé bancaire",
				"bankslipValue": "Montant relevé bancaire",
				"downloadBankslipPdf": "Télécharger le relevé bancaire en PDF",
				"expireDate": "Date d'expiration",
				"pendingBankslip": "Relevé bancaire en attente",
				"title": "Demander un retrait ou le paiement d'un billet",
				"titleBankslip": "Paiement du billet",
				"titlePendingBankslip": "Paiement par relevé bancaire ZIG",
				"titleTransfer": "Transférer le solde d'un lieu à l'autre",
				"titleWithdraw": "Demande de retrait",
				"transferOption": "Transfert d'un lieu à un autre",
				"warning": "Seuls les montants jusqu'au solde disponible pour retrait peuvent être demandés.",
				"withdraw": {
					"account": "Compte",
					"accountInfo": "Information du compte",
					"accountPlaceholder": "Saisir ou sélectionner un compte",
					"dataReview": "Analyse des données",
					"errorMessage": "La demande n'a pas pu être traitée.",
					"liquidValue": "Montant net",
					"liquidValuePlaceholder": "Saisir ici le montant net",
					"reason": "Motif de la demande",
					"reasonPlaceholder": "Indiquez ici le motif du retrait",
					"successMessage": "Retrait demandé avec succès !",
					"warning": "Les demandes effectuées après 10h30 (heure de Brasilia) ne seront traitées que le lendemain.",
					"warningAccountChoice": "Des frais à hauteur de {{value}} seront prélevés pour les retraits vers des comptes de tiers.",
					"withdrawValue": "Montant du retrait"
				},
				"withdrawOption": "Retrait"
			},
			"errorsValidations": {
				"anticipation": {
					"accountData": {
						"accountAgency": "Saisir le numéro de l'agence",
						"accountAgencyInvalid": "Agence invalide",
						"accountBank": "Sélectionner la banque à laquelle appartient le compte",
						"accountDigit": "Saisir le numéro de compte",
						"accountDocument": "Saisir le document du titulaire du compte (CPF/CNPJ)",
						"accountDocumentInvalid": "Document invalide",
						"accountHolder": "Saisir le nom du titulaire du compte",
						"accountName": "Saisir le nom pour identifier le compte",
						"accountNumber": "Saisir le numéro de compte",
						"accountPixKey": "Clé PIX invalide",
						"accountType": "Sélectionner le type de compte",
						"accountTypeExisting": "Sélectionnez l'un des comptes existants",
						"accountTypeWrapper": "Complétez vos coordonnées bancaires ou votre clé PIX",
						"noAccountType": "Sélectionner un type de compte pour l'avance"
					},
					"value": {
						"liquidValue": "Montant demandé supérieur au montant net disponible ({{totalAvailable}})",
						"noLiquidValue": "Saisir le montant net de l'anticipation",
						"noTotalValue": "Saisir le montant total de l'anticipation",
						"reason": "Indiquer un motif d'anticipation",
						"totalValue": "Montant demandé supérieur au montant total disponible ({{totalAvailable}})"
					}
				},
				"bankSlip": {
					"attachment": "Joindre le fichier du relevé bancaire",
					"barCode": "Saisir le code-barres du bordereau de banque",
					"basicInfoValue": "Montant demandé supérieur au montant total disponible ({{totalAvailable}})",
					"beneficiary": "Saisir le bénéficiaire du relevé bancaire",
					"dueDate": "ATTENTION : Le relevé bancaire ne sera payé que si le solde couvre les intérêts et les frais d'amende.",
					"invalidBarCode": "Code-barres invalide"
				},
				"withdraw": {
					"value": {
						"accountBank": "Sélectionner la banque à laquelle appartient le compte",
						"accountChoice": "Sélectionnez un type de compte pour la demande",
						"accountDigit": "Saisir le numéro de compte",
						"accountHolder": "Saisir le nom du titulaire du compte",
						"accountName": "Saisir le nom pour identifier le compte",
						"accountNumber": "Saisir le numéro de compte",
						"accountType": "Sélectionner le type de compte",
						"agencyInvalid": "Agence invalide",
						"agencyNumber": "Saisir le numéro de l'agence",
						"documentInvalid": "Document invalide",
						"documentNumber": "Saisir le document du titulaire du compte (CPF/CNPJ)",
						"existingAccount": "Sélectionnez l'un des comptes existants",
						"noWithdrawValue": "Saisir le montant du retrait",
						"pixKeyInvalid": "Clé PIX invalide",
						"reason": "Indiquer le motif de la demande",
						"receiverDataWrapper": "Complétez vos coordonnées bancaires ou votre clé PIX",
						"withdrawValue": "Montant demandé supérieur au montant total disponible ({{totalAvailable}})"
					}
				}
			},
			"transferForm": {
				"balanceAvailable": "Solde disponible",
				"enoughBalanceMessage": "Solde disponible pour le virement",
				"loadingTargetPlaceData": "Chargement des données à partir du lieu ciblé...",
				"reviewLabels": {
					"balanceAfterTransferAtSourcePlace": "Solde au lieu d'origine après virement",
					"balanceAfterTransferAtTargetPlace": "Solde au lieu ciblé après virement"
				},
				"selectPlaceLabel": "Sélectionner le lieu ciblé",
				"selectPlacePlaceholder": "Sélectionner le lieu de réception du virement",
				"submitFailedMessage": "Échec du virement du montant",
				"submitSucceededMessage": "Montant transféré avec succès",
				"transferTotalValueBtn": "Transfert de tout le solde disponible",
				"wizardLabels": {
					"review": "Analyse de données",
					"target": "Cibler",
					"value": "Montant à transférer"
				}
			},
			"withdrawConfirmation": {
				"modal": {
					"title": "Confirmation de la demande de retrait",
					"message": "Pour confirmer la demande de retrait, saisissez le code envoyé par la méthode de confirmation configurée pour le lieu.",
					"codeInput": {
						"label": "Code",
						"placeholder": "Tapez ici le code de confirmation"
					},
					"resendCodeBtnLabel": "Je n'ai pas reçu mon code"
				},
				"form": {
					"errors": {
						"onlyNumbers": "Le code ne doit contenir que des chiffres",
						"minLength": "Le code doit comporter au moins 6 chiffres"
					},
					"submit": {
						"success": "La demande a été approuvée avec succès",
						"error": "Code invalide ou expiré"
					}
				},
				"resendConfirmationSuccessfully": "Le code a été renvoyé avec succès",
				"notification": "Votre demande a été traitée avec succès, mais doit être confirmée à l'aide du code envoyé au contact de confirmation configuré dans les paramètres du lieu."
			},
			"bankSlipForm": {
				"error": "La demande n'a pas pu être traitée.",
				"request": "Demande",
				"success": "Paiement du billet demandé avec succès !",
				"tryAgain": "Réessayer",
				"warningBanner": {
					"description": "Les demandes effectuées après 10h30 (heure de Brasilia) ne seront traitées que le lendemain.",
					"title": "Attention"
				}
			},
			"bankslipAvailable": "Facture disponible",
			"consolidated": {
				"excelButton": "Exporter tableau",
				"extract": "Extract",
				"filename": "extract-zig",
				"formatFee": "De {{minFee}} à {{maxFee}}",
				"table": {
					"fee": "Frais",
					"feeMax": "Frais maximum",
					"feeMin": "Frais minimum",
					"name": "Nom",
					"payValue": "Créances/Dettes ZIG",
					"section": "Section",
					"totalValue": "Montant total"
				}
			},
			"devolution": {
				"expired": "Expiré",
				"title": "Rechargement expiré",
				"toExpire": "À expirer",
				"totalExpired": "Total des rechargements expirées",
				"totalToExpire": "Total des rechargements à expirer"
			},
			"dueDate_Abrev": "Exp",
			"excelButton": "Exporter tableau",
			"financial": {
				"details": "vois détails",
				"event": "Événements",
				"filename": "extract-journalier",
				"modality": "Modalité",
				"noDataToShow": "Il n'y a rien à montrer pour la période sélectionnée",
				"noResume": "Il n'y a pas de clôture dans la période",
				"pay": "À payer",
				"payvalue": "À payer/À recevoir",
				"receive": "À recevoir",
				"summaryTitle": "Synthèse pour {{date}}",
				"table": {
					"balance": "Solde",
					"datetime": "Date",
					"in": "Entrée",
					"out": "Sortie",
					"total": "Total",
					"withdrew": "Retiré"
				},
				"title": "Extract journalier"
			},
			"flow": {
				"emptyText": "Il n'y a rien à montrer pour la période sélectionnée",
				"filename": "extract-flux-trésorerie",
				"table": {
					"balance": "Solde",
					"competency": "Date de transaction",
					"date": "Date de règlement",
					"title": "Description",
					"value": "Montant"
				},
				"title": "Extract du flux de trésorerie"
			},
			"hooks": {
				"accountData": "Informations sur le compte",
				"summary": "Analyse des données",
				"value": "Montant d'anticipation"
			},
			"lastUpdated": "mis à jour il y a {{lastUpdated}}",
			"owedToZig": "Solde à payer à ZIG",
			"paidToZig": "Montant à payer à ZIG",
			"paidToZigMoreThanOneMonth": "Montant à payer à ZIG dans plus de 30 jours",
			"period": "Période",
			"tabs": {
				"accounts": "Comptes enregistrés",
				"adjustments": "Paramètres",
				"consolidated": "Consolidé",
				"devolution": "Rechargements expirés",
				"financial": "Déclaration journalière",
				"flow": "Extract du flux de trésorerie",
				"withdraws": "Retraits, avances et relevés bancaires",
				"automaticWithdraw": "Retrait automatique"
			},
			"title": "Extract",
			"totalBalance": "Solde total",
			"vendors": "Vendors",
			"withdrawRequestDetails": {
				"drawerTitle": "Demande de type {{type}}",
				"successNotification": "Demande annulée avec succès",
				"errorNotification": "Erreur d'annulation de la demande",
				"cancelWithdrawPlaceConfirmationButtonLabel": "Annuler la confirmation",
				"confirmWithdrawButtonLabel": "Confirmer la demande",
				"cancelWithdrawRequestButtonLabel": "Annuler la demande",
				"sections": {
					"summary": {
						"title": "Synthèse de la demande",
						"fields": {
							"place": "Lieu",
							"timestamp": "Date/Heure",
							"employee": "Employé"
						}
					},
					"details": {
						"title": "Demande de détails",
						"requestedValue": "Montant demandé",
						"anticipatedValue": "Montant anticipé",
						"proRata": "Pro-Rata",
						"totalValue": "Montant total",
						"bankAccount": "Compte bancaire",
						"obs": "Commentaire",
						"paymentMethod": "Moyen de paiement",
						"attachments": "Pièces jointes"
					}
				},
				"valueLabel": "Montant :"
			},
			"withdraws": {
				"filename": "avances-retraits-relevé bancaire",
				"table": {
					"datetime": "Request date",
					"type": "Type",
					"status": "Statut",
					"requestedValue": "Montant demandé",
					"liquidAnticipatedValue": "Montant anticipé",
					"proRataFee": "Pro rata",
					"appliedFee": "Frais appliqués",
					"proRataFeeTooltip": "Taux d'avance proportionnel à la durée du solde à reporter",
					"totalBruteValue": "Montant total",
					"bankAccount": "Compte bancaire",
					"ticketPayment": "Paiement du relevé bacaire",
					"username": "Utilisateur",
					"vendor": "Lieu",
					"clientObservation": "Motif",
					"obs": "Commentaire",
					"paymentMethod": "Moyen de paiement",
					"attachments": "Pièces jointes",
					"confirmWithdrawBtnLabel": "Confirmer la demande"
				},
				"withdrawType": {
					"anticipation": "Anticipation",
					"withdraw": "Retrait",
					"bankslip": "Relevé bancaire"
				},
				"statusType": {
					"pending": "En attente",
					"paid": "Payé",
					"refused": "Refusé",
					"processing": "En cours",
					"pendingPlaceConfirmation": "En attente de confirmation",
					"cancelled": "Annulé",
					"processingCancellation": "En cours d'annulation",
					"pixProcessing": "Traitement de PIX",
					"bankslipProcessing": "Traitement de relevé bancaire",
					"pendingManagerApproval": "En attente de l'approbation du responsable",
					"canceledPlaceConfirmation": "Annulé",
					"approvedByZigManager": "Approuvé par le responsable de Zig",
					"pendingAnticipation": "En attente d'anticipation",
					"pendingTreasuryAction": "En attente d'action de la ZIG"
				},
				"paymentType": {
					"bankAccount": "Compte bancaire",
					"bankPaymentSlip": "Relevé bancaire de paiements"
				},
				"filters": {
					"searchAccountPlaceholder": "Recherche par compte",
					"filterTypePlaceholder": "Filtrer par type",
					"filterStatusPlaceholder": "Filtrer par statut"
				}
			},
			"automaticWithdraw": {
				"type": "Type",
				"vendorName": "Nom du fournisseur",
				"expectedAmount": "Montant du retrait prévu",
				"placeBalance": "Placer le solde",
				"actualAmount": "Montant retiré",
				"status": "Statut",
				"vendor": "Vendeur",
				"place": "Place",
				"error": "Erreur",
				"success": "Succès",
				"partial": "Partiel"
			},
			"retainedBalance": "Solde conservé",
			"twentyPercentRetention": "20% de rétention des valeurs des 7 derniers jours",
			"totalRetained": "Total retenu",
			"relatedPartDataTooltip": "Données spécifiées à partir du 21/05/2024"
		},
		"financialReport": {
			"getSubTitle": "De {{since}} à {{until}}",
			"letterhead": "Émis par \"{{name}}\" à {{momentLT}} dans {{momentL}}",
			"menu": {
				"bonusByProduct": "Bonus par produit",
				"bonusReport": "Bonus",
				"cashierClose": "Clôture de caisses",
				"consumptionObligationReport": "Consommation minimum",
				"debtorsReport": "Comptes débiteurs",
				"devolutionReport": "Retour de carte par caisse",
				"discountsReportForPlace": "Remises sur compte",
				"financialReport": "Clôture",
				"refundedProductsReport": "Produits réservés",
				"seeRefundReports": "Services supprimés",
				"openedBillPayment": "Paiement des comptes ouverts",
				"openedBillReports": {
					"title": "Comptes ouverts",
					"description": "Visualisez et gérez les comptes ouverts et les paiements",
					"stillOpenInPeriod": "Encore ouverts dans la période",
					"stillOpenInPeriodTooltip": "Se réfère au montant des comptes ouverts dans la période sélectionnée",
					"linksGenerated": "Liens générés",
					"paidInPeriod": "Paiements de comptes ouverts résolus dans la période",
					"tabs": {
						"debtors": "Comptes ouverts",
						"payments": "Paiements de comptes ouverts"
					}
				},
				"reserveReport": "Rapport des forfaits",
				"rappiDiscountsReport": "Réductions Rappi",
				"minimumConsumptionReport": "Consommation anticipée",
				"openSalesReport": "Ventes uniques",
				"promotionsReports": "Promotions utilisées",
				"transactionTransfer": "Transferts de factures",
				"salesTotemTransaction": "Ventes par transações Totem",
				"cashierAdjustmentsReport": "Fonds de saignements et de changement",
				"zigAppTransactions": "Ventes par transações Zig.app"
			},
			"print": "Imprimer rapport",
			"tabs": {
				"bonusReport": {
					"title": "Bonus",
					"subtitle": "Ici, vous pouvez consulter toutes les primes accordées par les employés.",
					"description": "Voir tous les rapports de concession et d'utilisation de bonus",
					"filenameBonus": "bonus-accordé",
					"filenameAnticipated": "consommation-anticipée",
					"filenameConsumption": "consommation",
					"total": "Total de {{category}}",
					"select": "Sélectionnez une catégorie",
					"selectNotFound": "Catégorie introuvable",
					"tabs": {
						"given": "Bonus Accordé",
						"used": "Bonus Utilisé"
					},
					"usedBonus": "Bonus Utilisés",
					"columns": {
						"client": "Employé responsable",
						"date": "Date",
						"dateTime": "Date et Heure",
						"reason": "Raison",
						"receivedValue": "Valeur reçue",
						"spentValue": "Valeur dépensée dans la période",
						"spentValueInOtherEvents": "Valeur dépensée dans une autre période",
						"spentValueInBonus": "Valeur du Paiement en Bonus",
						"givenBy": "Donné par",
						"total": "Total"
					}
				},
				"cashierClose": {
					"billed": "Facturé",
					"cashiers": "Caisse",
					"changeFund": "Fonds de roulement",
					"closed": "Clôturé",
					"difference": "Écart",
					"excelExport": "Exporter tableau",
					"methods": {
						"ame": "Ame",
						"anticipated": "Anticipé",
						"bonus": "Bonus",
						"cash": "Espèces",
						"credit": "Crédit",
						"dashboard": "Tableau de bord",
						"debit": "Débit",
						"deliveryOnline": "Livraison en ligne",
						"foodVoucher": "Ticket Restaurant",
						"ifood": "Ifood",
						"installment": "Versement",
						"pix": "Pix",
						"postEvent": "Post événement",
						"rappi": "Rappi",
						"uber": "Uber",
						"voucher": "Voucher",
						"zigCredit": "Crédit ZIG",
						"zigDebit": "Débit ZIG"
					},
					"modality": "Modalité",
					"resume": "Synthèse",
					"search": "Récupérer caisse",
					"searchSectors": "Rechercher les secteurs",
					"title": "Clôture de caisses",
					"hawkers": "Ambulants",
					"hawkerCashier": "Caissier de Ambulants"
				},
				"consumptionObligationReport": {
					"columns": {
						"client": "Client",
						"date": "Date",
						"employee": "Donné par",
						"paidValue": "Surplus de consommation",
						"total": "Total",
						"userProductsValueAtEvent": "Utilisé en produits",
						"value": "Montant"
					},
					"filename": "consommation-minimum",
					"filenameObligation": "obligation-consommation",
					"title": "Consommation minimum"
				},
				"debtorsReport": {
					"clientInfo": "Information client",
					"clientTotal_one": "Total du client({{debtors}})",
					"clientTotal_other": "Total des clients ({{debtors}})",
					"columns": {
						"date": "Date",
						"filters": {
							"paid": "Déjà payé",
							"unpaid": "Je ne paye pas"
						},
						"others": {
							"allBillsPaid": "Toutes les factures payées",
							"paid": "Déjà payé",
							"payAllBills": "Payer toutes les factures",
							"paymentOptions": "Options de paiement"
						},
						"paidValue": "Paiement total",
						"paidInOtherEvents": "Payé après événement",
						"phone": "Téléphone",
						"stillOpen": "Encore ouvert",
						"tipValue": "Ouvert en service",
						"totalOpen": "Total ouvert",
						"username": "Nom",
						"value": "Compte ouvert",
						"document": "Document"
					},
					"filename": "comptes-ouverts",
					"goTo": "Aller à",
					"modalTitleDebts": "Paiement de {{debts}} factures",
					"modalTitleName": "Paiement de {{userName}}",
					"search": "Recherche du client...",
					"filterByStatus": "Filtrer par statut",
					"total": "Total",
					"title": "Comptes ouverts",
					"paymentLink": {
						"sendCharge": "Envoyer",
						"generatedLink": "Lien généré",
						"charged": "Chargé",
						"noReturn": "Pas de retour",
						"cancel": "Annuler",
						"discharge": "Décharger",
						"chooseShippingMethod": "Choisir le mode de livraison",
						"finalPaymentLink": "Cliquez ici pour copier le lien",
						"error": "Le numéro fourni par le client ne dispose pas de WhatsApp.",
						"details": "Détails {{userName}}",
						"openValues": "Valeurs ouvertes",
						"openConsumption": "Consommation ouverte",
						"totalDebit": "Débit total",
						"tip": "Pourboire",
						"mail": "Email",
						"phone": "Téléphone",
						"consumedProducts": "Produits consommés",
						"viewBillingDetails": "Voir les détails",
						"status": {
							"created": "Lien généré",
							"notCharged": "Non facturé",
							"expired": "Pas de réponse",
							"partiallyCreated": "Partiellement facturé"
						},
						"paidBillMessage": "Il n'est pas possible de facturer une facture déjà payée.",
						"selectService": "Souhaitez-vous inclure les frais de service dans le montant en attente ?",
						"selectServiceText": "En choisissant d'inclure les frais de service, le montant des frais sera ajouté au solde en attente du compte.",
						"dontIncludeService": "Ne pas inclure",
						"includeService": "Inclure les frais de service",
						"openService": "Service en attente",
						"seeMore": "Voir plus",
						"copyValidLink": "Assurez-vous qu'il s'agit d'un lien valide",
						"retrieveLink": "Récupérer le lien de facturation",
						"moreOptions": "Plus d'options",
						"confirmRemoveTip": "En supprimant le service de la facturation via un lien, le montant sera remis à zéro et ne pourra pas être récupéré.",
						"wishToProceed": "Souhaitez-vous continuer ?"
					}
				},
				"devolutionReport": {
					"cashDevolution": "Retour monnaie",
					"cashier": "Par caisse",
					"columns": {
						"employee": "Employé",
						"quantity": "Quantité",
						"type": "Type",
						"value": "Montant"
					},
					"devolution": "Remboursement en {{method}}",
					"devolutions": "{{value}} remboursements",
					"filename": "retour-carte-par-caisse",
					"filenameCard": "retour-carte",
					"sheetTitle": "Retour de carte {{sheetName}}",
					"title": "Retour de carte par caisse",
					"total": "Total",
					"totalCategory": "Total ({{category}})",
					"totalGeral": "Total global"
				},
				"discountsReportForPlace": {
					"columns": {
						"category": "Catégorie",
						"givenBy": "Donné par",
						"reason": "Motif",
						"receivedValue": "Montant reçu",
						"spentValue": "Montant dépensé dans la période",
						"spentValueInOtherEvents": "Montant dépensé dans une autre période",
						"total": "Total",
						"spentValueInBonus": "Valeur du Paiement en Bonus"
					},
					"dateTime": "Date et Heure"
				}
			},
			"cashierClose": {
				"billed": "Facturé",
				"cashiers": "Caisse",
				"changeFund": "Fonds de roulement",
				"closed": "Clôturé",
				"difference": "Écart",
				"excelExport": "Exporter tableau",
				"methods": {
					"ame": "Ame",
					"anticipated": "Anticipé",
					"bonus": "Bonus",
					"cash": "Espèces",
					"credit": "Crédit",
					"dashboard": "Tableau de bord",
					"debit": "Débit",
					"deliveryOnline": "Livraison en ligne",
					"foodVoucher": "Ticket Restaurant",
					"ifood": "Ifood",
					"installment": "Versement",
					"pix": "Pix",
					"postEvent": "Post événement",
					"rappi": "Rappi",
					"uber": "Uber",
					"voucher": "Voucher",
					"zigCredit": "Crédit ZIG",
					"zigDebit": "Débit ZIG"
				},
				"modality": "Modalité",
				"resume": "Synthèse",
				"search": "Récupérer caisse",
				"title": "Clôture de caisses",
				"hawkers": "Ambulants",
				"hawkerCashier": "Caissier de Ambulants"
			},
			"consumptionObligationReport": {
				"columns": {
					"client": "Client",
					"date": "Date",
					"employee": "Donné par",
					"paidValue": "Surplus de consommation",
					"total": "Total",
					"userProductsValueAtEvent": "Utilisé en produits",
					"value": "Montant"
				},
				"filename": "consommation-minimum",
				"filenameObligation": "obligation-consommation",
				"title": "Consommation minimum",
				"seeRefundReports": {
					"title": "Suppression des pourboires par le caissier"
				},
				"transactionTransferReport": {
					"title": "Transferts de factures",
					"fileName": "transferts_de_factures",
					"columns": {
						"originCardId": "ID de la carte d'origine",
						"receiverCardId": "Réception de l'identifiant de la carte",
						"originDocument": "Document client original/Mesa",
						"receiverDocument": "Document du séquestre/Mesa",
						"productValue": "Valeur du produit",
						"productDiscountValue": "Rabais",
						"productName": "Nom du produit",
						"employeeName": "Nombre del empleado",
						"date": "Temps"
					}
				}
			}
		},
		"products": {
			"bars": {
				"activeProducts": "Activer Produits",
				"addBar": "Ajouter Bar",
				"cancel": "Annuler",
				"delete": "Supprimer",
				"deleteBar": "Supprimer Bar",
				"yesDeleteBar": "Oui, supprimer la barre",
				"deleteMessage": "La suppression impactera l'opération: les produits ne seront plus affichés et les imprimantes seront désassociées. Cette action ne peut pas être annulée. Voulez-vous continuer?",
				"editBar": "Modifier Bar",
				"emptyMessage": "Aucun article à montrer",
				"inactiveProducts": "Produits inactifs",
				"notifications": {
					"productActivated": "Produit activé avec succès",
					"productDeactivated": "Produit désactivé avec succès"
				}
			},
			"newAndEditProduct": {
				"cancelButton": "Annuler",
				"confirmButton": "Confirmer",
				"errors": {
					"abvQuantity": "Le pourcentage doit être inférieur à 100",
					"categoryId": "Choisir ou créer une catégorie",
					"length": "Máx. {{length}} caractères",
					"name": "Utiliser uniquement des caractères valides",
					"newCategory": "Vous allez créer une nouvelle catégorie",
					"productFeature": "La fonctionnalité {{wrongFeature}}n'est pas remplie correctement.",
					"productFeatures": "Les {{wrongFeatures}} ne sont pas remplies correctement.",
					"productRules": "Il y a des entrées non remplies",
					"proportionalQuantity": "TLe montant doit être supérieur à 0",
					"requiredField": "Ce champ est obligatoire",
					"wrongSection": "L'étape {{wrongStep}} n'est pas remplie correctement.",
					"wrongSections": "Les étapes {{wrongSteps}} ne sont pas remplies correctement."
				},
				"forms": {
					"details": {
						"beerABV": "ABV - Taux d'alcool",
						"beerIbu": "IBU - Unités d'amertume internationales",
						"beerBrand": "Marque",
						"beerStyle": "Style de bière",
						"category": "Catégorie",
						"description": "Description",
						"fiscalDataMessage": "Le code produit est généré automatiquement",
						"hasAlcohol": "Contient de l'alcool",
						"hasFiscalData": "Données fiscales",
						"hasMountableProduct": "Produit combinable",
						"hasProductRule": "Tableau",
						"hasProportionalProduct": "Produit en g/ml",
						"isHiddenFromApp": "Ne pas afficher le produit dans l'application ZigApp",
						"measurement": "Stock contrôlé par",
						"menuCategory": "Catégorie de menu",
						"beerIntegrationPlaceFeatureWarning": "Fonction désactivée. Veuillez contacter le support pour l'activer dans le système.",
						"beerIntegrationDisabledWarning": "Il n'est pas possible de désactiver cette fonction lorsque l'option 'Synchronisation avec {{integration}}' est activée.",
						"beerIntegrationEnabledWarning": "Il n'est pas possible de activer cette fonction lorsque l'option 'Synchronisation avec {{integration}}' est activée.",
						"productReturn": "Produit retournable",
						"name": "Nom du produit",
						"picture": "Image",
						"price": " Prix",
						"priceIn": "Prix en",
						"selectType": "Sélectionner un type de produit",
						"syncWithBeerIntegration": "Synchronisation avec {{integration}}",
						"type": "Type de produit",
						"variablePrice": "Prix variable",
						"isSupplyToggle": "Entrée",
						"conversionRule": {
							"unit": "Unité",
							"amount": "Quantité",
							"unitMeansure": "Unité de mesure",
							"placeholderSelect": "Sélectionner",
							"convertionName": "Règle de conversion",
							"title": {
								"unitDefault": "Unité de mesure par défaut",
								"unitConvertion": "Règle de conversion"
							},
							"field": {
								"quantity": "Quantité",
								"unitMeansure": "Unité de mesure"
							},
							"resumeDescription": "équivaut à:",
							"infoConvertionRule": "Crée une deuxième unité de mesure pour votre produit, permettant de le gérer de différentes manières dans votre inventaire.",
							"warningConvertionRule": "La règle de conversion ne peut être activée que lorsque le produit est contrôlé par unité."
						}
					},
					"fiscal": {
						"cest": "CEST",
						"code": "SKU",
						"codeErrorMessage": "S'il n'est pas rempli, le code sera généré automatiquement.",
						"fiscalGroup": "Groupe fiscal",
						"fiscalProfile": "Profil fiscal",
						"ncm": "NCM"
					},
					"mountable": {
						"addStep": "Ajouter une étape",
						"getDescriptionDialog": {
							"activate": "Voulez-vous activer cet article dans les autres produits combinables qu'il compose ?",
							"disable": "Voulez-vous désactiver cet article dans les autres produits combinables qu'il compose ?"
						},
						"getTitleDialog": {
							"activate": "Activer l'article combinable",
							"disable": "Désctiver l'article combinable"
						},
						"information": "INFORMATION",
						"infos": {
							"invalidValue": "Valeur invalide",
							"label": "Information",
							"max": "Max",
							"min": "Min",
							"precification": "Tarification",
							"precificationErrorMessage": "Choisir un moyen",
							"precificationSelect": {
								"average": "Moyenne",
								"averageTooltip": "La moyenne des articles sélectionnés est incrémentée.",
								"higher": "Montant le plus élevé",
								"higherTooltip": "La valeur la plus élevée parmi les éléments sera ajoutée à la valeur du produit.",
								"label": "Choix...",
								"sum": "Supplémentaire",
								"sumTooltip": "Chaque article ajouté sera incrémenté dans le montant du produit."
							},
							"title": "Titre",
							"titleErrorMessage": "Nom invalide",
							"tooltipMax": "Nombre maximum d'articles à sélectionner.",
							"tooltipMin": "Nombre minimum d'articles à sélectionner.",
							"validateMaxMinErrors": {
								"maxBiggerThenMin": "La montant maximum doit être supérieur au montant minimum",
								"maxValueZero": "Le montant maximum ne peut être égal à zéro",
								"negativeValue": "Un montant négatif n'est pas autorisé"
							}
						},
						"items": {
							"additionalItems": "Ajouter un autre article",
							"itemKey": "Article {{itemKey}}",
							"label": "Articles",
							"maxQuantity": "Quantité max. sélectionnable",
							"maxQuantityTooltip": "Nombre maximum de fois que cet élément peut être sélectionné dans la section",
							"modificationItem": "Article de modification",
							"storageCount": "Réduction de la quantité",
							"storageCountErrorMessage": "Quantité non valide",
							"storageCountTooltip": "Quantité à déduire du stock par unité.",
							"title": " Article",
							"titleErrorMessage": "Aucun article sélectionné",
							"value": "Montant",
							"valueErrorMessage": "Montant supplémentaire non valide"
						},
						"itemsTitle": "ARTICLES",
						"step": "Étape"
					},
					"productRule": {
						"addInput": "Ajouter entrée",
						"addAnotherInput": "Ajouter une autre entrée",
						"generatedQuantity": "Quantité de produits générés",
						"input": "Entrée",
						"loss": "Perte",
						"quantity": "Quantité"
					},
					"proportionalValue": {
						"grams": "Grammes",
						"measurement": "Unité de mesure",
						"mililiters": "Millilitres",
						"quantity": "Quantité"
					}
				},
				"titles": {
					"add": "Ajouter Produit",
					"downloadQRCodeToSell": "Télécharger QR Code à vendre",
					"edit": "Modifier Produit",
					"hasFiscalData": "Données fiscales",
					"hasMountableProduct": "Produit combinable",
					"hasProductRule": "Tableau",
					"hasProportionalProduct": "Produit en g/ml",
					"productDetails": "Détails Produit",
					"releaseValue": "Valeur de libération"
				},
				"undefined": "Non déini"
			},
			"productArea": {
				"titles": {
					"productArea": "Zone de produits",
					"editProduct": "Modifier le produit",
					"addInput": "Ajouter une autre entrée",
					"editTechnicalSheet": "Modifier la fiche technique"
				},
				"tabs": {
					"productDetail": "Détails du produit",
					"technicalSheet": "Fiche technique"
				}
			},
			"productDetail": {
				"isActive": "Produit actif",
				"isInactive": "Produit inactif",
				"buttonEditProduct": "Modifier le produit",
				"variable": "Variable",
				"modalDeleteProduct": {
					"titleModal": "Confirmation requise",
					"confirmDeleteProduct": "Voulez-vous supprimer le produit : {{productName}} ?"
				},
				"sectionsCards": {
					"productDetail": "Détails du produit",
					"fiscalData": "Données fiscales",
					"cardProductSoldBy": "Produit vendu par g/ml",
					"cardProductMountable": "Produit assemblable",
					"releaseValue": "Valeur de libération",
					"conversionRule": "Règle de conversion"
				},
				"duplicateProductMountable": "Dupliquer le produit assemblé",
				"contentsSection": {
					"contentFiscalData": {
						"fieldName": {
							"ncm": "NCM",
							"cest": "CEST",
							"fiscalProfile": "Profil fiscal",
							"fiscalGroup": "Groupe fiscal",
							"fiscalCode": "SKU"
						},
						"placeholder": {
							"ncm": "Saisissez le NCM",
							"cestInput": "CEST",
							"cestSelect": "Sélectionnez le CEST",
							"fiscalProfile": "Sélectionnez le profil fiscal",
							"fiscalGroup": "Sélectionnez le groupe fiscal",
							"fiscalCode": "Saisissez le SKU"
						},
						"infoMessageMyTapp": "Il est impossible de désactiver cette fonctionnalité lorsque le mode \"Synchroniser avec My Tapp\" est actif.",
						"requiredField": "Champ obligatoire",
						"validationMessage": {
							"ncm": "Le NCM doit contenir 8 chiffres",
							"cest": "Le CEST doit contenir 7 chiffres",
							"fiscalCode": "S'il n'est pas renseigné, le code sera généré automatiquement",
							"patternFiscalCode": "Uniquement des chiffres, lettres, points et tirets"
						},
						"infoMessageManualcest": "Ajouter le CEST manuellement ?"
					},
					"contentProductDetail": {
						"fieldName": {
							"image": "Image",
							"name": "Nom",
							"productType": "Type de produit",
							"unitOfMeasurement": "Stock contrôlé par",
							"category": "Catégorie",
							"menuCategory": "Catégorie du menu",
							"price": "Prix",
							"description": "Description",
							"drinkStyle": "Style de boisson",
							"alcoholContent": "Teneur en alcool",
							"hasAlcohol": "Contient de l'alcool",
							"hiddenZigApp": "Ne pas afficher le produit dans ZigApp",
							"sincMyTapp": "Synchroniser avec MyTapp",
							"productReturn": "Produit consigné",
							"brand": "Marque",
							"variableValue": "Prix variable",
							"stockableProduct": "Produit stockable"
						},
						"requiredField": "Champ obligatoire",
						"editImage": "Cliquez sur l'image pour modifier"
					},
					"contentProportionalValue": {
						"quantity": "Cantidad",
						"unityMeasurement": "Unidad de medida",
						"requiredField": "Campo obligatorio",
						"infoMessageMyTapp": "No es posible desactivar esta función mientras esté activa la opción 'Sincronizar con My Tapp'.",
						"placeholder": {
							"quantity": "Ingrese una cantidad",
							"unitMeasurement": "Seleccione"
						},
						"optionsUnitMeasurement": {
							"ml": "Mililitros",
							"gm": "Gramos",
							"un": "Unidad"
						}
					},
					"contentProductMountable": {
						"labelStep": "Paso",
						"labelItems": "ÍTEMS",
						"labelTitleInfo": "INFORMACIÓN",
						"addNewItem": "Agregar otro ítem",
						"fields": {
							"labelRequiredField": "Campo obligatorio",
							"title": "Título",
							"pricing": "Precios",
							"max": {
								"title": "Máximo",
								"errorMessage": {
									"notNullable": "El valor máximo no puede ser cero",
									"cannotLessMinimum": "El valor máximo no puede ser menor que el valor mínimo"
								}
							},
							"min": {
								"title": "Mínimo",
								"errorMessage": {
									"cannotGreaterMaximum": "El valor mínimo no puede ser mayor que el valor máximo"
								}
							},
							"item": "Ítem",
							"SelectableMaxQuantity": "Cantidad máxima seleccionable",
							"AmountSlaughtered": {
								"title": "Cantidad sacrificada",
								"errorMessage": {
									"notNullable": "La cantidad sacrificada debe ser mayor que cero"
								}
							},
							"price": "Valor"
						},
						"modalToggleStatusItem": {
							"activeItem": "Activar ítem ensamblado",
							"deactiveItem": "Desactivar ítem ensamblado",
							"warningMessage": {
								"active": "¿Desea activar este ítem en otros productos ensamblados a los que pertenece?",
								"deactive": "¿Desea desactivar este ítem en otros productos ensamblados a los que pertenece?"
							}
						},
						"modalWarningMontable": {
							"excludeStep": "Excluir paso",
							"excludeItem": "Excluir ítem",
							"warningMessage": {
								"exludeLastStep": "No es posible excluir todos los pasos de un producto ensamblado.",
								"excludeLastItem": "No es posible excluir todos los ítems de un producto ensamblado."
							}
						}
					}
				}
			}
		},
		"tagTransfersReport": {
			"title": "Liens de carte",
			"descriptionPlace": "Liste de tous les transferts de liens des cartes de consommation de la période.",
			"descriptionEvent": "Liste de tous les transferts de l'événement",
			"filters": {
				"zigCodePlaceholder": "Filtrer par Zig Code",
				"zigCodeInvalid": "Code Zig invalide",
				"documentPlaceholder": "Filtrer par document client",
				"employeePlaceholder": "Filtrer par collaborateur"
			},
			"debtorsReport": {
				"clientInfo": "Information client",
				"clientTotal_one": "Total du client({{debtors}})",
				"clientTotal_other": "Total des clients ({{debtors}})",
				"columns": {
					"date": "Date",
					"filters": {
						"paid": "Déjà payé",
						"unpaid": "Je ne paye pas"
					},
					"others": {
						"allBillsPaid": "Toutes les factures payées",
						"paid": "Déjà payé",
						"payAllBills": "Payer toutes les factures",
						"paymentOptions": "Options de paiement"
					},
					"paidValue": "Paiement total",
					"paidInOtherEvents": "Payé après événement",
					"phone": "Téléphone",
					"stillOpen": "Encore ouvert",
					"tipValue": "Ouvert en service",
					"totalOpen": "Total ouvert",
					"username": "Nom",
					"value": "Compte ouvert",
					"document": "Document"
				},
				"filename": "comptes-ouverts",
				"goTo": "Aller à",
				"modalTitleDebts": "Paiement de {{debts}} factures",
				"modalTitleName": "Paiement de {{userName}}",
				"search": "Recherche du client...",
				"title": "Comptes ouverts",
				"paymentLink": {
					"sendCharge": "Envoyer",
					"generatedLink": "Lien généré",
					"charged": "Chargé",
					"noReturn": "Pas de retour",
					"cancel": "Annuler",
					"discharge": "Décharger",
					"chooseShippingMethod": "Choisir le mode de livraison",
					"finalPaymentLink": "Cliquez ici pour copier le lien",
					"error": "Le numéro fourni par le client ne dispose pas de WhatsApp.",
					"details": "Détails {{userName}}",
					"openValues": "Valeurs ouvertes",
					"openConsumption": "Consommation ouverte",
					"totalDebit": "Débit total",
					"tip": "Pourboire",
					"mail": "Email",
					"phone": "Téléphone",
					"consumedProducts": "Produits consommés",
					"viewBillingDetails": "Voir les détails",
					"status": {
						"created": "Lien généré",
						"notCharged": "Non facturé",
						"expired": "Pas de réponse"
					},
					"paidBillMessage": "Il n'est pas possible de facturer une facture déjà payée.",
					"selectService": "Souhaitez-vous inclure les frais de service dans le montant en attente ?",
					"selectServiceText": "En choisissant d'inclure les frais de service, le montant des frais sera ajouté au solde en attente du compte.",
					"dontIncludeService": "Ne pas inclure",
					"includeService": "Inclure les frais de service",
					"openService": "Service en attente",
					"seeMore": "Voir plus",
					"copyValidLink": "Assurez-vous qu'il s'agit d'un lien valide",
					"retrieveLink": "Récupérer le lien de facturation",
					"moreOptions": "Plus d'options"
				}
			},
			"devolutionReport": {
				"cashDevolution": "Retour monnaie",
				"cashier": "Par caisse",
				"columns": {
					"employee": "Employé",
					"quantity": "Quantité",
					"type": "Type",
					"value": "Montant"
				},
				"devolution": "Remboursement en {{method}}",
				"devolutions": "{{value}} remboursements",
				"filename": "retour-carte-par-caisse",
				"filenameCard": "retour-carte",
				"sheetTitle": "Retour de carte {{sheetName}}",
				"title": "Retour de carte par caisse",
				"total": "Total",
				"totalCategory": "Total ({{category}})",
				"totalGeral": "Total global"
			},
			"discountsReportForPlace": {
				"columns": {
					"category": "Catégorie",
					"clients": "Clients",
					"date": "Date",
					"discount": "Réduction",
					"employee": "Employé",
					"justify": " Justification",
					"percentage": "Pourcentage",
					"products": "Produits",
					"total": "Total"
				},
				"discounts": "Réductions",
				"filename": "réductions",
				"filter": "Filtrer par catégorie",
				"selectCategory": "Choisir catégorie",
				"title": "Réductions utilisé sur {{placeName}}"
			},
			"financialReport": {
				"analyticPayments": {
					"bonus": "Bonus par produit",
					"columns": {
						"author": "Employé",
						"client": "Client",
						"date": "Date",
						"method": "Moyen",
						"value": "Montant"
					},
					"searchMethod": "Sélectionner un moyen...",
					"searchName": "Recherche par client ou employé...",
					"title": "Rapport analytique"
				},
				"cmv": {
					"name": "Nom",
					"title": "CMV",
					"value": "Montant",
					"valuesName": "Coût total des produits vendus"
				},
				"columnSection": {
					"percentage": "pourcentage",
					"quantity": "quantité",
					"receipt": "reçu",
					"value": "montant"
				},
				"filename": "rapport_synthèse",
				"goTo": "aller à",
				"seeAllPaymentsButton": "Voir tous les paiements",
				"title": "Finances du {{placeName}}"
			},
			"minimumConsumptionReport": {
				"title": "Consommation anticipée"
			},
			"openSalesReport": {
				"columns": {
					"date": "Date",
					"employee": "Employé",
					"isRefunded": "A été remboursé",
					"method": "Moyen",
					"no": "non",
					"refundedAt": "Remboursé à",
					"refundedBy": "Remboursé par",
					"total": "Total",
					"value": "Montant",
					"yes": "oui"
				},
				"employeeSales": "Ventes uniques de {{employeeName}}",
				"searchPlaceholder": "Rechercher par nom d'employé",
				"seeAllSales": "Voir toutes les ventes",
				"title": "rapport Ventes uniques",
				"totalSales": "Total Ventes ouvertes"
			},
			"openedBillPayment": {
				"columns": {
					"client": "Client",
					"date": "Jour de paie",
					"employee": "Payé pour",
					"method": "Moyen",
					"observation": "Commentaire",
					"openedEventDate": "Date d'ouverture du compte",
					"tipValue": "Montant du pourboire",
					"total": "Total",
					"value": "Montant",
					"document": "Document"
				},
				"emptyText": "Naucune donnée à afficher.",
				"mixed": "Mélangé",
				"title": "Paiements de comptes ouverts",
				"tooltip": "Information Clients"
			},
			"promotionsReports": {
				"columns": {
					"userName": "Utilisateur",
					"userDocument": "Document",
					"productCategory": "Catégorie",
					"productName": "Produit",
					"promotionName": "Promotion",
					"totalDiscount": "Total Réduction",
					"uses": "Nombre d'utilisations"
				},
				"userPromotionReportFileName": "promotions-par-le-client",
				"userPromotionReportLabel": "Promotions utilisées par le client",
				"promotionReportFileName": "promotions-utilisées",
				"promotionReportLabel": "Promotions utilisées",
				"tablePromotionReportLabel": "Utilisées par Tables",
				"tableTitle": "Table",
				"promotionTitle": "Promotions",
				"tablePlaceholder": "Tous",
				"title": "Promotions utilisées dans {{placeName}}",
				"totalDiscount": "Réduction totale",
				"totalUses": "Utilisation totale"
			},
			"tableReports": {
				"title": "Promotions utilisées de {{placeName}}",
				"promotionReportLabel": "Promotions utilisées",
				"promotionReportFileName": "promotions-utilisees",
				"userPromotionReportLabel": "Utilisées par personnes",
				"tablePromotionReportLabel": "Utilisées par tables",
				"userPromotionReportFileName": "promotions-utilisees-par-personne",
				"totalDiscount": "Total de réduction",
				"tablePlaceholder": "Tous",
				"totalUses": "Nombre total d'utilisations",
				"columns": {
					"userName": "Nom",
					"productName": "Produit",
					"promotionName": "Promotions",
					"productCategory": "Catégorie",
					"uses": "Nombre d'utilisations",
					"totalDiscount": "Réduction totale",
					"openedAt": "Ouverture",
					"closedAt": "Fermeture"
				}
			},
			"rappiDiscountReport": {
				"sheet": {
					"columns": {
						"date": "Date",
						"employee": "Employé ayant appliqué la réduction",
						"products": "Produits",
						"value": "Montant de la réduction"
					},
					"filename": "rapport_réductions_rappi",
					"title": "Réductions Rappi"
				},
				"title": "Réductions Rappi"
			},
			"refundedProductsReport": {
				"columns": {
					"author": "Rechargement effectué par",
					"client": "Client",
					"date": "Date",
					"refundedBy": "Remboursé par",
					"totalValue": "Montant",
					"usedValue": "Montant utilisé"
				},
				"filenameRecharges": "rechargements-remboursés",
				"title": "Produits remboursés",
				"titleRecharges": "Rechargements remboursés"
			},
			"reserveReport": {
				"columns": {
					"confirmedPeople": "Confirmé",
					"invitedPeople": "Invités",
					"issued": "Émission de factures",
					"name": "Nom du forfait",
					"products": "Produits",
					"revenue": "Total Facturation",
					"value": "Montant du forfait"
				},
				"manyPackages": "{{quantity}} forfaits actifs pendant la période",
				"moreDetails": "Plus de détails",
				"onePackage": "Un forfait actif pendant la période",
				"title": "Forfaits",
				"total": "Total",
				"totalCategory": "Total ({{category}})",
				"withoutPackage": "Aucun forfait actif pendant la période"
			},
			"seeRefundReports": {
				"title": "Suppression des pourboires par le caissier"
			},
			"transactionTransferReport": {
				"title": "Transferts de factures",
				"fileName": "transferts_de_factures",
				"columns": {
					"originCardId": "ID de la carte d'origine",
					"receiverCardId": "Réception de l'identifiant de la carte",
					"originDocument": "Document client original/Mesa",
					"receiverDocument": "Document du séquestre/Mesa",
					"productValue": "Valeur du produit",
					"productDiscountValue": "Rabais",
					"productName": "Nom du produit",
					"employeeName": "Nombre del empleado",
					"date": "Temps"
				}
			}
		},
		"settings": {
			"menu": {
				"title": "Autres options de configuration",
				"general": {
					"title": "Général",
					"subtitle": "Informer les limites, e-mails et autres"
				},
				"record": {
					"title": "Jeton",
					"subtitle": "Configurer le mode jeton"
				},
				"couvert": {
					"title": "Couverture",
					"subtitle": "Définir les frais de couverture"
				},
				"features": {
					"title": "Fonctionnalités",
					"subtitle": "Activer les fonctionnalités souhaitées"
				},
				"pdv": {
					"title": "POS",
					"subtitle": "Configurer le point de vente"
				},
				"totem": {
					"title": "Totem",
					"subtitle": "Personnaliser un totem"
				},
				"refundReason": {
					"title": "Motifs de remboursement/annulation",
					"subtitle": "Configurez les motifs pour le point de vente"
				},
				"vendor": {
					"title": "Fournisseur",
					"subtitle": "Configurer les informations générales"
				},
				"fiscalPrinter": {
					"title": "Imprimantes fiscales",
					"subtitle": "Configurez les imprimantes fiscales"
				}
			},
			"alert": "Des modifications ont été apportées, sauvergarder pour les conserver.",
			"alterImage": "l'image a été modifiée avec succès",
			"attention": "Attention !",
			"url": "nomduproduit",
			"daysAndWorkingPeriod": "Jours et heures de fonctionnement",
			"address": {
				"postalCode": "Code Postal",
				"state": "État",
				"city": "Ville",
				"neighborhood": "Quartier",
				"address": "Adresse",
				"number": "Numéro",
				"complement": "Complément"
			},
			"workingPeriod": {
				"deletedPeriod": "Période supprimée.",
				"addDaysAndTime": "Ajouter des jours et des heures",
				"addOpeningHours": "Ajouter des heures d'ouverture",
				"daysOfTheWeek": "Jours de la semaine",
				"start": "Début",
				"end": "Fin"
			},
			"consumption": {
				"fiscalGroup": "Groupe fiscal",
				"fiscalProfile": "Profile fiscal",
				"label": "Mise en place d'une taxe minimale à la consommation",
				"ncm": "NCM"
			},
			"couvertEdit": {
				"add": "Ajouter",
				"cancel": "Annuler",
				"columns": {
					"category": "Catégorie",
					"name": "Nom",
					"price": "Prix",
					"public": "Public"
				},
				"edit": "Modifier",
				"editCouvert": "Modifier couvert",
				"error": {
					"required": "Ce champ est obligatoire",
					"value": "Le montant de l'abonnement doit être inférieur ou égal à la limite de l'abonnement postpayé."
				},
				"female": "femme",
				"label": "Modifier couverts",
				"male": "homme",
				"men": "Hommes",
				"women": "Femmes"
			},
			"data": {
				"peopleCapacity": "Capacité",
				"slug": "Slug",
				"peopleCapacityTooltip": "Nombre de personnes que le lieu accueille.",
				"label": "Données",
				"name": "Nom",
				"noneProduct": "Auncun produit",
				"selectProduct": "Sélectionnez un produit pour activer le dépôt de garantie automatique"
			},
			"passTemplate": "ID du modèle de passe",
			"devices": {
				"label": "POS du lieu ({{counter}})",
				"placeholder": "Ajouter un POS à ce lieu",
				"requestDevices": "Demander des appareils"
			},
			"email": "Emails pour recevoir la clôture d'événements",
			"emailError": "email invalide",
			"error": "Pas d'autorisation pour modifier le lieu",
			"errors": {
				"hasConsumptionObligation": "Champ obligatoire pour la configuration de l'obligation de consommation",
				"invalidName": "Veuillez saisir un nom valide",
				"invalidTip": "Saisir un montant allant jusqu'à 25 %.",
				"postPaidLimit": "Veuillez saisir un montant valide",
				"rechargeNotIntegratedLimit": "Montant minimum de",
				"minNonIntegratedPaymentLimit": "Montant minimum de {{value}}",
				"tipOptionsValuesRequired": "Les valeurs de pourboire sont nécessaires",
				"tipOptionLowerValue": "La \"Valeur inférieure\" doit être inférieure aux valeurs Moyenne et Supérieure",
				"tipOptionHigherValue": "La \"Valeur supérieure\" doit être supérieure à la valeur Moyenne"
			},
			"tip": {
				"taxType": "Type de taxe",
				"tipSuggestions": "Suggestions de pourboire",
				"tip": "Pourboire",
				"serviceTax": "Frais de service",
				"none": "Aucun",
				"lowerValue": "Valeur inférieure",
				"medValue": "Valeur moyenne",
				"higherValue": "Valeur supérieure",
				"tooltip": "Les recommandations de pourboire rendent le paiement de l'addition plus facile en proposant trois options de pourcentages (Moins, Moyenne et Plus) basées sur le montant total de l'addition, par exemple : 5%, 10% et 15%, limitées à 25%."
			},
			"everest": {
				"cnpj": "CNPJ",
				"host": "Hôte",
				"label": "Everest",
				"password": "Mot de passe",
				"user": "Utilisateur"
			},
			"ficha": {
				"text": "Titre du fichier",
				"placeholderText": "Entrez le titre de la carte",
				"logo": "Image à imprimer",
				"label": "Token",
				"upload": "Joindre l'image",
				"formatError": "Format non pris en charge",
				"imageFormatMessage": "L'image doit être au format PNG ou SVG.",
				"recommendationMessage": "Nous recommandons que l'image attribuée soit le logo de l'entreprise en noir, car il n'est pas possible d'imprimer dans une autre couleur.",
				"dragOrSelectMessage": "Faites glisser l'image depuis votre ordinateur ou sélectionnez-la à partir de 'Joindre l'image'.",
				"logoFormatMessage": "Le logo doit être au format PNG ou SVG avec un fond transparent.",
				"size": {
					"Small": "P - Petit",
					"Medium": "M - Moyen",
					"Large": "G - Grand",
					"NoImage": "Aucune image",
					"NoQRCode": "Pas de QRCode",
					"recommend": "recommandé"
				},
				"fontSize": "Taille de la police",
				"imageSize": "Image",
				"qrCodeSize": "Taille du code QR"
			},
			"limits": {
				"label": "Limites et services",
				"postPaidLimit": "Limite post-payée",
				"rechargeNotIntegratedLimit": "Limite de rechargement non intégrée",
				"serviceTax": "Frais de gestion",
				"nonIntegratedPaymentLimit": "Limite de paiement non intégrée par appareil et événement",
				"enableBuiltInLimit": "Activer la limite de recharge non intégrée",
				"enableNonIntegratedPaymentLimit": "Habilitar limite de paiement non intégrée par appareil et événement",
				"nonIntegratedPaymentLimitTooltip": "Cette limite fait référence au montant maximal de paiements non intégrés qu'un appareil peut recevoir pendant l'événement. Ce paramètre est la somme du total des Recharges et des Ventes sans Carte effectuées avec des paiements non intégrés.",
				"nonIntegratedRechargeLimitTooltip": "Cette limite fait référence au montant maximum qu'un employé peut gagner dans une recharge non intégrée."
			},
			"paymentBilling": {
				"hybrid": "Hybride",
				"pos": "Pos",
				"pre": "Pre"
			},
			"image": "Photo",
			"placeFeatures": "Functionalités",
			"refundReason": {
				"addReason": "Créer un raison",
				"cancel": "Annulation",
				"modalDelete": {
					"confirmation": "Voulez-vous supprimer la motif de la liste des motifs de remboursement et d'annulation ?",
					"description": "En supprimant le motif, il n'apparaîtra plus, mais restera dans les anciens rapports.",
					"title": "Supprimer la catégorie de remboursement"
				},
				"modalForm": {
					"addReason": "Créer une motif",
					"allowOpenText": "Activer la justification",
					"creatingReason": "Création d'une motif",
					"editReason": "Enregistrer les modifications",
					"editingReason": "Modification d'une motif",
					"reason": "Nom de la motif",
					"reasonPlaceholder": "Entrez le nom de la motif de remboursement et/ou d'annulation"
				},
				"reason": "Nom de la motif",
				"removeReason": "Modifier la motif",
				"refund": "Remboursement",
				"table": {
					"editReason": "Modifier la motif",
					"observation": "Observation",
					"reason": "Nom de la motif",
					"removeReason": "Supprimer la motif",
					"status": "Statut",
					"type": "Type"
				},
				"title": "Motifs de remboursement et d'annulation"
			},
			"fiscalPrinter": {
				"title": "Imprimantes fiscales",
				"name": "Nom",
				"type": "Type",
				"ip": "IP",
				"actions": "Actions",
				"deletedSuccessfully": "Imprimante supprimée avec succès",
				"addedSuccessfully": "Imprimante ajoutée avec succès"
			},
			"save": "Sauvegarder",
			"settings": {
				"label": "Paramètres",
				"myActionsPassword": {
					"label": "Mot de passe ¨Mes Actions¨",
					"placeholder": "EEntrez un mot de passe numérique ou le mot de passe par défaut sera 9090.",
					"tooltip": "Mot de passe numérique utilisé pour débloquer des actions restreintes sur le PDV, comme les annulations et les remboursements.",
					"showPassword": "Afficher le mot de passe",
					"hidePassword": "Masquer le mot de passe"
				},
				"sellVisualizationFormat": {
					"grid": "Grille",
					"label": "Format d'affichage des produits en vente",
					"list": "Liste",
					"placeholder": "Sélectionnez un format"
				},
				"kdsServer": {
					"label": "IP du serveur KDS",
					"placeholder": "Entrez l'IP",
					"sectionTitle": "KDS",
					"sectionDescription": "Configurez l'IP du serveur KDS"
				},
				"equipment": {
					"title": "Besoin de nouveaux équipements ?",
					"description": "Cliquez sur le bouton à côté pour contacter l'équipe responsable dans un environnement externe.",
					"button": "Demander un équipement"
				},
				"preBill": {
					"title": "Pré-facture",
					"description": "Personnalisez l'impression de la pré-facture sur le PDV.",
					"toggleLabel": "Afficher la composition des produits assemblables sur la pré-facture",
					"toggleDescription": "Affiche le détail des ingrédients et compléments des produits assemblables.",
					"alertTitle": "Important !",
					"alertMessage": "Même activé, le détail des produits assemblables ne s'affichera que si le PDV est en ligne.",
					"preview": {
						"title": "Pré-facture",
						"place": "BarDaVila - BarDavila",
						"address": "Adresse de l'établissement",
						"document": "CNPJ : 00.000.000/00",
						"date": "03/07/2026",
						"client": "Clients : TABLE 2",
						"productLabel": "Produit",
						"valueLabel": "Valeur",
						"itemMain": "x1 MTV - Picanha",
						"itemComplementOne": "x1 Passado",
						"itemComplementTwo": "x1 Arroz",
						"value": "R$ 50,00"
					}
				},
				"saveChanges": "Enregistrer les modifications"
			},
			"title": "Modifier Paramètres",
			"warningDialog": "Vous activez les paiements postpayés sur '{{name}}'. Êtes-vous sûr de vous ? Pour confirmer la modification, veuillez taper '{{text}}'.'",
			"totem": {
				"important": "Important",
				"instructions": "Pour personnaliser le totem correctement, assurez-vous que l'image présente les caractéristiques suivantes :",
				"logo": "Le logo de Zig restera sur le totem au même emplacement après la personnalisation.",
				"image": "Incluez un message dans l'image indiquant au client de toucher l'écran pour démarrer l'achat.",
				"dimensions": "Dimensions : 1080 pixels de large x 1920 pixels de haut.",
				"quality": "Cela garantira une personnalisation de haute qualité.",
				"colors": "Personnalisez les couleurs de votre totem : choisissez les couleurs primaires et secondaires selon votre préférence."
			},
			"vendor": {
				"definitions": "Définitions",
				"serviceFee": "Frais de service",
				"serviceTransfer": "Transfert de service",
				"serviceFeeVendor": "Fournisseur de frais de service",
				"serviceFeeVendorRequired": "Sélectionnez le fournisseur de la taxe de service",
				"serviceFeeVendorPlaceholder": "Sélectionnez le fournisseur pour recevoir le transfert",
				"paymentMethodSuccess": "Les méthodes de paiement du Vendor ont été mises à jour avec succès !",
				"serviceTransferSuccess": "Fournisseur de la taxe de service mis à jour avec succès !",
				"saveMethods": "Enregistrer les retenues",
				"resetChanges": "Restaurer les valeurs initiales",
				"vendor": "Fournisseur",
				"selectVendor": "Sélectionnez un fournisseur",
				"paymentMethods": "Conservation de tous les montants effectués sur place",
				"tooltip": "Si un fournisseur est sélectionné, la totalité du montant effectué en utilisant le mode de paiement choisi sera conservée sur le relevé de ce fournisseur.",
				"paymentMethod": "Méthode de paiement",
				"paymentMethodOptions": {
					"credit": "Crédit non intégré",
					"debit": "Débit non intégré",
					"cash": "Espèces",
					"voucher": "Bon"
				},
				"reprocessButton": "Retraiter les fournisseurs",
				"confirmReprocess": "Confirmer le retraitement",
				"reprocessLabel": "Événement",
				"reprocessPlaceholder": "Entrez l'ID de l'événement",
				"reprocessEmptySelect": "Selecione pelo menos um evento para reprocessar",
				"reprocessSuccess": "Les fournisseurs ont retraité avec succès"
			},
			"invoiceMoment": {
				"fieldLabel": "Sélectionnez le moment pour l'émission de la facture cashless",
				"tip": "Sélectionnez le moment de l'émission de la facture pour les paiements sans numéraire. Pour tous les autres modes de paiement qui ne sont pas sans numéraire, la facture sera toujours émise lors de la consommation",
				"recharge": "Recharge",
				"rechargeAndActivation": "Recharge et activation",
				"consumption": "Consommation",
				"consumptionAndActivation": "Consommation et activation"
			},
			"authKeysFeature": {
				"phone": "Téléphone",
				"email": "Courriel",
				"keySelectLabel": "Choisissez le type de clé",
				"addKey": "Ajouter des clés d'authentification",
				"contactsInputLabel": "Ajoutez une ou plusieurs clés pour l'authentification",
				"contactsEmailInputPlaceholder": "Entrez un courriel valide (ex: email@gmail.com)",
				"contactsPhoneInputPlaceholder": "Entrez un numéro de téléphone (ex: +55 (00) 0 00000000",
				"btnAddKey": "Ajouter des clés d'authentification",
				"btnCancelAddKey": "Annuler",
				"authKeyAreaTitle": "Authentification de retrait",
				"authKeyAreaSubtitle": "Enregistrez des clés (courriel ou téléphone) qui seront utilisées pour recevoir le code d'authentification lors de la demande d'un retrait.",
				"selectContactKeyMessage": "Sélectionnez un type de clés",
				"selectContactInputMessage": "Remplissez une clé de contact",
				"contactAlreadyExists": "Ce contact existe déjà !",
				"invalidEmail": "Courriel invalide",
				"invalidPhone": "Téléphone invalide. Doit contenir l'indicatif (ex: +5511999999999)",
				"incompletePhone": "Numéro de téléphone incomplet. Entrez tous les chiffres.",
				"invalidDDI": "Seuls les numéros de téléphone brésiliens sont acceptés. Utilisez l'indicatif +55 ou laissez-le vide.",
				"errorCreatingAuthKeys": "Erreur lors de la création des clés d'authentification",
				"invalidContactsFound": "Contacts invalides trouvés. Vérifiez les données et réessayez.",
				"errorCreatingSomeKeys": "Erreur lors de la création de certaines clés: {{errors}}"
			},
			"defaultDateFilter": "Filtre de date par défaut"
		},
		"placeTabs": {
			"catering": "Catering"
		}
	},
	"products": {
		"bars": {
			"activeProducts": "Activer Produits",
			"addBar": "Ajouter Bar",
			"cancel": "Annuler",
			"delete": "Supprimer",
			"deleteBar": "Supprimer Bar",
			"yesDeleteBar": "Oui, supprimer la barre",
			"deleteMessage": "La suppression impactera l'opération: les produits ne seront plus affichés et les imprimantes seront désassociées. Cette action ne peut pas être annulée. Voulez-vous continuer?",
			"editBar": "Modifier Bar",
			"emptyMessage": "Aucun article à montrer",
			"inactiveProducts": "Produits inactifs",
			"notifications": {
				"productActivated": "Produit activé avec succès",
				"productDeactivated": "Produit désactivé avec succès"
			},
			"transfer": {
				"noItems": "Aucun élément disponible",
				"noCategoryFound": "Aucune catégorie trouvée pour \"{{category}}\"",
				"noProductFound": "Aucun produit trouvé pour \"{{product}}\"",
				"noResultsFound": "Aucun résultat trouvé pour la catégorie \"{{category}}\" et le produit \"{{product}}\"",
				"selectProductsToActivate": "Sélectionner les produits à activer",
				"selectProductsToDeactivate": "Sélectionner les produits à désactiver",
				"inactiveProductTooltip": "Ce produit n'est pas actif dans le lieu et ne sera plus disponible pour la vente en POS ou imprimé dans les commandes de livraison"
			},
			"modal": {
				"addNewIp": "Ajouter une IP d'imprimante (Optionnel)",
				"barName": "Nom du bar",
				"barStock": "Inventaire",
				"printerType": "Type",
				"printerOffline": "Hors ligne",
				"numberOfLanes": "Nombre de vias",
				"numberOfLanesDescription": "Nombre de copies imprimées sur l'imprimante après la commande.",
				"menu": "Menu",
				"logoFicha": "Logo sur le fichier",
				"logoFichaInfo": "Si vous ne sélectionnez pas un logo pour le fichier dans le bar, le logo imprimé sur le fichier sera celui de {{placeName}}",
				"logoFichaDescription": "Image qui apparaîtra imprimée sur le fichier.",
				"stockDescription": "Le stock sélectionné sera utilisé par ce bar.",
				"menuDescription": "Le menu sélectionné sera utilisé par ce bar.",
				"barNamePlaceholder": "Entrez le nom du bar",
				"barStockPlaceholder": "Sélectionner",
				"menuPlaceholder": "Sélectionner un ou plusieurs menus",
				"saveModifiedBar": "Enregistrer les modifications",
				"addBar": "Ajouter un bar",
				"errors": {
					"printerTypeRequired": "Le champ type d'imprimante est obligatoire",
					"printerNameRequired": "Le champ nom de l'imprimante est obligatoire",
					"printerStockRequired": "Le champ stock de l'imprimante est obligatoire",
					"printerIpFormat": "Le champ IP doit être valide (ex: 192.168.1.1)",
					"pagesToPrintMin": "Le nombre de copies doit être au minimum de {{min}}",
					"pagesToPrintMax": "Le nombre de copies doit être au maximum de {{max}}",
					"validIp": "Le champ IP doit être valide",
					"requiredField": "Champ obligatoire",
					"maxLength": "Le champ doit contenir au maximum {{max}} caractères",
					"pagseguroFieldsRequired": "Compléter les données de Pagseguro"
				},
				"addImage": "Ajouter une image",
				"fileTypeInfo": "Type de fichier: jpeg, pjpeg, png",
				"multiEc": {
					"alertTitle": "Attention",
					"warning": "Tous les terminaux associés à ce bar transacteront avec les informations fournies. Les informations incorrectes peuvent empêcher les transactions!",
					"placeholder": "Entrez le",
					"pagseguroActivationCode": "Code d'activation Pagseguro",
					"checkBox": "Configurer les terminaux du client (EC du client)"
				}
			},
			"printerIps": "Imprimer IP",
			"kds": "Kds",
			"search": "Rechercher",
			"searchBarPlaceholder": "Rechercher par nom du bar",
			"searchProductPlaceholder": "Rechercher par produit",
			"searchCategoryPlaceholder": "Rechercher par catégorie de produit",
			"manageBar": "Gérer le bar",
			"menuTooltipActive": "Menu lié à ce bar et actif",
			"menuTooltipInactive": "Menu lié à ce bar et inactif",
			"stock": "Inventaire",
			"tableRangeSettings": {
				"card": {
					"barsLabel": "Impression sur les bars",
					"title": "Tables {{from}} à {{to}}"
				},
				"deleteModal": {
					"message": "Êtes-vous sûr de vouloir supprimer les tables {{from}} à {{to}} ? Cette action ne peut être annulée.",
					"title": "Supprimer la plage de tables"
				},
				"drawer": {
					"title": "Plage de tables"
				},
				"form": {
					"addIntervalBtn": "Ajouter une autre gamme",
					"bars": {
						"label": "Bars qui imprimeront les commande des tables ci-dessus",
						"placeholder": "Recharcher par nom"
					},
					"editingWarningTooltip": "Il n'est pas possible d'ajouter de nouvelles plages en mode édition.",
					"errors": {
						"atLeastOneBar": "Vous devez sélectionner au moins un bar pour imprimer les commandes des tables ci-dessus. (range {{number}})",
						"fromTableAlreadyUsed": "La première table de la plage (plage {{number}}) est déjà utilisée sur une autre plage.",
						"missingFromTable": "Tapez le numéro de la première table de la gamme (range {{number}})",
						"missingToTable": "Tapez le numéro de la dernière table de la gamme (range {{number}})",
						"toTableAlreadyUsed": "La dernière table de la plage (plage {{number}}) est déjà utilisée sur une autre plage."
					},
					"generalWrapperLabel": "Gamme {{number}}",
					"intervalWrapperLabel": "Gamme de tables",
					"removeIntervalBtn": "Supprimer la gamme",
					"status": {
						"errors": {
							"description": "Il n'a pas été possible d'ajouter la plage. Vérifier s'il n'y a pas un numéro de table déjà utilisé sur une autre plage.",
							"title": "Quelque chose n'a pas fonctionné."
						},
						"success": {
							"titleCreating": "Les plages de tableas ont été créées avec succès !",
							"titleEditing": "Mise à jour réussie."
						}
					}
				},
				"header": {
					"addBtn": "Ajouter une gamme de table",
					"filter": {
						"label": "Filtrer par bar",
						"optionAllLabel": "Tout montrer",
						"placeholder": "Sélectionner ou rechercher un bar"
					}
				},
				"tabs": {
					"generalSettings": "Paramètres généraux",
					"printByTableSettings": "Configurer l'impression par table"
				}
			}
		}
	},
	"fiscalReport": {
		"activeTab": "rapport-fiscal",
		"columns": {
			"date": "Date",
			"emitted": "Facture émise",
			"emittedNfce": "Facture client",
			"emittedNfse": "Facture service",
			"eventName": "Événement",
			"total": "Total",
			"totalReceipt": "Facture à émettre"
		},
		"errorNotification": "Date limite {{date}}",
		"fiscalProfile": "Profil fiscal",
		"period": "Période",
		"sheet": {
			"columns": {
				"date": "Date",
				"emitted": "Factures émises",
				"emittedNfce": "Factures client",
				"emittedNfse": "Factures service",
				"eventName": "Événement",
				"totalReceipt": "Facture à émettre"
			},
			"filename": "rapport_fiscal",
			"title": "Rapport fiscal"
		},
		"title": "Rapport fiscal"
	},
	"guestList": {
		"columns": {
			"active": "ACTIF",
			"description": "Description",
			"expiresAt": "Expiration",
			"inactive": "DÉSACTIVÉ",
			"name": "Nom de la liste",
			"status": "Statut",
			"userCount": "Invités",
			"guest": "Invité"
		},
		"addGuestError": {
			"relationReachesLimit": "La liste a déjà atteint la limite d'invités",
			"userAlreadyExists": "Invité déjà enregistré sur la liste",
			"userWithoutDocument": "Invité sans document"
		},
		"createList": "Créer une liste",
		"guestsNotImported": "Invités non importés",
		"deleteModal": {
			"confirm": "Supprimer la liste",
			"message": "Êtes-vous sûr de vouloir supprimer ces listes ?",
			"title": "Supprimer une liste"
		},
		"emptyList": {
			"defaultMessage": "Il semble que vous n'ayez pas encore créé de liste.",
			"defaultText": "Les listes apparaissent ici lorsque vous avez une liste enregistrée."
		},
		"importList": "Importer une liste",
		"importNewList": {
			"alert": "Avant d'importer le tableau, veillez à ce que toutes les lignes vides soient supprimées.",
			"altText": "Exemple de tableau à importer",
			"errorMessageDefault": "Tableau invalide, téléchargez-le à nouveau et apportez les modifications nécessaires. En cas de lignes vides en rouge, supprimez-les et réessayez.",
			"error": "Erreur",
			"list": "Liste",
			"message": "Message",
			"form": {
				"at": "à",
				"colorSelect": "Assigner une couleur",
				"couvertPercentage": "Réduction sur le couvert",
				"description": {
					"label": "Description",
					"limit": "{{count}} caractères restants",
					"placeholder": "Ajoutez une facture à votre liste si vous le souhaitez"
				},
				"entranceIds": {
					"label": "Entrée associée",
					"placeholder": "Sélectionner le type d'entrée associé"
				},
				"errorExpires": "Date et heure d'expiration.",
				"errorName": "Saisir le nom de la liste",
				"expiresAtDate": "Expiration de la liste",
				"listName": "Nom de la liste",
				"documentIsRequired": "Le document est obligatoire",
				"canBeInvitedByLink": "Partage de liste via lien",
				"addGuestTimeLimit": "Délai limite d'insertion des invités"
			},
			"format": "Format du tableau",
			"goBackModal": {
				"description": "En quittant cette page, vous perdrez toutes les informations que vous avez saisies. Voulez-vous quand même quitter cette page ?",
				"leavePage": "Quitter la page",
				"title": "Quitter"
			},
			"goBackText": "Retour aux listes",
			"importList": "Importer une liste existante dans cet événement",
			"middleTitle": "Pour importer une nouvelle liste, il suffit de télécharger un tableau.",
			"or": "ou",
			"relationUsers": "Clients à ajouter à la liste",
			"secondTitle": "Importer une liste nouvelle ou existante",
			"selectText": "Importer la liste de ce lieu pour cet événement",
			"sheetFileName": "Liste d'invités",
			"successMessage": "Importation réussie du tableau",
			"title": "Importer une nouvelle liste d'invités"
		},
		"infos": {
			"addGuest": "Ajourter invités",
			"addGuestModal": {
				"cpf": {
					"error": "CPF invalide",
					"label": "CPF"
				},
				"name": {
					"error": "Nom invalide",
					"label": "Prénom et nom",
					"placeholder": "Nom complet du client"
				},
				"phone": "Téléphone",
				"promoter": {
					"label": "Promoteur",
					"placeholder": "Saisir le nom du promoteur"
				}
			},
			"columns": {
				"actions": "Actions",
				"cpf": "CPF",
				"emptyText": "Pas de données à afficher.",
				"name": "Nom",
				"phone": "Téléphone",
				"promoter": "Promoteur"
			},
			"couvert": "Résuduction sur couvert",
			"description": {
				"empty": "Aucune description n'a été ajoutée",
				"label": "Description"
			},
			"download": "Liste des téléchargements",
			"edit": "Modifier les informations",
			"editGuest": "Modifier invité",
			"editInfos": "Modifier les informations de la liste",
			"editModal": {
				"color": "Assigner une couleur",
				"couvert": "Réduction sur couvert",
				"description": {
					"label": "Description",
					"limit": "{{limit}} caractères restants",
					"placeholder": "Ajoutez une facture à votre liste si vous le souhaitez"
				},
				"entrance": {
					"label": "Entrée associée",
					"placeholder": "Saisir ou sélectionner le type d'entrée"
				},
				"errors": {
					"description": "La description de la liste doit être inférieure à 280 caractères",
					"emptyName": "Saisir le nom de la liste",
					"expires": "Date et heure d'expiration",
					"length": "Le nom de la liste doit comporter moins de 100 caractères"
				},
				"expiresAt": "Expiration de la liste",
				"name": {
					"label": "Nom de la liste",
					"placeholder": "Spécifiez votre liste de manière à ce qu'elle s'identifie rapidement (nom de la liste - événement - date - lieu)."
				},
				"new": "Nouvelle liste",
				"save": "Enregistrer la modification",
				"title": "Modifier la liste"
			},
			"emptyList": {
				"defaultMessage": "Il semble que vous n'ayez pas enregistré d'invités",
				"importList": "Importer liste",
				"text": "La liste des invités apparaîtra ici lorsque vous aurez enregistré des invités."
			},
			"entrances": {
				"empty": "Aucune entrée associée",
				"error": "Aucune entrée associée avec cette liste",
				"label": "Entrée associée"
			},
			"expires": "Expiration",
			"goBack": "Retour aux listes",
			"guest": "Invité",
			"guests": "Invités",
			"import": "Importer tableau",
			"print": "Imprimer",
			"search": "Recherche d'un invité ou d'un promoteur"
		},
		"list": {
			"delete": {
				"list": "Supprimer une liste",
				"lists": "Supprimer plusieurs listes",
				"permanentlyList": "Supprimer définitivement la liste",
				"permanentlyLists": "Supprimer définitivement des listes",
				"selectedList": "La liste sélectionnée sera définitivement supprimée et ses informations (invités, enregistrement, ticket moyen, entrée, consommation, promoteurs) seront supprimées des rapports. Cette action ne peut être annulée. Voulez-vous quand même continuer ?",
				"selectedLists": "Les listes sélectionnées seront définitivement supprimées et leurs informations (invités, enregistrement, ticket moyen, entrée, consommation, promoteurs) seront supprimées des rapports. Cette action ne peut être annulée. Voulez-vous quand même continuer ?"
			},
			"goBack": "Retour aux listes",
			"import": {
				"description": "Pour importer une liste d'invités, il suffit de télécharger une feuille de calcul",
				"label": "Importer tableau des invités"
			},
			"print": {
				"date": "Date d'émission",
				"description": "Description",
				"discount": "Type de réduction",
				"entrance": "Entrée associée",
				"expiresAt": "Expire le",
				"noEntrance": "Aucune entrée n'est associée à cette liste."
			},
			"sheet": {
				"error": "Tableau invalide, téléchargez-lr à nouveau et apportez les modifications nécessaires. En cas de lignes vides en rouge, supprimez-les et réessayez.",
				"title": "Liste d'invités"
			},
			"success": "Tableau importé avec succès",
			"warning": "Avant d'importer le tableau, veillez à ce que toutes les lignes vides soient supprimées."
		},
		"list_one": "Liste",
		"list_other": "Listes",
		"menuDrop": {
			"delete": "Supprimer",
			"disable": "Désactiver une liste",
			"download": "Télécharger",
			"edit": "Modifier",
			"enable": "Activer une liste",
			"print": "Imprimer"
		},
		"newList": {
			"create": "Créer liste",
			"downloadList": "Télécharger la liste",
			"forms": {
				"firstStep": {
					"colorSelect": "Assigner une couleur",
					"couvertPercentage": "Réduction sur le prix d'entrée",
					"description": {
						"error": "La description de la liste doit être inférieure à 280 caractères",
						"label": "Description",
						"leftCharacters": "{{count}} caractères restants",
						"placeholder": "Ajoutez une note à votre liste si vous le souhaitez"
					},
					"canBeInvitedByLink": {
						"label": "Partage de liste via link",
						"error": "Pour qu'une liste soit partageable, une limite d'invités est requise"
					},
					"isDocumentRequired": {
						"label": "CPF requis"
					},
					"hasAutomaticEntranceCharge": {
						"label": "Facturer l'entrée automatiquement"
					},
					"entranceIds": {
						"label": "Entrée associée",
						"placeholder": "Sélectionner le type d'entrée associé"
					},
					"expiresAtDate": {
						"at": "le",
						"error": "Date et heure d'expiration",
						"label": "Expiration de la liste"
					},
					"addGuestTimeLimit": "Délai limite d'insertion des invités",
					"name": {
						"errorLength": "Le nom de la liste doit comporter moins de 100 caractères",
						"errorName": "Saisir le nom de la liste",
						"label": "Nom de la liste",
						"placeholder": "Saisissez ici le nom de votre liste"
					},
					"guestsLimitByPromoter": {
						"label": "Limite d'invités par promoteur",
						"placeholder": "Entrez le nombre limite"
					},
					"guestsLimit": {
						"label": "Limite d'invités",
						"placeholder": "Entrez le nombre limite"
					},
					"title": "Nouvelle liste"
				},
				"lastStep": {
					"cardTitle": "Télécharger/Imprimer",
					"title": "Liste créée avec succès"
				},
				"secondStep": {
					"addNewClient": "Ajouter un invité",
					"cpf": {
						"duplicate": "Dupliquer CPF",
						"error": "CPF invalide",
						"label": "CPF"
					},
					"label": "Vous pouvez ajouter manuellement des invités ou importer tableau. Si vous le souhaitez, vous pouvez ajouter ou importer des invités ultérieurement.",
					"name": {
						"error": "Nom invalide",
						"label": "Prénom et nom",
						"placeholder": "Entrez le nom de l'invité"
					},
					"phone": "Téléphone",
					"promoter": {
						"label": "Nom du promoteur",
						"placeholder": "Nom de la personne responsable de la liste"
					},
					"successImport": "Importation du tableau réussie",
					"title": "Client {{count}}"
				}
			},
			"goBackToLists": "Retour aux listes",
			"print": "Print",
			"list": "Liste",
			"steps": {
				"first": {
					"description": "Importation du tableau réussie",
					"title": "Liste des données"
				},
				"last": {
					"description": "Télécharger et imprimer",
					"title": "Préparer la liste"
				},
				"second": {
					"description": "Qui sont vos clients ?",
					"title": "Clients"
				}
			},
			"title": "Nouvelle liste d'invits",
			"view": "Voir la liste créée"
		},
		"promoter": {
			"promoter": {
				"title": "Promoteurs",
				"promoter": {
					"menu": {
						"deactivate": "Désactiver",
						"activate": "Activer",
						"edit": "Éditer"
					},
					"table": {
						"name": "Nom",
						"email": "E-mail",
						"phone": "Téléphone",
						"accessLevel": "Niveau d'accès",
						"active": "Actif",
						"pending": "En attente",
						"inactive": "Inactif"
					},
					"content": {
						"titleAddPromoter": "Ajouter un promoteur",
						"titleEditPromoter": "Modifier le promoteur"
					},
					"header": {
						"title": "Promoteurs",
						"text": "Zone du promoteur:",
						"promoter": "promoteur",
						"promoters": "promoteurs",
						"buttonAddPromoter": "Ajouter un promoteur",
						"buttonCopyPromoter": "Copier",
						"buttonCopyPromoterSuccess": "Lien copié",
						"buttonSearch": "Rechercher",
						"active": "Actif",
						"inactive": "Inactif",
						"pending": "En attente"
					},
					"addPromoter": {
						"subtitle": "Envoyer une invitation à:",
						"textAddPromoter": "Saisissez l'e-mail du promoteur auquel vous souhaitez accorder l'accès aux listes d'invités.",
						"messageAddPromoter": "Pour ajouter plusieurs promoteurs, séparez simplement les e-mails par des virgules (,)",
						"buttonInvite": "Envoyer une invitation",
						"successTittle": "Invitation envoyée avec succès !",
						"successText": "L'invitation a été envoyée aux e-mails enregistrés",
						"successButton": "Ajouter un promoteur"
					},
					"editPromoter": {
						"textStatusPromoter": "Statut",
						"textLevelPromoter": "Niveau d'accès",
						"name": "Nom",
						"email": "Email",
						"phone": "Téléphone",
						"messageLevelPromoter": "Peut afficher les événements, ajouter et modifier les invités dans les listes",
						"messageToolTipPromoter": "Le statut détermine si le promoteur a accès à vos listes",
						"pendingStatus": "En attente",
						"buttonInvite": "Renvoyer l'invitation",
						"buttonInviteSave": "Enregistrer les modifications",
						"successTittle": "Invitation envoyée avec succès !",
						"successText": "L'invitation a été envoyée aux e-mails enregistrés",
						"successButton": "Ajouter un promoteur",
						"active": "Actif",
						"inactive": "Inactif"
					},
					"store": {
						"messageActive": "Utilisateur activé avec succès",
						"messageDeactive": "Utilisateur désactivé avec succès",
						"messageSuccess": "Invitation renvoyée avec succès",
						"messageEdit": "Données du promoteur modifiées avec succès"
					}
				}
			},
			"report": {
				"empty": {
					"filters": {
						"subtitle": "Sélectionnez une autre option et réessayez",
						"title": "Aucun résultat n'a été trouvé pour cette sélection."
					},
					"noneList": {
						"subtitle": "Les rapports apparaissent ici lorsque vous avez une liste enregistrée.",
						"title": "Les rapports apparaitront ici lorsque vous avez une liste enregistrée."
					},
					"search": "Nous n'avons pas trouvé de résultats pour votre recherche."
				},
				"file": {
					"checkinDetails": "Détails des entrées",
					"consumptionTotal": "Total de consommation",
					"document": "CPF",
					"entranceTotal": "Total d'entrées",
					"entranceType": "type d'entrées",
					"filename": "rapport-liste-invités",
					"listName": "Nom de la liste",
					"name": "Nom",
					"numberOfActiveGuests": "Enregistrement effectué",
					"numberOfGuests": "Total invités",
					"promoter": "Promoteur",
					"titleByGuestList": "Rapport par liste d'invités",
					"titleGeneral": "Rapport général",
					"total": "Total Général",
					"upgrade": "Amélioration de l'entrée",
					"phone": "Téléphone",
					"birthDate": "Date de naissance"
				},
				"filters": {
					"period": "Période",
					"promoter": {
						"placeholder": "Ajouter un filtre par promoteur",
						"title": "Filtrer par promoteur"
					},
					"relation": {
						"placeholder": "Ajouter des filtres par liste",
						"title": "Filtrer par liste d'invités"
					}
				},
				"search": "Rechercher",
				"tabs": {
					"byList": {
						"columns": {
							"consumptionTotal": "Total de la consommation",
							"entranceTotal": "Total en entrées",
							"guests": "Invités",
							"promoters": "Promoteurs",
							"relationLists": "Listes",
							"total": "Total Général"
						},
						"title": "Par liste d'invités"
					},
					"general": {
						"cards": {
							"consumptionTotal": "Total de consommation",
							"entranceTotal": "Total d'entrées",
							"guests": "Invités",
							"promoters": "Promoteurs",
							"relationLists": "Listes",
							"total": "Total Général"
						},
						"columns": {
							"checkin": "Détails des entrées",
							"consumption": "Consommation",
							"cpf": "CPF",
							"entrance": "Type d'entrée",
							"generalTotal": "Total Général",
							"guestName": "Nom",
							"listName": "Liste",
							"promoter": "Promoteur",
							"upgradeEntrance": "Mise à niveau des entrées",
							"phone": "Téléphone",
							"birthDate": "Date de naissance"
						},
						"title": "Vue d'ensemble"
					}
				},
				"templateTitle": "Rapport Général",
				"title": "Rapports"
			},
			"searchList": "rechercher liste",
			"sheet": {
				"columns": {
					"cpf": "CPF",
					"name": "Nom",
					"phone": "Téléphone",
					"promoter": "Promoteur"
				},
				"error": "Tableau invalide",
				"example": "liste (exemple)",
				"filename": "liset_{{name}}",
				"title": "Liste : {{name}}"
			},
			"title": "Liste d'invités",
			"utils": {
				"expires": "Expire",
				"expiresAt": "Expire le",
				"hasExpired": "Expiré le",
				"insertLastName": "Insérer un nom de famille",
				"invalidName": "Nom invalide"
			}
		},
		"importXml": {
			"duplicatesCardInfo": {
				"dueDate": "Date d'échéance",
				"subtitle": "Dupliquer",
				"title": "Duplicatas",
				"value": "Montant"
			},
			"invoicecCardInfo": {
				"CFOP": "CFOP",
				"CNPJAndCPF": "CNPJ/CPF",
				"accesskey": "Clé d'accès",
				"amount": "Quantité",
				"billNumber": "Numéro de facture",
				"issuer": "Émetteur",
				"natureOfOperation": "Nature de l'opération",
				"noteData": "Données de facture",
				"noteSeries": "Séries de facture",
				"title": "Données Facture"
			},
			"paymentCardInfo": {
				"cashPayment": "En espèces",
				"installmentsPayment": "Versements",
				"payment": "Paiement"
			},
			"productCard": {
				"code": "SKU:",
				"costPricePerUnit": "Prix par unité",
				"costTypeOptions": {
					"total": "au total",
					"unit": "par unité",
					"milliliter": "par millilitre",
					"gram": "par gramme",
					"kilogram": "par kilogramme",
					"litre": "par litre"
				},
				"equivalentProduct": "Produit équivalent",
				"equivalentUnit": "1 {{product}} équivalent",
				"infoProduct": "Produit \"{{nameProduct}}\" ignoré",
				"quantities": "Qté :",
				"restoreproduct": "Cliquez ici pour restaurer",
				"unit": "Unité :",
				"unitPrice": "Prix unitaire :",
				"chartAccount": "Plan de comptes",
				"chartAccountPlaceholder": "Sélectionner un compte"
			},
			"stockItens": "Articles en stock",
			"title": "Import XML"
		},
		"invoicesIva": {
			"columns": {
				"actions": {
					"cancel": {
						"okText": "Oui, annuler la facture",
						"title": "Êtes-vous sûr de vouloir annuler la facture ?"
					},
					"cancelUnnavailable": {
						"okText": "Ok",
						"title": "Les factures émises il y a plus de 30 minutes ne peuvent pas être annulées"
					},
					"image": "Image",
					"pdf": "PDF",
					"title": "Actions",
					"json": "JSON",
					"cancelledJson": "JSON de cancelación",
					"xml": "XML",
					"cancelledXml": "XML de cancelación",
					"downloadXml": "Télécharger XML",
					"downloadJson": "Télécharger JSON"
				},
				"tooltips": {
					"nc": "Note de crédit / Note annulée",
					"ft": "Facture / Factures"
				},
				"eventDate": "Date de l'événement",
				"fiscalProfile": "Profil fiscal",
				"isCanceled": "Annulé",
				"issuedAt": "Émise le",
				"mode": "Mode d'émission",
				"transaction": "Transaction",
				"errorMsg": "Erreur",
				"recharge": "Recharge",
				"employee": "Employé",
				"number": "Numéro de facture",
				"serie": "Séries de facture",
				"value": "Montant de la facture",
				"expirationDate": "Date d'expiration",
				"status": {
					"label": "Statut",
					"pending": "En attente de création",
					"waiting": "En attente de délivrance"
				}
			},
			"downloadXML": "Télécharger XML",
			"descriptionForeign": "Ce rapport affiche les Factures et les Avoirs émis, permettant de filtrer par période, profil fiscal, employé, type de facture (Facture et Avoir) et type d'article (Recharge ou Produit)",
			"descriptionForeignMEX": "Ce rapport montre toutes les Notes en attente, ce qui signifie 1) celles qui ont été reçues par le système mais n'ont pas été émises pour une raison quelconque et 2) celles pour lesquelles une commande d'auto-émission a été créée et attend que le client les émette. Il permet de voir le message d'erreur associé à chaque Note en attente.",
			"downloadJSON": "Télécharger JSON",
			"missing": {
				"columns": {
					"actions": "Actions",
					"date": "Date",
					"number": "Numéro",
					"employee": "Employé",
					"serie": "Séries"
				},
				"download": "Télécharger XML",
				"fiscalProfileLabel": "Filtrar por perfil fiscal",
				"employeeLabel": "Filtrar por empleado",
				"invoiceTypeLabel": "Filtrar tipo de documento",
				"documentId": "Identifiant",
				"pendingAutoissuanceOrders": "Total brut en attente",
				"itemTypeLabel": "Filtrer le type d'article",
				"recharges": "Recharges",
				"products": "Produits",
				"zigSystemEmployee": "ZIG (sistema)",
				"creditInvoiceLabel": "Notas de crédito",
				"invoiceLabel": "Facturas",
				"fiscalProfile": "Profil fiscal",
				"period": "Période",
				"descriptionForeign": "Ce rapport montre toutes les Notes en attente, c'est-à-dire celles qui sont arrivées dans le système mais n'ont pas été émises pour une raison quelconque. Il permet de visualiser le message d'erreur associé à chaque Note en attente.",
				"selectFiscalProfile": "Sélectionner un profil fiscal",
				"title": "Factures manquantes",
				"titleForeign": "Factures en suspens"
			},
			"modelLabel": {
				"ivaVendus": "TVA - Vendus",
				"ivaFactura": "TVA - Factura",
				"nfce": "NFC-e",
				"nfse": "NFS-e",
				"nfsen": "NFS-e Nacional",
				"sat": "SAT"
			},
			"period": "Période",
			"sheet": {
				"columns": {
					"eventDate": "Date de l'événement",
					"fiscalProfile": "Profil fiscal",
					"imgUrl": "URL Image",
					"isCanceled": "Annulé",
					"issuedAt": "Émis le",
					"transaction": "Transaction",
					"recharge": "Recharge",
					"employee": "Employé",
					"mode": "Mode d'émission",
					"number": "Numéro de facture",
					"pdfUrl": "URL PDF",
					"serie": "Séries de facture",
					"value": "Montant de la facture",
					"xml": "XML",
					"json": "JSON"
				},
				"filename": "factures",
				"title": "Factures"
			},
			"title": "Factures",
			"downloadBackupModal": {
				"title": "Télécharger des fichiers XML",
				"placeholder": "Sélectionner",
				"error": "Erreur : {{error}}",
				"empty": "Aucune sauvegarde disponible",
				"content": "Pour télécharger ce nombre de fichiers, il est nécessaire de télécharger le mois entier.",
				"selectMonth": "Sélectionnez ci-dessous le mois de référence à télécharger."
			},
			"filters": {
				"zigSystemEmployee": "ZIG (système)",
				"fiscalProfileLabel": "Filtre par profil fiscal",
				"employeeLabel": "Filtre par employé",
				"invoiceItemType": "Filtrer par type d'article",
				"invoiceItemTypeProduct": "Produits",
				"invoiceItemTypeRecharge": "Recharges",
				"invoiceType": "Filtre sur le type de facture",
				"invoiceTypeAll": "Toutes les factures",
				"invoiceTypeWithCreditInvoice": "Factures avec factures de crédit",
				"invoiceTypeWithoutCreditInvoice": "Factures sans facture de crédit"
			}
		},
		"invoicesNational": {
			"title": "Factures",
			"description": "Télécharger des factures individuelles ou groupées émises au cours de la période sélectionnée.",
			"acitons": {
				"exportToExcel": "Exporter vers Excel",
				"downloadXml": "Télécharger XML"
			},
			"filters": {
				"fiscalProfileLabel": "Profil fiscal",
				"invoiceNumberLabel": "Numéro de facture",
				"invoiceNumberPlaceholder": "Rechercher par numéro de facture",
				"rangePickerLabel": "Période d'émission",
				"statusLabel": "Statut",
				"allInvoices": "Toutes les factures fiscales",
				"canceledInvoices": "Factures fiscales annulées"
			},
			"table": {
				"issuedAt": "Émis à",
				"mode": "Mode d'émission",
				"createdBy": "Employé",
				"fiscalProfile": "Profil fiscal",
				"eventDate": "Date de l'événement",
				"isCanceled": "Annulé",
				"serie": "Note série",
				"num": "Numéro de note",
				"value": "Notez la valeur",
				"actions": "Actions",
				"downloadInvoice": {
					"download": "Télécharger",
					"pdf": "PDF",
					"image": "Image",
					"xml": "XML",
					"cancelXml": "Annuler XML"
				},
				"cancelInvoice": {
					"yesCancel": "Oui, annuler la facture",
					"confirm": "ok",
					"areYouSure": "Êtes-vous sûr de vouloir annuler la facture ?",
					"cancel": "Annuler"
				},
				"paginationTotal": " sur {{total}}"
			}
		},
		"invoicesBackups": {
			"title": "Sauvegardes",
			"description": "Fichiers de factures émises par mois.",
			"filters": {
				"fiscalProfile": {
					"label": "Profil fiscal",
					"placeholder": "Rechercher par profil fiscal"
				}
			},
			"table": {
				"fiscalProfile": "Profil fiscal",
				"month": "Mois",
				"files": "Fichiers",
				"downloadDanfes": "Télécharger les DANFE",
				"downloadXmls": "Télécharger des XML",
				"unavaliable": "indisponible"
			}
		},
		"kardex": {
			"at": "le",
			"destiny": "Destiné",
			"download": "Télécharger tableau",
			"seeProduct": "Voir le produit",
			"applyFilters": "Appliquer les filtres",
			"emptyState": {
				"title": "Sélectionnez le stock pour commencer",
				"description": "Sélectionnez le stock, le produit et la période pour consulter le fichier Kardex du produit"
			},
			"header": {
				"count": "Quantité",
				"date": "Date",
				"obs": "Observation",
				"employeeName": "Employé",
				"ending": "Solde final",
				"initial": "Solde initial",
				"noValue": "Montant non renseigné",
				"note": "Facture",
				"type": "Transaction",
				"unitCostValue": "Coût unitaire",
				"selectStock": "Sélectionnez le stock",
				"selectProduct": "Sélectionnez le produit",
				"applyFilters": "Appliquer les filtres",
				"description": "Sélectionnez le stock, le produit et la période pour consulter le fichier Kardex du produit"
			},
			"label": "Stock",
			"nameNotFound": "Nom introuvable",
			"origin": "Origine",
			"period": "Période",
			"product": "Produit",
			"storage": "Stock",
			"title": "Carte Kardex",
			"dateFilterBy": {
				"label": "Filtrer les données par",
				"options": {
					"events": "Événements entre intervalle",
					"interval": "Tout entre intervalle"
				}
			},
			"transferTypeTranslate": {
				"cardExchange": "Échange contre une carte",
				"input": "Entre",
				"inventory": "Stock",
				"invoice": "Facturer l'entrée",
				"lost": "Perte",
				"manual": "Ajustement manuel",
				"productionIn": "Entrée Production",
				"productionLost": "Perte Production",
				"productionOut": "Sortie de production",
				"productionOutTo": "Production pour",
				"refund": "Perte sur les remboursements",
				"sell": "Vendre",
				"transferIn": "Virement (entrée)",
				"transferOut": "Virement (sortie)"
			}
		},
		"multivendor": {
			"debtorsReport": {
				"title": "Factures Impayées",
				"filters": {
					"vendor": "Fournisseur",
					"period": "Période"
				},
				"table": {
					"name": "Nom",
					"email": "E-mail",
					"phone": "Téléphone",
					"accessLevel": "Niveau d'accès",
					"active": "Actif",
					"pending": "En attente",
					"inactive": "Inactif"
				},
				"content": {
					"titleAddPromoter": "Ajouter un promoteur",
					"titleEditPromoter": "Modifier le promoteur"
				},
				"header": {
					"title": "Promoteurs",
					"text": "Zone du promoteur:",
					"promoter": "promoteur",
					"promoters": "promoteurs",
					"buttonAddPromoter": "Ajouter un promoteur",
					"buttonCopyPromoter": "Copier",
					"buttonCopyPromoterSuccess": "Lien copié",
					"buttonSearch": "Rechercher",
					"active": "Actif",
					"inactive": "Inactif",
					"pending": "En attente"
				},
				"addPromoter": {
					"subtitle": "Envoyer une invitation à:",
					"textAddPromoter": "Saisissez l'e-mail du promoteur auquel vous souhaitez accorder l'accès aux listes d'invités.",
					"messageAddPromoter": "Pour ajouter plusieurs promoteurs, séparez simplement les e-mails par des virgules (,)",
					"buttonInvite": "Envoyer une invitation",
					"successTittle": "Invitation envoyée avec succès !",
					"successText": "L'invitation a été envoyée aux e-mails enregistrés",
					"successButton": "Ajouter un promoteur"
				},
				"editPromoter": {
					"textStatusPromoter": "Statut",
					"textLevelPromoter": "Niveau d'accès",
					"name": "Nom",
					"email": "Email",
					"phone": "Téléphone",
					"messageLevelPromoter": "Peut afficher les événements, ajouter et modifier les invités dans les listes",
					"messageToolTipPromoter": "Le statut détermine si le promoteur a accès à vos listes",
					"pendingStatus": "En attente",
					"buttonInvite": "Renvoyer l'invitation",
					"buttonInviteSave": "Enregistrer les modifications",
					"successTittle": "Invitation envoyée avec succès !",
					"successText": "L'invitation a été envoyée aux e-mails enregistrés",
					"successButton": "Ajouter un promoteur",
					"active": "Actif",
					"inactive": "Inactif"
				},
				"store": {
					"messageActive": "Utilisateur activé avec succès",
					"messageDeactive": "Utilisateur désactivé avec succès",
					"messageSuccess": "Invitation renvoyée avec succès",
					"messageEdit": "Données du promoteur modifiées avec succès"
				}
			}
		},
		"report": {
			"empty": {
				"filters": {
					"subtitle": "Sélectionnez une autre option et réessayez",
					"title": "Aucun résultat n'a été trouvé pour cette sélection."
				},
				"noneList": {
					"subtitle": "Les rapports apparaissent ici lorsque vous avez une liste enregistrée.",
					"title": "Les rapports apparaitront ici lorsque vous avez une liste enregistrée."
				},
				"search": "Nous n'avons pas trouvé de résultats pour votre recherche."
			},
			"file": {
				"checkinDetails": "Détails des entrées",
				"consumptionTotal": "Total de consommation",
				"document": "CPF",
				"entranceTotal": "Total d'entrées",
				"entranceType": "type d'entrées",
				"filename": "rapport-liste-invités",
				"listName": "Nom de la liste",
				"name": "Nom",
				"numberOfActiveGuests": "Enregistrement effectué",
				"numberOfGuests": "Total invités",
				"promoter": "Promoteur",
				"titleByGuestList": "Rapport par liste d'invités",
				"titleGeneral": "Rapport général",
				"total": "Total Général",
				"upgrade": "Amélioration de l'entrée",
				"phone": "Téléphone",
				"birthDate": "Date de naissance"
			},
			"filters": {
				"period": "Période",
				"promoter": {
					"placeholder": "Ajouter un filtre par promoteur",
					"title": "Filtrer par promoteur"
				},
				"relation": {
					"placeholder": "Ajouter des filtres par liste",
					"title": "Filtrer par liste d'invités"
				}
			},
			"search": "Rechercher",
			"tabs": {
				"byList": {
					"columns": {
						"consumptionTotal": "Total de la consommation",
						"entranceTotal": "Total en entrées",
						"guests": "Invités",
						"promoters": "Promoteurs",
						"relationLists": "Listes",
						"total": "Total Général"
					},
					"title": "Par liste d'invités"
				},
				"general": {
					"cards": {
						"consumptionTotal": "Total de consommation",
						"entranceTotal": "Total d'entrées",
						"guests": "Invités",
						"promoters": "Promoteurs",
						"relationLists": "Listes",
						"total": "Total Général"
					},
					"columns": {
						"checkin": "Détails des entrées",
						"consumption": "Consommation",
						"cpf": "CPF",
						"entrance": "Type d'entrée",
						"generalTotal": "Total Général",
						"guestName": "Nom",
						"listName": "Liste",
						"promoter": "Promoteur",
						"upgradeEntrance": "Mise à niveau des entrées",
						"phone": "Téléphone",
						"birthDate": "Date de naissance"
					},
					"title": "Vue d'ensemble"
				}
			},
			"templateTitle": "Rapport Général",
			"title": "Rapports"
		},
		"searchList": "rechercher liste",
		"sheet": {
			"columns": {
				"cpf": "CPF",
				"name": "Nom",
				"phone": "Téléphone",
				"promoter": "Promoteur"
			},
			"error": "Tableau invalide",
			"example": "liste (exemple)",
			"filename": "liset_{{name}}",
			"title": "Liste : {{name}}"
		},
		"title": "Liste d'invités",
		"utils": {
			"expires": "Expire",
			"expiresAt": "Expire le",
			"hasExpired": "Expiré le",
			"insertLastName": "Insérer un nom de famille",
			"invalidName": "Nom invalide"
		}
	},
	"importXml": {
		"duplicatesCardInfo": {
			"dueDate": "Date d'échéance",
			"subtitle": "Dupliquer",
			"title": "Duplicatas",
			"value": "Montant"
		},
		"invoicecCardInfo": {
			"CFOP": "CFOP",
			"CNPJAndCPF": "CNPJ/CPF",
			"accesskey": "Clé d'accès",
			"amount": "Quantité",
			"billNumber": "Numéro de facture",
			"issuer": "Émetteur",
			"natureOfOperation": "Nature de l'opération",
			"noteData": "Données de facture",
			"noteSeries": "Séries de facture",
			"title": "Données Facture"
		},
		"paymentCardInfo": {
			"cashPayment": "En espèces",
			"installmentsPayment": "Versements",
			"payment": "Paiement"
		},
		"productCard": {
			"code": "SKU:",
			"costPricePerUnit": "Prix par unité",
			"costTypeOptions": {
				"total": "au total",
				"unit": "par unité",
				"milliliter": "par millilitre",
				"gram": "par gramme",
				"kilogram": "par kilogramme",
				"litre": "par litre"
			},
			"equivalentProduct": "Produit équivalent",
			"equivalentUnit": "1 {{product}} équivalent",
			"infoProduct": "Produit \"{{nameProduct}}\" ignoré",
			"quantities": "Qté :",
			"restoreproduct": "Cliquez ici pour restaurer",
			"unit": "Unité :",
			"unitPrice": "Prix unitaire :"
		},
		"stockItens": "Articles en stock",
		"title": "Import XML"
	},
	"invoices": {
		"columns": {
			"actions": {
				"cancel": {
					"okText": "Oui, annuler la facture",
					"title": "Êtes-vous sûr de vouloir annuler la facture ?"
				},
				"cancelUnnavailable": {
					"okText": "Ok",
					"title": "Les factures émises il y a plus de 30 minutes ne peuvent pas être annulées"
				},
				"image": "Image",
				"pdf": "PDF",
				"title": "Actions",
				"json": "JSON",
				"cancelledJson": "JSON de cancelación",
				"xml": "XML",
				"cancelledXml": "XML de cancelación",
				"downloadXml": "Télécharger XML",
				"downloadJson": "Télécharger JSON"
			},
			"tooltips": {
				"nc": "Note de crédit / Note annulée",
				"ft": "Facture / Factures"
			},
			"eventDate": "Date de l'événement",
			"fiscalProfile": "Profil fiscal",
			"isCanceled": "Annulé",
			"issuedAt": "Émise le",
			"mode": "Mode d'émission",
			"transaction": "Transaction",
			"errorMsg": "Erreur",
			"recharge": "Recharge",
			"employee": "Employé",
			"number": "Numéro de facture",
			"serie": "Séries de facture",
			"value": "Montant de la facture",
			"expirationDate": "Date d'expiration",
			"status": {
				"label": "Statut",
				"pending": "En attente de création",
				"waiting": "En attente de délivrance"
			}
		},
		"downloadXML": "Télécharger XML",
		"descriptionForeign": "Ce rapport affiche les Factures et les Avoirs émis, permettant de filtrer par période, profil fiscal, employé, type de facture (Facture et Avoir) et type d'article (Recharge ou Produit)",
		"descriptionForeignMEX": "Ce rapport montre toutes les Notes en attente, ce qui signifie 1) celles qui ont été reçues par le système mais n'ont pas été émises pour une raison quelconque et 2) celles pour lesquelles une commande d'auto-émission a été créée et attend que le client les émette. Il permet de voir le message d'erreur associé à chaque Note en attente.",
		"downloadJSON": "Télécharger JSON",
		"missing": {
			"columns": {
				"actions": "Actions",
				"date": "Date",
				"number": "Numéro",
				"employee": "Employé",
				"serie": "Séries"
			},
			"download": "Télécharger XML",
			"fiscalProfileLabel": "Filtrar por perfil fiscal",
			"employeeLabel": "Filtrar por empleado",
			"invoiceTypeLabel": "Filtrar tipo de documento",
			"documentId": "Identifiant",
			"pendingAutoissuanceOrders": "Total brut en attente",
			"itemTypeLabel": "Filtrer le type d'article",
			"recharges": "Recharges",
			"products": "Produits",
			"zigSystemEmployee": "ZIG (sistema)",
			"creditInvoiceLabel": "Notas de crédito",
			"invoiceLabel": "Facturas",
			"fiscalProfile": "Profil fiscal",
			"period": "Période",
			"descriptionForeign": "Ce rapport montre toutes les Notes en attente, c'est-à-dire celles qui sont arrivées dans le système mais n'ont pas été émises pour une raison quelconque. Il permet de visualiser le message d'erreur associé à chaque Note en attente.",
			"selectFiscalProfile": "Sélectionner un profil fiscal",
			"title": "Factures manquantes",
			"titleForeign": "Factures en suspens"
		},
		"modelLabel": {
			"ivaVendus": "TVA - Vendus",
			"ivaFactura": "TVA - Factura",
			"nfce": "NFC-e",
			"nfse": "NFS-e",
			"nfsen": "NFS-e Nacional",
			"sat": "SAT"
		},
		"period": "Période",
		"sheet": {
			"columns": {
				"eventDate": "Date de l'événement",
				"fiscalProfile": "Profil fiscal",
				"imgUrl": "URL Image",
				"isCanceled": "Annulé",
				"issuedAt": "Émis le",
				"transaction": "Transaction",
				"recharge": "Recharge",
				"employee": "Employé",
				"mode": "Mode d'émission",
				"number": "Numéro de facture",
				"pdfUrl": "URL PDF",
				"serie": "Séries de facture",
				"value": "Montant de la facture",
				"xml": "XML",
				"json": "JSON"
			},
			"filename": "factures",
			"title": "Factures"
		},
		"title": "Factures",
		"downloadBackupModal": {
			"title": "Télécharger des fichiers XML",
			"placeholder": "Sélectionner",
			"error": "Erreur : {{error}}",
			"empty": "Aucune sauvegarde disponible",
			"content": "Pour télécharger ce nombre de fichiers, il est nécessaire de télécharger le mois entier.",
			"selectMonth": "Sélectionnez ci-dessous le mois de référence à télécharger."
		},
		"filters": {
			"zigSystemEmployee": "ZIG (système)",
			"fiscalProfileLabel": "Filtre par profil fiscal",
			"employeeLabel": "Filtre par employé",
			"invoiceItemType": "Filtrer par type d'article",
			"invoiceItemTypeProduct": "Produits",
			"invoiceItemTypeRecharge": "Recharges",
			"invoiceType": "Filtre sur le type de facture",
			"invoiceTypeAll": "Toutes les factures",
			"invoiceTypeWithCreditInvoice": "Factures avec factures de crédit",
			"invoiceTypeWithoutCreditInvoice": "Factures sans facture de crédit"
		}
	},
	"kardex": {
		"at": "le",
		"destiny": "Destiné",
		"download": "Télécharger tableau",
		"seeProduct": "Voir le produit",
		"applyFilters": "Appliquer les filtres",
		"emptyState": {
			"title": "Sélectionnez le stock pour commencer",
			"description": "Sélectionnez le stock, le produit et la période pour consulter le fichier Kardex du produit"
		},
		"header": {
			"count": "Quantité",
			"date": "Date",
			"employeeName": "Employé",
			"ending": "Solde final",
			"initial": "Solde initial",
			"noValue": "Montant non renseigné",
			"note": "Facture",
			"type": "Transaction",
			"unitCostValue": "Coût unitaire.",
			"selectStock": "Sélectionnez le stock",
			"selectProduct": "Sélectionnez le produit",
			"applyFilters": "Appliquer les filtres",
			"description": "Sélectionnez le stock, le produit et la période pour consulter le fichier Kardex du produit"
		},
		"label": "Stock",
		"nameNotFound": "Nom introuvable",
		"origin": "Origine",
		"period": "Période",
		"product": "Produit",
		"storage": "Stock",
		"title": "Carte Kardex",
		"dateFilterBy": {
			"label": "Filtrer les données par",
			"options": {
				"events": "Événements entre intervalle",
				"interval": "Tout entre intervalle"
			}
		},
		"transferTypeTranslate": {
			"cardExchange": "Échange contre une carte",
			"input": "Entre",
			"inventory": "Stock",
			"invoice": "Facturer l'entrée",
			"lost": "Perte",
			"manual": "Ajustement manuel",
			"productionIn": "Entrée Production",
			"productionLost": "Perte Production",
			"productionOut": "Sortie de production",
			"productionOutTo": "Production pour",
			"refund": "Perte sur les remboursements",
			"sell": "Vendre",
			"transferIn": "Virement (entrée)",
			"transferOut": "Virement (sortie)"
		}
	},
	"multivendor": {
		"debtorsReport": {
			"title": "Factures Impayées",
			"filters": {
				"vendor": "Fournisseur",
				"period": "Période"
			},
			"table": {
				"title": "Rapport des Factures Impayées",
				"filename": "rapport_des_factures_impayees__{{vendor}}__{{date}}",
				"totalizer": {
					"totalOpen": "Total Impayé",
					"paidAfterEvent": "Payé Après l'Événement",
					"clients": "Clients",
					"stillOpen": "Toujours Impayé"
				},
				"columns": {
					"userName": "Nom",
					"userDocument": "Document",
					"phone": "Téléphone",
					"totalOpen": "Total Impayé",
					"paidAfterEvent": "Payé Après l'Événement",
					"stillOpen": "Toujours Impayé"
				}
			}
		},
		"closings": {
			"calendar": {
				"toReceive": "À recevoir",
				"totalSoldValue": "Montant total"
			},
			"choosePeriod": "Choisir la période pour exporter le tableau",
			"download": "télécharger tableau",
			"modal": {
				"details": "Détails du jour",
				"eventDate": "Date de l'événement",
				"fixedFee": "Frais de location fixes",
				"generalFeeValue": "Frais généraux variables",
				"generalPercentageFee": "Frais variables sur la facturation",
				"otherProductsFeeValue": "Frais variables sur les produits spéciaux",
				"payDate": "Date de paiement",
				"totalSoldValue": "Total Facturation",
				"vendorName": "Vendeur",
				"vendorValueToReceive": "Montant à percevoir"
			},
			"sheet": {
				"columns": {
					"eventDate": "Date de l'événement",
					"fixedFee": "Frais de location fixes",
					"generalFeeValue": "Frais généraux variables",
					"generalPercentageFee": "Frais variables sur la facturation",
					"otherProductsFeeValue": "Frais variables sur les produits spéciaux",
					"payDate": "Date de paiement",
					"totalSoldValue": "Total Facturation",
					"vendorName": "vendeur",
					"vendorValueToReceive": "Montant à percevoir"
				},
				"filename": "clôture-vendeurs",
				"title": "Clôture du vendeur"
			},
			"title": "Clôture par vendeur"
		},
		"extract": {
			"adjustments": {
				"add": "Ajouter nouveau paramètre",
				"deleteAdjustmentSuccess": "Adaptation supprimée",
				"originalPayDate": "Date d'éligibilité",
				"date": "Date de règlement",
				"obs": "Commentaire",
				"title": {
					"label": "Nom de l'ajustement",
					"placeholder": "Saisir le nom de l'ajustement"
				},
				"type": {
					"label": "Type d'ajustement",
					"vendorShouldPay": "Paiement au vendeur",
					"vendorShouldReceive": "À recevoir du vendeur"
				},
				"value": "Montant",
				"vendor": {
					"label": "Ajustement du vendeur au lancement",
					"placeholder": "Sélectionner le vendeur pour lancer les ajustements"
				},
				"electrical": "Électrique",
				"hydraulics": "Hydraulique",
				"cleaning": "Nettoyage",
				"supply": "Approvisionnement",
				"other": "Autre",
				"category": "Catégorie",
				"categoryPlaceholder": "Sélectionnez une catégorie"
			},
			"period": "Période",
			"placeAvaliable": "votre solde disponible",
			"requiredField": "Champ obligatoire",
			"tabs": {
				"adjustments": {
					"add": "Ajouter Ajustment",
					"columns": {
						"originalPayDate": "Date d'éligibilité",
						"date": "Date de règlement",
						"obs": "Commentaire",
						"title": "Nom",
						"value": "Montant",
						"vendorName": "Nom du vendeur"
					},
					"export": "Exporter tableau",
					"sheet": {
						"columns": {
							"originalPayDate": "Date d'éligibilité",
							"date": "Date de règlement",
							"obs": "Commentaire",
							"title": "Nom",
							"value": "Montant",
							"vendorName": "Nom du vendeur"
						},
						"filename": "extract-vendeur",
						"title": "Extract vendeur"
					},
					"title": "Paramètres",
					"import": {
						"vendorId": "ID du Vendeurs",
						"title": "Nom du réglage",
						"value": "Valeur (en centimes)",
						"originalPayDate": "Date d'éligibilité",
						"date": "Date de règlement",
						"type": "Type de réglage",
						"category": "Catégorie",
						"obs": "Observation",
						"importButton": "Importer les paramètres",
						"vendorName": "Nom du Vendeurs",
						"successNotification": "Paramètres importés avec succès.",
						"vendors": "Vendeurs",
						"electrical": "Électrique",
						"hydraulics": "Hydraulique",
						"supply": "Approvisionnement",
						"cleaning": "Nettoyage",
						"other": "Autre",
						"vendorIdTextError": "Erreur: saisissez l'identifiant du fournisseur",
						"vendorIdIsValidError": "Erreur: saisissez un identifiant de fournisseur valide",
						"titleTextError": "Erreur: saisissez un nom pour le paramètre",
						"titleIsValidError": "Erreur: définition d'un nom de plus de 255 caractères",
						"valueZeroError": "Erreur: saisissez une valeur de réglage autre que 0",
						"categoryError": "Erreur: Veuillez saisir une catégorie d'ajustement valide",
						"obsError": "Erreur: Obs d'ajustement avec plus de 255 caractères",
						"valueCentsError": "Attention ! La valeur est donnée en centimes, par exemple 123 équivaut à 1,23 R$"
					},
					"total": "Total",
					"modal": {
						"deleteAdjustments": "Supprimer les ajustements",
						"wantToDelete": "Êtes-vous sûr de vouloir supprimer cet ajustement ?",
						"cantBeUndone": "Cette action ne peut être annulée",
						"cancel": "Annuler"
					}
				},
				"history": {
					"columns": {
						"attachment": "Pièce jointe",
						"attachments": "Pièces jointes",
						"paymentMethod": "Moyen de paiement",
						"requestDate": "Date",
						"status": "Statut",
						"vendorName": "Vendeur",
						"withdrawValue": "Montant"
					},
					"export": "Exporter tableau",
					"labels": {
						"paid": "Payé",
						"pending": "En attente",
						"processing": "Traitement",
						"refused": "Refusé"
					},
					"sheet": {
						"columns": {
							"paymentMethod": "Moyen de paiement",
							"requestDate": "Date",
							"status": "Statut",
							"vendorName": "Vendeur",
							"withdrawValue": "Montant"
						},
						"filename": "extract-vendeur",
						"title": "Extract Vendeur"
					},
					"title": "Historique",
					"withdraws": {
						"columns": {
							"totalAvailable": "Solde",
							"totalRequestedValue": "Demandes de retrait",
							"vendorName": "Vendeur",
							"type": {
								"label": "Type",
								"Withdraw": "Retrait",
								"Anticipation": "Anticipation"
							}
						},
						"export": "Exporter tableau",
						"sheet": {
							"columns": {
								"availableValue": "Solde",
								"requestDate": "Date",
								"vendorName": "Vendeur",
								"withdrawValue": "Demandes de retrait",
								"anticipationValue": "Demandes d'anticipation"
							},
							"filename": "extract-vendeur",
							"title": "Extract Vendeur"
						},
						"title": "Demandes financières"
					},
					"extractByVendor": {
						"title": "Extrait par fournisseur",
						"filename": "extrait-par-fournisseur",
						"columns": {
							"title": "Résumé de la période",
							"payValue": "Total"
						},
						"selectPlaceholder": "Sélectionner un fournisseur",
						"available": "Solde disponible",
						"toBeReleased": "Anticipation disponible",
						"emptyTitle": "Il n'y a encore rien ici",
						"emptySubtitle": "Sélectionnez un fournisseur ou revenez plus tard.",
						"themes": {
							"retention": "Rétention",
							"productsCommissionPayment": "Taux effectif global sur chiffre d'affaires",
							"productsSoldInPaymentMethods": "Frais des modes de paiement",
							"productsSold": "Revenus avec produits",
							"tips": "Revenus avec service",
							"adjustments": "Réglages maison"
						}
					}
				},
				"withdraws": {
					"columns": {
						"totalAvailable": "Solde",
						"totalRequestedValue": "Demandes de retrait",
						"vendorName": "Vendeur",
						"type": {
							"label": "Type",
							"Withdraw": "Retrait",
							"Anticipation": "Anticipation"
						}
					},
					"export": "Exporter tableau",
					"sheet": {
						"columns": {
							"availableValue": "Solde",
							"requestDate": "Date",
							"vendorName": "Vendeur",
							"withdrawValue": "Demandes de retrait",
							"anticipationValue": "Demandes d'anticipation"
						},
						"filename": "extract-vendeur",
						"title": "Extract Vendeur"
					},
					"title": "Demandes financières"
				}
			},
			"title": "Extract Vendeur",
			"vendorOwned": "due aux vendeurs",
			"withdraw": {
				"requests": {
					"approve": "Approuver la sélection",
					"anticipationValue": "Montant de l'anticipation",
					"availableValue": "solde",
					"label": "Souhaitez-vous confirmer les demandes de retrait suivantes ?",
					"prorata": "Valeur au prorata",
					"reject": "Rejeter la sélection",
					"requestDate": "Demandé le",
					"title": "Demandes",
					"totalValue": "Total",
					"type": {
						"anticipation": "Anticipation",
						"label": "Taper",
						"withdraw": "Retirer"
					}
				},
				"title": "Demandes de retrait pour {{name}}",
				"transference": {
					"attachments": "Pièces jointes / Vouchers",
					"message": "Les demandes effectuées après 10h30 (heure de Brasilia) ne seront traitées que le lendemain.",
					"paymentMethod": {
						"label": "Moyen de paiement",
						"placeholder": "Saisir un moyen de paiement"
					},
					"title": "Virement",
					"totalValue": "Montant du paiement",
					"typeMethod": {
						"label": "Virement avec",
						"other": "Autre",
						"zigAvailable": "Utiliser le solde ZigPay"
					},
					"warning": "ATTENTION"
				},
				"anticipationBalance": "Votre solde disponible en anticipation",
				"pendingWithdraws": "Retraits en attente",
				"pendingAnticipations": "Anticipazioni in sospeso",
				"vendorsOwned": {
					"seeDetails": "Voir les détails",
					"name": "Nom",
					"total": "Total",
					"alertTitle": "Calcul des fournisseurs",
					"alertMessage": "Pour calculer le montant dû aux fournisseurs, seuls les soldes positifs sont ajoutés.",
					"list": "Liste des fournisseurs"
				}
			},
			"productsSold": {
				"activeTab": "produit-vendu-par-vendeur",
				"bonus": "Bonus par produit",
				"title": "Produits vendus par vendeur"
			},
			"revenues": {
				"activeTab": "revenu-vendeur",
				"columns": {
					"name": "Vendeur",
					"total": "Total",
					"totalSoldValue": "Produits vendus",
					"totalTipValue": "Pourboire",
					"rent": "Loyer",
					"revenue": "Revenus",
					"billing": "Facturation",
					"percentageFee": "Taux",
					"salesFee": "Frais de Vente",
					"salesFeeValue": "Transfert des Vente",
					"serviceFee": "Frais de Service",
					"serviceFeeValue": "Transfert des Service",
					"percentageFeeText": "Taux en {{fee}}",
					"adjustValue": "Ajustements",
					"electrical": "Électrique",
					"hydraulics": "Hydraulique",
					"supply": "Approvisionnement",
					"cleaning": "Nettoyage",
					"other": "Autre",
					"cashRetention": "Rétention de trésorerie",
					"singleProductReturns": "Retours individuels",
					"cashPayment": "Paiement en espèces",
					"voucherPayment": "Paiement par bon",
					"debitPayment": "Paiement par débit",
					"creditPayment": "Paiement à crédit",
					"totalSoldValueInCredit": "Facturation de crédit",
					"totalSoldValueInDebit": "Facture de débit",
					"totalSoldValueInPix": "Facturation dans Pix",
					"creditFee": "Frais de crédit",
					"debitFee": "Frais de débit",
					"pixFee": "Frais sur Pix",
					"totalSoldValueInCreditFeeValue": "Frais de crédit",
					"totalSoldValueInDebitFeeValue": "Frais de débit",
					"totalSoldValueInPixFeeValue": "Charger sur Pix",
					"totalSoldValueInOtherPaymentMethods": "Facturation avec d'autres modes de paiement",
					"billingTooltip": "Cette colonne fait référence à la somme des montants facturés par le fournisseur pour les produits, services, ajustements et restes de recharge.",
					"revenueTooltip": "Cette colonne représente le résultat des revenus moins tous les frais et ajustements facturés au fournisseur.",
					"voucherRetention": "Rétention des bons",
					"productsFee": "Transfert de produits à tarif spécial",
					"floorComplement": "Complément minimum garanti",
					"rechargeLeftovers": "Recharger les restes"
				},
				"sheet": {
					"columns": {
						"name": "Vendeur",
						"total": "Total",
						"totalSoldValue": "Produits vendus",
						"totalTipValue": "Pourboire",
						"rent": "Loyer",
						"revenue": "Revenus",
						"billing": "Facturation",
						"percentageFee": "Taux",
						"salesFee": "Frais de Vente",
						"salesFeeValue": "Transfert des Vente",
						"serviceFee": "Frais de Service",
						"serviceFeeValue": "Transfert des Service",
						"percentageFeeText": "Taux en {{fee}}",
						"adjustValue": "Ajustements",
						"electrical": "Électrique",
						"hydraulics": "Hydraulique",
						"supply": "Approvisionnement",
						"cleaning": "Nettoyage",
						"other": "Autre",
						"cashRetention": "Rétention de trésorerie",
						"singleProductReturns": "Retours individuels",
						"totalSoldValueInCredit": "Facturation de crédit",
						"totalSoldValueInDebit": "Facture de débit",
						"totalSoldValueInPix": "Facturation dans Pix",
						"creditFee": "Frais de crédit",
						"debitFee": "Frais de débit",
						"pixFee": "Frais sur Pix",
						"totalSoldValueInCreditFeeValue": "Frais de crédit",
						"totalSoldValueInDebitFeeValue": "Frais de débit",
						"totalSoldValueInPixFeeValue": "Charger sur Pix",
						"totalSoldValueInOtherPaymentMethods": "Facturation avec d'autres modes de paiement",
						"voucherRetention": "Rétention des bons",
						"productsFee": "Transfert de produits à tarif spécial",
						"floorComplement": "Complément minimum garanti",
						"rechargeLeftovers": "Recharger les restes"
					},
					"filename": "facturation_vendeur_dans_lieu",
					"title": "Facturation vendeur"
				},
				"title": "Facturation Vendeur",
				"totalizers": {
					"totalSold": "Revenu total du fournisseur",
					"totalReceipt": "Revenu total du fournisseur",
					"highestVendor": "Le plus grand fournisseur"
				}
			}
		},
		"notEmitedProducts": {
			"activeTab": "produits-non-émis",
			"columns": {
				"combo": "Combo",
				"count": "Quantité",
				"firstNotEmittedSellDate": "Premier jour non émis",
				"lastNotEmittedSellDate": "Dernier jour non émis",
				"name": "Produit"
			},
			"export": "Exporter tableau",
			"sheet": {
				"columns": {
					"combo": "Combo",
					"count": "Quantité",
					"firstNotEmittedSellDate": "Premier jour non émis",
					"lastNotEmittedSellDate": "Dernier jour non émis",
					"name": "Produit"
				},
				"filename": "produits_non_émis",
				"title": "Produits non émis"
			},
			"title": "Produits non émis"
		},
		"passwordCard": {
			"blockCard": "Bloquer carte",
			"columns": {
				"authorizedTransactioneration": "Opération/Transaction autorisée",
				"cardCreator": "Créateur de cartes",
				"cardNumber": "Numéro de carte",
				"cardOwner": "Titulaire de la carte",
				"cardStatus": "Statut de carte",
				"date": "Date/Heure",
				"pdvId": "Id PDV",
				"permissions": "Actions qui autorisent",
				"timeCreation": "Date/Heure de Création",
				"value": "Montant",
				"employeeName": "Employé",
				"sourceId": "Id de transaction"
			},
			"passwordCardDeleteModal": {
				"complement": {
					"multiple": "les cartes de mot de passe sélectionnées ?",
					"single": "la carte de mot de passe de {{cardName}}"
				},
				"confirmButton": "Oui, je veux bloquer la carte de mot de passe",
				"text": "En cas de perte d'une carte de mot de passe, il est conseillé de la bloquer. Lorsque vous confirmez le blocage, votre historique est enregistré, mais il n'est plus valide. Vous souhaitez donc bloquer "
			},
			"passwordCardHeader": {
				"blockButton": "Bloquer plusieurs cartes",
				"main": {
					"description": "Les cartes de mots de passe sont utilisées à la place des mots de passe dactylographiés et fonctionnent en approchant la carte, ce qui accélère l'opération. De cette manière, seuls les détenteurs de ces cartes pourront autoriser certaines actions au point de vente, ce qui offre un meilleur contrôle et une plus grande sécurité pour les procédures pertinentes telles que le retrait d'espèces et les remboursements.",
					"labelText": "Rechercher",
					"placeholder": "Recherche par titulaire de carte",
					"statusFilter": "Afficher uniquement les cartes actives",
					"title": "Carte de mot de passe"
				},
				"stockHistory": {
					"cardOwner": "Titulaire de carte: {{name}}",
					"title": "Carte de mot de passe - Historique du Stock"
				}
			},
			"statusEmployeeCard": {
				"active": "Active",
				"blocked": "Bloquée",
				"inactive": "Inactive"
			},
			"stockHistory": "Historique du Stock",
			"filename": "historique_du_stock"
		},
		"placeTabs": {
			"bars": " Bars",
			"beer": " Bière pression",
			"cmv": " Eng. depuis Menu",
			"combos": " Combos",
			"gng": " Grab and Go",
			"products": " Produits",
			"supplies": " Fournitures",
			"config": "Paramètres des menus"
		},
		"placeTitle": "Lieux",
		"placelinks": {
			"hybrid": "Hybride",
			"noEvents": "Sans événements",
			"none": "Auncun événement",
			"openEvent": "Événement ouvert",
			"post": "Post",
			"pre": "Pré"
		},
		"pos": {
			"methodTranslate": {
				"credit": "Crédit",
				"debit": "Débit"
			},
			"operations": {
				"columns": {
					"brand": "Signaler",
					"date": "Date et heure",
					"lastDigits": "Chiffres",
					"method": "Moyen",
					"value": "Montant"
				},
				"search": "Rechercher par signalement, chiffres ou valeur",
				"title": "Opérations"
			},
			"others": "Autres",
			"selectDate": "Sélectionner un jour pour visualiser les transactions",
			"sidebar": {
				"clear": "Nettoyer",
				"credit": "Crédit",
				"day": "Jour",
				"debit": "Débit",
				"info": "Sélectionnez une ou plusieurs dates pour voir les détails.",
				"title": "Total de {{month}}",
				"total": "Total"
			},
			"title": "Ventes POS"
		},
		"products": {
			"beerDispenser": {
				"emptyText": "Aucune bière trouvée.",
				"error": {
					"invalidIp": "Format IP invalide",
					"requiredField": "Champ obligatoire"
				},
				"ip": "IP",
				"modal": {
					"addBeerDispenser": "Ajouter Bière pression",
					"deleteDispenser": "Supprimer Bière pression",
					"deleteText": "Êtes-vous sûr de vouloir supprimer la bière pression ? <b>{{chopName}}</b>?",
					"dispenserIp": "IP Bière pression",
					"editBeerDispenser": "Modifier Bière pression",
					"name": "Nom",
					"number": "Numéro",
					"product": "Produit",
					"productTooltip": "Uniquement les produits en millilitres/litres"
				},
				"newBeerDispenser": "Nouvelle Bière pression",
				"number": "Numéro Bière pression",
				"product": "Produit",
				"searchPlaceholder": "Rechercher",
				"title": "Bière pression"
			},
			"personalizationSettings": {
				"personalizationSettings": "Configurer et personnaliser vos menus",
				"description": "Ici, vous personnaliserez la partie visuelle et configurerez les informations à afficher sur les menus. La personnalisation est unique et s'appliquera à tous les menus que vous avez.",
				"yourActiveProducts": "Vos produits actifs",
				"onlinePostPayment": "Payer à table",
				"delivery": "Livraison",
				"dineIn": "Commande à table",
				"onlineTab": "Commande en ligne",
				"viewMenu": "Menu digital",
				"title": "Titre",
				"placeName": "Nom du lieu",
				"logo": "Logo",
				"coverImg": "Image de couverture",
				"assignedImgInYourMenu": "L'image attribuée apparaîtra dans votre menu.",
				"infoImage": "Si vous n'ajoutez pas d'image, l'en-tête de votre produit sera le logo et le nom du lieu.",
				"recommendations": "Recommandations",
				"highQualityImg": "Nous vous recommandons d'utiliser un logo et une image de couverture de haute qualité pour une meilleure application.",
				"imgs": "Images",
				"primaryColor": "Couleur Principale",
				"colors": "Couleurs",
				"contrastColor": "Couleur de Contraste",
				"secondaryColor": "Couleur Secondaire",
				"saveCustomization": "Enregistrer la personnalisation",
				"serviceInformation": "Informations de service",
				"deliverySettings": "Paramètres de livraison",
				"pickUpAddress": "Adresse de retrait",
				"generateQrCode": "Générer un code QR",
				"state": "État",
				"select": "Sélectionner",
				"city": "Ville",
				"enterOrSelect": "Saisir ou sélectionner",
				"neighborhood": "Quartier",
				"neighborhoodName": "Entrez le nom du quartier",
				"address": "Adresse",
				"street": "Nom de la rue ou avenue",
				"number": "Numéro",
				"complement": "Complément",
				"typeOfFee": "Type de frais",
				"currentHold": "Attente actuelle",
				"holdPlaceholder": "15 minutes",
				"baseValue": "Valeur de base",
				"valuePerkm": "Valeur par Km",
				"visible": "Rendre visible",
				"averageTime": "Temps d'attente moyen",
				"status": "Statut (ouvert ou fermé)",
				"copyOrTypeLink": "Collez ou tapez le lien ici",
				"parameter": "Paramètre",
				"searchParameter": "Rechercher un paramètre",
				"parameterValue": "Valeur du paramètre",
				"value": "Valeur",
				"newQrCode": "Nouveau code QR",
				"importQrCode": "Importer un code QR",
				"downloadQrCode": "Télécharger le code QR",
				"uniqueFee": "Unique",
				"basePlusKm": "Base + Variable par Km",
				"perRatio": "Frais par rayon",
				"addMoreFee": "Ajouter un autre frais",
				"fromTo": "De {{beginning}} à {{end}}",
				"time": "{{minutes}} minutes",
				"chairNumber": "Numéro de chaise",
				"tableNumber": "Numéro de table",
				"roomNumber": "Numéro de chambre",
				"referencePoint": "Point de référence",
				"savedSuccessfully": "Mises à jour enregistrées avec succès!",
				"deliveryInfo": "Demander des informations de livraison (optionnel)",
				"selectInfo": "Sélectionnez l'information dont vous avez besoin",
				"radiusUntil": "Rayon jusqu'à",
				"complementExample": "Ex: Magasin A",
				"chair": "chaise",
				"table": "table",
				"room": "chambre",
				"reference": "référence",
				"menu": "Menu",
				"selectProduct": "Sélectionner le produit",
				"importSheet": "Importer la feuille de calcul pour générer des QR Codes",
				"importQrCodes": "Importer des QrCodes",
				"somethingWentWrong": "Quelque chose a mal tourné",
				"couldNotImportSheet": "Nous n'avons pas pu importer votre feuille de calcul. Vérifiez si elle suit le modèle proposé ou demandez de l'aide à notre support.",
				"importInstructions": "Après l'importation, les QR Codes seront automatiquement téléchargés dans vos téléchargements.",
				"configSlug": "Configurez votre slug ici",
				"generateMultipleQrCode": "Générer plusieurs QR Codes"
			},
			"cmv": {
				"details": {
					"contributionMargin": "Marge de contribution",
					"cost": "Coût",
					"editProductPrice": "Modifier le prix",
					"markup": "Balise",
					"productSimulator": "Simulator CMV",
					"realCost": "Coût réel",
					"salePrice": "Prix de vente"
				},
				"searchPlaceholder": "Sélectionner un produit ou une catégorie",
				"searchProduct": "Trouver un produit",
				"supply": {
					"columns": {
						"input": "Entrée",
						"loss": "Perte",
						"quantity": "Qté",
						"realCost": "Coût réel",
						"unitCost": "Coût unitaire"
					}
				}
			},
			"combo": {
				"activateMultipleCombosButton": "Activer des combos multiples",
				"activatedMultipleCombos": "Activer combos",
				"activatedSingleCombo": "Combo activé",
				"addComboButton": "Ajouter Combo",
				"addComboModal": {
					"add": " Ajouter",
					"addCombo": "Ajouter Combo",
					"cancel": "Annuler",
					"category": "Catégorie",
					"description": "Description",
					"edit": "À modifier",
					"editCombo": "Modifier Combo",
					"errors": {
						"invalidValue": "Montant invalide",
						"obrigatoryField": "Ce champ est obligatoire",
						"products": "La combinaison doit être associée à au moins un produit"
					},
					"fiscalData": "Données fiscales",
					"fiscalFields": {
						"cest": "CEST",
						"code": "SKU",
						"fiscalGroup": "Groupe fiscal",
						"fiscalProfile": "Profil fiscal",
						"ncm": "NCM"
					},
					"include": "Inclure",
					"includeFiscal": "Inclure les données fiscales ?",
					"printComboProductsIndividually": "Lors de la vente de ticket, imprimer les produits du combo individuellement",
					"name": "Nom",
					"picture": "Image :",
					"price": "Prix",
					"products": "Produits"
				},
				"columns": {
					"active": "Active",
					"category": "Catégorie",
					"description": "Description",
					"name": "Combo",
					"price": "Prix",
					"products": "Produits"
				},
				"deactivatedMultipleCombos": "Combos désactivés",
				"deactivatedSingleCombo": "Combo désactivé",
				"deleteCombo": "Voulez-vous supprimer le produit \"{{name}}\"?",
				"disableMultipleCombosButton": "Déasactiver plusieurs Combos",
				"placeholder": "Filtrer Combos",
				"table": {
					"active": "Actif",
					"category": "Catégorie",
					"description": "Description",
					"fiscalInfo": "Cette combinaison ne contient pas de données fiscales. Par conséquent, les données fiscales de vos produits seront prises en compte.",
					"name": "Combo",
					"price": "Prix",
					"products": "Produits",
					"warning": "Attention ! Pour rendre ce combo disponible à la vente, configurez son prix sur le côté"
				}
			},
			"editProducts": {
				"categoryChange": "Modifier la catégorie :",
				"categoryNone": "Aucune",
				"confirm": "Souhaitez-vous modifier les produits suivants ?",
				"save": "Sauvegarder",
				"title": "Modifier le produit",
				"typeChange": "Modifier le produit",
				"typeNone": " Aucun"
			},
			"grabAndGo": {
				"activeProducts": "Produits actifs pour Grab and Go",
				"disabledProducts": "Produits désactivés pour Grab and Go",
				"searchPlaceholder": "Filtrer Produits"
			},
			"newAndEditProduct": {
				"cancelButton": "Annuler",
				"confirmButton": "Confirmer",
				"errors": {
					"abvQuantity": "Le pourcentage doit être inférieur à 100",
					"categoryId": "Choisir ou créer une catégorie",
					"length": "Máx. {{length}} caractères",
					"name": "Utiliser uniquement des caractères valides",
					"newCategory": "Vous allez créer une nouvelle catégorie",
					"productFeature": "La fonctionnalité {{wrongFeature}}n'est pas remplie correctement.",
					"productFeatures": "Les {{wrongFeatures}} ne sont pas remplies correctement.",
					"productRules": "Il y a des entrées non remplies",
					"proportionalQuantity": "TLe montant doit être supérieur à 0",
					"requiredField": "Ce champ est obligatoire",
					"wrongSection": "L'étape {{wrongStep}} n'est pas remplie correctement.",
					"wrongSections": "Les étapes {{wrongSteps}} ne sont pas remplies correctement."
				},
				"forms": {
					"details": {
						"beerABV": "ABV - Taux d'alcool",
						"beerIbu": "IBU - Unités d'amertume internationales",
						"beerBrand": "Marque",
						"beerStyle": "Style de bière",
						"category": "Catégorie",
						"description": "Description",
						"fiscalDataMessage": "Le code produit est généré automatiquement",
						"hasAlcohol": "Contient de l'alcool",
						"hasFiscalData": "Données fiscales",
						"hasMountableProduct": "Produit combinable",
						"hasProductRule": "Tableau",
						"hasProportionalProduct": "Produit en g/ml",
						"isHiddenFromApp": "Ne pas afficher le produit dans l'application ZigApp",
						"measurement": "Stock contrôlé par",
						"menuCategory": "Catégorie de menu",
						"beerIntegrationPlaceFeatureWarning": "Fonction désactivée. Veuillez contacter le support pour l'activer dans le système.",
						"beerIntegrationDisabledWarning": "Il n'est pas possible de désactiver cette fonction lorsque l'option 'Synchronisation avec {{integration}}' est activée.",
						"beerIntegrationEnabledWarning": "Il n'est pas possible de activer cette fonction lorsque l'option 'Synchronisation avec {{integration}}' est activée.",
						"productReturn": "Produit retournable",
						"name": "Nom du produit",
						"picture": "Image",
						"price": " Prix",
						"priceIn": "Prix en",
						"selectType": "Sélectionner un type de produit",
						"syncWithBeerIntegration": "Synchronisation avec {{integration}}",
						"type": "Type de produit",
						"variablePrice": "Prix variable",
						"isSupplyToggle": "Entrée",
						"conversionRule": {
							"unit": "Unité",
							"amount": "Quantité",
							"unitMeansure": "Unité de mesure",
							"placeholderSelect": "Sélectionner",
							"convertionName": "Règle de conversion",
							"title": {
								"unitDefault": "Unité de mesure par défaut",
								"unitConvertion": "Règle de conversion"
							},
							"field": {
								"quantity": "Quantité",
								"unitMeansure": "Unité de mesure"
							},
							"resumeDescription": "équivaut à:",
							"infoConvertionRule": "Crée une deuxième unité de mesure pour votre produit, permettant de le gérer de différentes manières dans votre inventaire.",
							"warningConvertionRule": "La règle de conversion ne peut être activée que lorsque le produit est contrôlé par unité."
						}
					},
					"fiscal": {
						"cest": "CEST",
						"code": "SKU",
						"codeErrorMessage": "S'il n'est pas rempli, le code sera généré automatiquement.",
						"fiscalGroup": "Groupe fiscal",
						"fiscalProfile": "Profil fiscal",
						"ncm": "NCM",
						"hasIcmsRetidoOptions": {
							"yes": "Sim, possui ICMS pago anteriormente por ST",
							"no": "Não, não possui ICMS pago anteriormente por ST"
						},
						"fiscalIcmsBaseCalculoRetSt": "Base de Cálculo do ICMS Retido na operação anterior",
						"fiscalIcmsValorSubistituto": "Valor do ICMS Próprio do Substituto",
						"fiscalIcmsAliquotaFinal": "Alíquota Suportada pelo Consumidor Final"
					},
					"mountable": {
						"addStep": "Ajouter une étape",
						"getDescriptionDialog": {
							"activate": "Voulez-vous activer cet article dans les autres produits combinables qu'il compose ?",
							"disable": "Voulez-vous désactiver cet article dans les autres produits combinables qu'il compose ?"
						},
						"getTitleDialog": {
							"activate": "Activer l'article combinable",
							"disable": "Désctiver l'article combinable"
						},
						"information": "INFORMATION",
						"infos": {
							"invalidValue": "Valeur invalide",
							"label": "Information",
							"max": "Max",
							"min": "Min",
							"precification": "Tarification",
							"precificationErrorMessage": "Choisir un moyen",
							"precificationSelect": {
								"average": "Moyenne",
								"averageTooltip": "La moyenne des articles sélectionnés est incrémentée.",
								"higher": "Montant le plus élevé",
								"higherTooltip": "La valeur la plus élevée parmi les éléments sera ajoutée à la valeur du produit.",
								"label": "Choix...",
								"sum": "Supplémentaire",
								"sumTooltip": "Chaque article ajouté sera incrémenté dans le montant du produit."
							},
							"title": "Titre",
							"titleErrorMessage": "Nom invalide",
							"tooltipMax": "Nombre maximum d'articles à sélectionner.",
							"tooltipMin": "Nombre minimum d'articles à sélectionner.",
							"validateMaxMinErrors": {
								"maxBiggerThenMin": "La montant maximum doit être supérieur au montant minimum",
								"maxValueZero": "Le montant maximum ne peut être égal à zéro",
								"negativeValue": "Un montant négatif n'est pas autorisé"
							}
						},
						"items": {
							"additionalItems": "Ajouter un autre article",
							"itemKey": "Article {{itemKey}}",
							"label": "Articles",
							"maxQuantity": "Quantité max. sélectionnable",
							"maxQuantityTooltip": "Nombre maximum de fois que cet élément peut être sélectionné dans la section",
							"storageCount": "Réduction de la quantité",
							"storageCountErrorMessage": "Quantité non valide",
							"storageCountTooltip": "Quantité à déduire du stock par unité.",
							"title": " Article",
							"titleErrorMessage": "Aucun article sélectionné",
							"value": "Montant",
							"valueErrorMessage": "Montant supplémentaire non valide"
						},
						"itemsTitle": "ARTICLES",
						"step": "Étape"
					},
					"productRule": {
						"addInput": "Ajouter entrée",
						"addAnotherInput": "Ajouter une autre entrée",
						"generatedQuantity": "Quantité de produits générés",
						"input": "Entrée",
						"loss": "Perte",
						"quantity": "Quantité"
					},
					"proportionalValue": {
						"grams": "Grammes",
						"measurement": "Unité de mesure",
						"mililiters": "Millilitres",
						"quantity": "Quantité"
					}
				},
				"titles": {
					"add": "Ajouter Produit",
					"downloadQRCodeToSell": "Télécharger QR Code à vendre",
					"edit": "Modifier Produit",
					"hasFiscalData": "Données fiscales",
					"hasMountableProduct": "Produit combinable",
					"hasProductRule": "Tableau",
					"hasProportionalProduct": "Produit en g/ml",
					"productDetails": "Détails Produit",
					"releaseValue": "Valeur de libération"
				},
				"undefined": "Non déini"
			},
			"productArea": {
				"titles": {
					"productArea": "Zone de produits",
					"editProduct": "Modifier le produit",
					"addInput": "Ajouter une autre entrée",
					"editTechnicalSheet": "Modifier la fiche technique"
				},
				"tabs": {
					"productDetail": "Détails du produit",
					"technicalSheet": "Fiche technique"
				}
			},
			"productFeatureForm": {
				"fields": "Champs",
				"observation": "Commentaire",
				"org": "ORG",
				"selectHere": "Sélectionner ici...",
				"templatesOptionsPlaceholder": "Sélectionner un modèle",
				"typeHere": "Taper ici...",
				"validateMessage": "Ce champ est obligatoire.",
				"zig": "ZIG"
			},
			"productsTab": {
				"activeAll": "Tout activer",
				"activeAllQuestion": "Tout activer ?",
				"addProductButton": "Ajouter Produit",
				"importProductsButton": "Importer produits en masse",
				"checkAllItems": "Sélectionner tous les produits ({{counter}})",
				"deleteProducts": "Supprimer Produits",
				"deleteSelect": "Supprimer la sélection",
				"deleteSelectedProducts": "Supprimer la sélection",
				"disableAll": "Tout désactiver",
				"disableAllQuestion": "Tout désactiver ?",
				"downloadQrCodeAppSell": "Télécharger les QR codes de vente pour l'app ZIG",
				"editProducts": "Modifier Produits",
				"editProductsViaExcel": "Modifier les produits via Excel",
				"exportToExcelButton": "Exporter tableau",
				"findFiscalGroupError": "Groupe fiscal enregistré introuvable",
				"findFiscalProfileError": "Profil fiscal enregistré introuvable",
				"getDescriptionDialogActive": "Voulez-vous activer ce produit dans les produits combinables qu'il compose ?",
				"getDescriptionDialogDisable": "Voulez-vous désactiver ce produit dans les produits combinables qu'il compose ?",
				"getTitleDialogActive": "Activer Produit",
				"getTitleDialogDisable": "Désactiver Produit",
				"importModal": {
					"alertMessage": "Attention ! la valeur des produits est renseignée en cents, ex : 123 équivaut à 1.23€",
					"buttonText": "Choisir tableau",
					"downloadSheet": "Télécharger le tableau",
					"import": "Importer",
					"sheetFileName": "Produits",
					"title": "Importer des tableaux",
					"table": {
						"columns": {
							"product": "Produit",
							"error": "Erreur",
							"description": "Description"
						},
						"errors": {
							"invalidTaxData": "Données fiscales,",
							"ncm": "NCM",
							"cest": "CEST",
							"duplicatedFiscalCode": "SKU en double",
							"productNotFound": "Produit non trouvé",
							"categoryWithSubcategory": "Catégorie",
							"supercategoryNotFound": "Type de produit",
							"name": "Nom",
							"category": "Catégorie",
							"hasAlcohol": "Contient de l'alcool",
							"isHiddenFromApp": "Cacher le produit",
							"value": "Prix",
							"kind": "Type de produit",
							"beerAbv": "ABV - Teneur en alcool",
							"other": "Inconnue"
						},
						"errorsDescription": {
							"name": "Nom du produit non renseigné",
							"category": "Catégorie de produit non spécifiée",
							"hasAlcohol": "Le champ doit être vrai ou faux",
							"isHiddenFromApp": "Le champ doit être vrai ou faux",
							"value": "Le prix du produit n'est pas valide",
							"kind": "Le type de produit est invalide",
							"beerAbv": "ABV - La teneur en alcool doit être un nombre",
							"other": "Erreur inconnue"
						}
					}
				},
				"limitOver": "Limite au-dessus de {{limit}} sélectionné",
				"onDeleteMessage": {
					"cancelText": "Non",
					"content": "Attention ! Les produits seront définitivement supprimés.",
					"okText": "Oui",
					"title_one": "Voulez-vous supprimer {{counter}} produit?",
					"title_other": "Voulez-vous supprimer {{counter}} produits?"
				},
				"onDeleteSelectProductsError": "Oups ! Un problème est survenu, veuillez réessayer",
				"productWithoutCategory": "Produits sans catégorie de menu",
				"productsByCategory": "Produits par catégorie",
				"searchLabel": "Rechercher",
				"searchPlaceholder": "Recherche produits...",
				"sortByCategory": "Trier par catégorie",
				"sortByMenuCategory": "Trier par catégorie de menu",
				"syncModal": {
					"activeSyncOptionCheckbox": "Activer les produits synchronisés pour la vente à la livraison",
					"alertMessage": "Les produits qui ne sont pas en cours de livraison seront créés avec les mêmes informations.",
					"chooseTheVariablesCheckbox": {
						"all": "Tous",
						"category": "Catégorie",
						"description": "Description",
						"mountableItems": "Articles combinables",
						"name": "Nom",
						"order": "Commande",
						"picture": "Image",
						"price": "Prix",
						"subcategory": "Sous catégorie",
						"title": "Choisissez les variables qui seront synchronisées pour les produits déjà enregistrés dans la livraison :"
					},
					"chooseYourMenusMultiSelect": "Choisissez vos menus",
					"successFeedback": "Succès, tous les produits sont synchronisés !",
					"title": "Sync produits",
					"warningFeedback": "Certains produits ont présenté des problèmes de synchronisation.",
					"warningFeedbackTable": {
						"description": "Description",
						"type": "Type"
					}
				},
				"syncWithDelivery": "Synchronisation avec la livraison",
				"tabTitle": "Produits",
				"table": {
					"active": "Activer",
					"activeBars": "Actives Bars",
					"actions": "Actions",
					"delete": "Supprimer",
					"duplicate": "Dupliquer",
					"edit": "Modifier",
					"fiscalData": "Données fiscales",
					"hasProductionRule": "Tableau",
					"mountableDescription": "Produit Montable",
					"name": "Produit",
					"noOption": "Non",
					"onDeleteProductMessage": "Voulez-vous supprimer le produit {{productName}}?",
					"value": "Prix",
					"yesOption": "Oui",
					"fiscalCode": "SKU"
				},
				"testEmission": {
					"loadingText": "Veuillez patienter, nous testons les produits sélectionnés",
					"success": "Les données fiscales ont été testées avec succès",
					"successDescription": "Aucune erreur n'a été trouvée dans les données présentées",
					"testing": "Tests {{currentTest}}/{{length}}",
					"titleError": "Oups, nous avons trouvé des erreurs",
					"titleSuccess": "Test des données fiscales - Succès",
					"titleTesting": "Test des données fiscales",
					"updating": "Mise à jour des produits..."
				},
				"testFiscalData": "Test des données fiscales",
				"uncheckAllItems": "Désélectionner tous les produits ({{counter}})",
				"xlsxPicker": {
					"cell": {
						"falseHasAlcohol": "FAUX",
						"trueHasAlcohol": "VRAI"
					},
					"columns": {
						"bars": "Bars",
						"systemProductId": "Produit du Système",
						"category": "Catégorie",
						"cest": "Fiscal - CEST",
						"description": "Description",
						"fiscalCode": "SKU",
						"fiscalProductGroup": "Fiscal - Groupe fiscal",
						"fiscalProfile": "Fiscal - Profil fiscal",
						"fiscalIcmsBaseCalculoRetSt": "Base de calcul de l'ICMS retenu lors de l'opération précédente",
						"fiscalIcmsValorSubistituto": "Valeur de l'ICMS propre du substitut",
						"fiscalIcmsAliquotaFinal": "Taux supporté par le consommateur final",
						"hasAlcohol": "Contient de l'alcool ?",
						"id": "ID Produit",
						"image": "Image",
						"kind": "Type de produit",
						"menuCategory": "Catégorie de menu",
						"name": "Nom",
						"ncm": "Fiscal - NCM",
						"price": "Prix",
						"products": "produits",
						"variablePrice": "Prix variable",
						"beerBrand": "Marque de bière",
						"beerStyle": "Style de bière",
						"beerAbv": "ABV - Teneur en alcool",
						"isStockable": "Stockable"
					},
					"sheetDownload": "Télécharger un modèle de tableau",
					"sheetFeedback": {
						"errorMessage": "Tableau invalide, téléchargez-le à nouveau et apportez les modifications nécessaires.",
						"successMessage": "Tableau valide!"
					},
					"sheetHumanizeErrorMessage": {
						"default": "Une erreur s'est produite lors de l'importation du tableau",
						"emptyHeaderCell": "Nom manquant dans les colonnes",
						"emptySheet": "Ce tableau est vide",
						"sheetPoorlyFormatted": "Formatage du tableau pour la police Calibri, taille 11, suppression des espaces, des retours à la ligne inutiles et des caractères gras.",
						"unidentifieldColumn": "Erreur dans les noms de colonnes",
						"verifyBaseSheet": ", veuillez consulter le modèle de tableau ou l'utiliser comme tableau de base."
					},
					"sheetNameExample": "(exemple)",
					"sheetNameInvalid": "(invalide)",
					"sheetXlsxPicker": "Choisir un tableau"
				},
				"manageProducts": "Gestion des produits",
				"managePlaceProducts": "Gérer les produits du lieu"
			},
			"supplies": {
				"pageTitle": "Intrants",
				"pageDescription": "Les intrants sont tous les matériaux utilisés pour la production d'un certain produit ou dans la création d'un autre intrant. Sur cet écran, il est possible d'enregistrer et de visualiser tous les intrants enregistrés en un seul endroit.",
				"addSupplies": "Ajouter une entrée",
				"addSuppliesModal": {
					"errorMessage": "Ce champ est obligatoire",
					"name": "Nom",
					"unitMeasure": "Unité de mesure",
					"units": "Unités"
				},
				"step": {
					"supply": "Fourniture",
					"ingredients": "Ingrédients"
				},
				"addInputModal": {
					"title": "Ajouter une fourniture",
					"supply": "Fourniture ou produit",
					"name": "Nom",
					"placeholderName": "Entrez le nom de la fourniture",
					"sku": "SKU",
					"placeholderSKU": "Entrez le SKU",
					"image": "Photo",
					"descriptionImage": "Image carrée ou 500x500 pixels",
					"yieldPercentage": "Rendement",
					"basicStorageUnit": "Stock contrôlé par",
					"placeholderBasicStorageUnit": "Entrez l'unité de mesure",
					"aboutIngredients": "À propos des ingrédients",
					"ingredientsInfo": "Remplissez les champs d'ingrédients uniquement si le produit est une recette qui utilise d'autres fournitures. Par exemple, sauce tomate a besoin d'ingrédients, mais tomate non.",
					"selectInput": "Sélectionnez fourniture ou produit",
					"quantity": "Quantité",
					"loss": "Perte",
					"addIngredient": "Ajouter ingrédient"
				},
				"suppliesErrorsTableColumns": {
					"supply": "Entrée",
					"error": "Erreur"
				},
				"cancel": "Annuler",
				"conclude": "Terminer",
				"delete": "Supprimer",
				"deleteWarning": "Êtes-vous sûr de vouloir supprimer cet article ?",
				"edit": "Modifier",
				"editSupplies": "Modifiezr entrée",
				"erase": "Supprimer",
				"exportToExcel": "Exporter tableau",
				"importModal": {
					"buttonText": "Choisir un tableau",
					"conclude": "Terminer",
					"sheetFileName": "Entrées",
					"title": "Importer entrée"
				},
				"importSupplies": "Importer entrées",
				"no": " Non",
				"noCaps": "NON",
				"productRule": {
					"addAnotherSupply": "Ajouter une nouvelle entrée",
					"form": {
						"loss": "Perte",
						"product": "Produit",
						"quantity": "Quantité"
					},
					"generatedQuantity": "Quantité générée",
					"hasProductionRuleError": "Attention, ce tableau est erroné. Retirez le tableau et ajoutez-le à nouveau.",
					"title": "Tableau - {{productName}}",
					"tooltipMessage": "Pour modifier le montant généré, il est nécessaire de supprimer le tableau et de le créer à nouveau.",
					"warnings": {
						"emptyQuantity": "Ajouter le montant de l'entrée",
						"emptySupplies": "Sélectionner une entrée",
						"repeatEntry": "Vous avez ajouté des entrées répétées"
					}
				},
				"remove": "Supprimer",
				"searchPlaceholder": "Rechercher entrées",
				"formErrors": {
					"supplyName": "Le nom de l'approvisionnement doit être rempli",
					"conversionRule": "Les valeurs de la règle de conversion doivent être remplies"
				},
				"table": {
					"name": "Nom",
					"productionRule": "Recettes et production",
					"conversionRule": "Règle de conversion",
					"actions": "Actions",
					"sku": "SKU",
					"yieldPercentage": "Rendement",
					"links": "Produits et Intrants Liés",
					"stocks": "Stocks",
					"clickToEdit": "Cliquer pour modifier",
					"hasProductionRule": "Avez-vous un tableau ?"
				},
				"supplyActionModal": {
					"title": {
						"supply": "Liens de la fourniture",
						"stock": "Liens du stock"
					},
					"description": {
						"supply": "Liste des enregistrements auxquels cet article est lié",
						"stock": "Liste des stocks où le produit est présent"
					},
					"seeProductButton": "Voir le produit",
					"seeStockButton": "Voir le stock"
				},
				"yes": "Oui",
				"yesCaps": "OUI",
				"link": "Lien",
				"links": "Liens",
				"deleteSelectedSupplies": "Supprimer les fournitures sélectionnées",
				"deleteSelectedItens": "Supprimer les éléments sélectionnés",
				"deleteSupply": "Supprimer la fourniture",
				"deleteItems": "Supprimer les éléments",
				"importSupply": "Importer la fourniture",
				"import": "Importer",
				"confirmDeleteMessage": {
					"multiple": "En confirmant l'action, vous supprimez définitivement {{quantity}} fournitures. Voulez-vous continuer?",
					"single": "En confirmant l'action, vous supprimez définitivement la fourniture {{supply}}. Voulez-vous continuer?"
				},
				"viewRules": "Voir les recettes",
				"viewConversionRule": "Voir la règle",
				"doesNotHave": "N'a pas",
				"copiedSuccessfully": "Copié avec succès",
				"cannotDeleteSupply": "Impossible de supprimer car la fourniture est liée à d'autres produits"
			},
			"duplicateMountableProduct": {
				"duplicateMountable": "Dupliquer Montable",
				"createNewProduct": "Créer Nouveau Produit",
				"createNewProductDescription": "Dupliquez le produit montable et éditez un nouveau produit",
				"importDuplicateInBatch": "Importer Dupliqué en Lot",
				"importDuplicateInBatchDescription": "Importez l'étape montable pour les produits déjà créés",
				"importDuplicate": "Importer Dupliqué",
				"selectProductsDisclaimer": "Sélectionnez les produits pour lesquels vous souhaitez importer les données montables",
				"linkToProducts": "Lier aux Produits",
				"addProductsToMountable": "Ajoutez des produits pour ajouter la partie montable",
				"addProductsCount": "Ajouter {{countProducts}} produits",
				"duplicateConfirmation": "Confirmation de Duplication",
				"selectedProducts": "{{countProducts}} produit(s) ont été sélectionnés pour dupliquer les étapes montables.",
				"finishStep": "Voulez-vous terminer l'ajout des étapes ?",
				"finishStepNote": "NOTE : si des produits montables ont été sélectionnés, leurs étapes actuelles seront remplacées.",
				"backStage": "Étape Précédente",
				"confirmDuplicate": "Confirmer la Duplication",
				"successMessage": "Des étapes montables ont été ajoutées aux produits de la liste."
			},
			"technicalSheet": {
				"title": "Fiche technique",
				"modalDelete": {
					"title": "Supprimer la fiche technique",
					"text": "En confirmant l'action, vous supprimez définitivement la fiche technique. Voulez-vous continuer ?",
					"okText": "Oui, je veux supprimer la fiche technique"
				},
				"addInput": {
					"columns": {
						"inputName": "Entrée",
						"count": "Montant",
						"unitCostValue": "Coût unitaire",
						"totalCost": "Coût total",
						"actions": "Actions"
					},
					"warnings": {
						"withoutInput": "Sélectionner une entrée",
						"withoutQuantity": "Ajouter un montant",
						"alreadyExist": "L'entrée existe déjà dans la liste des entrées, veuillez sélectionner une autre entrée."
					},
					"inputName": "Entrée",
					"count": "Montant",
					"value": "Prix de revient",
					"price": "Prix",
					"add": "Ajouter"
				},
				"editInput": {
					"inputName": "Entrée",
					"count": "Montant",
					"value": "Prix de revient",
					"price": "Prix",
					"delete": "Éliminer"
				},
				"header": {
					"addButton": "Ajouter une entrée",
					"editButton": "Modifier la fiche technique"
				},
				"infoCard": {
					"value": "Prix de vente",
					"totalCost": "Coût total",
					"cmv": "CMV %",
					"profitMargin": "Marge bénéficiaire"
				},
				"table": {
					"columns": {
						"inputName": "Entrée",
						"count": "Montant",
						"loss": "Perte",
						"unitCostValue": "Coût unitaire",
						"yieldPercentage": "Performance",
						"unitCostWithYield": "Coût avec performance",
						"totalCost": "Coût total",
						"actions": "Actions"
					}
				}
			},
			"productDetail": {
				"isActive": "Produit actif",
				"isInactive": "Produit inactif",
				"buttonEditProduct": "Modifier le produit",
				"variable": "Variable",
				"modalDeleteProduct": {
					"titleModal": "Confirmation requise",
					"confirmDeleteProduct": "Voulez-vous supprimer le produit : {{productName}} ?"
				},
				"sectionsCards": {
					"productDetail": "Détails du produit",
					"fiscalData": "Données fiscales",
					"cardProductSoldBy": "Produit vendu par g/ml",
					"cardProductMountable": "Produit assemblable",
					"releaseValue": "Valeur de libération",
					"conversionRule": "Règle de conversion"
				},
				"duplicateProductMountable": "Dupliquer le produit assemblé",
				"contentsSection": {
					"contentFiscalData": {
						"fieldName": {
							"ncm": "NCM",
							"cest": "CEST",
							"fiscalProfile": "Profil fiscal",
							"fiscalGroup": "Groupe fiscal",
							"fiscalCode": "SKU"
						},
						"placeholder": {
							"ncm": "Saisissez le NCM",
							"cestInput": "CEST",
							"cestSelect": "Sélectionnez le CEST",
							"fiscalProfile": "Sélectionnez le profil fiscal",
							"fiscalGroup": "Sélectionnez le groupe fiscal",
							"fiscalCode": "Saisissez le SKU"
						},
						"infoMessageMyTapp": "Il est impossible de désactiver cette fonctionnalité lorsque le mode \"Synchroniser avec My Tapp\" est actif.",
						"requiredField": "Champ obligatoire",
						"validationMessage": {
							"ncm": "Le NCM doit contenir 8 chiffres",
							"cest": "Le CEST doit contenir 7 chiffres",
							"fiscalCode": "S'il n'est pas renseigné, le code sera généré automatiquement",
							"patternFiscalCode": "Uniquement des chiffres, lettres, points et tirets"
						},
						"infoMessageManualcest": "Ajouter le CEST manuellement ?"
					},
					"contentProductDetail": {
						"fieldName": {
							"image": "Image",
							"name": "Nom",
							"productType": "Type de produit",
							"unitOfMeasurement": "Stock contrôlé par",
							"category": "Catégorie",
							"menuCategory": "Catégorie du menu",
							"price": "Prix",
							"description": "Description",
							"drinkStyle": "Style de boisson",
							"alcoholContent": "Teneur en alcool",
							"hasAlcohol": "Contient de l'alcool",
							"hiddenZigApp": "Ne pas afficher le produit dans ZigApp",
							"sincMyTapp": "Synchroniser avec MyTapp",
							"productReturn": "Produit consigné",
							"brand": "Marque",
							"variableValue": "Prix variable",
							"stockableProduct": "Produit stockable"
						},
						"requiredField": "Champ obligatoire",
						"editImage": "Cliquez sur l'image pour modifier"
					},
					"contentProportionalValue": {
						"quantity": "Cantidad",
						"unityMeasurement": "Unidad de medida",
						"requiredField": "Campo obligatorio",
						"infoMessageMyTapp": "No es posible desactivar esta función mientras esté activa la opción 'Sincronizar con My Tapp'.",
						"placeholder": {
							"quantity": "Ingrese una cantidad",
							"unitMeasurement": "Seleccione"
						},
						"optionsUnitMeasurement": {
							"ml": "Mililitros",
							"gm": "Gramos",
							"un": "Unidad"
						}
					},
					"contentProductMountable": {
						"labelStep": "Paso",
						"labelItems": "ÍTEMS",
						"labelTitleInfo": "INFORMACIÓN",
						"addNewItem": "Agregar otro ítem",
						"fields": {
							"labelRequiredField": "Campo obligatorio",
							"title": "Título",
							"pricing": "Precios",
							"max": {
								"title": "Máximo",
								"errorMessage": {
									"notNullable": "El valor máximo no puede ser cero",
									"cannotLessMinimum": "El valor máximo no puede ser menor que el valor mínimo"
								}
							},
							"min": {
								"title": "Mínimo",
								"errorMessage": {
									"cannotGreaterMaximum": "El valor mínimo no puede ser mayor que el valor máximo"
								}
							},
							"item": "Ítem",
							"SelectableMaxQuantity": "Cantidad máxima seleccionable",
							"AmountSlaughtered": {
								"title": "Cantidad sacrificada",
								"errorMessage": {
									"notNullable": "La cantidad sacrificada debe ser mayor que cero"
								}
							},
							"price": "Valor"
						},
						"modalToggleStatusItem": {
							"activeItem": "Activar ítem ensamblado",
							"deactiveItem": "Desactivar ítem ensamblado",
							"warningMessage": {
								"active": "¿Desea activar este ítem en otros productos ensamblados a los que pertenece?",
								"deactive": "¿Desea desactivar este ítem en otros productos ensamblados a los que pertenece?"
							}
						},
						"modalWarningMontable": {
							"excludeStep": "Excluir paso",
							"excludeItem": "Excluir ítem",
							"warningMessage": {
								"exludeLastStep": "No es posible excluir todos los pasos de un producto ensamblado.",
								"excludeLastItem": "No es posible excluir todos los ítems de un producto ensamblado."
							}
						}
					}
				}
			}
		},
		"productMenu": {
			"all": "Tous les produits",
			"activedProducts": "Produits actifs",
			"inactivedProducts": "Produits inactifs",
			"isDisabledMenu": "Les menus principaux ne peuvent pas être édités ou supprimés",
			"defaultMenuName": "Menu Principal",
			"manageMenu": "Gestion des menus",
			"manageBars": "Bars",
			"tooltipActive": "Menu activé",
			"tooltipInactive": "Menu désactivé",
			"tooltipMenuType": "Type de menu",
			"info": {
				"product": "produit",
				"products": "produits"
			},
			"manageProducts": "Gestion des produits",
			"newMenu": "Nouveau menu",
			"createNewMenu": "Créez, modifiez et gérez les menus avec statut, en activant ou désactivant selon la demande.",
			"requiredField": "Champ Obligatoire",
			"menuName": "Nom de menu dupliqué",
			"duplicateMenu": "Dupliquer le Menu",
			"editMenu": "Modifier le menu",
			"closeAction": "Fermer",
			"addProducts": "Ajouter des Produits",
			"newMenuName": "Nom du Menu",
			"duplicateMenuError": "Il existe déjà un menu de ce type actif. Un seul menu actif par type est autorisé.",
			"menus": "Menus",
			"status": "Statut",
			"type": "Type",
			"createFirstMenu": "Créez votre premier menu maintenant",
			"createMenuInstructions": "Créez maintenant votre premier menu et associez des produits et des prix.",
			"createMenu": "Créer un Menu",
			"duplicate": "Dupliquer",
			"delete": "Supprimer",
			"edit": "Éditer",
			"deleteMenu": "Supprimer le Menu",
			"confirmDelete": "Voulez-vous supprimer {{menuName}}? Toutes les informations seront supprimées et cette action ne pourra pas être annulée.",
			"active": "Actif",
			"inactive": "Inactif",
			"confirmDuplicateMenu": "Voulez-vous dupliquer le {{menuName}}? Toutes les informations de la réplique seront identiques à l'original, mais ne seront pas liées à une quelconque zone.",
			"menuType": {
				"normal": "Normal",
				"delivery": "Livraison",
				"dineIn": "Commande à la table",
				"hawker": "Vendeur Ambulant",
				"grabAndGo": "Grab and Go",
				"onlineFicha": "Reçu en ligne",
				"pickUp": "Ramassage",
				"deliveryByMarketplace": "Livraison par le restaurant",
				"onlineTab": "Commande en ligne",
				"viewMenu": "Menu numérique",
				"deliveryIntegrated": "Livraison intégrée"
			},
			"activateMenu": "Activer Menu",
			"deactivateMenu": "Désactiver Menu",
			"importProducts": "À partir de l'importation de produits",
			"importWithSheet": "Utilisez une feuille de calcul pour importer automatiquement de nouveaux produits pour le nouveau menu",
			"linkExistingProducts": "Lier les produits existants",
			"selectImportedProducts": "Sélectionnez les produits déjà importés pour les lier au nouveau menu",
			"importCategoriesProducts": "Des catégories et des produits seront importés et créés. Si le produit existe déjà, il sera dupliqué lors de cette importation.",
			"emptyText": {
				"title": "No hay nada aquí todavía",
				"description": "Comienza vinculando categorías, luego agrega productos al menú."
			},
			"menuTypeLabel": "Type de Menu",
			"downloadSampleSheet": "Cliquez ici pour télécharger la feuille de calcul d'exemple",
			"clickToAddSheet": "Cliquez pour ajouter une feuille de calcul",
			"importSheet": "Importer la Feuille de Calcul",
			"importProductsTitle": "Importer des Produits",
			"emptyRowsWarning": "Votre feuille de calcul contient des lignes vides",
			"linkProductsToMenu": "Lier les produits au menu",
			"noProductFound": "Aucun produit trouvé",
			"enterNewMenuName": "Entrez le nom du nouveau menu",
			"selectMenuType": "Sélectionnez le type de menu",
			"addProductsCount": "Ajouter {{products}} produits",
			"selectProductsToLink": "Sélectionnez les produits que vous souhaitez lier au nouveau menu",
			"loadingProducts": "Chargement des produits",
			"fileLoadError": "Nous n'avons pas pu charger votre fichier. Veuillez confirmer si le fichier a été enregistré correctement et réessayer",
			"loadingSheet": "Chargement de la feuille de calcul",
			"invalidRowsError": "Lignes invalides, vérifiez les colonnes suivantes: {{rows}}",
			"linkProductToMenu": "Lier le produit",
			"createProduct": "Créer un Produit",
			"confirmRemoveProdutFromMenu": "Voulez-vous dissocier {{productName}} du menu ? Si des informations de prix ont été modifiées, vous les perdrez. Si vous souhaitez uniquement désactiver le produit du menu, vous pouvez cliquer sur l'interrupteur d'état dans le tableau des produits du menu.",
			"removeProductFromMenu": "Dissocier le produit du menu",
			"confirmRemoveProductFromMenuLabel": "Dissocier le produit",
			"revertProductPriceTitle": "Annuler le changement de prix",
			"confirmRevertProductPriceDescription": "En confirmant cette action, vous reviendrez au prix d'origine du produit, en abandonnant la modification précédemment effectuée. Le prix du produit est déterminé dans la section 'Gestion des Produits'.",
			"editProductTitle": "Modifier le {{productName}}",
			"category": "Catégorie",
			"price": "Prix",
			"saveChanges": "Enregistrer les Modifications",
			"editMenuProduct": "Modifier le produit dans le menu",
			"yes": "Oui",
			"no": "Non",
			"positivePriceErrorMessage": "Le prix doit être un nombre positif",
			"viewProductPage": "Voir la Page du Produit",
			"product": "Produit",
			"mountable": "Montable",
			"searchProduct": "Rechercher un Produit",
			"importWithSheetToMenu": "Utilisez une feuille de calcul pour importer automatiquement de nouveaux produits pour le menu",
			"createProductFromScratch": "Créer un produit à partir de zéro",
			"createNewProduct": "Créez un nouveau produit en remplissant toutes les données nécessaires",
			"selectProductsToLinkToMenu": "Sélectionnez les produits que vous souhaitez lier au menu",
			"addProductsToMenu": "Ajouter des produits au menu",
			"emptyMenu": "Menu vide",
			"addProductsToStartUsingIt": "Ajoutez des produits pour commencer à l'utiliser",
			"sku": "SKU",
			"nameMaxLength": "Limite de {{maxLength}} caractères dépassée",
			"menuCreated": "Menu créé avec succès",
			"menuUpdated": "Menu mis à jour avec succès",
			"menuRemoved": "Menu supprimé avec succès",
			"menuDuplicated": "Menu dupliqué",
			"menuStatusChanged": "Statut du menu modifié",
			"menuProductPriceChanged": "Le prix de {{productName}} a été modifié avec succès dans {{menuName}}.",
			"menuProductUpdated": "Le produit {{productName}} a été mis à jour avec succès dans {{menuName}}.",
			"menuProductRemoved": "Le produit {{productName}} a été supprimé avec succès de {{menuName}}.",
			"productsAmountAtMenu": "qte. de produits",
			"products": "produit(s)",
			"allCategories": "Toutes les catégories",
			"filters": {
				"all": "Tous",
				"filterByName": "Filtrer par nom",
				"filterByMenuType": "Filtrer par type de menu",
				"allMenuTypes": "Tous les types",
				"filterByLinkedBars": "Filtrer par bares liés",
				"activeFilters": "Filtres actifs",
				"clearAll": "Nettoyer tous les filtres",
				"noResults": "Aucun résultat trouvé avec les filtres actuels",
				"clearFilters": "Nettoyer les filtres"
			},
			"createMenuModal": {
				"menuNameLabel": "Nombre del menú",
				"menuNamePlaceholder": "Nom du menu",
				"title": "Créer un menu"
			},
			"editMenuModal": {
				"title": "Modifier le menu"
			},
			"bars": "Bars",
			"dashboard": {
				"productCount": "Cantidad de productos",
				"categoryCount": "Categorías",
				"barCount": "Bares"
			},
			"linkProductsDrawer": {
				"newlySelected": "Sélectionné",
				"addAllProducts": "Ajouter tous les produits",
				"linkProducts": "Lier les produits",
				"title": "Lier les produits au menu",
				"successMessage": "Produit(s) lié au menu avec succès",
				"typeToSearch": "Taper pour rechercher",
				"noProductFound": "Aucun produit trouvé",
				"product": "Produit",
				"sku": "SKU",
				"closeAction": "Fermer",
				"saveChanges": "Enregistrer les modifications",
				"selectProductsToLinkToMenu": "Sélectionnez les produits que vous souhaitez lier au menu",
				"searchProduct": "Rechercher un Produit"
			},
			"allowFichaExport": "Permettre l'exportation de fichiers."
		},
		"promotion": {
			"categoryModal": {
				"label": "Produit ou catégorie",
				"noneProduct": "Aucun produit trouvé",
				"placeholder": "Recherche d'un produit ou d'une catégorie",
				"title": "Ajouter un nouveau produit"
			},
			"copyModal": {
				"message": "Voulez-vous créer une copie de la promotion ?",
				"okText": "Copier",
				"placeholder": "Nom de la copie de promotion",
				"title": "Créer une copie de promotion"
			},
			"creationStep": {
				"error": "Impossible de rediriger la page.",
				"formatter": {
					"convertGoals": {
						"checkinTime": "Heure d'arrivée",
						"empty": "Ne dispose pas",
						"everybody": "Votre promotion ne nécessite pas d'objectifs"
					},
					"convertUsageConditions": {
						"at": "le",
						"days": "jours",
						"empty": "Ne dispose pas"
					},
					"frequencyOfEarning": {
						"eachEvent": "Une fois par événement",
						"everytime": "Toujours",
						"oncePerMonth": "Une fois par mois",
						"oncePerWeek": "Une fois par semaine"
					},
					"promotionEarning": {
						"birthdayPerson": {
							"description": "Pour les anniversaires dans le mois, la semaine ou le jour.",
							"name": "Anniversaire"
						},
						"checkinTime": {
							"description": "Pour les promotions, une heure d'arrivée spécifique est requise.",
							"name": "Heure d'arrivée"
						},
						"everybody": {
							"description": "Pour les promotions qui ne requièrent aucune condition d'utilisation",
							"name": "Tous les clients"
						},
						"gender": {
							"description": "Pour des promotions exclusives pour les femmes, les hommes ou autres.",
							"name": "Genre"
						},
						"guestList": {
							"name": "Liste d'invités"
						},
						"maximumPlaceFrequency": {
							"name": "Jauge maximum sur site"
						},
						"maximumValueConsumed": {
							"name": "Montant maximum consommé"
						},
						"minimumPlaceFrequency": {
							"name": "Fréquentation minimum sur site"
						},
						"minimumRechargeValue": {
							"description": "Pour les promotions qui requièrent un rechargement minimum de la part du client.",
							"name": "Montant minimum du rechargement"
						},
						"minimumValueConsumed": {
							"description": "Pour les promotions qui exigent que l'utilisateur consomme un montant minimum pour pouvoir bénéficier de la promotion.",
							"name": "Montant minimum consommé"
						},
						"ppuUsage": {
							"description": "Pour les promotions de vente effectuées exclusivement par l'intermédiaire de l'application.",
							"name": "Utilisation du PPU"
						},
						"productsConsumed": {
							"description": "Pour les promotions auxquelles le client a droit lors de l'achat d'un produit ou d'une catégorie de produits.",
							"name": "Acheter un produit ou une catégorie spécifique"
						},
						"productsConsumedQuantity": {
							"name": "Nombre de produits consommés"
						}
					},
					"promotionUsage": {
						"period": {
							"description": "Définir une période pendant laquelle le client peut utiliser la promotion",
							"name": "Heure"
						},
						"secondsToExpire": {
							"description": "Définir le délai dont dispose le client pour bénéficier de la promotion à laquelle il a droit",
							"name": "Délai d'expiration"
						},
						"weekDays": {
							"description": "Définir les jours de la semaine où le client peut utiliser la promotion",
							"name": "Jours de la semaine"
						}
					}
				},
				"steps": {
					"awards": "Récompenses",
					"goals": "Objectifs",
					"promotionInfo": "Info Promotions",
					"resume": "Synthèse",
					"usageConditions": "Conditions d'Utilisation"
				},
				"stepsPages": {
					"goals": {
						"add": "Ajouter Objectif",
						"tableWarningMessage": "Information non disponible pour les tables.",
						"conditions": {
							"birthday": {
								"day": "Anniversaire ce jour",
								"month": "Anniversaire dans le mois",
								"week": "Anniversaire dans la semaine"
							},
							"checkin": {
								"label": "Heure d'arrivée"
							},
							"gender": {
								"female": "Femme",
								"male": "Homme",
								"others": "Autre"
							},
							"minimumRecharge": {
								"label": "Montant minimum du rechargement"
							}
						},
						"error": "La condition TOUS LES CLIENTS doit être supprimée",
						"label": "Récurrence des revenus",
						"new": "Nouvel objectif",
						"placeholder": "Sélectionner une récurrence maximum des revenus"
					},
					"usageConditions": {
						"conditions": {
							"expiration": {
								"label": "Jours calendaires:",
								"suffix": "Jours"
							},
							"modal": {
								"add": "Ajouter une condition d'utilisation",
								"new": "Nouvelle condition d'utilisation"
							},
							"period": {
								"beginTime": "De :",
								"endTime": "à :",
								"error": "Format d'heure non valide pour la conversion"
							},
							"week": {
								"infoText": "Comme les événements peuvent commencer un jour de la semaine et se terminer l'autre jour, la promotion est valable le jour où l'événement commence. Le client peut donc utiliser la promotion le lendemain si l'événement a commencé la veille.",
								"validPromotion": "Promotion valide"
							}
						}
					}
				},
				"stepsWrapper": {
					"description": "Description introuvable",
					"save": "Sauvegarder les modifications",
					"title": "Titre non trouvé"
				}
			},
			"defaultName": "Copie de {{promotion}}",
			"errors": {
				"nameLength": "Le nom de la promotion n'a pas atteint le nombre minimum de caractères.",
				"notFilledCorrectly": "Les champs n'ont pas été remplis correctement.",
				"sameName": "Le nom de la copie est le même que celui de l'original."
			},
			"peopleTable": {
				"download": "Télécharger le modèle de tableau",
				"error": "Format invalide",
				"example": "exemple de tableau",
				"import": "Importer tableau"
			},
			"table": {
				"goals": {
					"empty": "Pas d'objectif",
					"label": "Liste d'objectifs de la promotion",
					"new": "Nouvel objectif"
				},
				"usageConditions": {
					"empty": "Pas de conditions d'utilisation",
					"label": "Liste des conditions d'utilisation de la promotion",
					"new": "Nouvelle condition d'utilisation"
				}
			}
		},
		"promotions": {
			"card": {
				"active": "Active",
				"expiresAt": "Expire dans {{date}} jour(s)",
				"inactive": "Inactive",
				"noExpirationDate": "Pas de date d'expiration",
				"subtitle": "Réduction {{discount}}",
				"withoutDiscount": "Pas de réduction"
			},
			"create": "Créer Promotion",
			"createPromotion": {
				"awards": {
					"description": "Sélectionnez les produits et les réductions auxquels le client aura droit.",
					"discountType": {
						"error": "Les produits suivants ont un montant inférieur à la réduction accordée",
						"label": "Type de réduction",
						"percentage": "Pourcentage",
						"table": {
							"add": "Ajouter Produits",
							"empty": {
								"description": "Si vous ne sélectionnez pas de produits, la promotion s'appliquera à tous les produits.",
								"label": "Pas de produit sélectionné"
							},
							"error": "Les montants maximum et minimum ne correspondent pas",
							"price": "Prix de vente",
							"product": "Produit",
							"promotionalPrice": "Prix promotionnel",
							"total": "Total de {{count}} produit(s)"
						},
						"value": "Montant"
					},
					"maxUses": {
						"label": "Nombre maximal d'utilisations par revenu",
						"withoutLimits": "Pas de limite"
					},
					"title": "Récompenses"
				},
				"goals": {
					"description": "Les objectifs sont des paramètres qui déterminent ce que votre client doit faire pour obtenir la promotion.",
					"title": "Objectifs"
				},
				"promotionInfo": {
					"description": "Définissez tous les paramètres nécessaires pour créer une promotion ciblée pour vos clients.",
					"errors": {
						"dateFormat": "Format de date invalide",
						"dayDiff": "Un décalage d'au moins un jour est nécessaire",
						"requiredField": "Ce champ est obligatoire",
						"selectPlace": "Veuillez sélectionner au moins un lieu",
						"maxUses": "La valeur ne doit pas dépasser la quantité de produits définie à l'étape précédente."
					},
					"expiration": {
						"info": "La promotion sera valable jusqu'à la date sélectionnée. À la date d'expiration, la promotion sera inactive et vous pourrez modifier la date d'expiration.",
						"label": "Expiration",
						"notExpire": "PAs de date d'expiration"
					},
					"places": "Lieux avec promotion",
					"promotionDescription": {
						"label": "Description de laromotion",
						"placeholder": "Saisissez la description de la promotion"
					},
					"promotionName": {
						"label": "Nom de la promotion",
						"placeholder": "Saisir le nom de la promotion"
					},
					"title": "Info Promotion"
				},
				"resume": {
					"description": "Vérifiez que toutes les informations sont correctes, puis publiez la promotion. Elle sera automatiquement activée et prête à être utilisée.",
					"sections": {
						"allProducts": "Tous les produits",
						"andMore": "et plus {{count}} produits",
						"awards": {
							"discount": "Réduction (%) sur le montant du produit",
							"products": "Produits avec réduction",
							"title": "Récompenses"
						},
						"goals": {
							"frequency": "Récurrence des revenus",
							"title": "Objectifs"
						},
						"promotionInfo": {
							"description": "Description",
							"maxUses": {
								"label": "Quantités d'utilisations par revenus",
								"oneUse": "{{use}} utilisation",
								"uses": "{{uses}} utilisations"
							},
							"name": "Nom",
							"places": "Lieux",
							"title": "Info Promotion"
						},
						"usageConditions": "Conditions d'utilisation"
					},
					"title": "Synthèse"
				},
				"usageConditions": {
					"description": "Dans cette étape, vous pouvez définir les paramètres d'utilisation de la promotion. Lorsque le client gagne la promotion, il ne peut l'utiliser que s'il respecte les conditions d'utilisation suivantes.",
					"title": "Conditions d'utilisation",
					"warning": "- Les conditions d'utilisation de « Acheter et gagner » sont également utilisées pour remporter la promotion. \n - L'expiration après gagner ne s'applique pas à \"Acheter et gagner\"."
				}
			},
			"empty": "La recherche n'a donné aucun résultat",
			"filter": {
				"active": "Active",
				"all": "Toutess",
				"inactive": "Inactive",
				"label": "Filtrer"
			},
			"search": "Recherche par nom de promotion",
			"selected": {
				"feature": "La fonction 'Achetez et gagnez' doit être active.",
				"active": "Active",
				"clientList": "Liste des clients",
				"clientListModal": {
					"addClient": {
						"label": "Ajouter des clients à la liste",
						"placeholder": "Saisir le document du client",
						"placeholderForeign": "Saisir le numéro de téléphone du client",
						"addClient": "Ajouter un client",
						"foreign": "Étranger"
					},
					"columns": {
						"cpf": "CPF",
						"cpfForeign": "Document",
						"name": "Nom",
						"phone": "Téléphone"
					},
					"error": "Impossible d'ajouter les clients ci-dessous :",
					"remove": "Supprimer les clients sélectionnés",
					"search": "Rechercher par nom ou CPF",
					"searchForeign": "Rechercher par nom ou téléphone",
					"title": "Liste des clients {{promotionName}}"
				},
				"copy": "Créer copie",
				"discountValue": {
					"title": "réduction {{discount}}",
					"unavailable": "Indisponible"
				},
				"erasePromotion": {
					"confimation": "Êtes-vous sûr de vouloir supprimer la promotion ?",
					"title": "Supprimer Promotion"
				},
				"expirationTime": {
					"noExpires": "Pas de date d'expiration",
					"title": "Expire dans : {{date}} jours"
				},
				"inactive": "Inactif",
				"maxUses": {
					"title": "{{uses}} utilisations par personne",
					"withoutLimit": "Pas de limite d'utilisation unique"
				},
				"productsList": {
					"all": "Tous les produits",
					"seeLess": "Voir moins",
					"seeMore": "Voir plus",
					"title": "PRODUITS EN PROMOTION",
					"unavailable": "Produit indisponible"
				},
				"title": "Nom de la promotion"
			},
			"sideTab": {
				"delete": "Supprimer",
				"modalConfirm": {
					"additionalText": "En désactivant la promotion, tous les clients qui l'ont reçue ne pourront plus l'utiliser jusqu'à ce qu'elle soit à nouveau activée. En outre, bien qu'elle figure sur la liste des promotions du point de vente, le staff ne pourra l'accorder à aucun client.",
					"errorMessage": "Nom de promotion incorrect",
					"inactivePomotion": "Désactiver la promotion",
					"infoText": "Saisissez le nom complet de la promotion pour confirmer votre action",
					"placeholderInactivePromotion": "Indiquez ici le nom de la promotion",
					"text": "Il y a actuellement des événements ouverts. Lorsque vous désactivez cette promotion, vous devez vous reconnecter manuellement sur chaque appareil.",
					"title": "Désactiver Promotion",
					"tooltipInactivePromotion": "Vous devez saisir le nom de la promotion exactement tel qu'il est enregistré pour procéder à la désactivation."
				},
				"popConfirm": {
					"deletePromotion": "Supprimer Promotion",
					"title": "Êtes-vous sûr de vouloir supprimer la promotion ?"
				},
				"promotionIs": {
					"active": "Active",
					"inactive": "Inactive"
				}
			},
			"title": "Promotions",
			"withoutPromotions": "Il n'y a pas de promotions enregistrées"
		},
		"search": {
			"activeTab": "rechercher",
			"columns": {
				"emitted": "Date d'émission",
				"transactionDate": "Date de la transaction",
				"everestUploadTime": "Date de téléchargement sur Everest",
				"isCanceled": "Annulé",
				"downloadPDF": "Télécharger PDF",
				"type": "Type",
				"xml": {
					"download": "Télécharger Facture XML",
					"label": "XML",
					"labelCancelledInvoice": "XML de cancelación",
					"downloadCancelledInvoice": "Télécharger XML de cancelación"
				},
				"json": {
					"labelInvoice": "JSON du document",
					"labelCreditNote": "JSON de la note de crédit",
					"download": "Télécharger JSON"
				}
			},
			"export": "Exporter tableau",
			"placeholder": "Numéro de facture",
			"foreignDescription": "Permet de rechercher par le numéro du document fiscal et de filtrer par période.",
			"search": "Rechercher",
			"sheet": {
				"columns": {
					"emitted": "Date d'émission",
					"everestUploadTime": "Date de téléchargement sur Everest",
					"isCanceled": "Annulé",
					"xml": "XML",
					"cancelledXml": "XML de cancelación",
					"jsonInvoice": "JSON facture",
					"jsonCreditNote": "JSON note de crédit"
				},
				"filename": "rechercher_facture",
				"title": "Rechercher Factures"
			},
			"title": "Rechercher Factures"
		},
		"searchPlaceInputPlaceholder": "Rechercher un lieu",
		"placeWithoutEvent": "Lieux sans événement pendant plus d'un mois",
		"settings": {
			"menu": {
				"title": "Autres options de configuration",
				"general": {
					"title": "Général",
					"subtitle": "Informer les limites, e-mails et autres"
				},
				"record": {
					"title": "Jeton",
					"subtitle": "Configurer le mode jeton"
				},
				"couvert": {
					"title": "Couverture",
					"subtitle": "Définir les frais de couverture"
				},
				"features": {
					"title": "Fonctionnalités",
					"subtitle": "Activer les fonctionnalités souhaitées"
				},
				"pdv": {
					"title": "POS",
					"subtitle": "Configurer le point de vente"
				},
				"totem": {
					"title": "Totem",
					"subtitle": "Personnaliser un totem"
				},
				"refundReason": {
					"title": "Motifs de remboursement/annulation",
					"subtitle": "Configurez les motifs pour le point de vente"
				},
				"vendor": {
					"title": "Fournisseur",
					"subtitle": "Configurer les informations générales"
				},
				"fiscalPrinter": {
					"title": "Imprimantes fiscales",
					"subtitle": "Configurez les imprimantes fiscales"
				}
			},
			"alert": "Des modifications ont été apportées, sauvergarder pour les conserver.",
			"alterImage": "l'image a été modifiée avec succès",
			"attention": "Attention !",
			"url": "nomduproduit",
			"daysAndWorkingPeriod": "Jours et heures de fonctionnement",
			"address": {
				"postalCode": "Code Postal",
				"state": "État",
				"city": "Ville",
				"neighborhood": "Quartier",
				"address": "Adresse",
				"number": "Numéro",
				"complement": "Complément"
			},
			"workingPeriod": {
				"deletedPeriod": "Période supprimée.",
				"addDaysAndTime": "Ajouter des jours et des heures",
				"addOpeningHours": "Ajouter des heures d'ouverture",
				"daysOfTheWeek": "Jours de la semaine",
				"start": "Début",
				"end": "Fin"
			},
			"consumption": {
				"fiscalGroup": "Groupe fiscal",
				"fiscalProfile": "Profile fiscal",
				"label": "Mise en place d'une taxe minimale à la consommation",
				"ncm": "NCM"
			},
			"data": {
				"peopleCapacity": "Capacité",
				"slug": "Slug",
				"peopleCapacityTooltip": "Nombre de personnes que le lieu accueille.",
				"label": "Données",
				"name": "Nom",
				"noneProduct": "Auncun produit",
				"selectProduct": "Sélectionnez un produit pour activer le dépôt de garantie automatique"
			},
			"passTemplate": "ID du modèle de passe",
			"devices": {
				"label": "POS du lieu ({{counter}})",
				"placeholder": "Ajouter un POS à ce lieu",
				"requestDevices": "Demander des appareils"
			},
			"email": "Emails pour recevoir la clôture d'événements",
			"emailError": "email invalide",
			"error": "Pas d'autorisation pour modifier le lieu",
			"errors": {
				"hasConsumptionObligation": "Champ obligatoire pour la configuration de l'obligation de consommation",
				"invalidName": "Veuillez saisir un nom valide",
				"invalidTip": "Saisir un montant allant jusqu'à 25 %.",
				"postPaidLimit": "Veuillez saisir un montant valide",
				"rechargeNotIntegratedLimit": "Montant minimum de",
				"minNonIntegratedPaymentLimit": "Montant minimum de {{value}}",
				"tipOptionsValuesRequired": "Les valeurs de pourboire sont nécessaires",
				"tipOptionLowerValue": "La \"Valeur inférieure\" doit être inférieure aux valeurs Moyenne et Supérieure",
				"tipOptionHigherValue": "La \"Valeur supérieure\" doit être supérieure à la valeur Moyenne"
			},
			"tip": {
				"taxType": "Type de taxe",
				"tipSuggestions": "Suggestions de pourboire",
				"tip": "Pourboire",
				"serviceTax": "Frais de service",
				"none": "Aucun",
				"lowerValue": "Valeur inférieure",
				"medValue": "Valeur moyenne",
				"higherValue": "Valeur supérieure",
				"tooltip": "Les recommandations de pourboire rendent le paiement de l'addition plus facile en proposant trois options de pourcentages (Moins, Moyenne et Plus) basées sur le montant total de l'addition, par exemple : 5%, 10% et 15%, limitées à 25%."
			},
			"everest": {
				"cnpj": "CNPJ",
				"host": "Hôte",
				"label": "Everest",
				"password": "Mot de passe",
				"user": "Utilisateur"
			},
			"ficha": {
				"text": "Titre du fichier",
				"placeholderText": "Entrez le titre de la carte",
				"logo": "Image à imprimer",
				"label": "Token",
				"upload": "Joindre l'image",
				"formatError": "Format non pris en charge",
				"imageFormatMessage": "L'image doit être au format PNG ou SVG.",
				"recommendationMessage": "Nous recommandons que l'image attribuée soit le logo de l'entreprise en noir, car il n'est pas possible d'imprimer dans une autre couleur.",
				"dragOrSelectMessage": "Faites glisser l'image depuis votre ordinateur ou sélectionnez-la à partir de 'Joindre l'image'.",
				"logoFormatMessage": "Le logo doit être au format PNG ou SVG avec un fond transparent."
			},
			"limits": {
				"label": "Limites et services",
				"postPaidLimit": "Limite post-payée",
				"rechargeNotIntegratedLimit": "Limite de rechargement non intégrée",
				"serviceTax": "Frais de gestion",
				"nonIntegratedPaymentLimit": "Limite de paiement non intégrée par appareil et événement",
				"enableBuiltInLimit": "Activer la limite de recharge non intégrée",
				"enableNonIntegratedPaymentLimit": "Habilitar limite de paiement non intégrée par appareil et événement",
				"nonIntegratedPaymentLimitTooltip": "Cette limite fait référence au montant maximal de paiements non intégrés qu'un appareil peut recevoir pendant l'événement. Ce paramètre est la somme du total des Recharges et des Ventes sans Carte effectuées avec des paiements non intégrés.",
				"nonIntegratedRechargeLimitTooltip": "Cette limite fait référence au montant maximum qu'un employé peut gagner dans une recharge non intégrée."
			},
			"paymentBilling": {
				"hybrid": "Hybride",
				"pos": "Pos",
				"pre": "Pre"
			},
			"image": "Photo",
			"placeFeatures": "Functionalités",
			"refundReason": {
				"addReason": "Créer un raison",
				"cancel": "Annulation",
				"modalDelete": {
					"confirmation": "Voulez-vous supprimer la motif de la liste des motifs de remboursement et d'annulation ?",
					"description": "En supprimant le motif, il n'apparaîtra plus, mais restera dans les anciens rapports.",
					"title": "Supprimer la catégorie de remboursement"
				},
				"modalForm": {
					"addReason": "Créer une motif",
					"allowOpenText": "Activer la justification",
					"creatingReason": "Création d'une motif",
					"editReason": "Enregistrer les modifications",
					"editingReason": "Modification d'une motif",
					"reason": "Nom de la motif",
					"reasonPlaceholder": "Entrez le nom de la motif de remboursement et/ou d'annulation"
				},
				"reason": "Nom de la motif",
				"removeReason": "Modifier la motif",
				"refund": "Remboursement",
				"table": {
					"editReason": "Modifier la motif",
					"observation": "Observation",
					"reason": "Nom de la motif",
					"removeReason": "Supprimer la motif",
					"status": "Statut",
					"type": "Type"
				},
				"title": "Motifs de remboursement et d'annulation"
			},
			"fiscalPrinter": {
				"title": "Imprimantes fiscales",
				"name": "Nom",
				"type": "Type",
				"ip": "IP",
				"actions": "Actions",
				"deletedSuccessfully": "Imprimante supprimée avec succès",
				"addedSuccessfully": "Imprimante ajoutée avec succès"
			},
			"save": "Sauvegarder",
			"settings": {
				"label": "Paramètres",
				"myActionsPassword": {
					"label": "Mot de passe ¨Mes Actions¨",
					"placeholder": "EEntrez un mot de passe numérique ou le mot de passe par défaut sera 9090."
				},
				"sellVisualizationFormat": {
					"grid": "Grille",
					"label": "Format d'affichage des produits en vente",
					"list": "Liste"
				}
			},
			"title": "Modifier Paramètres",
			"warningDialog": "Vous activez les paiements postpayés sur '{{name}}'. Êtes-vous sûr de vous ? Pour confirmer la modification, veuillez taper '{{text}}'.'",
			"totem": {
				"important": "Important",
				"instructions": "Pour personnaliser le totem correctement, assurez-vous que l'image présente les caractéristiques suivantes :",
				"logo": "Le logo de Zig restera sur le totem au même emplacement après la personnalisation.",
				"image": "Incluez un message dans l'image indiquant au client de toucher l'écran pour démarrer l'achat.",
				"dimensions": "Dimensions : 1080 pixels de large x 1920 pixels de haut.",
				"quality": "Cela garantira une personnalisation de haute qualité.",
				"colors": "Personnalisez les couleurs de votre totem : choisissez les couleurs primaires et secondaires selon votre préférence."
			},
			"vendor": {
				"definitions": "Définitions",
				"serviceFee": "Frais de service",
				"serviceTransfer": "Transfert de service",
				"serviceFeeVendor": "Fournisseur de frais de service",
				"serviceFeeVendorRequired": "Sélectionnez le fournisseur de la taxe de service",
				"serviceFeeVendorPlaceholder": "Sélectionnez le fournisseur pour recevoir le transfert",
				"paymentMethodSuccess": "Les méthodes de paiement du Vendor ont été mises à jour avec succès !",
				"serviceTransferSuccess": "Fournisseur de la taxe de service mis à jour avec succès !",
				"saveMethods": "Enregistrer les retenues",
				"resetChanges": "Restaurer les valeurs initiales",
				"vendor": "Fournisseur",
				"selectVendor": "Sélectionnez un fournisseur",
				"paymentMethods": "Conservation de tous les montants effectués sur place",
				"tooltip": "Si un fournisseur est sélectionné, la totalité du montant effectué en utilisant le mode de paiement choisi sera conservée sur le relevé de ce fournisseur.",
				"paymentMethod": "Méthode de paiement",
				"paymentMethodOptions": {
					"credit": "Crédit non intégré",
					"debit": "Débit non intégré",
					"cash": "Espèces",
					"voucher": "Bon"
				},
				"reprocessButton": "Retraiter les fournisseurs",
				"confirmReprocess": "Confirmer le retraitement",
				"reprocessLabel": "Événement",
				"reprocessPlaceholder": "Entrez l'ID de l'événement",
				"reprocessEmptySelect": "Selecione pelo menos um evento para reprocessar",
				"reprocessSuccess": "Les fournisseurs ont retraité avec succès"
			},
			"invoiceMoment": {
				"fieldLabel": "Sélectionnez le moment pour l'émission de la facture cashless",
				"tip": "Sélectionnez le moment de l'émission de la facture pour les paiements sans numéraire. Pour tous les autres modes de paiement qui ne sont pas sans numéraire, la facture sera toujours émise lors de la consommation",
				"recharge": "Recharge",
				"rechargeAndActivation": "Recharge et activation",
				"consumption": "Consommation",
				"consumptionAndActivation": "Consommation et activation"
			},
			"authKeysFeature": {
				"phone": "Téléphone",
				"email": "Courriel",
				"keySelectLabel": "Choisissez le type de clé",
				"addKey": "Ajouter des clés d'authentification",
				"contactsInputLabel": "Ajoutez une ou plusieurs clés pour l'authentification",
				"contactsEmailInputPlaceholder": "Entrez un courriel valide (ex: email@gmail.com)",
				"contactsPhoneInputPlaceholder": "Entrez un numéro de téléphone (ex: +55 (00) 0 00000000",
				"btnAddKey": "Ajouter des clés d'authentification",
				"btnCancelAddKey": "Annuler",
				"authKeyAreaTitle": "Authentification de retrait",
				"authKeyAreaSubtitle": "Enregistrez des clés (courriel ou téléphone) qui seront utilisées pour recevoir le code d'authentification lors de la demande d'un retrait.",
				"selectContactKeyMessage": "Sélectionnez un type de clés",
				"selectContactInputMessage": "Remplissez une clé de contact",
				"contactAlreadyExists": "Ce contact existe déjà !",
				"invalidEmail": "Courriel invalide",
				"invalidPhone": "Téléphone invalide. Doit contenir l'indicatif (ex: +5511999999999)",
				"incompletePhone": "Numéro de téléphone incomplet. Entrez tous les chiffres.",
				"invalidDDI": "Seuls les numéros de téléphone brésiliens sont acceptés. Utilisez l'indicatif +55 ou laissez-le vide.",
				"errorCreatingAuthKeys": "Erreur lors de la création des clés d'authentification",
				"invalidContactsFound": "Contacts invalides trouvés. Vérifiez les données et réessayez.",
				"errorCreatingSomeKeys": "Erreur lors de la création de certaines clés: {{errors}}"
			},
			"defaultDateFilter": "Filtre de date par défaut"
		},
		"subtitle": "Légende",
		"subtitles": {
			"longTimeWithoutEvent": "Longue période sans événement",
			"noEvent": "Aucun événémenent",
			"onGoingEvent": "Événement en cours",
			"recentEvent": "Événement récent",
			"waitingForApproval": "En attente de validation"
		},
		"timezone": "Timezone",
		"recharges": {
			"title": "Recharges",
			"activeTab": "recharges",
			"export": "Exporter Excel",
			"transactionedValue": "Valeur Transigée",
			"value": "Valeur Émise",
			"netValue": "Valeur Nette Émise",
			"periodFilter": "Filtrer par période",
			"eventsFilter": "Filtrer par événements",
			"filterIssuedLabel": "Filtrer par statut",
			"eventsSelected": "événements sélectionnés",
			"eventsFilterPlaceholder": "Sélectionnez les événements",
			"descriptionForeign": "Ce rapport montre toutes les recharges et affiche les informations de la Facture associée, le cas échéant. Il permet de filtrer par période, événements et statut.",
			"columns": {
				"totalValue": "Valeur de la recharge",
				"usedValue": "Valeur utilisée",
				"date": "Date",
				"eventName": "Événement",
				"eventDate": "Date de l'événement",
				"cnpj": "CNPJ Émetteur",
				"cpf": "CPF Client",
				"type": "Type",
				"issuerNIF": "NIF du commerçant",
				"recipientNIF": "NIF du client",
				"invoiceSeries": "Série de la facture",
				"invoiceNumber": "Numéro de la facture",
				"invoiceValue": "Valeur de la facture",
				"invoiceNetValue": "Valeur Nette de la Facture",
				"invoiceDate": "Date d'émission"
			}
		},
		"transactions": {
			"activeTab": "transactions",
			"columns": {
				"transactionId": "Id de transaction",
				"cnpj": "CNPJ du Détaillant",
				"count": "Quant.",
				"cpf": "CPF du Client",
				"issuerNIF": "NIF du Détaillant",
				"recipientNIF": "NIF du Client",
				"date": "Date",
				"discountValue": "Réductions",
				"eventDate": "date de l'événement",
				"eventName": "Événément",
				"invoiceDate": "Date d'émission",
				"type": "Taper",
				"invoiceNumber": "No.",
				"invoiceSeries": "Séries de facture",
				"invoiceValue": "Montant Facture",
				"invoiceNetValue": "Valeur nette Facture",
				"total": "Valeur totale",
				"isCombo": "Combo",
				"productName": "Produit",
				"value": "Valeur unitaire",
				"netValue": "Valeur nette"
			},
			"export": "Exporter tableau",
			"period": "Période",
			"sheet": {
				"columns": {
					"transactionId": "Id de transaction",
					"cnpj": "CNPJ du Détaillant",
					"count": "Quantité",
					"cpf": "CPF du Client",
					"issuerNIF": "NIF du Détaillant",
					"recipientNIF": "NIF du Client",
					"date": "Date",
					"discountValue": "Réduction",
					"eventDate": "Date de l'événement",
					"eventName": "Événement",
					"type": "Taper",
					"invoiceDate": "Date d'émission",
					"invoiceNumber": "No.",
					"invoiceSeries": "Séries de facture",
					"invoiceValue": "Montant Facture",
					"invoiceNetValue": "Valeur nette Facture",
					"isCombo": "It's Combo",
					"productName": "Produit",
					"value": "Valeur unitaire",
					"total": "Valeur totale",
					"netValue": "Valeur nette"
				},
				"filename": "transactions",
				"filenameForeign": "produits",
				"title": "Transactions",
				"titleForeign": "Produits"
			},
			"title": "Transactions",
			"descriptionForeign": "Dans ce rapport, il est possible d'avoir une vue de la facturation fiscale émise en tenant compte de chaque produit transigé, avec la possibilité de filtrer par période et statut. Le montant brut émis inclut la Taxe sur la Valeur Ajoutée (TVA), tandis que le montant net émis est calculé après déduction de la TVA",
			"valueTransactioned": "Valeur totale échangée",
			"value": "Valeur émise brute",
			"netValue": "Valeur nette d'émission",
			"titleForeign": "Produits",
			"filterIssued": "Émis",
			"filterNotIssued": "Non émis",
			"filterIssuedLabel": "Filtrer par statut"
		},
		"whatsUp": {
			"aboutSection": {
				"arena": "Arena",
				"bar": "Pub",
				"barAndRestaurant": "Bar et restaurant",
				"beachClub": "Beach club",
				"bistro": "Bistro",
				"descriptionEvent": "À cette étape, vous devez remplir les informations concernant l'événement. Essayez de remplir toutes les informations de façon claire et simple.",
				"descriptionInput": "Description (optionel)",
				"descriptionPlace": "À cette étape, vous devez remplir les informations concernant le lieu. Essayez de remplir toutes les informations de façon claire et simple.",
				"event": "Événement",
				"eventCategory": "Catégorie de l'événement",
				"eventDescriptionPlaceHolder": "Écrivez une courte description de l'événement",
				"eventName": "Nom de l'événement",
				"eventTagLimit": "Vous pouvez sélectionner jusqu'à 6 cartes. Les cartes aideront les utilisateurs à en savoir plus sur les éléments différenciateurs de votre événement.",
				"festival": "Festival",
				"musicTagLimit": "Utilisez les styles de cartes pour aider à faire connaître votre lieu/événement aux utilisateurs intéressés par les mêmes styles..",
				"musicTagPlaceholder": "Sélectionner jusqu'à 3 styles musicaux",
				"musicTags": "Style de musique",
				"nightclub": "Ballade",
				"placeCategory": "Catégorie de lieu",
				"placeDescriptionPlaceHolder": "Écrivez une courte description du lieu",
				"placeName": "Nom du lieu",
				"placeTagLimit": " Vous pouvez sélectionner jusqu'à 6 cartes. Les cartes aideront les utilisateurs à en savoir plus sur les éléments différenciateurs de votre lieu.",
				"pub": "Pub",
				"restaurant": "Restaurant",
				"show": "Spectacle",
				"tags": "Cartes",
				"tagsPlaceholder": "Sélectionner jusqu'à 6 cartes",
				"titleEvent": "À propose de l'événement",
				"titlePlace": "À propose du lieu"
			},
			"active": {
				"description": "Aucun frais supplémentaire ne sera facturé pour afficher votre lieu sur l'app ZIG",
				"titleEvent": "Afficher l'événement dans l'application utilisateur",
				"titlePlace": "Afficher le lieu dans l'application utilisateur",
				"unfilledFields": "Activation impossible. Certains champs obligatoires ne sont pas remplis."
			},
			"addressSection": {
				"address": "Adresse",
				"addressPlaceholder": "Nom de la rue ou e l'avenue",
				"city": "ville",
				"complement": "Complément (optionel)",
				"complementPlaceholder": "Complément d'adresse",
				"neighborhood": "Quartier",
				"number": "Numéro",
				"state": "État",
				"title": "Adresse",
				"titleOptional": "Complément d'adresse (optionel)",
				"zigLocation": "Antenne ZIG",
				"zigLocationTooltip": "Il s'agit de l'antenne ZIG où votre lieu a été enregistré. si vous désirez changer, veuillez contacter notre équipe.",
				"zipCode": "Code postal",
				"zipCodeLink": "Je ne connais pas mon Code postal"
			},
			"appearsInAppModal": {
				"description": "En le désactivant, votre lieu ne sera pas affiché dans l'application utilisateur. Voulez-vous continuer ?",
				"title": "Ne pas partager le lieu sur l'application"
			},
			"cancelEditModal": {
				"description": "En annulant la modification, les modifications ne seront pas sauvegardées. Voulez-vous continuer ?",
				"title": "annuler la modification"
			},
			"description": "Remplissez les données et partagez votre événement avec vos clients via l'application ZIGPAY. Permettez aux utilisateurs d'accéder aux heures d'ouverture, aux médias sociaux, aux photos et aux liens externes.",
			"edit": "Modifier les informations",
			"eventPublishObs": "En publiant, vous acceptez d'afficher les informations relatives à votre événement sur l'application ZIG et d'être responsable du contenu publié.",
			"formValidations": {
				"city": "Ville est un champ obligatoire",
				"date": "Date est un champ obligatoire",
				"description": "Limite de 160 caractères atteinte",
				"generalError": "*Les informations obligatoires n'ont pas été remplies",
				"image": "Image est obligatoire",
				"imageSize": "Charger des images jusq'à 500kb",
				"link": "Veuillez saisir un lien valide",
				"linkHighlightType": "Bouton réseau est un champ obligatoire",
				"locationCategory": "Catégorie di lieu est un champ obligatoire",
				"name": "Nom est un champ obligatoire",
				"nameMaxLength": "Le nombre maximum de caractère est {{maxLength}}",
				"neighborhood": "Quartier est un champ obligatoire",
				"postalCode": "Code postal est un champ obligatoire",
				"state": "État est un champ obligatoire",
				"streetName": "Adresse est un champ obligatoire",
				"streetNumber": "Numéro est un champ obligatoire",
				"tags": "Vous pouvez sélectionner jusqu'à {{numberTags}} cartes",
				"zigLocation": "Antenne ZIG est un champ obligatoire"
			},
			"inactive": {
				"eventTitle": "Votre événement n'est pas visible dans l'application. Il est important d'activer l'affichage.",
				"placeTitle": "Votre lieu n'est pas visible dans l'application. Il est important d'activer l'affichage."
			},
			"linkSection": {
				"buttonHighlight": "Bouton Réseau (optionél)",
				"facebook": " Facebook",
				"instagram": "Instagram",
				"pasteHere": "Coller ici",
				"reservation": "Réservations",
				"site": "Site",
				"ticket": "Billets",
				"title": "Liens externes (optionel)"
			},
			"operationSection": {
				"add": "Ajouter",
				"date": "Date",
				"day": "Jour",
				"eventDescription": "Saisir le jour et les horaires de votre événement",
				"eventTitle": "Dates de l'événement",
				"friday": "Vendredi",
				"monday": "Lundi",
				"placeDescription": "Indiquez le jour et les heures d'ouverture de votre lieu. Si votre lieu ne fonctionne pas certains jours de la semaine, ne l'ajoutez pas à la liste ci-dessous.",
				"placeTitle": "Horaires d'ouverture",
				"saturday": "Samedi",
				"sunday": "Dimanche",
				"thursday": "Jeudi",
				"time": "Heure (optionel)",
				"tuesday": "Mardi",
				"until": "Jusqu'à",
				"wednesday": "Mercredi"
			},
			"placePublishObs": "En publiant des informations, vous acceptez d'afficher vos informations de localisation dans l'application ZIG et d'être responsable du contenu publié.",
			"profileSection": {
				"brandImage": "Image de marque",
				"brandImageObs": "Image carrée ou 500x500 pixels",
				"description": "Vous pouvez télécharger des images d'une taille maximale de 500 kb aux formats .png, .jpg ou .jpeg selon les dimensions mentionnées ci-dessous :",
				"frontCoverImage": "Image de couverture",
				"galleryImage": "Image pour la gallerie (optionél)",
				"horizontalImageObs": "Image horizontale ou 1280x780 pixels",
				"seePreview": "Voir l'aperçu de l'app",
				"title": "Profil"
			},
			"publish": "Publier",
			"successModal": {
				"description": "ssurez-vous que la fonction \"Afficher la lieu dans l'application utilisateur\" est activée pour que votre lieu soit affiché dans Zig.app.",
				"eventTitle": "Les informations ont été sauvegardées avec succès !",
				"placeTitle": "Les informations ont été sauvegardées avec succès !"
			},
			"title": "Quoi de neuf ?"
		},
		"inventoryControl": {
			"title": "Inventaire",
			"emptyState": {
				"title": "Vous n'avez pas encore d'inventaire",
				"infoEmpty": "Cliquez sur ajouter créer un inventaire pour commencer",
				"addNewInventory": "Nouvel inventaire"
			},
			"homeInventoryControl": {
				"titleHome": "Inventaire",
				"description": "L'inventaire joue un rôle très important dans l'entreprise en aidant à contrôler les marchandises et à identifier les pertes et les éventuels écarts.",
				"buttonCreate": "Créer un inventaire",
				"mostRecent": {
					"titleSection": "Le plus récent"
				},
				"inventoryHistory": {
					"input": {
						"search": "Rechercher par",
						"placeholder": "Titre, stock ou dépositaire"
					},
					"select": {
						"filterByPeriod": "Filtrer par période",
						"filterByStatus": "Filtrer par statut",
						"allStatus": "Tous les statuts"
					},
					"titleTableColumns": {
						"inventoryTitle": "Titre de l'inventaire",
						"lastEditor": "Dernier éditeur",
						"lastEdition": "Dernière modification",
						"stockist": "Dépositaire",
						"stock": "Stock",
						"categories": "Catégories",
						"status": "Statut",
						"actions": "Actions"
					}
				}
			},
			"cardInventoryControl": {
				"cardInfo": {
					"stockist": "Dépositaire:",
					"editedIn": "Édité le:",
					"status": "Statut:",
					"statusTag": {
						"approved": "Approuvé",
						"open": "En cours",
						"in_review": "En révision",
						"reopened": "Reconté"
					}
				}
			},
			"stepperInventoryControl": {
				"steps": {
					"config": "Configuration",
					"count": "Listage et décompte",
					"ajustLoss": "Ajustements et pertes",
					"resumeInventory": "Résumé de l'inventaire",
					"approval": "Approbation"
				},
				"stepsDescription": {
					"count": "Enregistrez l'inventaire pendant le remplissage pour ne pas perdre votre progression",
					"resumeInventory": "Vérifiez les articles comptés avant d'envoyer"
				},
				"fieldRequired": "Champs requis"
			},
			"stepsInventoryControl": {
				"config": {
					"labels": {
						"titleInventory": "Donnez un titre à l'inventaire",
						"exampleTitleInventory": "ex: 'Inventaire des boissons'",
						"stockistName": "Nom du stockiste",
						"selectStock": "Sélectionnez le stock pour créer l'inventaire",
						"selectCategory": "Sélectionnez les catégories"
					},
					"inventoryPlaceholder": "Entrez le titre de l'inventaire",
					"stockPlaceholder": "Cliquez pour sélectionner",
					"categoryPlaceholder": "Cliquez pour sélectionner les catégories"
				},
				"count": {
					"labels": {
						"count": "Décompte",
						"unit": "Unité",
						"price": "Prix ​​d'achat",
						"amount": "Valeur totale",
						"deleteCategory": "Supprimer la catégorie",
						"deleteSelectedProducts": "Supprimer la sélection",
						"inventoryItems": "Articles en stock",
						"deleteItems": "Supprimer les éléments",
						"modalDescription": "En confirmant l'action, vous supprimerez définitivement {{amount}} {{itemLabel}} de l'inventaire. Souhaitez-vous continuer?",
						"modalDeleteCategoryMessage": "En confirmant l'action, la catégorie {{category}} sera supprimée définitivement. Voulez-vous continuer?",
						"modalDeleteProductMessage": "En confirmant l'action, le produit {{product}} sera supprimé définitivement. Voulez-vous continuer?",
						"deleteSelectedItems": "Supprimer les éléments sélectionnés",
						"searchProduct": "Rechercher un produit",
						"item": {
							"single": "élément",
							"plural": "éléments"
						}
					},
					"invalidCountConverted": "La quantité dans ce champ ne doit pas dépasser ou être égale à la quantité maximale de conversion enregistrée.",
					"filter": {
						"byProduct": "Organiser par produit",
						"byCategory": "Organiser par catégorie"
					},
					"notification": {
						"success": "Éléments supprimés avec succès.",
						"error": "Une erreur s'est produite lors de la suppression des éléments. Veuillez réessayer plus tard."
					}
				},
				"resume": {
					"tableColumns": {
						"category": "Catégorie",
						"quantity": "Quantité",
						"difference": "Différence",
						"system": "Système",
						"product": "Produit",
						"systemQuantity": "Quantité de système",
						"count": "Décompte",
						"countDifference": "Différence de nombre",
						"monetaryDifference": "Différence de {{currencyNarrowSymbol}}",
						"unit": "Unité",
						"action": {
							"label": "Action",
							"adjust": "Ajustement",
							"loss": "Perte"
						}
					}
				},
				"adjustLoss": {
					"tableColumns": {
						"category": "Catégorie",
						"quantity": "Quantité",
						"difference": "Différence",
						"system": "Système",
						"product": "Produit",
						"systemQuantity": "Quantité de système",
						"count": "Décompte",
						"countDifference": "Différence de nombre",
						"monetaryDifference": "Différence de {{currencyNarrowSymbol}}",
						"unit": "Unité",
						"action": {
							"label": "Action",
							"adjust": "Ajustement",
							"loss": "Perte"
						}
					}
				},
				"approval": {
					"exportExcel": "Exporter vers Excel",
					"inconsistencyInventory": {
						"products": "Produits",
						"sumOfPositiveDifferences": "Somme des différences positives",
						"sumOfNegativeDifferences": "Somme des différences négatives",
						"inconsistenciesByQuantity": "Top 5 des incohérences par quantité",
						"inconsistenciesByDiffences": "Top 5 des incohérences par valeur",
						"checkedProducts": "Produits vérifiés"
					},
					"inputPlaceholder": "Rechercher produit",
					"select": {
						"all": "Afficher tous les produits",
						"onlyNegativeDifference": "Seulement les produits avec une différence négative",
						"onlyPositiveDifference": "Seulement les produits avec une différence positive",
						"onlyWithoutDifference": "Seulement les produits sans différence"
					},
					"tableColumns": {
						"category": "Catégorie",
						"quantity": "Quantité",
						"difference": "Différence",
						"system": "Système",
						"product": "Produit",
						"systemQuantity": "Quantité de système",
						"count": "Décompte",
						"countDifference": "Différence de nombre",
						"monetaryDifference": "Différence de {{currencyNarrowSymbol}}",
						"unit": "Unité",
						"action": {
							"label": "Action",
							"adjust": "Ajustement",
							"loss": "Perte"
						}
					},
					"searchProduct": "Rechercher un produit"
				}
			},
			"wrapperInventoryControl": {
				"titleWrapper": "Créer un nouvel inventaire",
				"titleButtons": {
					"sendInventory": "Envoyer l'inventaire",
					"approveInventory": "Approuver l'inventaire",
					"retellInventory": "Recompter",
					"downloadInExcel": "Télécharger dans excel"
				},
				"placeholders": {
					"keywordSearch": "Rechercher par catégorie, code ou produit"
				},
				"headerInfos": {
					"name": "Nom",
					"inventoryTitle": "Titre de l'inventaire",
					"createAt": "Date de création",
					"lastEdtion": "Dernière édition",
					"detailsInventory": "Détails de l'inventaire",
					"stockist": "Gestionnaire de stock",
					"totalProducts": "Total de produits",
					"categoriesSelected": "Catégories sélectionnées",
					"storageAndCategoriesSelected": "Stock et catégories",
					"storageSelected": "Stockage sélectionné",
					"status": "Statut"
				},
				"seeMoreDetails": "Voir plus de détails",
				"drawerInfos": {
					"seeDetails": "Voir les détails"
				}
			},
			"updateStatusMessage": {
				"success": {
					"approved": {
						"title": "Inventaire terminé !",
						"message": "Inventaire terminé"
					},
					"in_review": {
						"title": "Inventaire envoyé pour révision !",
						"message": "L'inventaire sera révisé par un responsable"
					}
				},
				"error": {
					"approved": {
						"title": "Oups, quelque chose s'est mal passé !",
						"message": "Inventaire non terminé"
					},
					"in_review": {
						"title": "Oups, quelque chose s'est mal passé !",
						"message": "Inventaire non envoyé pour révision"
					}
				},
				"actions": {
					"goHome": "Retour à la page d'accueil",
					"backToResume": "Retour au résumé",
					"createAnotherInventory": "Créer un autre inventaire"
				}
			}
		},
		"alphabeticalOrder": "Ordre alphabétique",
		"lastEventOrder": "Dernier événement créé",
		"initialDefaultDateOrder": "Filtre de date par défaut",
		"financialFile": {
			"title": "Fichier financier",
			"description": "Suivez vos demandes d'équipements et d'abonnements.",
			"titleDescription": "Description",
			"downloadButton": "Télécharger",
			"table": {
				"columns": {
					"name": "Nom",
					"contractId": "ID du contrat",
					"period": "Période"
				}
			},
			"eventType": {
				"festival": "Festival",
				"fixedVenue": "Lieu fixe",
				"event": "Événement",
				"sports": "Sportif",
				"fairs": "Foires",
				"beachClub": "Club de plage",
				"retail": "Vente au détail",
				"bar": "Bar",
				"others": "Autres",
				"hotel": "Hôtel",
				"restaurant": "Restaurant",
				"school": "École",
				"arena": "Arène (Stade)",
				"hospitality": "Hospitalité",
				"nightclub": "Discothèque",
				"barRestaurant": "Bar et Restaurant",
				"beachTennisCourt": "Terrain de beach tennis",
				"carnival": "Carnaval",
				"juneParty": "Fête de juin",
				"musicFestival": "Festival de musique",
				"show": "Spectacle",
				"newYearsEve": "Réveillon du Nouvel An",
				"eventVenue": "Lieu de l'événement",
				"musicShow": "Concert de musique",
				"sportsEvent": "Événement sportif",
				"gastronomicEvent": "Événement gastronomique",
				"religiousEvent": "Événement religieux",
				"schoolEvent": "Événement scolaire",
				"seasonalHouse": "Maison saisonnière"
			},
			"eventModel": {
				"monthly": "Mensuel",
				"weekly": "Hebdomadaire",
				"oneTime": "Unique"
			},
			"invoiceType": {
				"daily": "Quotidien",
				"weekly": "Hebdomadaire",
				"monthly": "Mensuel",
				"atTermination": "À la fin",
				"perSession": "Par séance"
			},
			"financialClosingTitle": "Clôture financière",
			"zigDataSection": "Données - Zig",
			"currency": "Devise",
			"document": "Document",
			"name": "Nom",
			"address": "Adresse",
			"eventDataSection": "Données - Événement",
			"period": "Période",
			"notInformed": "Non communiqué",
			"type": "Type",
			"zigExecutive": "Exécutif Zig",
			"model": "Modèle",
			"billing": "Facturation",
			"automaticRepayment": "Virement automatique",
			"yes": "Oui",
			"no": "Non",
			"placeId": "PlaceId",
			"organizationId": "OrganizationId",
			"clientDataSection": "Données - Client",
			"client": "Client",
			"contract": "Contrat",
			"contractValidity": "Validité du contrat",
			"eventBillingHeader": "Facturation - Événement",
			"value": "Valeur",
			"total": "Total",
			"totalBilling": "Facturation totale",
			"zigBillingHeader": "Facturation - Zig",
			"item": "Article",
			"base": "Base",
			"taxRate": "Taux (%)",
			"zigInvoiceSummary": "Résumé facture Zig",
			"finalResultHeader": "Résultat final",
			"integratedAcquiringBalance": "Solde généré par acquisition intégrée",
			"nonIntegratedAcquiringBalance": "Solde généré par acquisition non intégrée",
			"zigInvoice": "Facture Zig",
			"balanceToTransfer": "Solde à transférer",
			"finalBalanceToTransfer": "Solde final à transférer",
			"technicalAnalysisHeader": "Analyse technique",
			"previousValue": "Valeur précédente",
			"newValue": "Nouvelle valeur",
			"issuance": "Émission",
			"date": "Date",
			"version": "Version",
			"meta": "Objectif",
			"others": "Autres",
			"eventEntries": "Entrées - Événement",
			"totalBalance": "Solde final",
			"tpvOthers": "TPV Autres",
			"integratedAcquiring": "Acquisition intégrée",
			"nonIntegratedAcquiring": "Acquisition non intégrée",
			"zigBilling": "Facturation Zig",
			"balanceMovement": "Mouvement de solde",
			"to": "à"
		},
		"rechargeManagement": {
			"title": "Gestion du solde",
			"titleWithPeriod": "Recharges des {{period}} derniers jours",
			"titleWithoutPeriod": "Recharges",
			"editButton": "Modifier les soldes sélectionnées",
			"statusSelect": "Statut",
			"statusPlaceholder": "Filtrer par statut",
			"employeesSelect": "Employé qui a créé",
			"employeesPlaceholder": "Filtrer par employé",
			"clientSearch": "Document client",
			"clientPlaceholder": "Filtrer par client",
			"period": "Période",
			"editTitle_other": "Modification des soldes {{value}}",
			"editTitle_one": "Modification du solde",
			"save": "Enregistrer les modifications",
			"validPlace": "Lieux où les recharges sont valables",
			"validPlacePlaceholder": "Cliquez pour sélectionner les emplacements. Tous les emplacements précédemment valides perdront leur validité s'ils ne figurent pas dans cette sélection, à l'exception de l'emplacement où la recharge a été initialement effectuée",
			"expirationDate": "Date d'expiration",
			"valid": "Valable pour plus de {{value}} jours",
			"expireToday": "Expire aujourd'hui",
			"expired": "Expiré il y a {{value}} jours",
			"required": "Champ obligatoire",
			"columns": {
				"id": "ID",
				"date": "Date de création",
				"method": "mode de paiement",
				"author": "Employé qui a créé",
				"user": "Client",
				"totalValue": "Valeur",
				"expiresAt": "Date d'expiration",
				"validPlaces": "valable dans les lieux",
				"status": "Statut",
				"rechargeType": "Type",
				"minimumConsumption": "Consommation anticipée",
				"bonus": "Bonus",
				"recharge": "Recharger"
			},
			"activeLabel": "Valide",
			"expiredLabel": "Expiré",
			"refundedLabel": "Remboursé",
			"emptyTitle": "Il n'y avait pas de soldes",
			"emptySubtitle": "Il n'y a aucun solde dans la période sélectionnée",
			"warningMessage": "Cette recharge continuera à être utilisée <b>même si elle apparaît comme inversée dans l'historique</b> jusqu'à ce que le client soit réinscrit s'il est déjà dans son ZigTag.",
			"hasBonusOrMinimumConsumptionPlaceIdsError": "Modification des emplacements bloqués pour les bonus et la consommation anticipée",
			"hasBonusOrMinimumConsumptionexpiresAtError": "Pour Consommation Anticipée, édition uniquement pour les dates expirées",
			"editAllButton": "Modifier tous les soldes",
			"editAllMessage": "Etes-vous sûr de vouloir modifier tous les soldes?",
			"editAllConfirm": "Oui, allez à modifier",
			"order": "Commander",
			"asc": "Le plus ancien",
			"desc": "Dernier"
		},
		"transactionsReport": {
			"title": "Liste des transactions",
			"descriptionPlace": "Liste de toutes les transactions de la période",
			"descriptionEvent": "Liste de toutes les transactions d'événement",
			"filter": {
				"title": "Filtre",
				"emptyFilter": "Cliquez pour filtrer",
				"modal": {
					"inputPlaceholder": "Tapez ici",
					"selectPlaceholder": "Sélectionner ici",
					"descriptionEnd": "pour filtrer les transactions"
				},
				"modalOptions": {
					"terminal": {
						"label": "Terminal",
						"title": "Numéro de terminal",
						"description": "Entrer le numéro du terminal"
					},
					"clientDocument": {
						"label": "Document client",
						"title": "CPF ou numéro de document",
						"description": "Saisir le CPF ou le numéro de document du client"
					},
					"employee": {
						"label": "Employé",
						"title": "Nom de l'employé",
						"description": "Entrez le nom de l'employé"
					},
					"zigCode": {
						"label": "Code Zig",
						"description": "Entrez le numéro Code Zig"
					},
					"paymentMethod": {
						"label": "Mode de paiement",
						"description": "Sélectionnez un mode de paiement"
					},
					"transactionType": {
						"label": "Type de transaction",
						"description": "Sélectionnez un type de transaction"
					},
					"bar": {
						"label": "Filtrer par barre",
						"title": "Barre",
						"description": "Sélectionner une barre"
					}
				}
			},
			"print": "Imprimer le rapport",
			"table": {
				"id": "ID",
				"date": "Date",
				"syncDate": "Date de synchronisation",
				"type": "Type",
				"employee": "Employé",
				"terminal": "Terminale",
				"deviceId": "ID de l'appareil",
				"zigCode": "Code Zig",
				"bar": "Barre",
				"client": "Client",
				"product": "Produit",
				"quantity": "Quantité",
				"source": "Source",
				"paymentMethod": "Mode de paiement",
				"status": "Statut",
				"document": "Document",
				"acquirer": "Acquéreur",
				"acquirerTransactionId": "Acquisition de l'ID de transaction",
				"cardBrand": "Drapeau de carte",
				"nsu": "NSU",
				"nsuHost": "NSU Host",
				"authorizationCode": "Code d'autorisation",
				"bin": "Bin",
				"service": "Service",
				"value": "Valeur",
				"hawkerDocument": "Document ambulant",
				"hawkerName": "Nom ambulant"
			},
			"transactionTypes": {
				"recharge": "Recharge",
				"transaction": "Transaction",
				"ficha": "Jeton",
				"canceled": "Annulée",
				"refund": "Remboursement",
				"digitalCashless": "Cashless digital"
			},
			"maxSearchPeriod": "La période de recherche maximale est de 31 jours",
			"exportExcel": {
				"success": "Email avec export envoyé avec succès.",
				"title": "Rapport d'exportation",
				"label": "Veuillez saisir votre email pour envoyer la feuille de calcul",
				"error": "Veuillez saisir un email valide",
				"placeholder": "Entrez votre email"
			}
		},
		"bonusCategories": {
			"title": "Catégories de bonus"
		},
		"kds": {
			"emptyKdsDescription": "Le KDS n'a pas encore été créé. Lorsqu'il sera disponible, il s'affichera ici.",
			"editKds": "Vos modifications ont été enregistrées.",
			"title": "Paramètres du KDS",
			"subtitle": "Configurez le KDS pour améliorer et organiser les opérations de votre cuisine.",
			"createdAt": "Créé le",
			"seeKds": "Voir le KDS",
			"linkedBar": "Bar lié",
			"basic": "Basique",
			"main": "Principal",
			"general": "Général",
			"mainTooltip": "Le KDS Principal centralise le contrôle des commandes, vous permettant de modifier les statuts, d'annuler, de voir les annulations et de suivre toutes les commandes.",
			"basicTooltip": "Le KDS Basique affiche toutes les commandes qui lui sont attribuées avec le statut 'ouvert' et 'terminé', sans permettre de modifications ni la visualisation des annulations.",
			"confirmModal": {
				"title": "Vous avez des modifications non enregistrées",
				"description": "Pour quitter la page sans perdre votre progression, enregistrez vos modifications. Si vous continuez sans enregistrer, toutes les modifications seront perdues.",
				"close": "Quitter sans enregistrer"
			},
			"form": {
				"name": "Nom du KDS",
				"linkedBar": "Bar lié",
				"status": "Changement de statut",
				"timeManagement": "Gestion du temps",
				"readyTimeOrderLabel": "Temps pour qu'une commande soit considérée comme prête",
				"standardTimeOrderLabel": "Temps standard par commande (min.)",
				"originOrder": "Origine de la commande (livraison et autres intégrations)",
				"orderNumber": "Numéro de commande",
				"tableNumber": "Numéro de table",
				"customerName": "Nom du client",
				"saveChanges": "Enregistrer les modifications",
				"generalSettings": "Paramètres généraux",
				"timeSettings": "Paramètres de temps",
				"orderCardSettings": "Paramètres de la carte de commande"
			},
			"statusChangeTypes": {
				"auto": "Automatiquement",
				"manual": "Manuellement"
			},
			"timeManagementTypes": {
				"byProduct": "Utiliser le temps par produit de l'intégration",
				"defaultTime": "Utiliser un standard par commande",
				"noManagement": "Ne pas utiliser de temps"
			},
			"reports": {
				"title": "Rapport",
				"description": "Suivez les performances générales de production de vos KDS.",
				"averageAssemblyOrder": "Temps moyen de montage des commandes",
				"productionBySector": "Secteur avec le plus grand temps de production",
				"top10FastestProducts": "Top 10 des produits les plus rapides",
				"slowestProducts": "Produits avec le temps de production le plus long",
				"top10LongestOrders": "Top 10 des commandes les plus longues",
				"order": "Commande",
				"averageProductionTime": "Temps moyen de production des commandes",
				"highestSectorProduction": "Secteur avec le plus grand temps de production",
				"orderTable": {
					"orderNumber": "Numéro de commande",
					"customer": "Client",
					"origin": "Origine",
					"local": "Lieu",
					"date": "Date/heure"
				},
				"resumeDrawer": {
					"order": "Commande",
					"title": "Résumé de la commande",
					"date": "Date et heure",
					"customer": "Client",
					"originOrder": "Origine de la commande",
					"locationOrder": "Lieu de la commande",
					"table": {
						"quantity": "Qté",
						"product": "Produit",
						"sector": "Secteur",
						"time": "Temps"
					}
				},
				"noItemFound": "Aucun article trouvé"
			},
			"zigKds": {
				"title": "Gestion KDS",
				"description": "Gérez vos KDS, liez des produits aux écrans et suivez les commandes.",
				"searchPlaceholder": "Rechercher...",
				"createNew": "Créer nouveau",
				"card": {
					"linkedBarLabel": "Bar(s) lié(s):",
					"linkedProductsLabel": "Produits Liés",
					"editButton": "Modifier",
					"addScreenButton": "Ajouter écran",
					"editScreen": "Modifier écran",
					"deleteScreen": "Supprimer écran",
					"primary": "Primaire",
					"secondary": "Secondaire"
				},
				"emptyState": {
					"createNewKds": "Créer un nouveau KDS",
					"title": "Aucun KDS configuré encore",
					"description": "Vous n'avez pas encore de KDS. Enregistrez et configurez-en un pour suivre vos commandes sur les écrans.",
					"noSearchResults": {
						"title": "KDS non trouvé",
						"description": "Nous n'avons trouvé aucun KDS avec les termes recherchés. Essayez d'ajuster votre recherche."
					}
				},
				"deleteScreenModal": {
					"title": "Supprimer écran",
					"confirmText": "Êtes-vous sûr de vouloir <highlight>supprimer</highlight> l'écran {{screenName}}?",
					"warningText": "En confirmant, tous les produits associés à cet écran seront supprimés.",
					"cancelButton": "Retour",
					"confirmButton": "Confirmer"
				},
				"drawer": {
					"createTitle": "Créer nouveau KDS",
					"editTitle": "Modifier KDS",
					"backButton": "Retour",
					"saveButton": "Enregistrer",
					"deleteButton": "Supprimer KDS"
				},
				"deleteKdsModal": {
					"title": "Supprimer KDS",
					"confirmText": "Êtes-vous sûr de vouloir <highlight>supprimer</highlight> le KDS {{kdsName}}?",
					"warningText": "En confirmant, tous les écrans liés et produits associés à ce KDS seront supprimés.",
					"backButton": "Retour",
					"confirmButton": "Confirmer"
				},
				"configForm": {
					"kdsNameLabel": "Nom du KDS",
					"kdsNamePlaceholder": "Décrivez le nom du nouveau KDS",
					"linkedBarsLabel": "Bar(s) lié(s)",
					"linkedBarsPlaceholder": "Sélectionnez un ou plusieurs bars à lier",
					"productsDisplayedLabel": "Produits affichés",
					"productsDisplayedDescription": "Liste de tous les produits du bar qui peuvent être affichés sur ce KDS.",
					"emptyProductsTitle": "Aucun produit affiché encore",
					"emptyProductsBullet1": "Enregistrez des produits dans le bar lié pour qu'ils apparaissent ici.",
					"emptyProductsBullet2": "Liez ce KDS à un bar pour charger les produits.",
					"goToBarsButton": "Aller aux bars et secteurs",
					"products": "produits"
				},
				"tabs": {
					"configuration": "Configuration",
					"statusAndTime": "Statut et Temps"
				},
				"generalSettings": {
					"timeManagementTitle": "Gestion du temps",
					"statusUpdateTitle": "Mise à jour du statut de la commande",
					"cardInfoTitle": "Informations affichées sur la carte de commande"
				},
				"screensPanel": {
					"configuredScreensLabel": "Écrans configurés",
					"addScreenButton": "Ajouter écran",
					"unsavedWarningTitle": "KDS Principal Non Enregistré",
					"unsavedWarningMessage": "Pour pouvoir <strong>modifier ou ajouter de nouveaux écrans</strong>, vous devez <strong>enregistrer les paramètres du KDS Principal ci-dessous.</strong>",
					"productsLabel": "Produits"
				},
				"productsPreview": {
					"searchPlaceholder": "Rechercher par produit ou catégorie",
					"loadingMessage": "Chargement des produits...",
					"noResultsMessage": "Aucun produit trouvé pour la recherche.",
					"noProductsMessage": "Aucun produit trouvé pour le bar sélectionné."
				},
				"settings": {
					"timeSettings": {
						"timerEnabled": {
							"label": "Chronomètre de temps de commande",
							"description": "Compte le temps de la commande depuis la création jusqu'à la finalisation."
						},
						"productionTimeEnabled": {
							"label": "Temps de production par produit",
							"description": "Affiche le temps estimé de préparation de chaque produit."
						}
					},
					"cardInfoSettings": {
						"showOrderNumber": {
							"label": "Numéro de commande",
							"description": "Affiche l'identifiant unique de la commande."
						},
						"showOrigin": {
							"label": "Origine",
							"description": "Indique d'où la commande a été passée (PDV, livraison, etc.)."
						},
						"showOrderTime": {
							"label": "Heure de commande",
							"description": "Affiche l'heure à laquelle la commande a été créée"
						},
						"showCustomerTable": {
							"label": "Client/Table",
							"description": "Affiche le nom du client ou le numéro de table."
						},
						"showProductionTimeCard": {
							"label": "Temps de production par produit",
							"description": "Affiche le temps estimé de préparation de chaque article."
						},
						"showObservation": {
							"label": "Observation",
							"description": "Affiche des observations supplémentaires de la commande."
						}
					},
					"statusModeOptions": {
						"manual": {
							"label": "Manuel",
							"description": "Permet d'avancer le statut de la commande manuellement"
						},
						"automatic": {
							"label": "Automatique",
							"description": "Permet d'avancer le statut de la commande après un temps défini"
						}
					}
				},
				"notifications": {
					"kdsCreated": "KDS créé avec succès",
					"kdsEdited": "KDS modifié avec succès",
					"kdsDeleted": "KDS supprimé avec succès",
					"screenDeleted": "Écran supprimé avec succès"
				}
			}
		}
	},
	"store": {
		"backofficeStore": {
			"addBar": "Bar ajouté",
			"addStorage": "Stock créé avec succès",
			"createBillTypes": "Type de compte créé avec succès",
			"createCategorie": "Catégorie créée",
			"createCostCenters": "Centre de coût créé",
			"createNewSupplier": "Nouveau fournisseur ajouté avec succès",
			"createTransfer": "Transfert réalisé avec succès",
			"deleteAccount": "Compte client supprimé",
			"deleteBackofficeProduct": "Produit supprimé du stock",
			"deleteBackofficeProducts": "Tous les produits ont été supprimés du stock",
			"deleteBar": "Bar supprimé avec succès",
			"deleteBill": "Compte supprimé",
			"deleteBillTypes": "Type de compte supprimé",
			"deleteCategorie": "Catégorie supprimé",
			"deleteCostCenter": "Centre de coût supprimé",
			"deleteSupplier": "Fournisseur supprimé avec succès",
			"deleteTransfer": "Transfert supprimé avec succès",
			"editAccount": "Compte client modifié",
			"editBill": "Compte modifié avec succès",
			"editBillTypes": "Type de compte modifié",
			"editCategorie": "Catégorie modifiée",
			"editCostCenter": "Centre de coût modifié",
			"editSupplier": "Fournisseur modifié avec succès",
			"editTransfer": "Transfert modifié avec succès",
			"importBackofficeBills": "Imports Comptes",
			"inputBackofficeProductsV2_other": "Un ou plusieurs produits n'ont pas été ajoutés",
			"inputBackofficeProductsV2_zero": "Produits ajoutés au stock",
			"saveBackofficeProductsQuantityV2": "Produit mis à jour",
			"transferBackofficeProduct": "Produit transféré",
			"updateBar": "Bar modifié avec succès",
			"updateStorage": "Stock modifié avec succès",
			"zeroBackofficeAllProductsAtStorage": "Tous les produits sont mis à zéro"
		},
		"barStore": {
			"addTableBarRange": "Ajout de la configuration de l'impression des tables.",
			"deleteBar": "Bar supprimé.",
			"deleteRange": "La configuration de l'impression des tables a été supprimée.",
			"editBar": "Bar mis à jour.",
			"editTableBarRange": "Mise à jour de la configuration de l'impression des tables."
		},
		"cashierStore": {
			"addCashierClosingObs": "Commenatire ajouté.",
			"bleedCashier_other": "Retrait espèces effectué avec succès.",
			"bleedCashier_zero": "Fonds de caisse effectué avec succès",
			"createBleedLEGACY": "Retrait espèces ajouté",
			"createCashierChangeLEGACY": "Fonds de caisse ajouté",
			"createMultipleChangesLEGACY": "Tous les fonds ont été enregistrés",
			"createMultipleChangesLEGACYError": "{{errors}} de {{cashiersId}} donne l'erreur : {{jsonErrors}}",
			"updateCashierClosingLEGACY": "Caisse clôturé avec succès"
		},
		"clientStore": {
			"clientAlreadyAdded": "Ce client a déjà été ajouté",
			"editClientDetails": "Mise à jour des détails du client.",
			"editClientDetailsPlace": "Détails du client mis à jour.",
			"editUserDetails": "Détails du client mis à jour.",
			"getClientByCPFOrPhone": "Client ajouté",
			"payAllBillsAtPlace": "Factures payées avec succès",
			"payBillAtPlace": "Compte payé avec succès",
			"payBillsLoading": "Marqué comme payé",
			"payBillsSuccess": "Comptes payés avec succès",
			"payBillsWarning": "{{success}} facture payées avec succès, et {{errors}} erreurs de paiement des factures."
		},
		"cmvStore": {
			"error": {
				"getCategories": "Erreur dans la recherche de la catégorie"
			}
		},
		"comboStore": {
			"createCombo": "Combo créé.",
			"deleteCombo": "Combo supprimé.",
			"editCombo": "Combo mis à jour."
		},
		"deliveryStore": {
			"activateManyProductsLoading": "Activation des produits",
			"activateManyProductsWarning": "{{countFailures}} produit(s) n'ont pas pu être actualisé(s).",
			"addProduct": "Produit ajouté avec succès !",
			"addProductV2": "Produit ajouté avec succès !",
			"deactivateManyProductsLoading": "Désactivation de produits",
			"deactivateManyProductsWarning": "{{countFailures}} produit(s) n'ont pas pu être actualisé(s).",
			"deleteMenu": "Menu supprimé avec succès !"
		},
		"deviceStore": {
			"addDevice": "Terminal ajouté au lieu avec succès",
			"removeDeviceFromEvent": "Terminal retiré de l'événement.",
			"updateEmployeeDeviceConfigs": "Terminal configuré avec succès"
		},
		"employeeStore": {
			"addEmployee": "Employé ajouté.",
			"addMultipleEmployees": {
				"error": "Erreur lors de l'ajout des employés:",
				"success": "Employés ajoutés avec succès:"
			},
			"removeMultipleEmployees": "{{successCount}} employés ont été supprimés avec succès",
			"removeMultipleEmployeesError": "{{errorCount}} employés n'ont pas pu être supprimés",
			"createRole": "Fonction créée avec succès",
			"deleteRole": "Fonction supprimée avec succès",
			"editEmployee": "Employé actualisé.",
			"removeEmployee": "Employé supprimé.",
			"updateRole": "Fonction modifiée avec succès."
		},
		"eventStore": {
			"closeEvent": "Événement clôturé.",
			"closeEventLoading": "Clôture événement",
			"createEvent": "Événement créé.",
			"deleteEvent": "Événement supprimé.",
			"emitInnovaroGeneralInvoices": "Factures émises avec succès",
			"giveRechargeToUser": "Rechargement crée avec succès",
			"eventEditedSuccessfully": "Événement modifié avec succès",
			"openEvent": "Événement ouvert.",
			"payAllBillsAtEvent": "Factures payées avec succès",
			"payBillAtEventWithMultiplePayments": "Facture payée avec succès",
			"refundFichaSell": "Token remboursé avec succès"
		},
		"extractStore": {
			"createAdjustmentInVendorExtract": "Ajustement ajouté avec succès",
			"createBankAccount": "Compte bancaire créé avec succès",
			"deleteBankAccount": "Compte bancaire supprimé avec succès !",
			"orderWithdrawCancellation": "Annulation de retrait envoyée avec succès.",
			"payVendorWithdrawRequests": "Validations envoyées avec succès",
			"revertManyVendorsWithDrawRequests": "Refus de demande envoyé avec succès!",
			"updateBankAccount": "Compte bancaire actualisé avec succès!"
		},
		"fiscalStore": {
			"createFiscalProductGroup": "Création d'un groupe fiscal réussie",
			"createFiscalProfile": "Création d'un profil fiscal réussie",
			"deleteFiscalProductGroup": "Groupe fiscal supprimé avec succès",
			"editFiscalProductGroup": "Groupe fiscal modifié avec succès.",
			"editFiscalProfile": "Profile fiscal modifié avec succès",
			"issueManualInvoiceForReserveError": "Erreur n°{{number}}: {{error}}",
			"issueManualInvoiceForReserveError_zero": "Erreur générant {{failedInvoiceCount}} factures",
			"issueManualInvoiceForReserve_other": "{{issuedInvoices}} Factures générées avec succès",
			"issueManualInvoiceForReserve_zero": "Toutes les factures ont été générées avec succès",
			"minimumConsumptionFiscalSuccess": "Consommation minimale configurée avec succès",
			"rechargeFiscalSuccess": "Recharge configurée avec succès"
		},
		"invoiceStore": {
			"cancelInvoice": "Facture annulée avec succès!",
			"cancelInvoiceNC": "Note de crédit générée avec succès ! Votre note de crédit sera disponible sous peu",
			"issueAllEventInvoices": "Factures de l'événement émises.",
			"issueInvoicesOfTransactions": "Les factures sont émises",
			"notifyOfIssuingWarning_other": "{{issuedInvoices}} factures émises, mais les erreurs suivantes ont été trouvées : {{errors}}",
			"notifyOfIssuingWarning_zero": "Aucune facture n'a été émise, les erreurs suivantes ont été trouvées : {{errors}}",
			"notifyOfIssuing_other": "{{invoiceCount}} factures émises",
			"notifyOfIssuing_zero": "Il n'y a pas eu de facture à émettre",
			"sendInvoicesByEmail": "Factures envoyées par courrier électronique.."
		},
		"itemStore": {
			"activateMountableSectionItem_all": "Articles activés avec succès",
			"activateMountableSectionItem_one": "Article activé avec succès",
			"activateProductsInPlace": "Produits activéss",
			"activateProductsInPlaceLoading": "Activation de produits",
			"activateSingleProductInPlace": "Produit activé",
			"activatedEntrance": "Entrée activée",
			"activatedProduct": "Produit activé",
			"activatingEntrance": "Activation des entrées",
			"activatingProduct": "Activation de produit",
			"addProduct": "Produit ajouté",
			"addSupply": "Entrée ajouté",
			"attachProductionRule": "Fiche technique créée avec succès",
			"createBeerTap": "Boutique créée avec succès !",
			"createCategory": "Catégorie créée avec succès",
			"createEntrance": "Entrée ajoutée",
			"deactivateMountableSectionItem_all": "Articles désactivés avec succès",
			"deactivateMountableSectionItem_one": "Article désactivé avec succès",
			"deactivateProductsInPlace": "Produits désactivés",
			"deactivateProductsInPlaceLoading": "Désactivation de produit",
			"deactivateSingleProductInPlace": "Produit désactivé",
			"deactivatedEntrance": "Entrée désactivée",
			"deactivatedProduct": "Produit désactivé",
			"deactivatingEntrance": "Désactivation d'entrée",
			"deactivatingProduct": "Désactivation du produit",
			"deleteCategory": "Catégorie supprimée",
			"deleteEntrance": "Entrée supprimée",
			"deleteMultipleProducts": "Supprimé avec succès",
			"deleteProduct": "Produit supprimé",
			"deleteProductError": "Erreur lors de la suppression du produit",
			"deleteProductFromPlace": "Produit supprimé",
			"editBeerTap": "Bière pression éditée avec succès !",
			"editCategory": "Catégorie mise à jour",
			"editEntrance": "Entrée mise à jour",
			"editEntranceImage": "Entrée mise à jour",
			"editMultipleProducts": "{{name}} modifié avec succès!",
			"editMultipleProductsError": "{{name}} n'a pas pu être modifié : {{reason}}",
			"editProduct": "Produit mis à jour",
			"editProductionRule": "Règle de production actualisée",
			"editProductionRuleInput": "Insumo modifié avec succès",
			"editSupply": "Fourniture modifiée",
			"errorToAdd": "Erreur lors de l'ajout {{name}}",
			"importProducts": "{{products}} produits importés",
			"importProductsError": "Erreur lors du modification du produit {{name}}: {{message}}",
			"importProductsToEdit": "{{products}} produits modifiés",
			"importProductsToEditError": "Erreur lors de la modification du produit {{name}}: {{message}}",
			"importProductsToEditWarning": "{{products}} produits modifiés et {{errorCounter}} produits ont eu des problèmes d'édition",
			"importProductsWarning": "{{products}} produits importés et {{errorCounter}} produits ont eu un problème d'importation",
			"removeBeerTap": "Bière pression supprimée avec succès!",
			"removeProductionRule": "La fiche technique a été supprimée avec succès"
		},
		"organizationStore": {
			"addMultipleOrgProducts": "Produits ajoutés",
			"addMultipleProductsInPlace": "Lieux ajoutés",
			"addProductToOrg": "Produit ajouté",
			"deleteMultipleOrgProducts": "({{products}}) produits ont été retirés de l'inventaire dans tous les emplacements.",
			"deleteMultipleOrgProductsQueued": "La suppression de ({{products}}) produits a été mise en file d'attente et sera traitée en arrière-plan.",
			"deleteProduct": "Produit supprimé",
			"deleteProductError": "Errur lors de la suppression du produit",
			"editMultipleOrgProducts": "Produits modifiés",
			"editOrgProduct": "Produit édité",
			"tooglePlaces": "Lieux modifiés",
			"activateGiftback": "Giftback activé avec succès",
			"deactivateGiftback": "Giftback désactivé avec succès"
		},
		"placeStore": {
			"activateDiscountCategory": "Réduction activée avec succès !",
			"addEmailToMinimumStorageAlert": "Emails enregistrés avec succès",
			"alterFichaLogo": "Envoi d'une image.",
			"alterFichaText": "Titre du formulaire envoyé.",
			"confirmSignPlaceContracts": "Abonnement terminé avec succès",
			"createManualLostReport": "Perte manuelle créée avec succès.",
			"createStorageAlerts": "Alerte créée avec succès",
			"deleteDiscountCategory": "La réduction a été supprimée avec succès !",
			"deleteStorageAlerts": "Alerte supprimée avec succès",
			"disableDiscountCategory": "Réduction désactivée avec succès !",
			"editEverestConfig": "Données Everest mises à jour",
			"editEverestConfigWarning": "Validation des données avec Everest",
			"editPlace": "Lieu mis à jour.",
			"editStorageAlerts": "Alerte modifiée avec succès",
			"removeEmailToMinimumStorageAlert": "Email supprimé avec succès"
		},
		"productFeatureStore": {
			"createProductFeature": "Fonctionnalité du produit créée avec succès !",
			"createProductFeatureTemplate": "Modèle de fonctionnalité du produit créé avec succès !",
			"editProductFeature": "Modification réussie de la fiche produit !",
			"editProductFeatureTemplate": "Modèle de fonctionnalité du produit modifié avec succès !",
			"org": "ORG",
			"removeProductFeature": "Fonctionnalité du produit supprimée avec succès!",
			"removeProductFeatureTemplate": "Modèle de fonctionnalité du produit supprimé avec succès!",
			"removeProductFeaturesByTemplateId": "Caractéristiques du produit liées au modèle supprimées avec succès !",
			"zig": "ZIG"
		},
		"promotionStore": {
			"createPromotion": "Promotion créée avec succès",
			"editPromotion": "Promotion éditée avec succès",
			"updatePromotionPeople": "Mise à jour des clients réussie",
			"usersInfoRewriteLoading": "La recherche de données sur les clients peut prendre beaucoup de temps.",
			"deletePromotion": "Promotion supprimée avec succès"
		},
		"relationStore": {
			"activateOrDeactivateRelation_active": "Listes activées avec succès",
			"activateOrDeactivateRelation_deactive": "Liste désactivée avec succès",
			"addRelationUser": "Invité ajouté avec succès !",
			"deleteMultipleRelation_one": "Suppression réussie de la liste",
			"deleteMultipleRelation_other": "Suppression réussie des listes",
			"deleteRelation": "Suppression réussie des listes",
			"deleteRelationUser": "Utilisateur supprimé de la liste avec succès",
			"editRelation": "Informations de la liste modifiées avec succès !",
			"editRelationUser": "Invité modifié avec succès!"
		},
		"reserveStore": {
			"addReserve": "Forfait créé avec succès",
			"createReserveTemplate": "Package template created successfully!",
			"deleteReserve": "Forfait supprimé avec succès",
			"editReserve": "Forfait modifié avec succès"
		},
		"smsStore": {
			"cancelSmsCampaign": "Horaire annulé.",
			"editSmsCampaignClients": "Groupe de destinataires modifié."
		},
		"vendorStore": {
			"createVendor": "Vendeur créé avec succès",
			"editVendor": "Vendeur modifié avec succès"
		},
		"whatsUpStore": {
			"setPlaceDetailStatus_active": "Lieu activé dans l'application Zig",
			"setPlaceDetailStatus_inactive": "Lieu désactivé dans l'application Zig"
		}
	}
}
